// This file is auto-generated by @hey-api/openapi-ts

export type ClientOptions = {
    baseUrl: string;
};

export const AddressTag = {
    HEAD_OFFICE: 'head_office',
    REGISTERED_ADDRESS: 'registered_address',
    PRIMARY_ADDRESS: 'primary_address'
} as const;

export type AddressTag = typeof AddressTag[keyof typeof AddressTag];

export type AddressRes = {
    id: string;
    personAddressId?: string | null;
    country: string | null;
    city: string | null;
    street: string | null;
    houseNumber: string | null;
    singleAddressString: string | null;
    postCode: string | null;
    tags?: Array<AddressTag>;
};

export const BankAccountStatus = {
    DRAFT: 'DRAFT',
    PENDING_VERIFICATION: 'PENDING_VERIFICATION',
    PENDING_ADMIN_REVIEW: 'PENDING_ADMIN_REVIEW',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED',
    INACTIVE: 'INACTIVE',
    INVESTOR_OTP_REQUESTED: 'INVESTOR_OTP_REQUESTED',
    INVESTOR_OTP_SUCCEEDED: 'INVESTOR_OTP_SUCCEEDED',
    INVESTOR_OTP_FAILED: 'INVESTOR_OTP_FAILED'
} as const;

export type BankAccountStatus = typeof BankAccountStatus[keyof typeof BankAccountStatus];

export const VerificationMethod = {
    AIS: 'AIS',
    OPEN_BANKING_US: 'OPEN_BANKING_US',
    COP: 'COP',
    VOP: 'VOP',
    MANUAL: 'MANUAL'
} as const;

export type VerificationMethod = typeof VerificationMethod[keyof typeof VerificationMethod];

export const ValidationType = {
    IBAN: 'IBAN',
    BIC: 'BIC',
    ABA_ROUTING: 'ABA_ROUTING',
    CA_ROUTING: 'CA_ROUTING',
    SORT_CODE: 'SORT_CODE'
} as const;

export type ValidationType = typeof ValidationType[keyof typeof ValidationType];

export const CurrencyType = {
    EUR: 'EUR',
    GBP: 'GBP',
    USD: 'USD',
    DKK: 'DKK',
    NOK: 'NOK',
    PLN: 'PLN',
    SEK: 'SEK',
    CHF: 'CHF',
    DZD: 'DZD',
    ARS: 'ARS',
    AMD: 'AMD',
    AWG: 'AWG',
    AUD: 'AUD',
    AZN: 'AZN',
    BSD: 'BSD',
    BHD: 'BHD',
    THB: 'THB',
    PAB: 'PAB',
    BBD: 'BBD',
    BYN: 'BYN',
    BZD: 'BZD',
    BMD: 'BMD',
    VES: 'VES',
    VED: 'VED',
    BOB: 'BOB',
    BRL: 'BRL',
    BND: 'BND',
    BGN: 'BGN',
    BIF: 'BIF',
    CVE: 'CVE',
    CAD: 'CAD',
    KYD: 'KYD',
    XOF: 'XOF',
    XAF: 'XAF',
    XPF: 'XPF',
    CLP: 'CLP',
    COP: 'COP',
    KMF: 'KMF',
    CDF: 'CDF',
    BAM: 'BAM',
    NIO: 'NIO',
    CRC: 'CRC',
    CUP: 'CUP',
    CZK: 'CZK',
    GMD: 'GMD',
    MKD: 'MKD',
    DJF: 'DJF',
    STN: 'STN',
    DOP: 'DOP',
    VND: 'VND',
    XCD: 'XCD',
    EGP: 'EGP',
    SVC: 'SVC',
    ETB: 'ETB',
    FKP: 'FKP',
    FJD: 'FJD',
    HUF: 'HUF',
    GHS: 'GHS',
    GIP: 'GIP',
    HTG: 'HTG',
    PYG: 'PYG',
    GNF: 'GNF',
    GYD: 'GYD',
    HKD: 'HKD',
    UAH: 'UAH',
    ISK: 'ISK',
    INR: 'INR',
    IRR: 'IRR',
    IQD: 'IQD',
    JMD: 'JMD',
    JOD: 'JOD',
    KES: 'KES',
    PGK: 'PGK',
    KWD: 'KWD',
    AOA: 'AOA',
    MMK: 'MMK',
    LAK: 'LAK',
    GEL: 'GEL',
    LBP: 'LBP',
    ALL: 'ALL',
    HNL: 'HNL',
    SLE: 'SLE',
    LRD: 'LRD',
    LYD: 'LYD',
    SZL: 'SZL',
    LSL: 'LSL',
    MGA: 'MGA',
    MWK: 'MWK',
    MYR: 'MYR',
    MUR: 'MUR',
    MXN: 'MXN',
    MDL: 'MDL',
    MAD: 'MAD',
    MZN: 'MZN',
    NGN: 'NGN',
    ERN: 'ERN',
    NAD: 'NAD',
    NPR: 'NPR',
    ANG: 'ANG',
    ILS: 'ILS',
    TWD: 'TWD',
    NZD: 'NZD',
    BTN: 'BTN',
    KPW: 'KPW',
    MRU: 'MRU',
    TOP: 'TOP',
    PKR: 'PKR',
    MOP: 'MOP',
    CUC: 'CUC',
    UYU: 'UYU',
    PHP: 'PHP',
    BWP: 'BWP',
    QAR: 'QAR',
    GTQ: 'GTQ',
    ZAR: 'ZAR',
    OMR: 'OMR',
    KHR: 'KHR',
    RON: 'RON',
    MVR: 'MVR',
    IDR: 'IDR',
    RUB: 'RUB',
    RWF: 'RWF',
    SHP: 'SHP',
    SAR: 'SAR',
    RSD: 'RSD',
    SCR: 'SCR',
    SGD: 'SGD',
    PEN: 'PEN',
    SBD: 'SBD',
    KGS: 'KGS',
    SOS: 'SOS',
    TJS: 'TJS',
    SSP: 'SSP',
    LKR: 'LKR',
    XSU: 'XSU',
    SDG: 'SDG',
    SRD: 'SRD',
    SYP: 'SYP',
    BDT: 'BDT',
    WST: 'WST',
    TZS: 'TZS',
    KZT: 'KZT',
    TTD: 'TTD',
    MNT: 'MNT',
    TND: 'TND',
    TRY: 'TRY',
    TMT: 'TMT',
    AED: 'AED',
    UGX: 'UGX',
    UZS: 'UZS',
    VUV: 'VUV',
    KRW: 'KRW',
    YER: 'YER',
    JPY: 'JPY',
    CNY: 'CNY',
    ZMW: 'ZMW',
    ZWL: 'ZWL'
} as const;

export type CurrencyType = typeof CurrencyType[keyof typeof CurrencyType];

export type BankAccountIdentifierValueRes = {
    /**
     * BankAccountIdentifier key, e.g. sort_code
     */
    key: string;
    /**
     * Display label for the key, e.g. Sort code
     */
    label: string;
    value: string;
    /**
     * BankAccountFormatRule the value was entered under; null = classic entry
     */
    bankAccountFormatRuleId: string | null;
};

export type DataBankAccountTct = {
    id: string;
    bankName: string | null;
    accountHolder: string | null;
    accountNumber: string;
    iban: string | null;
    swiftCode: string | null;
    investorInstructions: string | null;
    personId: string | null;
    status: BankAccountStatus;
    verificationMethod: VerificationMethod | null;
    validationMethods: Array<ValidationType>;
    countryCode: string | null;
    currency: CurrencyType | null;
    /**
     * Live identifier rows, including format-specific keys
     */
    identifiers: Array<BankAccountIdentifierValueRes>;
    migrated: boolean;
};

export type UserOneSchemaConfig = {
    oneSchemaJwt: string;
    oneSchemaClientId: string;
    complex: boolean;
};

export const ApplicationType = {
    GODMODE: 'godmode',
    DEALSTACK: 'dealstack',
    INVESTOR: 'investor'
} as const;

export type ApplicationType = typeof ApplicationType[keyof typeof ApplicationType];

export const PermissionRoleWithOwnerEnum = {
    ADMIN: 'admin',
    USER_ADMIN: 'userAdmin',
    KYC_ADMIN: 'kycAdmin',
    EDITOR: 'editor',
    EXPORT_VIEWER: 'exportViewer',
    VIEWER: 'viewer',
    OWNER: 'owner'
} as const;

export type PermissionRoleWithOwnerEnum = typeof PermissionRoleWithOwnerEnum[keyof typeof PermissionRoleWithOwnerEnum];

export type PermissionRes = {
    resourceType: string;
    resourceId: string;
    permissionRole: PermissionRoleWithOwnerEnum;
    isImplicit: boolean;
};

export type PersonSummaryRes = {
    id: string;
    email: {
        [key: string]: unknown;
    } | null;
    firstName?: {
        [key: string]: unknown;
    } | null;
    lastName?: {
        [key: string]: unknown;
    } | null;
};

export type DataUserResponse = {
    id: string;
    authProviderUserId: string;
    active: boolean;
    deleted: boolean;
    email: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    telephonePrefix: string;
    phoneNumber: string;
    addressId: string;
    address: AddressRes;
    bankAccountId: string;
    bankAccount: DataBankAccountTct;
    isPhoneNumberInvalid: boolean;
    createdAt: string;
    updatedAt: string;
    oneSchemaConfig: UserOneSchemaConfig;
    platformAccess: Array<ApplicationType>;
    permissions: Array<PermissionRes> | null;
    person: PersonSummaryRes | null;
};

export type UserOrganizationRes = {
    /**
     * Id of the organization the user belongs to (resolved via WorkOs membership). Null when the user has no organization.
     */
    organizationId: string | null;
};

export type UserSignatureImageEntityRes = {
    id: string;
    userId: string;
    signatureImageFileId: string;
};

export type GetUserProfileRes = {
    id: string;
    email: string;
    firstName?: string;
    lastName?: string;
    birthDate?: string;
    telephonePrefix?: string;
    phoneNumber?: string;
    address?: AddressRes;
    userSignatureImage?: UserSignatureImageEntityRes;
    vehicleData: {
        [key: string]: unknown;
    };
    representative: {
        [key: string]: unknown;
    };
    isRepresentativeSameAsUser: boolean;
};

export const Gender = {
    MALE: 'MALE',
    FEMALE: 'FEMALE',
    OTHER: 'OTHER'
} as const;

export type Gender = typeof Gender[keyof typeof Gender];

export const LegalPersonTags = {
    TARGET: 'TARGET',
    FUND: 'FUND',
    CO_INVESTOR: 'CO_INVESTOR',
    EXTERNAL_LENDER: 'EXTERNAL_LENDER',
    BID_CO: 'BID_CO',
    SPV: 'SPV',
    PC_MANAGED: 'PC_MANAGED'
} as const;

export type LegalPersonTags = typeof LegalPersonTags[keyof typeof LegalPersonTags];

export const PersonType = { NATURAL: 'NATURAL', LEGAL: 'LEGAL' } as const;

export type PersonType = typeof PersonType[keyof typeof PersonType];

export const SecurityType = {
    LOAN: 'LOAN',
    PREFERENCE_SHARE: 'PREFERENCE_SHARE',
    TRACKING_SHARE: 'TRACKING_SHARE',
    PARTNERSHIP_UNIT: 'PARTNERSHIP_UNIT',
    OPTIONS: 'OPTIONS',
    ORDINARY_SHARE: 'ORDINARY_SHARE',
    VIRTUAL_EQUITY: 'VIRTUAL_EQUITY',
    OTHER: 'OTHER',
    WARRANT: 'WARRANT',
    OTHER_EQUITY: 'OTHER_EQUITY',
    BOND: 'BOND',
    DEFERRED_SHARE: 'DEFERRED_SHARE'
} as const;

export type SecurityType = typeof SecurityType[keyof typeof SecurityType];

export const SecurityParticipationThresholdBasis = { TOTAL_SOURCES_FOR_ISSUER: 'TOTAL_SOURCES_FOR_ISSUER', TOTAL_PROCEEDS_WITHIN_TIER: 'TOTAL_PROCEEDS_WITHIN_TIER' } as const;

export type SecurityParticipationThresholdBasis = typeof SecurityParticipationThresholdBasis[keyof typeof SecurityParticipationThresholdBasis];

export const SecurityIssuedIn = { UNITS: 'UNITS', CURRENCY: 'CURRENCY' } as const;

export type SecurityIssuedIn = typeof SecurityIssuedIn[keyof typeof SecurityIssuedIn];

export const SecurityEquityBasis = { UNITS: 'UNITS', COST_AT_ISSUE: 'COST_AT_ISSUE' } as const;

export type SecurityEquityBasis = typeof SecurityEquityBasis[keyof typeof SecurityEquityBasis];

export const IncomeType = { INTEREST: 'INTEREST', TRACKING: 'TRACKING' } as const;

export type IncomeType = typeof IncomeType[keyof typeof IncomeType];

export type DataSecurityTct = {
    id: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    nominalValue?: number;
    fairMarketValuePerUnit?: number;
    votesPerUnit?: number;
    issuerId: string;
    loanDefinitionId?: string;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    residueRights: boolean;
    includeInReturns: boolean;
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis?: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string;
    issuedIn: SecurityIssuedIn;
    hasNomineeStructure: boolean;
    equityBasis?: SecurityEquityBasis;
    unitDenominator: number;
    authorisedCapital?: number;
    incomeType?: IncomeType | null;
};

export const ElfStatus = { ACTV: 'ACTV', INAC: 'INAC' } as const;

export type ElfStatus = typeof ElfStatus[keyof typeof ElfStatus];

export type LegalFormRes = {
    type: string;
    uniq_id_by_elf_code_and_language: string;
    elf_code: string;
    elf_status: ElfStatus;
    country_of_formation?: string;
    country_code_ISO_3166_1?: string;
    jurisdiction_of_formation?: string;
    country_sub_division_code_ISO_3166_2?: string;
    entity_legal_form_name_local_name?: string;
    language?: string;
    language_code_ISO_639_1?: string;
    entity_legal_form_name_transliterated_name_per_ISO_01_140_10: string;
    abbreviations_local_language?: string;
    abbreviations_transliterated?: string;
    date_created_YYYY_MM_DD_ISO_8601: string;
    modification?: string;
    modification_date_YYYY_MM_DD_ISO_8601?: string;
    reason?: string;
};

export const JurisdictionType = { COUNTRY_ONLY: 'COUNTRY_ONLY', COUNTRY_AND_SUBDIVISION: 'COUNTRY_AND_SUBDIVISION' } as const;

export type JurisdictionType = typeof JurisdictionType[keyof typeof JurisdictionType];

export type JurisdictionRes = {
    jurisdiction_name: string;
    country_code: string;
    languages: Array<string>;
    group: string;
    type: JurisdictionType;
};

export type RegistrationDetailsRes = {
    corporateRegistrationNumber?: string;
    legalForm?: LegalFormRes;
    name?: string;
    jurisdiction?: JurisdictionRes;
    selectedJurisdictionLanguage?: string;
    jurisdictionCountryCode?: string;
    jurisdictionName?: string;
    jurisdictionLanguages?: Array<string>;
    jurisdictionType?: string;
    jurisdictionGroup?: string;
};

export type DataPersonTct = {
    id: string;
    dateOfBirth: string | null;
    deleted: boolean;
    email: string | null;
    firstName?: string | null;
    displayName: string;
    gender: Gender | null;
    lastName?: string | null;
    userId: string | null;
    phoneNumber: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    citizenship: Array<string>;
    domicile: string | null;
    tags: Array<LegalPersonTags> | null;
    hasNomineeStructure: boolean;
    telephonePrefix: string | null;
    type: PersonType;
    providerDetailsFriendlyName: string | null;
    providerDetailsLegalForm: string | null;
    personRegistrationDetailsId: string | null;
    securities?: Array<DataSecurityTct>;
    addresses?: Array<AddressRes>;
    registrationDetails: RegistrationDetailsRes | null;
    updatedAt: string;
    createdAt: string;
};

export type GetUserPersonsRes = {
    id: string;
    persons: Array<DataPersonTct>;
};

export type UpdateUserPersonalDetailsDto = {
    firstName: string;
    lastName: string;
    birthDate: string;
    addressId: {
        [key: string]: unknown;
    };
    country: string;
    street: string;
    city: string;
    houseNumber: string;
    postCode: string;
    phoneNumber: string;
    telephonePrefix: string;
    signatureImageFileId?: string;
};

export type UpdateUserSignatureDto = {
    signatureImageFileId: string;
};

export type UpdateUserVehicleDataDto = {
    country: string;
    street: string;
    city: string;
    houseNumber: string;
    postCode: string;
};

export type UpdateUserRepresentativeDto = {
    firstName: string;
    lastName: string;
    email: string;
    birthDate?: string;
    country?: string;
    street?: string;
    city?: string;
    houseNumber?: string;
    postCode?: string;
    phoneNumber?: string;
    telephonePrefix?: string;
};

export type UserWithOnlyEmailAndNameRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
};

export type UserSignatureRes = {
    signatureImageFileId: string;
    signedUrl: string;
};

export const InvestorState = {
    CREATE_AND_COLLABORATE: 'CREATE_AND_COLLABORATE',
    REVIEW_AND_SEND: 'REVIEW_AND_SEND',
    COLLECT_AND_APPROVE: 'COLLECT_AND_APPROVE',
    MONITOR_AND_CHANGE: 'MONITOR_AND_CHANGE',
    EXIT_AND_ARCHIVE: 'EXIT_AND_ARCHIVE'
} as const;

export type InvestorState = typeof InvestorState[keyof typeof InvestorState];

export type DataUserInvestorTct = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    birthDate: string | null;
    telephonePrefix: string;
    phoneNumber: string;
    address: AddressRes | null;
    active: boolean;
};

export const InvestmentWorkflowCompletionStep = {
    PERSONAL_INFORMATION: 'PERSONAL_INFORMATION',
    INVESTMENT_VEHICLE_INFORMATION: 'INVESTMENT_VEHICLE_INFORMATION',
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    OTHER: 'OTHER',
    KYC_INSTRUCTIONS: 'KYC_INSTRUCTIONS',
    KYC_PERSONAL: 'KYC_PERSONAL',
    KYC_COMPANY: 'KYC_COMPANY',
    KYC_FORMS: 'KYC_FORMS',
    DECLARATIONS: 'DECLARATIONS',
    CONTRACTS: 'CONTRACTS',
    COMPLETED: 'COMPLETED'
} as const;

export type InvestmentWorkflowCompletionStep = typeof InvestmentWorkflowCompletionStep[keyof typeof InvestmentWorkflowCompletionStep];

export type DataShareholderInvestorRepresentativeRes = {
    id: string;
    dateOfBirth: string | null;
    deleted: boolean;
    email: string | null;
    firstName?: string | null;
    displayName: string;
    gender: Gender | null;
    lastName?: string | null;
    userId: string | null;
    phoneNumber: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    citizenship: Array<string>;
    domicile: string | null;
    tags: Array<LegalPersonTags> | null;
    hasNomineeStructure: boolean;
    telephonePrefix: string | null;
    type: PersonType;
    providerDetailsFriendlyName: string | null;
    providerDetailsLegalForm: string | null;
    personRegistrationDetailsId: string | null;
    securities?: Array<DataSecurityTct>;
    addresses?: Array<AddressRes>;
    registrationDetails: RegistrationDetailsRes | null;
    updatedAt: string;
    createdAt: string;
    relationId: {
        [key: string]: unknown;
    };
};

export type AddressDto = {
    country: string;
    street: string;
    city: string;
    houseNumber: string;
    postCode: string;
};

export type ControllingPartyTaxResidenceDto = {
    taxResidency: string;
    tin?: string;
};

export const PersonRelationType = {
    PIV: 'PIV',
    REPRESENTATIVE: 'REPRESENTATIVE',
    UBO: 'UBO',
    PSC: 'PSC',
    DIRECTOR: 'DIRECTOR',
    TRUSTEE: 'TRUSTEE',
    SETTLER_OR_GRANTOR: 'SETTLER_OR_GRANTOR',
    PROTECTOR_OR_ENFORCER: 'PROTECTOR_OR_ENFORCER',
    BENEFICIARY: 'BENEFICIARY',
    OTHER: 'OTHER'
} as const;

export type PersonRelationType = typeof PersonRelationType[keyof typeof PersonRelationType];

export type ControllingPartyDto = {
    relationId?: string;
    personId?: string;
    email: string;
    firstName: string;
    lastName: string;
    dateOfBirth?: string;
    placeOfBirth?: string;
    countryOfBirth?: string;
    citizenship?: Array<string>;
    address?: AddressDto;
    taxResidences: Array<ControllingPartyTaxResidenceDto>;
    relationshipType: PersonRelationType;
    customRelationType?: string;
};

export type InvestorProcessSettingsDto = {
    areMorePivDocsRequested: boolean;
    morePivDocsRequestedComment: string;
};

export const InvestmentStatus = {
    NOT_SENT_OUT: 'NOT_SENT_OUT',
    AWAITING_INVESTOR: 'AWAITING_INVESTOR',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    PENDING_RELEASE: 'PENDING_RELEASE',
    COMPLETED: 'COMPLETED'
} as const;

export type InvestmentStatus = typeof InvestmentStatus[keyof typeof InvestmentStatus];

export const ProgrammeStatus = {
    JOINER: 'JOINER',
    HOLDER: 'HOLDER',
    LEAVER: 'LEAVER',
    INACTIVE: 'INACTIVE'
} as const;

export type ProgrammeStatus = typeof ProgrammeStatus[keyof typeof ProgrammeStatus];

export type DealTct = {
    id: string;
};

export type MipTct = {
    id: string;
    deal: DealTct;
};

export type BankAccountIdentifierRes = {
    /**
     * BankAccountIdentifier key, e.g. sort_code
     */
    key: string;
    /**
     * Display label for the key, e.g. Sort code
     */
    label: string;
    value: string;
    /**
     * BankAccountFormatRule the value was entered under; null = classic entry
     */
    bankAccountFormatRuleId: string | null;
};

export type BankAccountRes = {
    id: string;
    accountHolder: string | null;
    bankName: string | null;
    accountNumber: string | null;
    iban: string | null;
    swiftCode: string | null;
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode: string | null;
    currency: CurrencyType | null;
    status: BankAccountStatus;
    /**
     * Live identifier rows, including format-specific keys
     */
    identifiers: Array<BankAccountIdentifierValueRes>;
    updatedAt: string;
};

export type DataPersonWithBankAccountsRes = {
    id: string;
    dateOfBirth: string | null;
    deleted: boolean;
    email: string | null;
    firstName?: string | null;
    displayName: string;
    gender: Gender | null;
    lastName?: string | null;
    userId: string | null;
    phoneNumber: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    citizenship: Array<string>;
    domicile: string | null;
    tags: Array<LegalPersonTags> | null;
    hasNomineeStructure: boolean;
    telephonePrefix: string | null;
    type: PersonType;
    providerDetailsFriendlyName: string | null;
    providerDetailsLegalForm: string | null;
    personRegistrationDetailsId: string | null;
    securities?: Array<DataSecurityTct>;
    addresses?: Array<AddressRes>;
    registrationDetails: RegistrationDetailsRes | null;
    updatedAt: string;
    createdAt: string;
    bankAccounts: Array<BankAccountRes>;
};

export type DataShareholderInvestorWithPersonRes = {
    id: string;
    mipId: string;
    state: InvestorState;
    user: DataUserInvestorTct;
    completionStep: InvestmentWorkflowCompletionStep | null;
    pivPerson?: DataPersonTct | null;
    draftPivPerson?: DataPersonTct | null;
    representativePerson?: DataShareholderInvestorRepresentativeRes | null;
    draftRepresentativePerson?: DataPersonTct | null;
    controllingParties?: Array<ControllingPartyDto>;
    isRepresentativeSameAsUser: boolean;
    processSettings: InvestorProcessSettingsDto | null;
    totalHoldings: number | null;
    totalPending: number | null;
    totalSecurities: number | null;
    investmentStatus: InvestmentStatus;
    programmeStatus: ProgrammeStatus;
    mip: MipTct;
    person: DataPersonWithBankAccountsRes | null;
    personId: string;
};

export type DataShareholderInvestorTct = {
    id: string;
    mipId: string;
    state: InvestorState;
    user: DataUserInvestorTct;
    completionStep: InvestmentWorkflowCompletionStep | null;
    pivPerson?: DataPersonTct | null;
    draftPivPerson?: DataPersonTct | null;
    representativePerson?: DataShareholderInvestorRepresentativeRes | null;
    draftRepresentativePerson?: DataPersonTct | null;
    controllingParties?: Array<ControllingPartyDto>;
    isRepresentativeSameAsUser: boolean;
    processSettings: InvestorProcessSettingsDto | null;
    totalHoldings: number | null;
    totalPending: number | null;
    totalSecurities: number | null;
    investmentStatus: InvestmentStatus;
    programmeStatus: ProgrammeStatus;
    mip: MipTct;
};

export const DocumentWorkflowInstanceStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
    EXPIRED: 'EXPIRED',
    PENDING_ADDITIONAL_SIGNATURES: 'PENDING_ADDITIONAL_SIGNATURES',
    PENDING_FORM_SUBMISSION: 'PENDING_FORM_SUBMISSION',
    REJECTED: 'REJECTED'
} as const;

export type DocumentWorkflowInstanceStatus = typeof DocumentWorkflowInstanceStatus[keyof typeof DocumentWorkflowInstanceStatus];

export type GetUserInvestmentDocumentsRes = {
    id: string;
    fileId: string;
    name: string;
    createdDate: string;
    dealId: string;
    status: DocumentWorkflowInstanceStatus;
};

export type GetInvestorDealDocumentsRes = {
    id: string;
    fileId: string;
    name: string;
    dealId: string;
    /**
     * Deal name, so the portal can group documents without a second round trip
     */
    dealName: string;
    createdDate: string;
};

export type PutShareholderInvestorDto = {
    firstName: string;
    lastName: string;
    birthDate: string;
    addressId: {
        [key: string]: unknown;
    };
    country: string;
    street: string;
    city: string;
    houseNumber: string;
    postCode: string;
    phoneNumber: string;
    telephonePrefix: string;
};

export type LegalRepresentativeDto = {
    firstName: string;
    lastName: string;
    email: string;
    relationId: string;
};

export type PersonalInvestmentVehicleDto = {
    pivName: string;
    corporateRegistrationNumber: string;
    address: AddressDto;
};

export type PatchShareholderInvestorVehicleDataDto = {
    draftPivId?: string;
    /**
     * The standalone KYC workflow this answer belongs to. Sent by the standalone journey, which otherwise cannot be told apart from the joiner: both post here, and an investor can have an open investment and a standalone KYC at once. Rejected unless it is the caller’s own open standalone workflow on this programme.
     */
    kycWorkflowId?: string;
    controllingParties?: Array<ControllingPartyDto>;
    legalRepresentative?: LegalRepresentativeDto;
    personalInvestmentVehicle?: PersonalInvestmentVehicleDto;
};

export type PatchShareholderInvestorCompletionStepDto = {
    step: InvestmentWorkflowCompletionStep;
};

export type LoanForTransactionRes = {
    name: string;
    funder: string;
};

export type InvestorTransactionSummaryRes = {
    cost: number;
    number: number | null;
    investmentWorkflowUpdatedAt: string;
    isNegative: boolean | null;
    isCompleted: boolean;
    currency: CurrencyType;
    securityId: string | null;
    securityIssuerDisplayName: string | null;
    securityName: string | null;
    securityUnitDenominator: number | null;
    securityIssuedIn: SecurityIssuedIn | null;
    loan: LoanForTransactionRes | null;
};

export type GetInvestorTransactionsRes = {
    transactions: Array<InvestorTransactionSummaryRes>;
};

export type CreateSimplePersonNaturalDto = {
    firstName: string;
    lastName: string;
};

export type PersonNaturalRes = {
    id: string;
    addresses?: Array<AddressRes>;
    dateOfBirth?: string;
    hasInvalidTransactions: boolean;
    deleted: boolean;
    email?: string;
    firstName: string;
    displayName?: string;
    gender?: Gender;
    lastName?: string;
    pgUserId?: string;
    phoneNumber?: string;
    placeOfBirth?: string;
    tags?: Array<LegalPersonTags>;
    telephonePrefix?: string;
    type: PersonType;
    providerDetailsFriendlyName?: string;
    providerDetailsLegalForm?: string;
    personRegistrationDetailsId?: string;
    createdAt: string;
    updatedAt: string;
    entityCurrency?: {
        [key: string]: unknown;
    };
};

export type CreatePersonLegalDto = {
    name: string;
    jurisdiction?: JurisdictionRes;
    selectedJurisdictionLanguage?: string;
    legalForm?: {
        [key: string]: unknown;
    };
    corporateRegistrationNumber?: string;
};

export type PersonLegalRes = {
    id: string;
    deleted: boolean;
    displayName: string;
    gender?: Gender;
    pgUserId: string;
    tags?: Array<LegalPersonTags>;
    hasNomineeStructure: boolean;
    createdAt: string;
    updatedAt: string;
    type: PersonType;
    hasInvalidTransactions: boolean;
    addresses?: Array<AddressRes>;
    registrationDetails: RegistrationDetailsRes;
    entityCurrency?: {
        [key: string]: unknown;
    };
};

export type UpdateRegistrationDetails = {
    jurisdictionName?: string;
    selectedJurisdictionLanguage?: string;
    legalFormId?: string;
    corporateRegistrationNumber?: string;
    name: string;
};

export type UpdatePersonDto = {
    displayName?: string;
    tags?: Array<LegalPersonTags>;
    hasNomineeStructure?: boolean;
    registrationDetails?: UpdateRegistrationDetails;
};

export type UpdateNaturalPersonDto = {
    firstName: string;
    lastName: string;
    displayName?: string;
    dateOfBirth?: string;
    phoneNumber?: string;
    telephonePrefix?: string;
    countryOfBirth?: string;
    placeOfBirth?: string;
    citizenship?: Array<string>;
    domicile?: string;
};

export type UpdateNaturalPersonEmailDto = {
    email: string;
};

export type PersonByEmailLookupAddressRes = {
    country: string;
    city: string;
    postCode: string;
    street: string;
    houseNumber: string;
};

export type PersonByEmailLookupTaxResidenceRes = {
    taxResidency: string;
    tin: string | null;
};

export type PersonByEmailLookupRes = {
    found: boolean;
    firstName: {
        [key: string]: unknown;
    } | null;
    lastName: {
        [key: string]: unknown;
    } | null;
    dateOfBirth: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    citizenship: Array<string> | null;
    address: PersonByEmailLookupAddressRes | null;
    taxResidences: Array<PersonByEmailLookupTaxResidenceRes> | null;
};

export type PersonNameWithIdRes = {
    id: string;
    displayName: {
        [key: string]: unknown;
    } | null;
};

export type GetPersonByIdRes = {
    id: string;
    dateOfBirth: {
        [key: string]: unknown;
    } | null;
    deleted: boolean;
    email: {
        [key: string]: unknown;
    } | null;
    firstName: {
        [key: string]: unknown;
    } | null;
    displayName: string;
    gender: Gender | null;
    lastName: {
        [key: string]: unknown;
    } | null;
    phoneNumber: {
        [key: string]: unknown;
    } | null;
    countryOfBirth: {
        [key: string]: unknown;
    } | null;
    placeOfBirth: {
        [key: string]: unknown;
    } | null;
    domicile: {
        [key: string]: unknown;
    } | null;
    citizenship: Array<{
        [key: string]: unknown;
    }> | null;
    tags?: Array<LegalPersonTags>;
    hasNomineeStructure: boolean;
    addresses?: Array<AddressRes>;
    registrationDetails?: RegistrationDetailsRes;
    telephonePrefix: {
        [key: string]: unknown;
    } | null;
    type: PersonType;
    updatedAt: string;
    createdAt: string;
    hasInvalidTransactions?: boolean;
    hasSecurities?: boolean;
    canIssueSecurities?: boolean;
    providerDetailsFriendlyName: {
        [key: string]: unknown;
    } | null;
    providerDetailsLegalForm: {
        [key: string]: unknown;
    } | null;
    personRegistrationDetailsId: {
        [key: string]: unknown;
    } | null;
    entityCurrency?: CurrencyType | null;
    pgInvestorId?: string;
    isFunder?: boolean;
    representative?: PersonNameWithIdRes | null;
    userId: {
        [key: string]: unknown;
    } | null;
};

export type GetPersonTaxInformationRes = {
    id: string;
    countryCode: string;
    personId: string;
    authority: string | null;
    number: string | null;
};

export type RelatedPersonRes = {
    id: string;
    displayName: string | null;
    relationId: string;
    email: string | null;
    customRelationType: string | null;
    taxResidence: Array<GetPersonTaxInformationRes>;
};

export type GetRelatedPeopleForPerson = {
    PIV: Array<RelatedPersonRes>;
    REPRESENTATIVE: Array<RelatedPersonRes>;
    UBO: Array<RelatedPersonRes>;
    PSC: Array<RelatedPersonRes>;
    DIRECTOR: Array<RelatedPersonRes>;
    TRUSTEE: Array<RelatedPersonRes>;
    SETTLER_OR_GRANTOR: Array<RelatedPersonRes>;
    PROTECTOR_OR_ENFORCER: Array<RelatedPersonRes>;
    BENEFICIARY: Array<RelatedPersonRes>;
    OTHER: Array<RelatedPersonRes>;
};

export type NamesOfPersonWithRelation = {
    id: string;
    displayName: string | null;
};

export type CreatePersonRelatedPeopleDto = {
    type: PersonRelationType;
    customRelationType?: string;
    personIds: Array<string>;
    createLegalRepresentative?: boolean;
};

export type AddRelatedPersonByEmailDto = {
    email: string;
    firstName?: string;
    lastName?: string;
    relationType: PersonRelationType;
    customRelationType?: string;
};

export type UpdateRelatedPersonRelationDto = {
    type: PersonRelationType;
    customRelationType?: string;
    createLegalRepresentative?: boolean;
};

export type DeletePersonRelatedPersonDto = {
    relationType: PersonRelationType;
    relatedPersonId: string;
};

export type GetPersonForCapRes = {
    id: string;
    computedName: string;
    type: PersonType;
    jurisdictionCountryCode?: string;
    corporateRegistrationNumber?: string;
    tags: Array<LegalPersonTags>;
    hasSecuritiesWithInvalidTransactions: boolean;
};

export type PersonTagRes = {
    name: LegalPersonTags;
    count: number;
};

export type IsInvestmentWorkflowExistsRes = {
    isTsaExist: boolean;
};

export type BulkCreateLegalPersonDto = {
    name: string;
    corporateRegistrationNumber?: string;
};

export type BulkUploadPersonLegalsDto = {
    persons: Array<BulkCreateLegalPersonDto>;
};

export type CreatePersonTaxInformationDto = {
    countryCode: string;
    number: string | null;
    authority: string | null;
};

export type BulkCreateNaturalPersonEmploymentDto = {
    /**
     * Display name of an existing legal person in the deal
     */
    employerName: string;
    /**
     * The employee's identifier at the employer.
     */
    employeeReference?: string;
    startDate?: string;
    endDate?: string;
    jobTitle?: string;
};

export type BulkCreateNaturalPersonDto = {
    firstName: string;
    lastName: string;
    email?: string;
    phoneNumber?: string;
    dateOfBirth?: string;
    placeOfBirth?: string;
    countryOfBirth?: string;
    citizenship?: Array<Array<unknown>>;
    taxResidence?: CreatePersonTaxInformationDto;
    employment?: BulkCreateNaturalPersonEmploymentDto;
};

export type BulkUploadPersonNaturalDto = {
    persons: Array<BulkCreateNaturalPersonDto>;
};

export type CreatePersonAddressDto = {
    country?: string;
    tags?: Array<AddressTag>;
    houseNumber?: string;
    postCode?: string;
    street?: string;
    city?: string;
};

export type UpdatePersonAddressDto = {
    id: string;
    country?: string;
    tags?: Array<AddressTag>;
    houseNumber?: string;
    postCode?: string;
    street?: string;
    city?: string;
};

export type IsPersonEmailInUseRes = {
    isEmailInUse: boolean;
};

export type BankAccountIdentifierEntryDto = {
    /**
     * BankAccountIdentifier key, e.g. sort_code
     */
    key: string;
    /**
     * Raw value; empty clears the identifier
     */
    value: string;
};

export type CreatePersonBankAccountDto = {
    accountHolder?: string;
    bankName?: string;
    accountNumber?: string;
    swiftCode?: string;
    iban?: string;
    currency?: CurrencyType;
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode?: {
        [key: string]: unknown;
    } | null;
    /**
     * BankAccountFormatRule the identifiers were entered against
     */
    formatRuleId?: string;
    identifiers?: Array<BankAccountIdentifierEntryDto>;
};

export type VerifyBankIdentifierEntryDto = {
    /**
     * BankAccountIdentifier key, e.g. routing_number
     */
    key: string;
    /**
     * Raw value as entered in the form
     */
    value: string;
};

export type VerifyBankIdentifiersDto = {
    /**
     * Format rule whose validationType decides the verification; omitted = classic IBAN flow
     */
    formatRuleId?: string;
    identifiers: Array<VerifyBankIdentifierEntryDto>;
};

export const BankDataLookupOutcome = {
    SUCCESS: 'SUCCESS',
    INVALID: 'INVALID',
    UNAVAILABLE: 'UNAVAILABLE'
} as const;

export type BankDataLookupOutcome = typeof BankDataLookupOutcome[keyof typeof BankDataLookupOutcome];

export const BankIdentifierValidationType = {
    NONE: 'NONE',
    IBAN: 'IBAN',
    BIC: 'BIC',
    ABA_ROUTING: 'ABA_ROUTING',
    CA_ROUTING: 'CA_ROUTING',
    SORT_CODE: 'SORT_CODE'
} as const;

export type BankIdentifierValidationType = typeof BankIdentifierValidationType[keyof typeof BankIdentifierValidationType];

export type VerifyBankIdentifiersRes = {
    outcome: BankDataLookupOutcome;
    validationType: BankIdentifierValidationType;
    message?: {
        [key: string]: unknown;
    } | null;
    bankName?: {
        [key: string]: unknown;
    } | null;
    bic?: {
        [key: string]: unknown;
    } | null;
    bankAddress?: {
        [key: string]: unknown;
    } | null;
    city?: {
        [key: string]: unknown;
    } | null;
    state?: {
        [key: string]: unknown;
    } | null;
    /**
     * Country the verified identifier belongs to (from the identifier itself)
     */
    countryCode?: {
        [key: string]: unknown;
    } | null;
    accountNumber?: {
        [key: string]: unknown;
    } | null;
    bban?: {
        [key: string]: unknown;
    } | null;
    routingNumber?: {
        [key: string]: unknown;
    } | null;
    achSupported?: {
        [key: string]: unknown;
    } | null;
    fedwireSupported?: {
        [key: string]: unknown;
    } | null;
};

export type GetPersonInvestmentProgrammesRes = {
    id: string;
    entityId: {
        [key: string]: unknown;
    } | null;
    programmeName: {
        [key: string]: unknown;
    } | null;
    isInvestor: boolean;
    isIssuer: boolean;
    isLoanFunder: boolean;
    isPivSource: boolean;
};

export type SummaryMipNameTct = {
    id: string;
    programmeName: {
        [key: string]: unknown;
    } | null;
};

export const TransactionType = {
    TRANSFER: 'TRANSFER',
    ISSUE: 'ISSUE',
    REDEMPTION: 'REDEMPTION',
    CANCELLATION: 'CANCELLATION',
    ISSUE_SPLIT: 'ISSUE_SPLIT',
    REDEMPTION_REVERSE_SPLIT: 'REDEMPTION_REVERSE_SPLIT',
    TRANSFER_CONVERSION: 'TRANSFER_CONVERSION',
    SHAREHOLDER_CONTRIBUTION: 'SHAREHOLDER_CONTRIBUTION',
    REDUCTION_IN_SHARE_CAPITAL: 'REDUCTION_IN_SHARE_CAPITAL',
    CONVERSION_SHARE_CAPITAL: 'CONVERSION_SHARE_CAPITAL',
    DIVIDEND: 'DIVIDEND',
    VESTING_EVENT: 'VESTING_EVENT'
} as const;

export type TransactionType = typeof TransactionType[keyof typeof TransactionType];

export const TransactionTitle = {
    LEGAL_TITLE: 'LEGAL_TITLE',
    BENEFICIAL_INTEREST: 'BENEFICIAL_INTEREST',
    BENEFICIAL_INTEREST_AND_LEGAL_TITLE: 'BENEFICIAL_INTEREST_AND_LEGAL_TITLE'
} as const;

export type TransactionTitle = typeof TransactionTitle[keyof typeof TransactionTitle];

export type InterestPairSiblingRes = {
    id: string;
    type?: TransactionType;
    title?: TransactionTitle;
    date?: string;
    units?: number;
    programmeManaged: boolean;
    isSelf: boolean;
    hasBuyerHolding: boolean;
};

export const TransactionThresholdExpressedAs = { TOTAL_VALUE_IN_TIER: 'TOTAL_VALUE_IN_TIER', VALUE_PER_UNIT: 'VALUE_PER_UNIT' } as const;

export type TransactionThresholdExpressedAs = typeof TransactionThresholdExpressedAs[keyof typeof TransactionThresholdExpressedAs];

export type DataSecurityWithIssuerTct = {
    id: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    nominalValue?: number;
    fairMarketValuePerUnit?: number;
    votesPerUnit?: number;
    issuerId: string;
    loanDefinitionId?: string;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    residueRights: boolean;
    includeInReturns: boolean;
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis?: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string;
    issuedIn: SecurityIssuedIn;
    hasNomineeStructure: boolean;
    equityBasis?: SecurityEquityBasis;
    unitDenominator: number;
    authorisedCapital?: number;
    incomeType?: IncomeType | null;
    issuer: DataPersonTct;
    hasExchangeRights?: boolean;
};

export type GetTransactionRes = {
    id: string;
    date: string;
    securityId: string;
    destinationId?: string;
    sourceId?: string;
    fromMipId?: string;
    soldForId?: string;
    boughtForId?: string;
    order?: number;
    pgSaId?: string;
    toMipId?: string;
    type?: TransactionType;
    title?: TransactionTitle;
    interestPairId?: string;
    redemptionGroupId?: string;
    interestPairSibling?: InterestPairSiblingRes;
    createdAt: string;
    updatedAt: string;
    isTransactionValid?: boolean;
    transactionError?: string;
    isPossibleRedemption?: boolean;
    originalTransactionBeforeSplitId?: string;
    sourcePgTsaId?: string;
    destinationPgTsaId?: string;
    transactionOneBeforePairId?: string;
    transactionTwoBeforePairId?: string;
    participationThresholdExpressedAs: TransactionThresholdExpressedAs;
    participationThreshold?: number;
    units?: number;
    cost?: number;
    sourceBalanceStrict?: number;
    sourceBalanceNonStrict?: number;
    destBalanceStrict?: number;
    destBalanceNonStrict?: number;
    deleted: boolean;
    security?: DataSecurityWithIssuerTct;
    conversionTargetSecurityId?: string;
    sourcePersonName?: string;
    destinationPersonName?: string;
    soldForPersonName?: string;
    boughtForPersonName?: string;
    securityName?: string;
    securityUnitDenominator: number;
    buyerMipName?: string;
    sellerMipName?: string;
    /**
     * Count of transactions on the same date for this entity
     */
    transactionsOnSameDateCount?: number;
};

export type GetPersonMipOpenTsaWarningRes = {
    hasOpenTsa: boolean;
};

export type EmploymentRecordRes = {
    id: string;
    employeeId: string;
    employerId: string;
    startDate?: string | null;
    endDate?: string | null;
    jobTitle?: string | null;
    employeeReference?: string | null;
    isPrimaryForEmployee: boolean;
    createdAt: string;
    updatedAt: string;
};

export type CreateEmploymentRecordDto = {
    /**
     * The natural person being employed
     */
    employeeId: string;
    /**
     * The legal person (employer)
     */
    employerId: string;
    startDate?: string;
    endDate?: string;
    jobTitle?: string;
    /**
     * The employee's identifier at the employer.
     */
    employeeReference?: string;
    /**
     * Marks this record as the primary employment for the employee; any other primary record is demoted.
     */
    isPrimaryForEmployee?: boolean;
};

export type PersonEmploymentRes = {
    id: string;
    employerName: string;
    employeeReference?: string | null;
    isPrimaryForEmployee: boolean;
};

export type UpsertPersonEmploymentDto = {
    /**
     * Employer name; matched to a legal person in the deal by name, or created.
     */
    employerName: string;
    /**
     * The employee's identifier at the employer.
     */
    employeeReference: string;
};

export type EmploymentEmployerRes = {
    id: string;
    displayName: string;
};

export type UpdateEmploymentRecordDto = {
    startDate?: string | null;
    endDate?: string | null;
    jobTitle?: string | null;
    employeeReference?: string | null;
    /**
     * Marks this record as the primary employment for the employee; any other primary record is demoted.
     */
    isPrimaryForEmployee?: boolean;
};

export type ValidateTinDto = {
    tin: string;
    /**
     * two-letter country code
     */
    countryCode: string;
};

export type ValidateTinRes = {
    isValid: boolean;
    /**
     * Validated tax number
     */
    tin: string;
    /**
     * Type of tax number
     */
    tinType: string;
};

export const VestingTermType = { STRAIGHT_LINE: 'STRAIGHT_LINE', GRADED: 'GRADED' } as const;

export type VestingTermType = typeof VestingTermType[keyof typeof VestingTermType];

export const VestingMode = { VALUE: 'VALUE', PHYSICAL: 'PHYSICAL' } as const;

export type VestingMode = typeof VestingMode[keyof typeof VestingMode];

export const VestingTermTimeUnitType = { MONTHLY: 'MONTHLY', YEARLY: 'YEARLY' } as const;

export type VestingTermTimeUnitType = typeof VestingTermTimeUnitType[keyof typeof VestingTermTimeUnitType];

export type VestingTermGradedRes = {
    id: string;
    vestingTermId: string;
    percentage: number;
    duration: number;
    durationTimeUnit: VestingTermTimeUnitType;
    order: number;
};

export type VestingTermStraightLineRes = {
    id: string;
    vestingTermId: string;
    period: number;
    periodTimeUnit: VestingTermTimeUnitType;
    interval: number;
    cliff: {
        [key: string]: unknown;
    } | null;
};

export const VestingTermLeaverProvisionType = {
    GOOD_LEAVER: 'GOOD_LEAVER',
    INTERMEDIATE_LEAVER: 'INTERMEDIATE_LEAVER',
    BAD_LEAVER: 'BAD_LEAVER'
} as const;

export type VestingTermLeaverProvisionType = typeof VestingTermLeaverProvisionType[keyof typeof VestingTermLeaverProvisionType];

export const VestingTermPurchaseTermsType = {
    PURCHASE_PRICE: 'PURCHASE_PRICE',
    FAIR_MARKET: 'FAIR_MARKET',
    LOWER_PRICE: 'LOWER_PRICE',
    HIGHER_PRICE: 'HIGHER_PRICE',
    PURCHASE_PRICE_DISCOUNT: 'PURCHASE_PRICE_DISCOUNT',
    FAIR_MARKET_DISCOUNT: 'FAIR_MARKET_DISCOUNT'
} as const;

export type VestingTermPurchaseTermsType = typeof VestingTermPurchaseTermsType[keyof typeof VestingTermPurchaseTermsType];

export type VestingTermLeaverProvisionRes = {
    id: string;
    vestingTermId: string;
    type: VestingTermLeaverProvisionType;
    vestedSharesPercentage: number;
    vestedPurchaseTerms: VestingTermPurchaseTermsType;
    unvestedSharesPercentage: number;
    unvestedPurchaseTerms: VestingTermPurchaseTermsType;
};

export const PerformanceVestingMetricType = {
    MOIC: 'MOIC',
    XIRR: 'XIRR',
    MOIC_AND_XIRR: 'MOIC_AND_XIRR'
} as const;

export type PerformanceVestingMetricType = typeof PerformanceVestingMetricType[keyof typeof PerformanceVestingMetricType];

export type PerformanceVestingHurdleRes = {
    id: string;
    performanceVestingTermId: string;
    order: number;
    moicThreshold: {
        [key: string]: unknown;
    } | null;
    xirrThreshold: {
        [key: string]: unknown;
    } | null;
    incrementalPercentage: number;
    cumulativePercentage?: number;
};

export type PerformanceVestingMeasurementSubjectRes = {
    id: string;
    performanceVestingTermId: string;
    personId: string;
};

export type PerformanceVestingTermRes = {
    id: string;
    vestingTermId: string;
    metricType: PerformanceVestingMetricType;
    hurdles: Array<PerformanceVestingHurdleRes>;
    measurementSubjects: Array<PerformanceVestingMeasurementSubjectRes>;
};

export type VestingTermRes = {
    id: string;
    mipId: string | null;
    organizationId: string | null;
    name: string;
    type: VestingTermType;
    vestingMode: VestingMode;
    timeBasedPercentage: number;
    performancePercentage: number;
    unvestedPercentage: number;
    optionPeriod: number;
    optionPeriodTimeUnit: VestingTermTimeUnitType;
    hasLiveTransactions: boolean;
    vestingTermGraded: Array<VestingTermGradedRes>;
    vestingTermStraightLine?: VestingTermStraightLineRes;
    vestingTermLeaverProvisions: Array<VestingTermLeaverProvisionRes>;
    performanceVestingTerm?: PerformanceVestingTermRes;
};

export type VestingTermSimplifiedRes = {
    id: string;
    mipId: string | null;
    organizationId: string | null;
    name: string;
    type: VestingTermType;
    vestingMode: VestingMode;
    timeBasedPercentage: number;
    performancePercentage: number;
    unvestedPercentage: number;
    optionPeriod: number;
    optionPeriodTimeUnit: VestingTermTimeUnitType;
    hasLiveTransactions: boolean;
};

export type CreateVestingTermDto = {
    type: VestingTermType;
    name: string;
    timeBasedPercentage: number;
    performancePercentage: number;
    vestingMode: VestingMode;
    optionPeriod: number;
    optionPeriodTimeUnit: VestingTermTimeUnitType;
};

export type ApplyVestingStartDateDto = {
    startDate: string | null;
};

export type SaveTransactionVestingDto = {
    startDate: string | null;
    vestingTermId: string;
};

export type ApplyVestingTermDto = {
    vestingTermId: string;
    investmentWorkflowId: string;
};

export type ApplyVestingTermToTransactionDto = {
    vestingTermId: string;
    transactionId: string;
};

export type RemoveVestingTermDto = {
    investmentWorkflowId: string;
};

export type RemoveVestingTermFromTransactionDto = {
    transactionId: string;
};

export const LoanDefinitionType = { MANAGEMENT_LOAN: 'MANAGEMENT_LOAN', DEFERRED_PAYMENT: 'DEFERRED_PAYMENT' } as const;

export type LoanDefinitionType = typeof LoanDefinitionType[keyof typeof LoanDefinitionType];

export const InvestmentWorkflowStatus = {
    OPEN: 'OPEN',
    DEFINITION_COMPLETE: 'DEFINITION_COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETE: 'COMPLETE',
    RELEASED: 'RELEASED'
} as const;

export type InvestmentWorkflowStatus = typeof InvestmentWorkflowStatus[keyof typeof InvestmentWorkflowStatus];

export const AccountStatus = {
    NOT_INVITED: 'NOT_INVITED',
    INIVITED: 'INIVITED',
    ACTIVE: 'ACTIVE'
} as const;

export type AccountStatus = typeof AccountStatus[keyof typeof AccountStatus];

export type RangeFilter = {
    min?: number;
    max?: number;
};

export const InvestorEligibilityFilter = {
    RELEASE: 'release',
    INVITE: 'invite',
    ALLOCATION: 'allocation',
    LEAVER: 'leaver'
} as const;

export type InvestorEligibilityFilter = typeof InvestorEligibilityFilter[keyof typeof InvestorEligibilityFilter];

export type CustomDetailFilterDto = {
    customDetailId: string;
    text?: string;
    boolean?: boolean;
};

export type InvestorsFilterQuery = {
    documentWorkflowIds?: Array<string>;
    securityTypes?: Array<SecurityType>;
    loanDefinitionTypes?: Array<LoanDefinitionType>;
    investorIds?: Array<string>;
    investmentStatuses?: Array<InvestmentWorkflowStatus>;
    accountStatuses?: Array<AccountStatus>;
    programmeStatuses?: Array<ProgrammeStatus>;
    totalHoldings?: RangeFilter;
    totalPending?: RangeFilter;
    pivPersonsIds?: Array<string>;
    mipClassifierIds?: Array<string>;
    eligibilityFilter?: InvestorEligibilityFilter;
    hasActiveInvestmentWorkflow?: boolean;
    customDetailFilters?: Array<CustomDetailFilterDto>;
    countryOfBirth?: string;
    taxResidenceSearch?: string;
    citizenships?: Array<string>;
    employeeIdSearch?: string;
};

export type BulkUpdateInvestorsVestingDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
    vestingTermId: string | null;
    startDate: string | null;
};

export type UpdateVestingTermDto = {
    type?: VestingTermType;
    name?: string;
    timeBasedPercentage?: number;
    performancePercentage?: number;
    vestingMode?: VestingMode;
    optionPeriod?: number;
    optionPeriodTimeUnit?: VestingTermTimeUnitType;
};

export type CreateVestingTermGradedDto = {
    percentage: number;
    duration: number;
    durationTimeUnit: VestingTermTimeUnitType;
    order?: number;
    vestingTermId: string;
};

export type UpdateVestingTermGradedDto = {
    percentage: number;
    duration: number;
    durationTimeUnit: VestingTermTimeUnitType;
    order?: number;
};

export type CreateVestingTermStraightLineDto = {
    period: number;
    periodTimeUnit: VestingTermTimeUnitType;
    interval: number;
    cliff?: number;
    vestingTermId: string;
};

export type UpdateVestingTermStraightLineDto = {
    period: number;
    periodTimeUnit: VestingTermTimeUnitType;
    interval: number;
    cliff?: number;
};

export type CreateVestingTermLeaverProvisionDto = {
    type: VestingTermLeaverProvisionType;
    vestedSharesPercentage: number;
    vestedPurchaseTerms: VestingTermPurchaseTermsType;
    unvestedSharesPercentage: number;
    unvestedPurchaseTerms: VestingTermPurchaseTermsType;
    vestingTermId: string;
};

export type UpdateVestingTermLeaverProvisionDto = {
    type: VestingTermLeaverProvisionType;
    vestedSharesPercentage: number;
    vestedPurchaseTerms: VestingTermPurchaseTermsType;
    unvestedSharesPercentage: number;
    unvestedPurchaseTerms: VestingTermPurchaseTermsType;
};

export type PerformanceVestingHurdleEntryDto = {
    moicThreshold?: number;
    xirrThreshold?: number;
    incrementalPercentage: number;
};

export type UpsertPerformanceVestingDto = {
    vestingTermId: string;
    metricType: PerformanceVestingMetricType;
    measurementSubjectPersonIds?: Array<string>;
    hurdles?: Array<PerformanceVestingHurdleEntryDto>;
};

export type BankAccountSupportedCountryRes = {
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode: string;
    countryName: string;
};

export const VerificationScheme = {
    COP: 'COP',
    VOP: 'VOP',
    NONE: 'NONE'
} as const;

export type VerificationScheme = typeof VerificationScheme[keyof typeof VerificationScheme];

export type BankAccountFormatFieldRes = {
    /**
     * BankAccountIdentifier key this field maps to
     */
    key: string;
    label: string;
    required: boolean;
    /**
     * Validation regex for the value
     */
    pattern?: string;
    placeholder?: string;
    options?: Array<string>;
    /**
     * Fixed, non-editable value prescribed by the format (e.g. BR account type)
     */
    value?: string;
};

export type BankAccountFormatRuleRes = {
    id: string;
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode: string;
    formatName: string;
    verificationScheme: VerificationScheme;
    validationType: BankIdentifierValidationType;
    fields: Array<BankAccountFormatFieldRes>;
    displayOrder: number;
};

export const OneSchemaTemplateKey = {
    CAP_TRANSACTIONS_UPLOAD: 'cap_transactions_upload',
    CAP_TRANSACTIONS_UPLOAD_COMPLEX: 'cap_transactions_upload_complex',
    CAP_SECURITIES_UPLOAD: 'cap_securities_upload',
    UPLOAD_MANAGEMENT_LOANS: 'upload_management_loans',
    UPLOAD_NATURAL_PERSONS: 'upload_natural_persons',
    UPLOAD_LEGAL_PERSONS: 'upload_legal_persons',
    UPSERT_ALLOCATIONS: 'upsert_allocations'
} as const;

export type OneSchemaTemplateKey = typeof OneSchemaTemplateKey[keyof typeof OneSchemaTemplateKey];

export type CreateOneSchemaTransactionsSessionDto = {
    oneSchemaJwt: string;
    oneSchemaClientId: string;
    oneSchemaTemplateKey: OneSchemaTemplateKey;
    selectedEntityId: string;
    dealId: string;
};

export type CreateOneSchemaSessionSuccessRes = {
    id: number;
    status: string;
    token: string;
    user_jwt: string;
    message: string;
    error: string;
};

export type OneSchemaValidateDto = {
    [key: string]: unknown;
};

export type OneSchemaInvalidRowRes = {
    row_id: number;
    column: string;
    column_index?: number;
    severity: string;
    message: string;
};

export type CreateOneSchemaPersonSessionDto = {
    oneSchemaJwt: string;
    oneSchemaClientId: string;
    oneSchemaTemplateKey: OneSchemaTemplateKey;
    dealId: string;
};

export type OneSchemaLegalPersonRowValueDto = {
    name: string;
    reg_number: string;
};

export type OneSchemaNaturalPersonRowValueDto = {
    first_name: string;
    last_name: string;
    email_address?: string;
    phone_number?: string;
    date_of_birth?: string;
    country_of_birth?: string;
    place_of_birth?: string;
    nationality?: string;
    tax_residence?: string;
    tax_number?: string;
    employer?: string;
    employee_id?: string;
    employment_start_date?: string;
    employment_end_date?: string;
    job_title?: string;
};

export type PrepareOneSchemaManagementLoansCacheDto = {
    dealId: string;
    funderId: string;
    userJwt: string;
};

export const OneSchemaManagementLoanTransactionType = { WITHDRAWAL: 'withdrawal', REPAYMENT: 'repayment' } as const;

export type OneSchemaManagementLoanTransactionType = typeof OneSchemaManagementLoanTransactionType[keyof typeof OneSchemaManagementLoanTransactionType];

export type OneSchemaManagementLoanRowValueDto = {
    loan_definition_name: string;
    investor_full_name: string;
    investment_vehicle_name?: string;
    transaction_date: string;
    cost: number;
    transaction_type_precomputed: OneSchemaManagementLoanTransactionType;
};

export type PrepareOneSchemaShareAssociationsCacheDto = {
    mipId: string;
    userJwt: string;
};

export type OneSchemaShareAssociationRowValueDto = {
    investor_full_name: string;
    investor_email: string;
    security_name: string;
    security_type: string;
    units: string;
    cost: string;
    expected_transaction_type?: string;
    deleted?: string;
};

export type DataFileTct = {
    id: string;
    name: string;
    extension: string;
    s3key: string;
    md5?: {
        [key: string]: unknown;
    } | null;
    createdAt?: string;
};

export type DownloadFileDto = {
    id: string;
    name?: string;
};

export type BulkDownloadFilesDto = {
    files: Array<DownloadFileDto>;
};

export type PersonEntity = {
    [key: string]: unknown;
};

export type DataLoanDefinitionTct = {
    id: string;
    type: LoanDefinitionType;
    name: string;
    funder: string;
    funderId?: string;
    funderPerson?: PersonEntity;
};

export const CustomDetailDataTypeEnum = {
    STRING: 'STRING',
    NUMBER: 'NUMBER',
    BOOLEAN: 'BOOLEAN',
    BANK_ACCOUNT: 'BANK_ACCOUNT',
    TAX_RESIDENCY: 'TAX_RESIDENCY',
    TIN: 'TIN',
    COUNTRY_OF_BIRTH: 'COUNTRY_OF_BIRTH',
    FORM: 'FORM',
    PRE_FILLABLE_FORM: 'PRE_FILLABLE_FORM'
} as const;

export type CustomDetailDataTypeEnum = typeof CustomDetailDataTypeEnum[keyof typeof CustomDetailDataTypeEnum];

export const CustomDetailEnum = { INDIVIDUAL: 'INDIVIDUAL', VEHICLE: 'VEHICLE' } as const;

export type CustomDetailEnum = typeof CustomDetailEnum[keyof typeof CustomDetailEnum];

export const CustomDetailCategory = {
    TAX_RESIDENCY: 'TAX_RESIDENCY',
    FATCA: 'FATCA',
    CRS: 'CRS',
    GDPR: 'GDPR'
} as const;

export type CustomDetailCategory = typeof CustomDetailCategory[keyof typeof CustomDetailCategory];

export type DataCustomDetailTct = {
    id: string;
    name: string;
    dataType: CustomDetailDataTypeEnum;
    type: CustomDetailEnum;
    category: CustomDetailCategory | null;
    instruction: string | null;
    file: DataFileTct | null;
    isChecked: boolean;
    archived: boolean;
    isCreatedFromPreFillableForm: boolean;
    isCreatedFromGeneratableDocumentTemplate: boolean;
    deleted: boolean;
};

export const SignatureType = {
    ELECTRONIC: 'ELECTRONIC',
    WET_INK: 'WET_INK',
    REVIEW: 'REVIEW'
} as const;

export type SignatureType = typeof SignatureType[keyof typeof SignatureType];

export const ESignProvider = { EID_EASY: 'EID_EASY' } as const;

export type ESignProvider = typeof ESignProvider[keyof typeof ESignProvider];

export const ContractType = {
    DEAL: 'DEAL',
    SIDE_LETTER: 'SIDE_LETTER',
    MULTISIGNATURE: 'MULTISIGNATURE',
    FORM: 'FORM'
} as const;

export type ContractType = typeof ContractType[keyof typeof ContractType];

export const InvestmentWorkflowType = {
    JOINER_CREATE: 'JOINER_CREATE',
    JOINER: 'JOINER',
    ALLOCATION: 'ALLOCATION',
    LEAVER: 'LEAVER'
} as const;

export type InvestmentWorkflowType = typeof InvestmentWorkflowType[keyof typeof InvestmentWorkflowType];

export const DocumentWorkflowTemplateVisibleIn = {
    INVESTMENT_WORKFLOWS_BUYING: 'INVESTMENT_WORKFLOWS_BUYING',
    INVESTMENT_WORKFLOWS_SELLING: 'INVESTMENT_WORKFLOWS_SELLING',
    NON_INVESTMENT_WORKFLOWS: 'NON_INVESTMENT_WORKFLOWS',
    KYC_INDIVIDUAL: 'KYC_INDIVIDUAL',
    KYC_VEHICLE: 'KYC_VEHICLE'
} as const;

export type DocumentWorkflowTemplateVisibleIn = typeof DocumentWorkflowTemplateVisibleIn[keyof typeof DocumentWorkflowTemplateVisibleIn];

export const CounterpartyType = { TWO_SIGNATORIES: 'TWO_SIGNATORIES', ONE_SIGNATORIES: 'ONE_SIGNATORIES' } as const;

export type CounterpartyType = typeof CounterpartyType[keyof typeof CounterpartyType];

export type DataCounterpartyTct = {
    id: string;
    name: string;
    type: CounterpartyType;
};

export type DataContractTct = {
    id: string;
    mipId: string;
    file: DataFileTct;
    createdBy: string;
    name: string;
    signatureType: SignatureType;
    esignProvider: ESignProvider | null;
    type: ContractType;
    applicability: Array<InvestmentWorkflowType>;
    visibleIn: Array<DocumentWorkflowTemplateVisibleIn>;
    isExpired: boolean;
    isRejected: boolean;
    archived: boolean;
    instruction: string;
    requiredWitnesses: number;
    counterparties: Array<DataCounterpartyTct>;
};

export const MipState = { DRAFT: 'DRAFT', ACTIVE: 'ACTIVE' } as const;

export type MipState = typeof MipState[keyof typeof MipState];

export type DataMipTct = {
    id: string;
    dealId: string;
    currency: CurrencyType;
    loanDefinitions: Array<DataLoanDefinitionTct>;
    bankAccount: DataBankAccountTct;
    customDetails: Array<DataCustomDetailTct>;
    contractFiles: Array<DataContractTct>;
    entityId: {
        [key: string]: unknown;
    } | null;
    entity: DataPersonTct | null;
    programmeName: string;
    state: MipState;
    updatedBy: string;
    updatedAt: string;
    securityValuationDate?: string;
    isLocked: boolean;
};

export type DataDealTct = {
    id: string;
    name: string;
    targetName: string;
    mips: Array<DataMipTct>;
    deleted: boolean;
    createdAt: string;
};

export type DataSimpleMipTct = {
    id: string;
    dealId: string;
    isKycRequired: boolean;
    currency: CurrencyType;
    entityId: {
        [key: string]: unknown;
    } | null;
    entity: DataPersonTct | null;
    programmeName: string;
    deal: DataDealTct;
    state: MipState;
    isLocked: boolean;
    updatedAt: string;
    createdAt: string;
    securityValuationDate?: string;
    deleted: boolean;
};

export type DataIsAnyInvestorActiveInMipTct = {
    isActive: boolean;
};

export type DataIsAnyInvitedInvestorInMipTct = {
    isInvited: boolean;
};

export type DataUserTct = {
    id: string;
    authProviderUserId: string;
    active: boolean;
    deleted: boolean;
    email: string;
    firstName: string;
    lastName: string;
    birthDate: string;
    telephonePrefix: string;
    phoneNumber: string;
    addressId: string;
    address: AddressRes;
    bankAccountId: string;
    bankAccount: DataBankAccountTct;
    isPhoneNumberInvalid: boolean;
    createdAt: string;
    updatedAt: string;
};

export type UserRes = {
    id: string;
    email: string;
    firstName: {
        [key: string]: unknown;
    } | null;
    lastName: {
        [key: string]: unknown;
    } | null;
};

export type InvestmentWorkflowRes = {
    id: string;
    type: InvestmentWorkflowType;
};

export type InvestorWithInvestmentWorkflowRes = {
    id: string;
    user: UserRes;
    investmentWorkflows: Array<InvestmentWorkflowRes>;
};

export type DataCustomDetailWithoutFormTct = {
    id: string;
    investorEmail: string;
    name: string;
    value: string;
    type: CustomDetailEnum;
    dataType: CustomDetailDataTypeEnum;
};

export type GetInvestorAddress = {
    postCode: string;
    houseNumber: string;
    street: string;
    city: string;
    country: string;
    singleAddressString: string;
    id: string;
};

export type GetInvestorPersonalInformationRes = {
    phoneNumber: {
        [key: string]: unknown;
    };
    telephonePrefix: {
        [key: string]: unknown;
    };
    address: GetInvestorAddress | null;
    birthDate: {
        [key: string]: unknown;
    };
    vehicleData: {
        [key: string]: unknown;
    };
    representative: {
        [key: string]: unknown;
    };
};

export type UpdateInvestorPivDataDto = {
    pivCountry?: string;
    pivCity?: string;
    pivPostCode?: string;
    pivStreet?: string;
    pivHouseNumber?: string;
    pivName: string;
    pivRegNumber?: string;
};

export type UpdateLegalRepDetailsDto = {
    repCountry?: string;
    repCity?: string;
    repPostCode?: string;
    repStreet?: string;
    repHouseNumber?: string;
    repTelephonePrefix?: string;
    repPhoneNumber?: string;
    repBirthDate?: string;
    repFirstName: string;
    repLastName: string;
    repEmail: string;
};

export type UpdateInvestorPersonalDetailsDto = {
    birthDate?: string;
    phoneNumber?: string;
    telephonePrefix?: string;
    country?: string;
    street?: string;
    city?: string;
    houseNumber?: string;
    postCode?: string;
    vehicleData?: UpdateInvestorPivDataDto;
    representative?: UpdateLegalRepDetailsDto;
};

export type UpdateCustomDetailTypeDto = {
    type: CustomDetailEnum;
};

export const InternalDealTag = {
    SUPPORT: 'SUPPORT',
    SALES_DEMO: 'SALES_DEMO',
    ONBOARDING: 'ONBOARDING',
    LIVE: 'LIVE',
    LEGACY: 'LEGACY'
} as const;

export type InternalDealTag = typeof InternalDealTag[keyof typeof InternalDealTag];

export type DealBasicDataTct = {
    id: string;
    name: string;
    targetName: string;
    updatedBy: string;
    currency: {
        [key: string]: unknown;
    };
    internalDealTag: InternalDealTag | null;
    updatedAt: string;
    createdAt: string;
    isRestricted: boolean;
    /**
     * Authoritative deal-level "supports nominee structures" switch (stored on Deal).
     */
    hasNomineeStructure: boolean;
};

export type SummaryMipTct = {
    id: string;
    entityId: {
        [key: string]: unknown;
    } | null;
    entity: DataPersonTct | null;
    programmeName: string;
    currency: CurrencyType;
    state: MipState;
    updatedBy: string;
    updatedAt: string;
    numberOfInvestors: number;
    customDetails: Array<DataCustomDetailTct>;
    isLocked: boolean;
    securityValuationDate: string;
};

export type SummaryDealTct = {
    id: string;
    name: string;
    targetName: string;
    updatedBy: string;
    updatedAt: string;
    createdAt: string;
    /**
     * When true, DealStack Support users do not get inherited access; access requires an explicit grant.
     */
    isRestricted: boolean;
    /**
     * Authoritative deal-level "supports nominee structures" switch (stored on Deal).
     */
    hasNomineeStructure: boolean;
    /**
     * When true, the current user sees this deal through inherited DealStack Support access rather than an explicit deal grant.
     */
    isVisibleThroughDealStackSupportAccess: boolean;
    mips: Array<SummaryMipTct>;
    currency: CurrencyType | null;
    internalDealTag: InternalDealTag | null;
};

export type ChangeDealDto = {
    dealId: string;
};

export type UpdateUserNameDto = {
    firstName: string;
    lastName: string;
};

export type UpdateUserEmailDto = {
    email: string;
};

export type UpdateMipIsKycRequiredDto = {
    isKycRequired: boolean;
};

export type UpdateMipIsLockedDto = {
    isLocked: boolean;
};

export type DealEntity = {
    [key: string]: unknown;
};

export type GetInvestorShareAssociationsDataRes = {
    securityType: SecurityType;
    securityName: string;
    number: number;
    cost: number;
    shareAssociationId: string;
};

export type UpdateShareAssociation = {
    number?: number;
    cost?: number;
    shareAssociationId: string;
};

export type UpdateShareAssociationsDto = {
    updateShareAssociations: Array<UpdateShareAssociation>;
};

export type UploadFileDto = {
    skipPdfProcessing: string;
};

export type DataLoanWithTsaIdTct = {
    id: string;
    amount: number;
    amountRemaining: number;
    loanDefinitionId: string;
    investmentWorkflowId: string;
};

export type DataLoanDefinitionWithLoansTct = {
    id: string;
    type: LoanDefinitionType;
    name: string;
    funder: string;
    funderId: string;
    loans: Array<DataLoanWithTsaIdTct>;
    mipId: string;
};

export const WorkOsEventStatus = {
    PENDING: 'PENDING',
    PROCESSING: 'PROCESSING',
    COMPLETE: 'COMPLETE',
    SKIPPED: 'SKIPPED',
    FAILED: 'FAILED'
} as const;

export type WorkOsEventStatus = typeof WorkOsEventStatus[keyof typeof WorkOsEventStatus];

export type WorkOsEventRes = {
    id: string;
    type: string;
    payload: {
        [key: string]: unknown;
    };
    occurredAt: string;
    receivedAt: string;
    status: WorkOsEventStatus;
    attempts: number;
    claimedAt?: string | null;
    nextAttemptAt?: string | null;
    processedAt?: string | null;
    outcomeReason?: string | null;
};

export type WorkOsEventListRes = {
    items: Array<WorkOsEventRes>;
    take: number;
    skip: number;
    hasMore: boolean;
};

export const EmailChangeEligibilityReason = {
    LOCAL: 'LOCAL',
    DOMAIN_GUEST: 'DOMAIN_GUEST',
    DOMAIN_MANAGED_BY_IDP: 'DOMAIN_MANAGED_BY_IDP',
    TARGET_EMAIL_IN_USE: 'TARGET_EMAIL_IN_USE',
    VERIFICATION_UNAVAILABLE: 'VERIFICATION_UNAVAILABLE'
} as const;

export type EmailChangeEligibilityReason = typeof EmailChangeEligibilityReason[keyof typeof EmailChangeEligibilityReason];

export const EmailCollisionSide = {
    DEALSTACK: 'DEALSTACK',
    WORKOS: 'WORKOS',
    BOTH: 'BOTH'
} as const;

export type EmailCollisionSide = typeof EmailCollisionSide[keyof typeof EmailCollisionSide];

export type EmailChangeEligibilityRes = {
    allowed: boolean;
    reason: EmailChangeEligibilityReason;
    domain?: string | null;
    organizationName?: string | null;
    requiresMembershipMove: boolean;
    collidesWith?: EmailCollisionSide | null;
};

export type ContractAndDocumentWorkflowFileNames = {
    id: string;
    name: string;
};

export type GetContractAndDocumentWorkflowFileNamesRes = {
    contractsAndDocuments: Array<ContractAndDocumentWorkflowFileNames>;
    nextCursor?: {
        [key: string]: unknown;
    } | null;
};

export type CreateFileAssociationDto = {
    id: string;
};

export type CreateCounterpartyDto = {
    name: string;
    type: CounterpartyType;
};

export type CreateContractDto = {
    name: string;
    type: ContractType;
    signatureType: SignatureType;
    file: CreateFileAssociationDto;
    counterparties: Array<CreateCounterpartyDto>;
    applicability?: Array<InvestmentWorkflowType>;
    classifiers?: Array<string>;
    instruction?: string;
    requiredWitnesses?: number;
    /**
     * Triggers investor reevaluation when true
     */
    triggerInvestorReevaluate?: boolean;
};

export type PaginationDto = {
    /**
     * Number of items to return
     */
    take?: number;
    /**
     * Number of items to return
     */
    skip?: number;
};

/**
 * Field to sort by
 */
export const DocumentWorkflowInstanceSortKey = {
    DOCUMENT_NAME: 'documentName',
    INVESTOR: 'investor',
    COUNTERPARTY: 'counterparty',
    STATUS: 'status',
    CREATED_AT: 'createdAt',
    UPDATED_AT: 'updatedAt'
} as const;

/**
 * Field to sort by
 */
export type DocumentWorkflowInstanceSortKey = typeof DocumentWorkflowInstanceSortKey[keyof typeof DocumentWorkflowInstanceSortKey];

export type BaseSortByDto = {
    /**
     * Field to sort by
     */
    key?: DocumentWorkflowInstanceSortKey;
    /**
     * Toggle to sort in ascending or descending order
     */
    desc?: boolean;
};

/**
 * Filter by one or more investor signature statuses
 */
export const DocumentWorkflowInstanceSignatureStatus = {
    CREATED: 'CREATED',
    PENDING_SIGNATURE: 'PENDING_SIGNATURE',
    SIGNED: 'SIGNED',
    COMPLETED: 'COMPLETED',
    DECLINED: 'DECLINED',
    EXPIRED: 'EXPIRED',
    ERROR: 'ERROR',
    WAITING_FOR_WITNESS_SIGNATURES: 'WAITING_FOR_WITNESS_SIGNATURES',
    CLOSED_WITHOUT_SIGNATURE: 'CLOSED_WITHOUT_SIGNATURE'
} as const;

/**
 * Filter by one or more investor signature statuses
 */
export type DocumentWorkflowInstanceSignatureStatus = typeof DocumentWorkflowInstanceSignatureStatus[keyof typeof DocumentWorkflowInstanceSignatureStatus];

/**
 * Filter by one or more display-level document statuses
 */
export const DisplayWorkflowStatus = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    AWAITING_DATE: 'AWAITING_DATE',
    REVOKED: 'REVOKED',
    ERROR: 'ERROR'
} as const;

/**
 * Filter by one or more display-level document statuses
 */
export type DisplayWorkflowStatus = typeof DisplayWorkflowStatus[keyof typeof DisplayWorkflowStatus];

export type DateRangeDto = {
    from?: string;
    to?: string;
};

export type InvestmentProgrammeDocumentsFieldFilterQueryDto = {
    /**
     * Filter by one or more investor signature statuses
     */
    investorSignatureStatuses?: Array<DocumentWorkflowInstanceSignatureStatus>;
    /**
     * Filter by investor name or email (partial match)
     */
    investorName?: string;
    /**
     * Filter by counterparty name or email (partial match)
     */
    counterpartyName?: string;
    /**
     * Filter to documents linked to a specific investment workflow (exact match on ID)
     */
    investmentWorkflowId?: string;
    /**
     * Filter to the documents of one or more investors (exact match on ID) — the id-based counterpart of investorName
     */
    investorIds?: Array<string>;
    /**
     * Filter by one or more document workflow instance statuses
     */
    statuses?: Array<DocumentWorkflowInstanceStatus>;
    /**
     * Filter by one or more display-level document statuses
     */
    displayStatuses?: Array<DisplayWorkflowStatus>;
    /**
     * Filter to documents where investor has no signature requirement
     */
    investorNoSignatureRequired?: boolean;
    /**
     * Filter by document name (partial match)
     */
    documentName?: string;
    /**
     * Filter by batch name (partial match)
     */
    batchName?: string;
    /**
     * Filter by one or more counterparty signing role names
     */
    counterpartyRoleNames?: Array<string>;
    /**
     * Filter by one or more counterparty signature statuses
     */
    counterpartySignatureStatuses?: Array<string>;
    /**
     * Filter by creation date from (inclusive)
     */
    createdAt?: DateRangeDto;
    /**
     * Filter by last updated date from (inclusive)
     */
    updatedAt?: DateRangeDto;
    /**
     * Filter by deal classifier IDs (matches workflows whose template carries any of these classifiers)
     */
    dealClassifierIds?: Array<string>;
};

/**
 * Filter instances by a single investor signing status
 */
export const InvestorSigningStatus = {
    NOT_SIGNED: 'NOT_SIGNED',
    SIGNED_SELF_ONLY: 'SIGNED_SELF_ONLY',
    SIGNED_PIV_ONLY: 'SIGNED_PIV_ONLY',
    PENDING_WITNESS: 'PENDING_WITNESS'
} as const;

/**
 * Filter instances by a single investor signing status
 */
export type InvestorSigningStatus = typeof InvestorSigningStatus[keyof typeof InvestorSigningStatus];

export type BaseQuickFiltersDto = {
    /**
     * Filter instances where a specific user ID is required as a signer
     */
    userIdRequiredOnSignature?: string;
    /**
     * Filter instances with any investor signatures required
     */
    anyInvestorSignatureRequired?: boolean;
    /**
     * Filter instances with any counterparty signatures required
     */
    anyCounterpartySignatureRequired?: boolean;
    /**
     * Filter instances with unassigned counterparties
     */
    unassignedCounterparty?: boolean;
    /**
     * Filter instances that are reissuable
     */
    reissueable?: boolean;
    /**
     * Filter instances that are reissuable
     */
    revokeable?: boolean;
    /**
     * Filter simple document workflow instances that are revokeable
     */
    simpleDocumentRevokeable?: boolean;
    /**
     * Filter document workflow instances that have a signer awaiting a reminder
     */
    remindable?: boolean;
    /**
     * Filter instances where the given user has an unsigned counterparty signature with eID Easy provider
     */
    signableByCurrentUser?: string;
    /**
     * Filter instances that have at least one open (unassigned, unsigned) counterparty role
     */
    hasOpenCounterpartyRoles?: boolean;
    /**
     * Filter instances that can have an authorised signatory invited now: at least one open (unassigned, unsigned) counterparty role AND every investor-side signer (PARTY/PIV/REPRESENTATIVE) already signed. Mirrors the bulk-invite gate so the table only lists documents the invite would actually act on.
     */
    invitableAuthorisedSignatory?: boolean;
    /**
     * Filter instances by a single investor signing status
     */
    investorSigningStatus?: InvestorSigningStatus;
    /**
     * Filter instances that have at least one claimable investor signer (PARTY/REPRESENTATIVE/PIV, unclaimed, unsigned, claimable signing config)
     */
    hasClaimableInvestorSigners?: boolean;
    /**
     * Filter instances that are COMPLETED, eID Easy, require post-dating and have not been dated yet
     */
    awaitingPostDating?: boolean;
    /**
     * Filter instances that may receive a new counterparty in bulk: not closed, not missing a signing config, has an outstanding signature somewhere on the instance. Readiness, headroom, manual placement and duplicate-name are evaluated per-document, not by this filter.
     */
    counterpartyAddable?: boolean;
};

export const DocumentSigningScope = { PER_PARTICIPANT: 'PER_PARTICIPANT', ALL_PARTICIPANTS: 'ALL_PARTICIPANTS' } as const;

export type DocumentSigningScope = typeof DocumentSigningScope[keyof typeof DocumentSigningScope];

export type InvestmentProgrammeDocumentInvestorRes = {
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    status: DocumentWorkflowInstanceSignatureStatus | null;
};

export type InvestmentProgrammeDocumentCounterpartyRes = {
    userId: string | null;
    firstName: string | null;
    lastName: string | null;
    email: string | null;
    roleName: string | null;
    roleId: string;
    status: DocumentWorkflowInstanceSignatureStatus | null;
    assigned: boolean;
    invitedExternally: boolean;
};

export type InvestmentProgrammeDocumentClassifierRes = {
    id: string;
    name: string;
};

export type InvestmentProgrammeDocumentRes = {
    documentWorkflowInstanceId: string;
    fileName: string | null;
    templateName: string | null;
    fileId: string | null;
    batchName: string | null;
    requiresEsignature: boolean;
    signingScope: DocumentSigningScope | null;
    eSignProvider: ESignProvider | null;
    investor: Array<InvestmentProgrammeDocumentInvestorRes>;
    counterparties: Array<InvestmentProgrammeDocumentCounterpartyRes>;
    classifiers: Array<InvestmentProgrammeDocumentClassifierRes>;
    workflowStatus: DocumentWorkflowInstanceStatus;
    requiresPostDating: boolean;
    dateAppliedAt: string | null;
    isSignableForm: boolean;
    formSubmitted: boolean;
    createdAt: string;
    updatedAt: string;
};

export type InvestorCountsRes = {
    SIGNED: number;
    CREATED: number;
    /**
     * Count of documents where investor has no signature requirement
     */
    NO_SIGNATURE_REQUIRED: number;
};

export type CounterpartyCountsRes = {
    SIGNED: number;
    CREATED: number;
};

export type StatusCountsRes = {
    /**
     * Completed signing, excluding documents still awaiting a post-signing date
     */
    COMPLETED: number;
    /**
     * Completed signing but still awaiting a DC-1000 post-signing effective date
     */
    AWAITING_DATE: number;
    /**
     * Pending + In Progress + Pending Additional Signatures + Pending Form Submission
     */
    IN_PROGRESS: number;
    REVOKED: number;
    /**
     * Error + Expired
     */
    ERROR: number;
};

export type InvestmentProgrammeDocumentAggregateInfoRes = {
    investor: InvestorCountsRes;
    counterparty: CounterpartyCountsRes;
    status: StatusCountsRes;
    total: number;
};

export type InvestmentProgrammeDocumentsRes = {
    files: Array<Array<unknown>>;
    documents: Array<InvestmentProgrammeDocumentRes>;
    aggregateInfo: InvestmentProgrammeDocumentAggregateInfoRes;
};

export type InvestmentProgrammeSigningRoleRes = {
    value: string;
    label: string;
    group: string;
};

export type InvestmentProgrammeSigningRolesRes = {
    signingRoles: Array<InvestmentProgrammeSigningRoleRes>;
};

export type InvestmentProgrammeDocumentsCounterpartyFilterDto = {
    /**
     * Filter by one or more counterparty signing role names
     */
    roleNames?: Array<string>;
    /**
     * Filter by one or more counterparty signature statuses
     */
    signatureStatuses?: Array<string>;
};

export type InvestmentProgrammeDocumentsQueryFilterFieldDto = {
    /**
     * Filter by one or more investor signature statuses
     */
    investorSignatureStatuses?: Array<DocumentWorkflowInstanceSignatureStatus>;
    /**
     * Filter by investor name or email (partial match)
     */
    investorName?: string;
    /**
     * Filter by counterparty name or email (partial match)
     */
    counterpartyName?: string;
    /**
     * Filter to documents linked to a specific investment workflow (exact match on ID)
     */
    investmentWorkflowId?: string;
    /**
     * Filter to the documents of one or more investors (exact match on ID) — the id-based counterpart of investorName
     */
    investorIds?: Array<string>;
    /**
     * Filter by one or more document workflow instance statuses
     */
    statuses?: Array<DocumentWorkflowInstanceStatus>;
    /**
     * Filter by one or more display-level document statuses
     */
    displayStatuses?: Array<DisplayWorkflowStatus>;
    /**
     * Filter to documents where investor has no signature requirement
     */
    investorNoSignatureRequired?: boolean;
    /**
     * Filter by document name (partial match)
     */
    documentName?: string;
    /**
     * Filter by batch name (partial match)
     */
    batchName?: string;
    /**
     * Filter by counterparty roles and signature statuses
     */
    counterparty?: InvestmentProgrammeDocumentsCounterpartyFilterDto;
    /**
     * Filter by document creation date range
     */
    createdAt?: DateRangeDto;
    /**
     * Filter by document last updated date range
     */
    updatedAt?: DateRangeDto;
    /**
     * Filter by deal classifier IDs (matches workflows whose template carries any of these classifiers)
     */
    dealClassifierIds?: Array<string>;
};

export type BulkDownloadFileFilters = {
    /**
     * The inclusive dates to search between, from or up to
     */
    dateRange?: DateRangeDto;
    quickFilters?: BaseQuickFiltersDto;
    /**
     * Field-specific filters for document name, batch, investor, status, and dates
     */
    fieldFilter?: InvestmentProgrammeDocumentsQueryFilterFieldDto;
};

export type BulkDownloadFileDto = {
    /**
     * If true, query all items (respecting filters, search, excludedFileIds). If false, only fetch by specific selectedFileIds (ignore filters/search,excludedFileIds).
     */
    allFilesSelected?: boolean;
    /**
     * List of IDs to exclude when allFilesSelected = true
     */
    excludedFileIds?: Array<string>;
    /**
     * List of IDs to fetch when allFilesSelected = false
     */
    selectedFileIds?: Array<string>;
    /**
     * Filters to apply to the files to be downloaded
     */
    filters?: BulkDownloadFileFilters;
};

export const DocumentSigningRoleType = {
    PARTY: 'PARTY',
    PIV: 'PIV',
    REPRESENTATIVE: 'REPRESENTATIVE',
    COUNTERPARTY: 'COUNTERPARTY',
    WITNESS: 'WITNESS',
    CERTIFIER: 'CERTIFIER'
} as const;

export type DocumentSigningRoleType = typeof DocumentSigningRoleType[keyof typeof DocumentSigningRoleType];

export type InvestmentProgrammeDocumentDetailsWitnessRes = {
    signatureId?: string;
    signerId: string;
    email: string;
    status?: DocumentWorkflowInstanceSignatureStatus;
};

/**
 * Resolved security level: explicit signer override falling back to template config default. BASIC includes DRAW; ADVANCED is strong methods only.
 */
export const DocumentSigningSecurityLevel = { BASIC: 'BASIC', ADVANCED: 'ADVANCED' } as const;

/**
 * Resolved security level: explicit signer override falling back to template config default. BASIC includes DRAW; ADVANCED is strong methods only.
 */
export type DocumentSigningSecurityLevel = typeof DocumentSigningSecurityLevel[keyof typeof DocumentSigningSecurityLevel];

export type InvestmentProgrammeDocumentDetailsSignerRes = {
    id?: string;
    investorId?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    status?: DocumentWorkflowInstanceSignatureStatus;
    assigned: boolean;
    /**
     * True when this signer was invited by email (e.g. an authorised signatory) rather than assigned to a DealStack user account.
     */
    invitedExternally?: boolean;
    userId?: string;
    signatureId?: string;
    fileId?: string;
    witnesses: Array<InvestmentProgrammeDocumentDetailsWitnessRes>;
    /**
     * Resolved witness requirement: explicit signer override falling back to role default
     */
    requiresWitness: boolean;
    /**
     * Resolved security level: explicit signer override falling back to template config default. BASIC includes DRAW; ADVANCED is strong methods only.
     */
    effectiveSecurityLevel: DocumentSigningSecurityLevel;
    claimedByName: string | null;
    claimedByUserId: string | null;
};

export type InvestmentProgrammeDocumentDetailsSignerGroupRes = {
    groupName: string;
    groupType: DocumentSigningRoleType;
    roleId: string;
    requiredNumberOfSignatures: number;
    signers: Array<InvestmentProgrammeDocumentDetailsSignerRes>;
};

export const DocumentWorkflowTemplateType = {
    SIGNATURE_REQUIRED: 'SIGNATURE_REQUIRED',
    FORM_INPUT: 'FORM_INPUT',
    READ_ONLY: 'READ_ONLY',
    SIGNABLE_FORM: 'SIGNABLE_FORM'
} as const;

export type DocumentWorkflowTemplateType = typeof DocumentWorkflowTemplateType[keyof typeof DocumentWorkflowTemplateType];

/**
 * SIGNATURES_COLLECTED — somebody has signed. SIGNING_IN_PROGRESS — nobody has finished, but a prepare has run, so the signature pages are allocated and the file is out with the signing provider.
 */
export const TemplateSettingLockReason = {
    DOCUMENTS_ISSUED: 'DOCUMENTS_ISSUED',
    SIGNING_IN_PROGRESS: 'SIGNING_IN_PROGRESS',
    SIGNATURES_COLLECTED: 'SIGNATURES_COLLECTED'
} as const;

/**
 * SIGNATURES_COLLECTED — somebody has signed. SIGNING_IN_PROGRESS — nobody has finished, but a prepare has run, so the signature pages are allocated and the file is out with the signing provider.
 */
export type TemplateSettingLockReason = typeof TemplateSettingLockReason[keyof typeof TemplateSettingLockReason];

export type TemplateSettingLockRes = {
    locked: boolean;
    /**
     * SIGNATURES_COLLECTED — somebody has signed. SIGNING_IN_PROGRESS — nobody has finished, but a prepare has run, so the signature pages are allocated and the file is out with the signing provider.
     */
    reason?: TemplateSettingLockReason;
};

export type InvestmentProgrammeDocumentDetailsRes = {
    documentWorkflowInstanceId: string;
    documentName: string;
    fileName: string;
    fileId: string;
    batchName: string;
    groups: Array<InvestmentProgrammeDocumentDetailsSignerGroupRes>;
    workflowStatus: DocumentWorkflowInstanceStatus;
    statusMessage: string | null;
    signatureType?: SignatureType;
    signingScope?: DocumentSigningScope;
    eSignProvider?: ESignProvider | null;
    documentWorkflowTemplateType: DocumentWorkflowTemplateType;
    formSubmittedAt?: string | null;
    readyForCounterpartySigning: boolean;
    requiresPostDating: boolean;
    dateAppliedAt: string | null;
    effectiveDate: string | null;
    createdAt: string;
    updatedAt: string;
    /**
     * Whether the witness requirement can still be turned ON for a signer on this document. Locked once a signature has been collected or a signing prepare has run: the signature pages were laid out without room for a witness row and cannot be re-laid out without breaking the signatures already in the file. Turning it OFF stays available regardless — it is the only way to unblock a document waiting on a witness.
     */
    witnessRequirementLock: TemplateSettingLockRes;
};

export const DocumentWorkflowEventLogType = {
    SIGNER_ASSIGNED: 'SIGNER_ASSIGNED',
    SIGNER_UNASSIGNED: 'SIGNER_UNASSIGNED',
    SIGNATURE_CLAIMED: 'SIGNATURE_CLAIMED',
    DOCUMENT_SIGNED: 'DOCUMENT_SIGNED',
    FORM_SUBMITTED: 'FORM_SUBMITTED',
    FORM_REMOVED: 'FORM_REMOVED',
    DOCUMENT_REJECTED: 'DOCUMENT_REJECTED',
    DOCUMENT_ERROR: 'DOCUMENT_ERROR',
    DOCUMENT_PENDING_SIGNATURE: 'DOCUMENT_PENDING_SIGNATURE',
    DOCUMENT_PENDING_WITNESS_SIGNATURE: 'DOCUMENT_PENDING_WITNESS_SIGNATURE',
    DOCUMENT_COMPLETED: 'DOCUMENT_COMPLETED',
    DOCUMENT_EXPIRED: 'DOCUMENT_EXPIRED',
    DOCUMENT_REISSUED: 'DOCUMENT_REISSUED',
    DOCUMENT_CREATED_AND_SENT: 'DOCUMENT_CREATED_AND_SENT',
    DOCUMENT_PREVIEWED: 'DOCUMENT_PREVIEWED',
    DOCUMENT_REVOKED: 'DOCUMENT_REVOKED',
    DOCUMENT_FILE_REPLACED: 'DOCUMENT_FILE_REPLACED',
    DOCUMENT_DATE_APPLIED: 'DOCUMENT_DATE_APPLIED',
    WITNESS_INVITED: 'WITNESS_INVITED',
    WITNESS_EMAIL_CHANGED: 'WITNESS_EMAIL_CHANGED',
    WITNESS_INVITATION_RE_SENT: 'WITNESS_INVITATION_RE_SENT',
    COUNTERPARTY_INVITED: 'COUNTERPARTY_INVITED',
    COUNTERPARTY_INVITATION_RE_SENT: 'COUNTERPARTY_INVITATION_RE_SENT',
    COUNTERPARTY_INVITATION_CANCELLED: 'COUNTERPARTY_INVITATION_CANCELLED',
    SIGNER_REMINDER_SENT: 'SIGNER_REMINDER_SENT',
    SIGNER_REMINDER_SENT_AUTOMATED: 'SIGNER_REMINDER_SENT_AUTOMATED',
    SIGNER_ADDED: 'SIGNER_ADDED',
    DOCUMENT_CLOSED_WITHOUT_SIGNATURE: 'DOCUMENT_CLOSED_WITHOUT_SIGNATURE',
    PARTY_ADDED: 'PARTY_ADDED',
    SIGNER_REMOVED: 'SIGNER_REMOVED',
    CERTIFIER_INVITED: 'CERTIFIER_INVITED',
    CERTIFIER_INVITATION_RE_SENT: 'CERTIFIER_INVITATION_RE_SENT',
    CERTIFIER_CHANGED: 'CERTIFIER_CHANGED',
    CERTIFICATION_TEXT_UPDATED: 'CERTIFICATION_TEXT_UPDATED'
} as const;

export type DocumentWorkflowEventLogType = typeof DocumentWorkflowEventLogType[keyof typeof DocumentWorkflowEventLogType];

export type File = {
    id: string;
    name: string;
};

export type UserDetails = {
    firstName: string | null;
    lastName: string | null;
};

export type UserSession = {
    browserName: string;
    browserVersion: string;
    osName: string;
    ipAddress: string;
    user: UserDetails;
};

export type PublicSignerInfo = {
    email: string | null;
    role: DocumentSigningRoleType | null;
    fullName: string | null;
};

export type AuditEventActor = {
    userSession: UserSession | null;
    publicSigner: PublicSignerInfo | null;
};

export type DocumentWorkflowEventLogEntity = {
    eventType: DocumentWorkflowEventLogType;
    status: DocumentWorkflowInstanceStatus;
    statusMessage?: string;
    comment?: string;
    createdAt: string;
    file?: File;
    previousFile?: File;
    userAction: AuditEventActor;
    signingMethodLabel?: string;
    complianceLabel?: string;
};

export type ReplaceDocumentFileDto = {
    /**
     * ID of the previously uploaded file that should become the active version
     */
    newFileId: string;
    /**
     * Reason for replacing the file, captured in the activity log
     */
    comment: string;
};

export type CloseDocumentWithoutSignatureDto = {
    /**
     * Why the document is being closed without the investor signing. Recorded on the instance and in the activity log.
     */
    reason: string;
};

export type AssignSignerDto = {
    /**
     * The role ID to assign the signer to
     */
    roleId: string;
    /**
     * The user ID to assign as a signer
     */
    userId: string;
};

export type UnassignSignerDto = {
    /**
     * The role ID to unassign the signer from
     */
    roleId: string;
    /**
     * The user ID to unassign as a signer
     */
    userId: string;
};

export type EligibleInvestorRes = {
    id: string;
    name: string;
};

export type AddInvestorEligibilityRes = {
    canAdd: boolean;
    reason: string | null;
    freeRows: number | null;
    totalRows: number | null;
    eligibleInvestors: Array<EligibleInvestorRes>;
};

export type AddInvestorsDto = {
    /**
     * Investors to add to the instance.
     */
    investorIds: Array<string>;
};

export const OccupiedPlacementKind = { SIGNATURE: 'SIGNATURE', DATE: 'DATE' } as const;

export type OccupiedPlacementKind = typeof OccupiedPlacementKind[keyof typeof OccupiedPlacementKind];

export type OccupiedPlacementRes = {
    /**
     * The slot key for a signature, date:<index> for a date.
     */
    key: string;
    kind: OccupiedPlacementKind;
    label: string;
    isWitness: boolean;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type AddCounterpartyPlacementRes = {
    /**
     * Instance file the manager draws the boxes on.
     */
    fileId: string;
    /**
     * Locks the box aspect ratio and minimum height.
     */
    showStampMetadata: boolean;
    /**
     * Every box already on the document, which the new boxes must keep clear of.
     */
    occupiedBoxes: Array<OccupiedPlacementRes>;
};

export type AddCounterpartyEligibilityRes = {
    canAdd: boolean;
    reason: string | null;
    freeRows: number | null;
    totalRows: number | null;
    /**
     * Largest slot count this document can still take; 0 when none.
     */
    maxSlots: number;
    /**
     * APPLIES when signature-page headroom limits the addition (eID Easy), NOT_APPLICABLE when pages are generated per signer on demand (wet ink) and there is no limit to report.
     */
    headroom: string;
    /**
     * Non-null when the document stamps by hand, so a signature box must be placed for every new slot. Null on a document that signs on the appended signature page.
     */
    placement: AddCounterpartyPlacementRes | null;
};

export type CounterpartyInviteDto = {
    firstName: string;
    lastName: string;
    email: string;
};

export type AddCounterpartySlotDto = {
    /**
     * Existing Dealstack user to assign this slot to.
     */
    userId?: string;
    /**
     * External person to invite to this slot.
     */
    invite?: CounterpartyInviteDto;
};

export type AddCounterpartyPlacementDto = {
    /**
     * Zero-based slot ordinal within the new counterparty.
     */
    signatureIndex: number;
    /**
     * 1-indexed page of the instance file.
     */
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type AddCounterpartyDto = {
    /**
     * Name of the counterparty as it should read on the document.
     */
    name: string;
    slots: Array<AddCounterpartySlotDto>;
    /**
     * One box per slot, required when the document places stamps by hand and rejected when it does not.
     */
    placements?: Array<AddCounterpartyPlacementDto>;
};

export type CounterpartySlotAssignmentRes = {
    signerId: string;
    /**
     * UNASSIGNED | ASSIGNED | INVITED | FAILED
     */
    status: string;
    message: string | null;
};

export type AddCounterpartyRes = {
    roleId: string;
    signerIds: Array<string>;
    assignmentResults: Array<CounterpartySlotAssignmentRes>;
};

export type RemoveSignerDto = {
    /**
     * The signer slot to remove. Its PIV, representative and witnesses go with it.
     */
    signerId: string;
};

export type UploadFileInfo = {
    fileName: string;
    mimeType: string;
    extension: string;
};

export type SignWetInkDocumentUploadDto = {
    fileData: UploadFileInfo;
    signingRoleType: DocumentSigningRoleType;
    roleName?: string;
    investorId?: string;
};

export type GetPreSignedUrl = {
    fileName: string;
    fileKey: string;
    uploadPreSignedUrl: string;
};

export type PresignedFileData = {
    md5: string;
    fileName: string;
    fileKey: string;
    mimeType: string;
    fileExtension: string;
};

export type SignWetInkDocumentDto = {
    fileData: PresignedFileData;
    roleName?: string;
    investorId?: string;
};

export type SubmitFormUploadDto = {
    fileData: UploadFileInfo;
    investorId: string;
};

export type SubmitFormDto = {
    fileData: PresignedFileData;
    investorId: string;
};

export type BulkDownloadFileSyncRes = {
    /**
     * The file ID of the generated zip file
     */
    fileId: string;
    /**
     * Pre-signed URL to download the zip file
     */
    downloadUrl: string;
};

export type BulkDownloadFileAsyncRes = {
    /**
     * Indicates that the download is being processed asynchronously
     */
    isAsync: boolean;
    /**
     * S3 key of the zip file that will be generated
     */
    zipFileS3Key: string;
};

export type BulkRevokeDocumentsDto = {
    /**
     * If true, query all items (respecting filters, search, excludedDocumentWorkflowInstanceIds). If false, only revoke by specific selectedDocumentWorkflowInstanceIds (ignore filters/search,excludedDocumentWorkflowInstanceIds).
     */
    allDocumentsSelected?: boolean;
    /**
     * List of document workflow instance IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * List of document workflow instance IDs to revoke when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply to the documents to be revoked
     */
    filters?: BulkDownloadFileFilters;
    /**
     * Reason for revoking the documents
     */
    reason: string;
};

export type BulkReissueDocumentsDto = {
    /**
     * If true, query all items (respecting filters, search, excludedDocumentWorkflowInstanceIds). If false, only reissue by specific selectedDocumentWorkflowInstanceIds (ignore filters/search,excludedDocumentWorkflowInstanceIds).
     */
    allDocumentsSelected?: boolean;
    /**
     * List of document workflow instance IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * List of document workflow instance IDs to reissue when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply to the documents to be reissued
     */
    filters?: BulkDownloadFileFilters;
};

export type BulkAssignCounterpartiesPreviewDto = {
    /**
     * If true, query all items (respecting filters and excludedDocumentWorkflowInstanceIds). If false, only use selectedDocumentWorkflowInstanceIds.
     */
    allDocumentsSelected: boolean;
    /**
     * IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * IDs to include when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply
     */
    filters?: BulkDownloadFileFilters;
};

export type BulkAssignCounterpartiesPreviewCurrentAssigneeRes = {
    userId: string;
    firstName: string;
    lastName: string;
    documentCount: number;
    signedDocumentCount: number;
};

export type BulkAssignCounterpartiesPreviewRoleRes = {
    roleName: string;
    roleIds: Array<string>;
    documentCount: number;
    assignedCount: number;
    unassignedCount: number;
    currentAssignees: Array<BulkAssignCounterpartiesPreviewCurrentAssigneeRes>;
    invitedCount: number;
};

export type BulkAssignCounterpartiesPreviewRes = {
    totalDocuments: number;
    roles: Array<BulkAssignCounterpartiesPreviewRoleRes>;
};

/**
 * Whether to assign or unassign the user
 */
export const BulkAssignAction = { ASSIGN: 'ASSIGN', UNASSIGN: 'UNASSIGN' } as const;

/**
 * Whether to assign or unassign the user
 */
export type BulkAssignAction = typeof BulkAssignAction[keyof typeof BulkAssignAction];

export type BulkAssignCounterpartyChangeDto = {
    /**
     * Role name to apply the change to
     */
    roleName: string;
    /**
     * All template signing role IDs that share this role name
     */
    roleIds: Array<string>;
    /**
     * Whether to assign or unassign the user
     */
    action: BulkAssignAction;
    /**
     * User ID to assign or unassign
     */
    userId: string;
};

export type BulkAssignCounterpartyDto = {
    /**
     * If true, query all items. If false, only use selectedDocumentWorkflowInstanceIds.
     */
    allDocumentsSelected: boolean;
    /**
     * IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * IDs to include when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply
     */
    filters?: BulkDownloadFileFilters;
    /**
     * List of role changes to apply
     */
    changes: Array<BulkAssignCounterpartyChangeDto>;
};

export type StartBulkAssignCounterpartyRes = {
    /**
     * Temporal workflow ID — used by the frontend to poll job status
     */
    jobId: string;
};

/**
 * Lifecycle status of the job
 */
export const BulkAssignCounterpartyJobStatus = {
    INITIATED: 'INITIATED',
    PREPARING: 'PREPARING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

/**
 * Lifecycle status of the job
 */
export type BulkAssignCounterpartyJobStatus = typeof BulkAssignCounterpartyJobStatus[keyof typeof BulkAssignCounterpartyJobStatus];

export type BulkAssignCounterpartyJobStatusRes = {
    /**
     * Lifecycle status of the job
     */
    status: BulkAssignCounterpartyJobStatus;
    actorId: string;
    total: number;
    processed: number;
    assigned: number;
    unassigned: number;
    skipped: number;
    errors: Array<string>;
};

export type BulkAddCounterpartyPreviewDto = {
    /**
     * If true, query all items (respecting filters and excludedDocumentWorkflowInstanceIds). If false, only use selectedDocumentWorkflowInstanceIds.
     */
    allDocumentsSelected: boolean;
    /**
     * IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * IDs to include when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply
     */
    filters?: BulkDownloadFileFilters;
    /**
     * Name of the counterparty as it should read on the document.
     */
    name: string;
    slots: Array<AddCounterpartySlotDto>;
};

export const BulkAddCounterpartySkipReason = {
    DOCUMENT_CLOSED: 'DOCUMENT_CLOSED',
    UNSUPPORTED_PROVIDER: 'UNSUPPORTED_PROVIDER',
    NOT_READY_FOR_SIGNING: 'NOT_READY_FOR_SIGNING',
    NO_OUTSTANDING_SIGNATURES: 'NO_OUTSTANDING_SIGNATURES',
    SIGNATURE_HEADROOM_EXHAUSTED: 'SIGNATURE_HEADROOM_EXHAUSTED',
    SIGNATURE_HEADROOM_UNKNOWN: 'SIGNATURE_HEADROOM_UNKNOWN',
    DUPLICATE_COUNTERPARTY_NAME: 'DUPLICATE_COUNTERPARTY_NAME',
    MANUAL_PLACEMENT: 'MANUAL_PLACEMENT',
    DOCUMENT_NOT_FOUND: 'DOCUMENT_NOT_FOUND',
    UNEXPECTED_ERROR: 'UNEXPECTED_ERROR'
} as const;

export type BulkAddCounterpartySkipReason = typeof BulkAddCounterpartySkipReason[keyof typeof BulkAddCounterpartySkipReason];

export type BulkAddCounterpartyPreviewSkipGroupRes = {
    reason: BulkAddCounterpartySkipReason;
    message: string;
    count: number;
};

export type BulkAddCounterpartyPreviewRes = {
    totalSelected: number;
    evaluated: number;
    evaluationTruncated: boolean;
    eligibleCount: number;
    slotsRequested: number;
    inviteDowngradedCount: number;
    skipped: Array<BulkAddCounterpartyPreviewSkipGroupRes>;
};

export type BulkAddCounterpartyDto = {
    /**
     * If true, query all items (respecting filters and excludedDocumentWorkflowInstanceIds). If false, only use selectedDocumentWorkflowInstanceIds.
     */
    allDocumentsSelected: boolean;
    /**
     * IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * IDs to include when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply
     */
    filters?: BulkDownloadFileFilters;
    /**
     * Name of the counterparty as it should read on the document.
     */
    name: string;
    slots: Array<AddCounterpartySlotDto>;
};

export type StartBulkAddCounterpartyRes = {
    /**
     * Temporal workflow ID — used by the frontend to poll job status
     */
    jobId: string;
};

/**
 * Lifecycle status of the job
 */
export const BulkAddCounterpartyJobStatus = {
    INITIATED: 'INITIATED',
    PREPARING: 'PREPARING',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

/**
 * Lifecycle status of the job
 */
export type BulkAddCounterpartyJobStatus = typeof BulkAddCounterpartyJobStatus[keyof typeof BulkAddCounterpartyJobStatus];

export type BulkAddCounterpartyJobStatusRes = {
    /**
     * Lifecycle status of the job
     */
    status: BulkAddCounterpartyJobStatus;
    actorId: string;
    total: number;
    processed: number;
    added: number;
    skipped: number;
    skippedByReason: Array<BulkAddCounterpartyPreviewSkipGroupRes>;
    slotsOpen: number;
    slotsAssigned: number;
    slotsInvited: number;
    slotsFailed: number;
    inviteDowngraded: number;
    errors: Array<string>;
};

export type BulkInviteAuthorisedSignatoriesPreviewDto = {
    allDocumentsSelected: boolean;
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    filters?: BulkDownloadFileFilters;
};

export type BulkInviteAuthorisedSignatoryCurrentInviteeRes = {
    email: string;
    firstName: string;
    lastName: string;
    documentCount: number;
    signedDocumentCount: number;
};

export type BulkInviteAuthorisedSignatoriesPreviewRoleRes = {
    roleName: string;
    roleIds: Array<string>;
    documentCount: number;
    invitedCount: number;
    openCount: number;
    currentInvitees: Array<BulkInviteAuthorisedSignatoryCurrentInviteeRes>;
};

export type BulkInviteAuthorisedSignatoriesPreviewRes = {
    totalDocuments: number;
    roles: Array<BulkInviteAuthorisedSignatoriesPreviewRoleRes>;
};

export type BulkInviteAuthorisedSignatoryChangeDto = {
    /**
     * Role name to invite the signatory to
     */
    roleName: string;
    /**
     * All template signing role IDs sharing this role name
     */
    roleIds: Array<string>;
    /**
     * Email address of the authorised signatory
     */
    email: string;
    firstName: string;
    lastName: string;
};

export type BulkCancelAuthorisedSignatoryChangeDto = {
    /**
     * Role name to cancel the invitation on
     */
    roleName: string;
    /**
     * All template signing role IDs sharing this role name
     */
    roleIds: Array<string>;
    /**
     * Invited authorised signatory to cancel
     */
    email: string;
};

export type BulkInviteAuthorisedSignatoryDto = {
    allDocumentsSelected: boolean;
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    filters?: BulkDownloadFileFilters;
    /**
     * New authorised signatories to invite. At least one of changes or cancellations is required
     */
    changes?: Array<BulkInviteAuthorisedSignatoryChangeDto>;
    /**
     * Invited authorised signatories to cancel, processed before changes
     */
    cancellations?: Array<BulkCancelAuthorisedSignatoryChangeDto>;
};

export type BulkInviteAuthorisedSignatoryResultRes = {
    documentWorkflowInstanceId: string;
    roleName: string;
    email: string;
    success: boolean;
    reason?: string;
};

export type BulkInviteAuthorisedSignatoryRes = {
    invitedSignerCount: number;
    emailsSent: number;
    skipped: number;
    cancelledSignerCount: number;
    results: Array<BulkInviteAuthorisedSignatoryResultRes>;
};

export type BulkRemindSignersDto = {
    /**
     * If true, query all items (respecting filters, search, excludedDocumentWorkflowInstanceIds). If false, only remind signers on the specific selectedDocumentWorkflowInstanceIds (ignore filters/search,excludedDocumentWorkflowInstanceIds).
     */
    allDocumentsSelected: boolean;
    /**
     * List of document workflow instance IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * List of document workflow instance IDs to remind signers on when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Filters to apply to the documents whose signers should be reminded
     */
    filters?: BulkDownloadFileFilters;
};

export type StartBulkRemindSignersRes = {
    /**
     * Temporal workflow ID — used by the frontend to poll job status
     */
    jobId: string;
};

/**
 * Lifecycle status of the job
 */
export const BulkRemindSignersJobStatus = {
    INITIATED: 'INITIATED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

/**
 * Lifecycle status of the job
 */
export type BulkRemindSignersJobStatus = typeof BulkRemindSignersJobStatus[keyof typeof BulkRemindSignersJobStatus];

export type BulkRemindSignersJobStatusRes = {
    /**
     * Lifecycle status of the job
     */
    status: BulkRemindSignersJobStatus;
    actorId: string;
    total: number;
    processed: number;
    reminded: number;
    skippedCooldown: number;
    skippedNoEmail: number;
    skippedNoUser: number;
    skippedNotRemindable: number;
    failed: number;
    errors: Array<string>;
};

export type BulkApplyDateDto = {
    allDocumentsSelected: boolean;
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    filters?: BulkDownloadFileFilters;
    /**
     * Effective date in yyyy-MM-dd
     */
    effectiveDate: string;
};

export type StartBulkApplyDateRes = {
    /**
     * Temporal workflow ID — used by the frontend to poll job status
     */
    jobId: string;
};

/**
 * Lifecycle status of the job
 */
export const BulkPostDatingJobStatus = {
    INITIATED: 'INITIATED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

/**
 * Lifecycle status of the job
 */
export type BulkPostDatingJobStatus = typeof BulkPostDatingJobStatus[keyof typeof BulkPostDatingJobStatus];

export const PostDatingSkipReason = {
    NOT_FOUND: 'NOT_FOUND',
    NOT_COMPLETED: 'NOT_COMPLETED',
    NOT_POST_DATED: 'NOT_POST_DATED',
    NOT_EID_EASY: 'NOT_EID_EASY',
    ALREADY_DATED: 'ALREADY_DATED',
    NO_PLACEMENTS: 'NO_PLACEMENTS',
    DIFFERENT_DATE: 'DIFFERENT_DATE',
    UNSIGNED_FILE: 'UNSIGNED_FILE',
    NO_RESOLVED_POSITION: 'NO_RESOLVED_POSITION'
} as const;

export type PostDatingSkipReason = typeof PostDatingSkipReason[keyof typeof PostDatingSkipReason];

export type BulkApplyDateSkippedItemRes = {
    instanceId: string;
    reason: PostDatingSkipReason;
};

export type BulkApplyDateFailedItemRes = {
    instanceId: string;
    error: string;
};

export type BulkApplyDateJobStatusRes = {
    /**
     * Lifecycle status of the job
     */
    status: BulkPostDatingJobStatus;
    actorId: string;
    /**
     * Effective date in yyyy-MM-dd
     */
    effectiveDate: string;
    totalPlacements: number;
    appliedPlacements: number;
    totalDocuments: number;
    completedDocuments: number;
    skipped: Array<BulkApplyDateSkippedItemRes>;
    failed: Array<BulkApplyDateFailedItemRes>;
    errors: Array<string>;
};

export type BulkClaimOnBehalfPreviewDto = {
    allDocumentsSelected: boolean;
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    filters?: BulkDownloadFileFilters;
};

export type BulkClaimOnBehalfPreviewSignerRes = {
    investorId: string;
    name: string;
    signerIds: Array<string>;
    documentCount: number;
};

export type BulkClaimOnBehalfPreviewRoleRes = {
    roleType: DocumentSigningRoleType;
    claimableCount: number;
    skippedCount: number;
    signers: Array<BulkClaimOnBehalfPreviewSignerRes>;
};

export type BulkClaimOnBehalfPreviewRes = {
    roles: Array<BulkClaimOnBehalfPreviewRoleRes>;
    totalClaimable: number;
    totalSkipped: number;
};

export type BulkClaimOnBehalfDto = {
    /**
     * Signer IDs to claim
     */
    signerIds: Array<string>;
};

export type BulkClaimOnBehalfRoleRes = {
    roleType: DocumentSigningRoleType;
    claimed: number;
    skipped: number;
};

export type BulkClaimOnBehalfRes = {
    claimed: number;
    skipped: number;
    byRole: Array<BulkClaimOnBehalfRoleRes>;
    generationJobId: string | null;
};

/**
 * Lifecycle status of the job
 */
export const BulkClaimGenerationJobStatus = {
    INITIATED: 'INITIATED',
    IN_PROGRESS: 'IN_PROGRESS',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

/**
 * Lifecycle status of the job
 */
export type BulkClaimGenerationJobStatus = typeof BulkClaimGenerationJobStatus[keyof typeof BulkClaimGenerationJobStatus];

export type BulkClaimGenerationJobStatusRes = {
    /**
     * Lifecycle status of the job
     */
    status: BulkClaimGenerationJobStatus;
    actorId: string;
    total: number;
    processed: number;
    generated: number;
    failed: number;
    errors: Array<string>;
};

export const SignerContactType = { SMS: 'sms', EMAIL: 'email' } as const;

export type SignerContactType = typeof SignerContactType[keyof typeof SignerContactType];

export type OtpContactDto = {
    channel: SignerContactType;
    /**
     * Phone number (E.164-ish) or email address
     */
    value: string;
};

export type EidEasyPrepareDto = {
    /**
     * Signature ID to prepare for signing
     */
    signatureId: string;
    /**
     * Signing method
     */
    method?: 'smart-id' | 'ftn' | 'draw' | 'otp' | 'se-bankid' | 'no-bankid' | 'mitid' | 'freja';
    /**
     * Redirect URL after FTN or OTP signing
     */
    signatureRedirect?: string;
    /**
     * Base64-encoded drawn signature image (data URL format)
     */
    drawnSignatureBase64?: string;
    /**
     * Required when method is OTP
     */
    otpContact?: OtpContactDto;
    /**
     * How the drawn signature was produced: canvas (hand-drawn, persisted) or typed (script-fonted, not persisted)
     */
    drawnSignatureSource?: 'canvas' | 'typed';
};

export type EidEasyCompleteDto = {
    /**
     * eID Easy document ID returned from prepare step
     */
    docId: string;
};

export type SignerSessionInfoRes = {
    startedAt?: string | null;
    ipAddress?: string | null;
    location?: string | null;
    browser?: string | null;
};

export type EidEasyCompleteRes = {
    status: string;
    fileId?: string | null;
    signingMethod?: string | null;
    verificationLevel?: string | null;
    signedAt?: string | null;
    session?: SignerSessionInfoRes | null;
};

export type ApplyDatePrepareDto = {
    /**
     * The effective date to apply, as YYYY-MM-DD. Re-validated server-side; ignored if a date was already stored for this document.
     */
    effectiveDate: string;
};

export type ApplyDateCompleteDto = {
    /**
     * The eID Easy doc_id returned by apply-date/prepare
     */
    docId: string;
};

export type BulkSetSignerRequiresWitnessDto = {
    /**
     * Every signing role in the target signer group. A visual group spans multiple roles (PARTY plus each investor’s nested PIV / REPRESENTATIVE), so the override is applied to all of them.
     */
    roleIds: Array<string>;
    /**
     * true / false to set an explicit override on every signer of the given roles on this instance; null clears the override and falls back to each role default.
     */
    requiresWitness?: {
        [key: string]: unknown;
    } | null;
};

export type BulkSetSignerSecurityLevelDto = {
    /**
     * Every signing role in the target signer group. A visual group spans multiple roles (PARTY plus each investor’s nested PIV / REPRESENTATIVE), so the override is applied to all of them.
     */
    roleIds: Array<string>;
    /**
     * BASIC enables simple-sign (DRAW) in addition to strong methods; ADVANCED restricts to strong methods only. Pass null to clear the per-signer override and inherit the template-config default.
     */
    securityLevel?: DocumentSigningSecurityLevel | null;
};

export type SetSignerRequiresWitnessDto = {
    /**
     * true / false to set an explicit override on this signer only; null clears the override and falls back to the role default.
     */
    requiresWitness?: {
        [key: string]: unknown;
    } | null;
};

export type SetSignerSecurityLevelDto = {
    /**
     * BASIC enables simple-sign (DRAW) in addition to strong methods; ADVANCED restricts to strong methods only. Pass null to clear the per-signer override and inherit the template-config default. Applies to this signer only.
     */
    securityLevel?: DocumentSigningSecurityLevel | null;
};

export type InviteWitnessDto = {
    /**
     * The parent signature ID (the investor signature being witnessed)
     */
    parentSignatureId: string;
    /**
     * Email address of the witness
     */
    witnessEmail: string;
};

export type InviteRepresentativeDto = {
    /**
     * The representative signature ID
     */
    signatureId: string;
    /**
     * Email address of the representative
     */
    representativeEmail: string;
};

export type InviteAuthorisedSignatoryDto = {
    /**
     * The counterparty signature ID
     */
    signatureId: string;
    /**
     * Email address of the authorised signatory
     */
    email: string;
    /**
     * First name of the authorised signatory
     */
    firstName: string;
    /**
     * Last name of the authorised signatory
     */
    lastName: string;
};

export type CancelAuthorisedSignatoryDto = {
    /**
     * Signature id of the slot whose authorised signatory is being cancelled
     */
    signatureId: string;
};

export type ResendInvitationDto = {
    /**
     * The signature ID to resend the invitation for
     */
    signatureId: string;
};

export const EidEasySigningMethod = {
    SMART_ID: 'smart-id',
    FTN: 'ftn',
    DRAW: 'draw',
    OTP: 'otp',
    SE_BANKID: 'se-bankid',
    NO_BANKID: 'no-bankid',
    MITID: 'mitid',
    FREJA: 'freja'
} as const;

export type EidEasySigningMethod = typeof EidEasySigningMethod[keyof typeof EidEasySigningMethod];

export type BulkEidEasyPrepareDto = {
    /**
     * If true, sign all matching documents (respecting filters and excludedDocumentWorkflowInstanceIds). If false, sign only the explicit selectedDocumentWorkflowInstanceIds.
     */
    allDocumentsSelected: boolean;
    /**
     * Document workflow instance IDs to sign when allDocumentsSelected = false
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Document workflow instance IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Table filters to apply when allDocumentsSelected = true
     */
    filters?: BulkDownloadFileFilters;
    method: EidEasySigningMethod;
    /**
     * Redirect URL after FTN signing
     */
    signatureRedirect?: string;
    /**
     * Base64-encoded drawn signature image (required for all bulk signing methods)
     */
    drawnSignatureBase64: string;
    /**
     * How the drawn signature was produced: canvas (hand-drawn, persisted) or typed (script-fonted, not persisted)
     */
    drawnSignatureSource?: 'canvas' | 'typed';
    /**
     * OTP dispatch target (SMS or email). Required when method is OTP; ignored for other methods. The service rejects with 400 if absent on an OTP request.
     */
    otpContact?: OtpContactDto;
};

export const BulkSignJobStatus = {
    INITIATED: 'INITIATED',
    PREPARING: 'PREPARING',
    READY_TO_SIGN: 'READY_TO_SIGN',
    COMPLETING: 'COMPLETING',
    COMPLETED: 'COMPLETED',
    FAILED: 'FAILED'
} as const;

export type BulkSignJobStatus = typeof BulkSignJobStatus[keyof typeof BulkSignJobStatus];

export const BulkSigningActorKind = { USER: 'user', PUBLIC_SIGNER: 'publicSigner' } as const;

export type BulkSigningActorKind = typeof BulkSigningActorKind[keyof typeof BulkSigningActorKind];

export type BulkSignJobActorRes = {
    kind: BulkSigningActorKind;
    userId?: string;
    personId?: string;
    programmeId?: string;
};

export type BulkSignJobStatusRes = {
    status: BulkSignJobStatus;
    actor: BulkSignJobActorRes;
    method: string;
    totalDocuments: number;
    preparedCount: number;
    completedCount: number;
    failedCount: number;
    docId?: {
        [key: string]: unknown;
    } | null;
    clientId?: {
        [key: string]: unknown;
    } | null;
    baseUrl?: {
        [key: string]: unknown;
    } | null;
    errors: Array<string>;
};

export type AttachKycFormDto = {
    /**
     * The KYC form DocumentWorkflowTemplate to attach to this investment
     */
    templateId: string;
};

export const AcceptanceStatus = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    REREQUESTED: 'REREQUESTED'
} as const;

export type AcceptanceStatus = typeof AcceptanceStatus[keyof typeof AcceptanceStatus];

export type ReviewKycFormDto = {
    templateId: string;
    status: AcceptanceStatus;
    rejectionComment?: string;
};

export type ResetKycFormDto = {
    /**
     * The KYC form DocumentWorkflowTemplate whose submission to reset (clear).
     */
    templateId: string;
};

export type MipFormAttachmentRes = {
    templateId: string;
    formName: string;
    instruction: string | null;
    visibleIn: Array<DocumentWorkflowTemplateVisibleIn>;
    isAttached: boolean;
    kycFormWorkflowStateId: string | null;
};

export const SubjectAction = {
    NOT_YET_ACTED: 'NOT_YET_ACTED',
    CONFIRMED_UNCHANGED: 'CONFIRMED_UNCHANGED',
    UPDATED: 'UPDATED',
    ADMIN_UPLOADED: 'ADMIN_UPLOADED'
} as const;

export type SubjectAction = typeof SubjectAction[keyof typeof SubjectAction];

export type InvestorKycFormRes = {
    templateId: string;
    instanceId: string;
    formName: string;
    instruction: string | null;
    visibleIn: Array<DocumentWorkflowTemplateVisibleIn>;
    templateFileId: string;
    fileId: string | null;
    status: AcceptanceStatus | null;
    isInherited: boolean;
    subjectAction: SubjectAction | null;
    rejectionComment: string | null;
    fileName: string | null;
    createdAt: string;
    requiresSignature: boolean;
    signatureStatus: DocumentWorkflowInstanceSignatureStatus | null;
    signatureId: string | null;
};

/**
 * What was uploaded. A Word form is edited as a document; a PDF on a coordinate canvas.
 */
export const DocumentWorkflowTemplateSourceFormat = { PDF: 'PDF', DOCX: 'DOCX' } as const;

/**
 * What was uploaded. A Word form is edited as a document; a PDF on a coordinate canvas.
 */
export type DocumentWorkflowTemplateSourceFormat = typeof DocumentWorkflowTemplateSourceFormat[keyof typeof DocumentWorkflowTemplateSourceFormat];

export type KycFormTemplateRes = {
    id: string;
    fileId: string;
    name: string;
    instruction: string | null;
    visibleIn: Array<DocumentWorkflowTemplateVisibleIn>;
    category: CustomDetailCategory | null;
    fileName: string;
    archived: boolean;
    isPreFillable: boolean;
    requiresSignature: boolean;
    /**
     * Whether the signature box is admin-placed on the document.
     */
    useManualSignaturePlacement: boolean;
    /**
     * Whether the stamp renders its metadata block. Drives the box aspect ratio, so the placement editor has to open in the mode the box was drawn in.
     */
    showStampMetadata: boolean;
    /**
     * What was uploaded. A Word form is edited as a document; a PDF on a coordinate canvas.
     */
    sourceFormat: DocumentWorkflowTemplateSourceFormat;
};

export type KycLibraryTemplateRes = {
    id: string;
    name: string;
    description: string | null;
    sourceFormat: DocumentWorkflowTemplateSourceFormat;
    updatedAt: string;
};

export type PendingKycSignaturePlacementDto = {
    /**
     * 1-based PDF page number
     */
    pageNum: number;
    /**
     * PDF-native X (origin bottom-left, points)
     */
    x: number;
    /**
     * PDF-native Y (origin bottom-left, points)
     */
    y: number;
    /**
     * Stamp width in PDF points
     */
    width: number;
    /**
     * Stamp height in PDF points
     */
    height: number;
};

export type CreateKycFormTemplateDto = {
    name: string;
    instruction: string;
    type: CustomDetailEnum;
    fileId?: string;
    globalDocumentTemplateId?: string;
    category?: CustomDetailCategory | null;
    /**
     * Require the investor to e-sign this form via eID Easy.
     */
    requiresSignature: boolean;
    /**
     * Place the signature box manually rather than on an appended signatures page.
     */
    useManualSignaturePlacement?: boolean;
    showStampMetadata?: boolean;
    pendingSignaturePlacements?: Array<PendingKycSignaturePlacementDto>;
};

export type UpdateKycFormTemplateDto = {
    name: string;
    instruction: string;
    type: CustomDetailEnum;
    category?: CustomDetailCategory | null;
    /**
     * Require the investor to e-sign this form via eID Easy.
     */
    requiresSignature: boolean;
    /**
     * Place the signature box manually rather than on an appended signatures page.
     */
    useManualSignaturePlacement?: boolean;
    showStampMetadata?: boolean;
    pendingSignaturePlacements?: Array<PendingKycSignaturePlacementDto>;
};

export type SignaturePlacementRes = {
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type SignatureSlotRes = {
    signingRoleId: string;
    signatureIndex: number;
    isWitness: boolean;
    label: string;
    roleType: DocumentSigningRoleType;
    roleName: string;
    placement?: SignaturePlacementRes | null;
};

export type DatePlacementRes = {
    id: string;
    placementIndex: number;
    pageNum: number | null;
    x: number | null;
    y: number | null;
    width: number;
    height: number;
};

export type GetSignatureSlotsRes = {
    slots: Array<SignatureSlotRes>;
    requiresPostDating: boolean;
    datePlacements: Array<DatePlacementRes>;
    showStampMetadata?: boolean;
};

export type SignaturePlacementDto = {
    /**
     * FK to DocumentWorkflowTemplateSigningRole
     */
    signingRoleId: string;
    /**
     * True when this stamp is the witness of the signing role
     */
    isWitness: boolean;
    /**
     * Zero-based index within the role (0..requiredNumberOfSignatures-1)
     */
    signatureIndex: number;
    /**
     * 1-based PDF page number
     */
    pageNum: number;
    /**
     * PDF-native X (origin bottom-left, points)
     */
    x: number;
    /**
     * PDF-native Y (origin bottom-left, points)
     */
    y: number;
    /**
     * Stamp width in PDF points
     */
    width: number;
    /**
     * Stamp height in PDF points
     */
    height: number;
};

export type UpdateKycSignaturePlacementDto = {
    /**
     * Whether the stamp position is admin-placed rather than appended.
     */
    useManualSignaturePlacement: boolean;
    /**
     * Whether the stamp renders its metadata block (drives the expected aspect ratio).
     */
    showStampMetadata?: boolean;
    signaturePlacements?: Array<SignaturePlacementDto>;
};

export const FieldBindingSource = {
    ACROFORM: 'ACROFORM',
    TOKEN: 'TOKEN',
    MANUAL: 'MANUAL'
} as const;

export type FieldBindingSource = typeof FieldBindingSource[keyof typeof FieldBindingSource];

export type FieldBindingRes = {
    id: string;
    fieldKey: string;
    source: FieldBindingSource;
    detectedText: string;
    label: string;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
    bindingTemplate: string | null;
};

export type FieldBindingDto = {
    /**
     * Stable per-template key (see field detection service)
     */
    fieldKey: string;
    source: FieldBindingSource;
    /**
     * Raw AcroForm field name or the token text
     */
    detectedText: string;
    /**
     * Display name shown in the UI
     */
    label: string;
    /**
     * 1-based PDF page number
     */
    pageNum: number;
    /**
     * PDF-native X (origin bottom-left, points)
     */
    x: number;
    /**
     * PDF-native Y (origin bottom-left, points)
     */
    y: number;
    /**
     * Field width in PDF points
     */
    width: number;
    /**
     * Field height in PDF points
     */
    height: number;
    /**
     * LiquidJS expression; null/undefined = unbound
     */
    bindingTemplate?: {
        [key: string]: unknown;
    } | null;
};

export type UpdateFieldBindingsDto = {
    bindings: Array<FieldBindingDto>;
};

export type DataPointWithSampleRes = {
    group: string;
    label: string;
    path: string;
    sampleValue: string;
    optional: boolean;
    fieldName?: string;
    choices?: string;
};

export type SecurityOptionRes = {
    id: string;
    name: string;
    type: string;
    currency: string;
    issuerId: string;
    issuerName: string;
    isHeld: boolean | null;
    hasOpenAllocation: boolean | null;
};

export type FieldBindingCatalogueRes = {
    dataPoints: Array<DataPointWithSampleRes>;
    securities: Array<SecurityOptionRes>;
    scopedSamples: {
        [key: string]: {
            [key: string]: {
                [key: string]: string;
            };
        };
    };
    uncollectedRequirements: Array<string>;
};

export type FieldBindingPreviewRes = {
    fileId: string;
};

export type DocxFlowFieldRes = {
    /**
     * Field name as it appears in the document
     */
    name: string;
    /**
     * Display name shown in the UI
     */
    label: string;
    /**
     * Format filters this field is used with
     */
    filters: Array<string>;
    /**
     * How many places in the document this field appears
     */
    occurrences: number;
    /**
     * Surrounding text for each occurrence
     */
    contexts: Array<string>;
    /**
     * LiquidJS expression; null = unlinked
     */
    bindingTemplate: string | null;
};

export type DocxFlowProblemRes = {
    /**
     * unclosed | invalid_name | too_many_filters | single_brace
     */
    kind: string;
    /**
     * The offending text as written
     */
    text: string;
    /**
     * What is wrong and what to write instead
     */
    message: string;
    /**
     * Surrounding text, so it can be found in the document
     */
    context: string;
};

export type DocxFlowDocumentRes = {
    /**
     * The reflow document: a ProseMirror-shaped tree of blocks with page geometry in its attrs. Opaque to the API; the editor and the renderer share its schema.
     */
    document: {
        [key: string]: unknown;
    };
    fields: Array<DocxFlowFieldRes>;
    problems: Array<DocxFlowProblemRes>;
    /**
     * What the conversion could not carry over
     */
    warnings: Array<string>;
    /**
     * Field names with no data point behind them yet
     */
    unlinked: Array<string>;
    /**
     * Whether stamps draw their metadata block, which sets how much space a signature anchor reserves.
     */
    showStampMetadata: boolean;
};

export type SaveDocxFlowDocumentDto = {
    /**
     * The edited reflow document. Only its `content` is taken — page geometry and the conversion warnings come from what is already stored, so an edit cannot resize the page.
     */
    document: {
        [key: string]: unknown;
    };
    /**
     * Field name to LiquidJS expression, MERGED over what is stored. A field dragged in from the catalogue arrives already linked; merging rather than replacing means adding one can never unlink another.
     */
    bindings?: {
        [key: string]: string;
    };
};

export type DocxRenderSignatureBoxRes = {
    signingRoleId: string;
    isWitness: boolean;
    signatureIndex: number;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type DocxRenderDateBoxRes = {
    templateDatePlacementId: string;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type DocxRenderFieldBoxRes = {
    name: string;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

/**
 * `undecided`: the fields view had no answer to decide it with, so its content is shown labelled.
 */
export const DocxRenderRuleDecision = {
    SHOWN: 'shown',
    HIDDEN: 'hidden',
    UNDECIDED: 'undecided'
} as const;

/**
 * `undecided`: the fields view had no answer to decide it with, so its content is shown labelled.
 */
export type DocxRenderRuleDecision = typeof DocxRenderRuleDecision[keyof typeof DocxRenderRuleDecision];

/**
 * The test’s own answer; null when the rule was left undecided.
 */
export const DocxRenderRuleAnswer = {
    TRUE: 'true',
    FALSE: 'false',
    UNKNOWN: 'unknown'
} as const;

/**
 * The test’s own answer; null when the rule was left undecided.
 */
export type DocxRenderRuleAnswer = typeof DocxRenderRuleAnswer[keyof typeof DocxRenderRuleAnswer];

export type DocxRenderRuleOutcomeRes = {
    ruleId: string;
    /**
     * `undecided`: the fields view had no answer to decide it with, so its content is shown labelled.
     */
    decision: DocxRenderRuleDecision;
    /**
     * The test’s own answer; null when the rule was left undecided.
     */
    answer: DocxRenderRuleAnswer | null;
};

export type DocxRenderRes = {
    /**
     * The rendered PDF, saved as a file
     */
    fileId: string;
    /**
     * Where each signature anchor landed, for a preview to draw its stamp in
     */
    signatureBoxes: Array<DocxRenderSignatureBoxRes>;
    /**
     * Where each date anchor landed, for a preview to draw its date box in
     */
    dateBoxes: Array<DocxRenderDateBoxRes>;
    /**
     * Where each field value landed, for a preview to highlight it
     */
    fieldBoxes: Array<DocxRenderFieldBoxRes>;
    /**
     * What each of the document’s rules did in this render
     */
    ruleOutcomes: Array<DocxRenderRuleOutcomeRes>;
};

export type RenderDocxTemplateDto = {
    /**
     * The document as it stands in the editor, unsaved edits included. Omit to render what is stored. Folded onto the stored document exactly as a save would fold it, so the preview is the page a save would produce — without saving, which would publish a half-finished deed to whatever generation runs next.
     */
    document?: {
        [key: string]: unknown;
    };
    /**
     * Links for fields the unsaved edit added, so a field just dragged in resolves in the preview rather than rendering blank.
     */
    bindings?: {
        [key: string]: string;
    };
    /**
     * Answers set by hand for what the document’s rules read: `dataPoints` keyed by data point path, `cohorts` keyed by cohort id. Written into the recipient’s data for this render only, so the fields that print them agree with the rules. Omit to render the data as it is.
     */
    scenario?: {
        [key: string]: unknown;
    };
};

export type ArchiveProgrammeKycFormTemplateDto = {
    archived: boolean;
    applyToInstances: boolean;
};

export type KycFormTemplateInstanceCountRes = {
    count: number;
};

export type DeleteProgrammeKycFormTemplatesDto = {
    templateIds: Array<string>;
    applyToInstances: boolean;
};

export type WitnessDetailsDto = {
    [key: string]: unknown;
};

export type WitnessInviteDto = {
    /**
     * Email address of the witness to invite
     */
    witnessEmail: string;
};

export type PublicSigningPrepareDto = {
    [key: string]: unknown;
};

export type PublicSigningCompleteDto = {
    [key: string]: unknown;
};

export type ProgrammeSignatureTokenDto = {
    signatureId: string;
};

export type PublicBulkPrepareDto = {
    method: EidEasySigningMethod;
    /**
     * Document workflow instance IDs to sign. Omit to sign every bulk-signable document in the programme.
     */
    selectedDocumentWorkflowInstanceIds?: Array<string>;
    /**
     * Base64-encoded drawn signature image (required for bulk signing)
     */
    drawnSignatureBase64: string;
    /**
     * Redirect URL after FTN signing
     */
    signatureRedirect?: string;
    /**
     * OTP dispatch target (SMS or email). Required when method is OTP; ignored for other methods. The service rejects with 400 if absent on an OTP request.
     */
    otpContact?: OtpContactDto;
};

export type CertifierDetailsDto = {
    token: string;
    fullName: string;
    address: string;
    professionalCapacity: string;
};

export type StatusOkRes = {
    status: string;
};

export type CertificationTextDto = {
    token: string;
    text: string;
};

export type CertificationTextRes = {
    certificationText: string;
    defaultCertificationText: string;
    textEditedAt: string | null;
    fileId: string;
};

export const DocumentTemplateStatus = {
    DRAFT: 'DRAFT',
    PUBLISHED: 'PUBLISHED',
    ARCHIVED: 'ARCHIVED'
} as const;

export type DocumentTemplateStatus = typeof DocumentTemplateStatus[keyof typeof DocumentTemplateStatus];

export const TemplateAvailability = { SELECTED_DEALS: 'SELECTED_DEALS', ALL_DEALS: 'ALL_DEALS' } as const;

export type TemplateAvailability = typeof TemplateAvailability[keyof typeof TemplateAvailability];

export type GlobalDocumentTemplateRes = {
    id: string;
    name: string;
    description: string | null;
    status: DocumentTemplateStatus;
    availability: TemplateAvailability;
    dealCount: number;
    fileId: string;
    sourceFormat: DocumentWorkflowTemplateSourceFormat;
    kycAudience: Array<DocumentWorkflowTemplateVisibleIn>;
    kycCategory: CustomDetailCategory | null;
    createdAt: string;
    updatedAt: string;
};

export type CreateGlobalDocumentTemplateDto = {
    name: string;
    description?: string;
    fileId: string;
};

export type UpdateGlobalDocumentTemplateDto = {
    name?: string;
    description?: string;
    status?: DocumentTemplateStatus | null;
    kycAudience?: Array<DocumentWorkflowTemplateVisibleIn>;
    kycCategory?: CustomDetailCategory | null;
};

export type TemplateAvailabilityRes = {
    availability: TemplateAvailability;
    dealIds: Array<string>;
};

export type SetTemplateAvailabilityDto = {
    availability: TemplateAvailability;
    dealIds: Array<string>;
};

export type DealDocumentTemplateSummaryRes = {
    id: string;
    name: string;
    description: string | null;
    updatedAt: string;
};

export const PreFillableFormTemplateTypeEnum = { INDIVIDUAL: 'INDIVIDUAL', VEHICLE: 'VEHICLE' } as const;

export type PreFillableFormTemplateTypeEnum = typeof PreFillableFormTemplateTypeEnum[keyof typeof PreFillableFormTemplateTypeEnum];

export type DataPreFillableFormTemplateTct = {
    id: string;
    name: string;
    instruction: string | null;
    type: PreFillableFormTemplateTypeEnum;
    fileId: string;
    createdAt: string;
    updatedAt: string;
};

export const GeneratableDocumentWorkflowTemplateType = {
    GDPR_NOTICE: 'GDPR_NOTICE',
    ANNUAL_STATEMENT: 'ANNUAL_STATEMENT',
    FORM_S431: 'FORM_S431'
} as const;

export type GeneratableDocumentWorkflowTemplateType = typeof GeneratableDocumentWorkflowTemplateType[keyof typeof GeneratableDocumentWorkflowTemplateType];

export type DataGeneratableDocumentTemplateProjectWithProjectTct = {
    id: string;
    deal: DataDealTct;
    generatableDocumentWorkflowTemplateId: string;
    createdAt: string;
    updatedAt: string;
};

export type DataGeneratableDocumentWorkflowTemplateFieldTct = {
    id: string;
    fieldKey: string;
    /**
     * LiquidJs template that will be used to get field value from available data
     */
    fieldSourceTemplate?: string | null;
    fieldSourceDescription?: string | null;
    generatableDocumentWorkflowTemplateId: string;
};

export type GdwtCustomDetailDefinitionTct = {
    id: string;
    name: string;
    entityType: PreFillableFormTemplateTypeEnum;
    instruction?: string | null;
    generatableDocumentWorkflowTemplateId: string;
};

export type DataGeneratableDocumentTemplateWithAllRelationsTct = {
    id: string;
    name: string;
    type: GeneratableDocumentWorkflowTemplateType;
    generatableDocumentWorkflowTemplateProjects: Array<DataGeneratableDocumentTemplateProjectWithProjectTct>;
    generatableDocumentWorkflowTemplateFields: Array<DataGeneratableDocumentWorkflowTemplateFieldTct>;
    generatableDocumentWorkflowTemplateCustomDetailDefinitions: Array<GdwtCustomDetailDefinitionTct>;
    createdAt: string;
    updatedAt: string;
};

export type DataGeneratableDocumentWorkflowTemplateTct = {
    id: string;
    name: string;
    type: GeneratableDocumentWorkflowTemplateType;
    createdAt: string;
    updatedAt: string;
};

export type UpdateGeneratableDocumentTemplateDto = {
    id: string;
    name: string;
};

export type GetGeneratableDocumentsTemplateAssignedProjectRes = {
    id: string;
    dealId: string;
    generatableDocumentWorkflowTemplateId: string;
    createdAt: string;
    updatedAt: string;
    projectName: string;
};

export type UpdateGeneratableDocumentTemplateSmartFieldDto = {
    id: string;
    fieldSourceTemplate?: string;
    fieldSourceDescription?: string;
};

export type UpdateGeneratableDocumentTemplateSmartFieldsDto = {
    smartFields: Array<UpdateGeneratableDocumentTemplateSmartFieldDto>;
};

export type AssignProjectToGeneratableDocumentTemplateDto = {
    templateId: string;
    dealId: string;
};

export type UnassignProjectFromGeneratableDocumentTemplateDto = {
    templateId: string;
    dealId: string;
};

export type CreateGdwtCustomDetailsDefinitionDto = {
    name: string;
    entityType: PreFillableFormTemplateTypeEnum;
    instruction?: {
        [key: string]: unknown;
    } | null;
};

export type CreateGdwtCustomDetailsDefinitionsDto = {
    templateId: string;
    customDetailsDefinitions: Array<CreateGdwtCustomDetailsDefinitionDto>;
};

export type UpdateGdwtCustomDetailDefinitionDto = {
    id: string;
    name: string;
    instruction?: string;
};

export type UpdateGdwtCustomDetailDefinitionsDto = {
    customDetailsDefinitions: Array<UpdateGdwtCustomDetailDefinitionDto>;
};

export type DeleteGdwtCustomDetailsDefinitionsDto = {
    customDetailsDefinitionsIds: Array<string>;
};

export type DataPreFillableFormTemplateProjectWithProjectTct = {
    id: string;
    deal: DataDealTct;
    preFillableFormTemplateId: string;
    createdAt: string;
    updatedAt: string;
};

export type DataPreFillableFormTemplateWithProjectsTct = {
    id: string;
    name: string;
    instruction: {
        [key: string]: unknown;
    } | null;
    type: PreFillableFormTemplateTypeEnum;
    fileId: string;
    createdBy: DataUserTct;
    preFillableFormTemplatesProjects: Array<DataPreFillableFormTemplateProjectWithProjectTct>;
    assignedOrganizationNames: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type PreFillableFormOrganizationOptionRes = {
    id: string;
    name: string;
};

export type UploadPreFillableFormTemplateFileRes = {
    fileId: string;
    fileName: string;
    fillableFieldsKeys: Array<string>;
};

export type CreatePreFillableFormTemplateFieldDto = {
    fieldKey: string;
    fieldSourceTemplate?: string;
    fieldSourceDescription?: string;
};

export type CreatePreFillableFormTemplateCustomDetailDefinitionDto = {
    localId: string;
    name: string;
    instruction?: string;
};

export type CreatePreFillableFormTemplateDto = {
    name: string;
    instruction?: string;
    type: PreFillableFormTemplateTypeEnum;
    category?: CustomDetailCategory | null;
    assignedProjects: Array<string>;
    assignedOrganizations?: Array<string>;
    fileId: string;
    fillableFieldsMapping: Array<CreatePreFillableFormTemplateFieldDto>;
    customDetailsDefinitions: Array<CreatePreFillableFormTemplateCustomDetailDefinitionDto>;
};

export type CreateCustomDetailDefinitionDto = {
    name: string;
    instruction?: {
        [key: string]: unknown;
    } | null;
};

export type CreateManyCustomDetailsDefinitionsForPreFillableFormTemplateDto = {
    formTemplateId: string;
    customDetailsDefinitions: Array<CreateCustomDetailDefinitionDto>;
};

export type UpdatePreFillableFormTemplateCustomDetailDefinitionDto = {
    id: string;
    name: string;
    instruction?: {
        [key: string]: unknown;
    } | null;
};

export type UpdateCustomDetailsDefinitionsDto = {
    customDetailsDefinitions: Array<UpdatePreFillableFormTemplateCustomDetailDefinitionDto>;
};

export type DeleteCustomDetailsDefinitionsDto = {
    customDetailsDefinitionsIds: Array<string>;
};

export type UpdatePreFillableFormTemplateFieldDto = {
    id: string;
    fieldSourceTemplate?: string;
    fieldSourceDescription?: string;
};

export type UpdatePreFillableFormTemplateDto = {
    id: string;
    name: string;
    instruction?: string;
    type: PreFillableFormTemplateTypeEnum;
    category?: CustomDetailCategory | null;
    assignedProjects: Array<string>;
    assignedOrganizations?: Array<string>;
    fillableFieldsMapping: Array<UpdatePreFillableFormTemplateFieldDto>;
};

export type DataPreFillableFormTemplateFieldTct = {
    id: string;
    fieldKey: string;
    fieldSourceTemplate: {
        [key: string]: unknown;
    } | null;
    fieldSourceDescription: {
        [key: string]: unknown;
    } | null;
    preFillableFormTemplateId: string;
    updatedAt: string;
    createdAt: string;
};

export type DataPreFillableFormCustomDetailDefinitionTct = {
    id: string;
    name: string;
    instruction: string;
    preFillableFormTemplateId: string;
    updatedAt: string;
    createdAt: string;
};

export type DataPreFillableFormTemplateWithAllRelationsTct = {
    id: string;
    name: string;
    instruction: string | null;
    type: PreFillableFormTemplateTypeEnum;
    category: CustomDetailCategory | null;
    file: DataFileTct;
    createdBy: DataUserTct;
    preFillableFormTemplatesProjects: Array<DataPreFillableFormTemplateProjectWithProjectTct>;
    assignedOrganizationIds: Array<string>;
    preFillableFormTemplateFields: Array<DataPreFillableFormTemplateFieldTct>;
    preFillableFormCustomDetailDefinitions: Array<DataPreFillableFormCustomDetailDefinitionTct>;
    createdAt: string;
    updatedAt: string;
};

export type PreFillableFormTemplateCustomDetailsDefinitionsRes = {
    customDetailDefinitions: Array<DataPreFillableFormCustomDetailDefinitionTct>;
};

export type GetLoanDefinitionForDealRes = {
    mipName: string;
    loanDefinitionName: string;
    loanDefinitionId: string;
};

export const PeriodUnitType = {
    DAILY: 'DAILY',
    MONTHLY: 'MONTHLY',
    QUARTERLY: 'QUARTERLY',
    YEARLY: 'YEARLY'
} as const;

export type PeriodUnitType = typeof PeriodUnitType[keyof typeof PeriodUnitType];

export const SecurityInterestDefinitionBaseRate = { ZERO: 'ZERO' } as const;

export type SecurityInterestDefinitionBaseRate = typeof SecurityInterestDefinitionBaseRate[keyof typeof SecurityInterestDefinitionBaseRate];

export const DayCountConvention = {
    ACTUAL_ACTUAL_ISDA: 'ACTUAL_ACTUAL_ISDA',
    THIRTY_360_ISDA: 'THIRTY_360_ISDA',
    THIRTY_365_ISDA: 'THIRTY_365_ISDA',
    ACTUAL_365_FIXED: 'ACTUAL_365_FIXED'
} as const;

export type DayCountConvention = typeof DayCountConvention[keyof typeof DayCountConvention];

export const SecurityInterestDefinitionPrincipal = {
    ISSUE_COST_PER_UNIT: 'ISSUE_COST_PER_UNIT',
    VALUE_PER_UNIT: 'VALUE_PER_UNIT',
    VALUE_FOR_TOTAL_ISSUE: 'VALUE_FOR_TOTAL_ISSUE'
} as const;

export type SecurityInterestDefinitionPrincipal = typeof SecurityInterestDefinitionPrincipal[keyof typeof SecurityInterestDefinitionPrincipal];

export type DataSecurityInterestDefinitionTct = {
    id: string;
    securityId: string;
    interestPeriodUnits: number;
    interestPeriodUnitType: PeriodUnitType;
    interestBaseRate: SecurityInterestDefinitionBaseRate;
    accrualPeriod: PeriodUnitType;
    dayCountConvention?: DayCountConvention;
    interestFloatingRate: number;
    deemedStartDate?: string;
    compoundingPeriod?: PeriodUnitType;
    firstInterestDate?: string;
    principal?: SecurityInterestDefinitionPrincipal;
    principalValue?: number;
};

export type DataSecurityRedemptionRightsTct = {
    id: string;
    securityId: string;
    term?: PeriodUnitType;
    termDuration?: number;
};

export const SecurityCatchUpRightsBasis = { DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK: 'DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_OR_EQUAL_RANK', DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_RANK: 'DISTRIBUTIONS_TO_SECURITIES_IN_HIGHER_RANK' } as const;

export type SecurityCatchUpRightsBasis = typeof SecurityCatchUpRightsBasis[keyof typeof SecurityCatchUpRightsBasis];

export type DataSecurityCatchUpRightsTct = {
    id: string;
    securityId: string;
    target: number;
    basis: SecurityCatchUpRightsBasis;
};

export type DataSecurityTrackingRes = {
    securityId: string;
    securityName: string;
    currency: CurrencyType;
    issuerName: string;
};

export const SecurityExchangeTransactionType = { ISSUE: 'ISSUE', TRANSFER: 'TRANSFER' } as const;

export type SecurityExchangeTransactionType = typeof SecurityExchangeTransactionType[keyof typeof SecurityExchangeTransactionType];

export const SecurityExchangeRightsPeriodBasis = {
    FIXED_DATE: 'FIXED_DATE',
    RELATIVE_TO_ISSUE_DATE: 'RELATIVE_TO_ISSUE_DATE',
    UNRESTRICTED: 'UNRESTRICTED'
} as const;

export type SecurityExchangeRightsPeriodBasis = typeof SecurityExchangeRightsPeriodBasis[keyof typeof SecurityExchangeRightsPeriodBasis];

export const PeriodDateType = {
    DAYS: 'DAYS',
    MONTHS: 'MONTHS',
    YEARS: 'YEARS'
} as const;

export type PeriodDateType = typeof PeriodDateType[keyof typeof PeriodDateType];

export type SecurityExchangeRightsTctExchangedFor = {
    name: string;
};

export type DataSecurityExchangeRightsTct = {
    id: string;
    securityId: string;
    transactionType: SecurityExchangeTransactionType;
    exchangedForSecurityId: string;
    rate: number;
    periodBasis: SecurityExchangeRightsPeriodBasis;
    periodBasisDate?: string;
    periodBasisIntervalStartDuration?: number;
    periodBasisIntervalStartPeriod?: PeriodDateType;
    periodBasisIntervalEndDuration?: number;
    periodBasisIntervalEndPeriod?: PeriodDateType;
    price?: number;
    additionalPriceRate?: number;
    additionalPriceAccrualPeriod?: PeriodUnitType;
    additionalPriceDayCountConvention?: DayCountConvention;
    additionalPriceDeemedStartDate?: string;
    additionalPriceCompoundingPeriod?: PeriodUnitType;
    additionalPriceFirstInterestDate?: string;
    exchangedForSecurity?: SecurityExchangeRightsTctExchangedFor | null;
};

export type DataSecurityExchangeRightsSecurityTct = {
    name: string;
};

export type DataSecurityExchangeRightsExchangedFromTct = {
    id: string;
    securityId: string;
    transactionType: SecurityExchangeTransactionType;
    exchangedForSecurityId: string;
    rate: number;
    periodBasis: SecurityExchangeRightsPeriodBasis;
    periodBasisDate?: string;
    periodBasisIntervalStartDuration?: number;
    periodBasisIntervalStartPeriod?: PeriodDateType;
    periodBasisIntervalEndDuration?: number;
    periodBasisIntervalEndPeriod?: PeriodDateType;
    price?: number;
    additionalPriceRate?: number;
    additionalPriceAccrualPeriod?: PeriodUnitType;
    additionalPriceDayCountConvention?: DayCountConvention;
    additionalPriceDeemedStartDate?: string;
    additionalPriceCompoundingPeriod?: PeriodUnitType;
    additionalPriceFirstInterestDate?: string;
    exchangedForSecurity?: SecurityExchangeRightsTctExchangedFor | null;
    security: DataSecurityExchangeRightsSecurityTct | null;
};

export const SecurityFeatureType = {
    RESIDUE: 'RESIDUE',
    TRACKING: 'TRACKING',
    CATCH_UP: 'CATCH_UP',
    INTEREST: 'INTEREST',
    PRINCIPAL: 'PRINCIPAL',
    OPTION: 'OPTION',
    LIQUIDATION_PREFERENCE: 'LIQUIDATION_PREFERENCE'
} as const;

export type SecurityFeatureType = typeof SecurityFeatureType[keyof typeof SecurityFeatureType];

export type SecurityRankDefinitionRes = {
    id: string;
    issuerId: string;
    dealId: string;
    displayName: string;
    sortOrder: number;
    isTracking: boolean;
    isResidue: boolean;
    deleted: boolean;
    updatedAt: string;
    createdAt: string;
};

export type SecurityRankWithRankRefRes = {
    id: string;
    rankId: string;
    securityId: string;
    featureType: SecurityFeatureType;
    deleted: boolean;
    updatedAt: string;
    createdAt: string;
    rank: SecurityRankDefinitionRes;
};

export const RatchetMetricType = {
    MOIC: 'MOIC',
    XIRR: 'XIRR',
    MOIC_AND_XIRR: 'MOIC_AND_XIRR'
} as const;

export type RatchetMetricType = typeof RatchetMetricType[keyof typeof RatchetMetricType];

export type SecurityRatchetScheduleEntryRes = {
    id: string;
    scheduleId: string;
    order: number;
    moicThreshold: number | null;
    xirrThreshold: number | null;
    entitlementPercentage: number;
};

export type SecurityRatchetMetricSubjectRes = {
    id: string;
    scheduleId: string;
    personId: string;
    personName: string;
};

export type SecurityRatchetScheduleRes = {
    id: string;
    securityId: string;
    metricType: RatchetMetricType;
    initialEntitlementPercentage: number;
    distributeUntilBreakpoint: boolean;
    entries: Array<SecurityRatchetScheduleEntryRes>;
    metricSubjects: Array<SecurityRatchetMetricSubjectRes>;
};

export type DataSecurityWithAllFeaturesAndRanksTct = {
    id: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    nominalValue?: number;
    fairMarketValuePerUnit?: number;
    votesPerUnit?: number;
    issuerId: string;
    loanDefinitionId?: string;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    residueRights: boolean;
    includeInReturns: boolean;
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis?: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string;
    issuedIn: SecurityIssuedIn;
    hasNomineeStructure: boolean;
    equityBasis?: SecurityEquityBasis;
    unitDenominator: number;
    authorisedCapital?: number;
    incomeType?: IncomeType | null;
    issuerHasNomineeStructure: boolean;
    hasLiquidationPreference: boolean;
    securityInterestDefinition: DataSecurityInterestDefinitionTct | null;
    securityRedemptionRights: DataSecurityRedemptionRightsTct | null;
    securityCatchUpRights: DataSecurityCatchUpRightsTct | null;
    tracking: Array<DataSecurityTrackingRes> | null;
    securityExchangeRights: DataSecurityExchangeRightsTct | null;
    totalShareCapital?: number;
    totalNominalValue?: number;
    totalSharePremium?: number;
    totalInIssue?: number;
    nominalValuePerUnit?: number;
    exchangedFrom: Array<DataSecurityExchangeRightsExchangedFromTct> | null;
    securityRanks: Array<SecurityRankWithRankRefRes> | null;
    securityRatchetSchedule: SecurityRatchetScheduleRes | null;
};

export type GetSecurityDataForMipRes = {
    id: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    nominalValue?: number;
    fairMarketValuePerUnit?: number;
    votesPerUnit?: number;
    issuerId: string;
    loanDefinitionId?: string;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    residueRights: boolean;
    includeInReturns: boolean;
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis?: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string;
    issuedIn: SecurityIssuedIn;
    hasNomineeStructure: boolean;
    equityBasis?: SecurityEquityBasis;
    unitDenominator: number;
    authorisedCapital?: number;
    incomeType?: IncomeType | null;
    hasTransactions: boolean;
    isSubjectToVesting: boolean;
};

export type SortDto = {
    key: string;
    desc?: boolean;
};

export type SecurityFilterDto = {
    id?: string;
    currency?: CurrencyType;
    name?: string;
    issuerId?: string;
    type?: Array<SecurityType>;
    nominalValue?: number;
    votesPerUnit?: string;
};

export type GetSecurityListFilterDto = {
    pagination?: PaginationDto;
    sortBy?: Array<SortDto>;
    search?: string;
    filter?: SecurityFilterDto;
};

export type GetPersonSecurityDataRes = {
    id: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    nominalValue?: number;
    fairMarketValuePerUnit?: number;
    votesPerUnit?: number;
    issuerId: string;
    loanDefinitionId?: string;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    residueRights: boolean;
    includeInReturns: boolean;
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis?: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string;
    issuedIn: SecurityIssuedIn;
    hasNomineeStructure: boolean;
    equityBasis?: SecurityEquityBasis;
    unitDenominator: number;
    authorisedCapital?: number;
    incomeType?: IncomeType | null;
    isSubjectToVesting: boolean;
    totalNominalValue?: number;
    nominalValuePerUnit?: number;
    totalSharePremium?: number;
    totalShareCapital?: number;
    totalVested?: number;
    totalUnvested?: number;
};

export type SecurityCountsDto = {
    totalNominalValue?: number;
    totalSharePremium?: number;
    totalShareCapital?: number;
    totalVested?: number;
    totalUnvested?: number;
    uniqueTypeCount: number;
    uniqueCurrency: number;
    uniqueNominalValue: number;
    uniqueVotesPerUnit: number;
    uniqueAuthorisedCapital: number;
    uniqueCreatedAt: number;
};

export type GetPersonSecuritiesRes = {
    totalCount: number;
    hasNextPage: boolean;
    securities: Array<GetPersonSecurityDataRes>;
    securityCounts: SecurityCountsDto;
};

export type DoesPersonHaveSecuritiesRes = {
    doesPersonHaveSecurities: boolean;
};

export type SecurityRankRes = {
    id: string;
    rankId: string;
    securityId: string;
    featureType: SecurityFeatureType;
    deleted: boolean;
    updatedAt: string;
    createdAt: string;
};

export type GetPersonSecuritiesWithFeaturesAndRanksRes = {
    securityId: string;
    securityName: string;
    securityType: SecurityType;
    securityFeatureType: SecurityFeatureType;
    warrantOverId?: string;
    warrantOverName?: string;
    isMergedIncomeRight?: boolean;
    hasRatchetSchedule?: boolean;
    securityRank: SecurityRankRes | null;
};

export type IsSecuritiesUsedInAnyMipRes = {
    isSecuritiesUsedInAnyMip: boolean;
};

export type CreateSecurityProgrammeSettingsDto = {
    mipId: string;
    isSubjectToVesting?: boolean;
};

export type CreateSecurityDto = {
    issuerId: string;
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    votesPerUnit?: number | null;
    nominalValue?: number | null;
    fairMarketValuePerUnit?: number | null;
    hasNomineeStructure?: boolean;
    securityProgrammeSettings?: CreateSecurityProgrammeSettingsDto | null;
};

export type BulkCreateSecurityDto = {
    name: string;
    type: SecurityType;
    currency: CurrencyType;
    votesPerUnit?: number | null;
    nominalValue?: number | null;
    fairMarketValuePerUnit?: number | null;
    hasNomineeStructure?: boolean;
    securityProgrammeSettings?: CreateSecurityProgrammeSettingsDto | null;
};

export type BulkCreateSecuritiesDto = {
    securities: Array<BulkCreateSecurityDto>;
    issuerId: string;
};

export type BulkUpdateTrackedSecuritiesDto = {
    trackingSecurityId: string;
    trackedSecurityIds?: Array<string>;
};

export type BulkOperationResult = {
    count: number;
};

export type UpdateSecurityProgrammeSettingsDto = {
    mipId: string;
    isSubjectToVesting?: boolean;
};

export type UpdateSecurityDto = {
    id: string;
    name: string;
    type: SecurityType;
    votesPerUnit?: number | null;
    fairMarketValuePerUnit?: number | null;
    nominalValue?: number | null;
    issuedIn?: SecurityIssuedIn;
    equityBasis?: SecurityEquityBasis | null;
    residueRights?: boolean | null;
    includeInReturns?: boolean | null;
    hasNomineeStructure?: boolean;
    loanDefinitionId?: string | null;
    unitDenominator?: number | null;
    securityProgrammeSettings?: UpdateSecurityProgrammeSettingsDto | null;
    incomeType?: IncomeType;
};

export type UpdateCurrencyForPersonSecurities = {
    currency: CurrencyType;
};

export type BulkUpdateSecuritiesDto = {
    securities: Array<UpdateSecurityDto>;
};

export type BulkSoftDeleteSecuritiesDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
};

export type DownloadSecuritiesCsvDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    /**
     * Date for calculating totals (defaults to today)
     */
    date?: string;
};

export type UpdateSecurityAuthorisedCapitalDto = {
    authorisedCapital: number | null;
};

export type UpdateSecurityParticipationThresholdDto = {
    residueParticipationThreshold: boolean;
    residueParticipationThresholdBasis: SecurityParticipationThresholdBasis;
    participationThresholdBasisTierId?: string | null;
};

export type SecurityNominalValueRes = {
    nominalValue: number | null;
};

export type CreateUpdateSecurityExchangeRightsDto = {
    transactionType: SecurityExchangeTransactionType;
    exchangedForSecurityId: string;
    rate: number;
    periodBasis: SecurityExchangeRightsPeriodBasis;
    periodBasisDate?: string | null;
    periodBasisIntervalStartDuration?: number | null;
    periodBasisIntervalStartPeriod?: PeriodDateType | null;
    periodBasisIntervalEndDuration?: number | null;
    periodBasisIntervalEndPeriod?: PeriodDateType | null;
    price?: number | null;
    additionalPriceRate?: number;
    additionalPriceAccrualPeriod?: PeriodUnitType | null;
    additionalPriceDayCountConvention?: DayCountConvention | null;
    additionalPriceDeemedStartDate?: string | null;
    additionalPriceCompoundingPeriod?: PeriodUnitType | null;
    additionalPriceFirstInterestDate?: string | null;
};

export type CreateUpdateSecurityInterestDefinitionDto = {
    accrualPeriod: PeriodUnitType;
    interestFloatingRate: number;
    deemedStartDate?: string | null;
    compoundingPeriod?: PeriodUnitType | null;
    firstInterestDate?: string | null;
    dayCountConvention?: DayCountConvention;
    principal: SecurityInterestDefinitionPrincipal;
    principalValue?: number | null;
};

export type CreateUpdateSecurityRedemptionRightsDto = {
    term: PeriodUnitType | null;
    termDuration: number | null;
};

export type CreateUpdateSecurityCatchUpRightsDto = {
    target: number;
    basis: SecurityCatchUpRightsBasis;
};

export type SecurityLiquidationPreferenceRes = {
    id: string;
    securityId: string;
    principal: SecurityInterestDefinitionPrincipal;
    principalValue?: number | null;
};

export type CreateUpdateSecurityLiquidationPreferenceDto = {
    principal: SecurityInterestDefinitionPrincipal;
    principalValue?: number | null;
};

export type ReleaseWorkflowProgressRes = {
    investorsReleased: number;
    investorsFailed: number;
    totalInvestors: number;
    completed: boolean;
};

export type InvestmentDetailsAddress = {
    country: string | null;
    city: string | null;
};

export type InvestmentDetailsTaxResidence = {
    countryCode: string;
    number: string | null;
};

export type InvestmentDetailsInvestor = {
    id: string;
    personId: string;
    displayName: string;
    email: string | null;
    phoneNumber: string | null;
    address: InvestmentDetailsAddress | null;
    taxResidences: Array<InvestmentDetailsTaxResidence>;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    nationality: Array<string>;
    domicile: string | null;
};

export type InvestmentDetailsPivAddress = {
    country: string | null;
    city: string | null;
    postCode: string | null;
    street: string | null;
    houseNumber: string | null;
};

export type InvestmentDetailsPivRepresentative = {
    id: string;
    displayName: string;
};

export type InvestmentDetailsPiv = {
    id: string;
    displayName: string;
    registrationNumber: string | null;
    jurisdiction: string | null;
    address: InvestmentDetailsPivAddress | null;
    legalRepresentative: InvestmentDetailsPivRepresentative | null;
};

export const TransactionState = {
    PENDING: 'PENDING',
    INCOMPLETE: 'INCOMPLETE',
    COMPLETED: 'COMPLETED'
} as const;

export type TransactionState = typeof TransactionState[keyof typeof TransactionState];

export type InvestmentDetailsLoan = {
    id: string;
    loanDefinitionId: string;
    name: string;
    type: LoanDefinitionType;
    funder: string;
    amount: number;
};

export type InvestmentDetailsPayment = {
    cost: number;
    status: TransactionState;
    annotation: string | null;
    loans: Array<InvestmentDetailsLoan>;
};

export type InvestmentDetailsCreatedBy = {
    id: string;
    firstName: {
        [key: string]: unknown;
    };
    lastName: {
        [key: string]: unknown;
    };
    email: string | null;
};

export type InvestmentDetailsPendingDocuments = {
    count: number;
    singleDocumentId: string | null;
};

export type InvestmentDetailsPendingActions = {
    kyc: boolean;
    documents: InvestmentDetailsPendingDocuments;
    consideration: boolean;
};

export type GetInvestmentDetailsSummaryRes = {
    investmentWorkflowId: string;
    kycWorkflowId: string | null;
    mipId: string;
    dealId: string;
    programmeName: string | null;
    investor: InvestmentDetailsInvestor;
    lastLoginAt: string | null;
    piv: InvestmentDetailsPiv | null;
    payment: InvestmentDetailsPayment;
    totalCost: number;
    currency: CurrencyType;
    isReleased: boolean;
    investmentStatus: InvestmentWorkflowStatus;
    investmentType: InvestmentWorkflowType;
    createdAt: string;
    createdBy: InvestmentDetailsCreatedBy | null;
    targetStartDate: string | null;
    targetCompletionDate: string | null;
    approvedAt: string | null;
    actualCompletionDate: string | null;
    pendingActions: InvestmentDetailsPendingActions;
};

export const ExpectedTransactionType = {
    ISSUE: 'ISSUE',
    TRANSFER: 'TRANSFER',
    REDEMPTION: 'REDEMPTION',
    CANCELLATION: 'CANCELLATION'
} as const;

export type ExpectedTransactionType = typeof ExpectedTransactionType[keyof typeof ExpectedTransactionType];

export type InvestmentDetailsAllocation = {
    id: string;
    securityId: string;
    securityName: string;
    securityType: SecurityType;
    securityCurrency: CurrencyType;
    issuingEntityId: string;
    issuingEntityName: string;
    units: number;
    cost: number;
    vestingTermId: string | null;
    vestingTermName: string | null;
    transactionType: ExpectedTransactionType | null;
};

export type GetInvestmentDetailsAllocationsRes = {
    allocations: Array<InvestmentDetailsAllocation>;
    canMutateAllocations: boolean;
};

export const InvestmentDetailsLegalDocumentSignerStatus = { SIGNED: 'SIGNED', PENDING: 'PENDING' } as const;

export type InvestmentDetailsLegalDocumentSignerStatus = typeof InvestmentDetailsLegalDocumentSignerStatus[keyof typeof InvestmentDetailsLegalDocumentSignerStatus];

export type InvestmentDetailsLegalDocumentSigner = {
    id: string;
    displayName: string | null;
    status: InvestmentDetailsLegalDocumentSignerStatus;
    roleName: string;
    roleType: DocumentSigningRoleType;
};

export type InvestmentDetailsLegalDocument = {
    id: string;
    name: string;
    status: DocumentWorkflowInstanceStatus;
    signatureType: SignatureType;
    signers: Array<InvestmentDetailsLegalDocumentSigner>;
};

export type GetInvestmentDetailsLegalDocumentsRes = {
    legalDocuments: Array<InvestmentDetailsLegalDocument>;
    canMutateLegalDocuments: boolean;
};

export type ManageableLegalDocument = {
    templateId: string;
    name: string;
    instruction: string | null;
    isEnabled: boolean;
};

export type GetManageableLegalDocumentsRes = {
    masterDocuments: Array<ManageableLegalDocument>;
    canMutateLegalDocuments: boolean;
};

export type ToggleLegalDocumentDto = {
    enabled: boolean;
};

export type InvestmentDetailsBankIdentifier = {
    /**
     * Display label for the key, e.g. Sort code
     */
    label: string;
    value: string;
};

export type InvestmentDetailsBankInformation = {
    id: string | null;
    accountHolder: string | null;
    bankName: string | null;
    accountNumber: string | null;
    swiftCode: string | null;
    iban: string | null;
    countryCode: string | null;
    currency: CurrencyType | null;
    identifiers: Array<InvestmentDetailsBankIdentifier>;
    isNew: boolean;
};

export type GetInvestmentDetailsBankInformationRes = {
    bankInformation: InvestmentDetailsBankInformation | null;
    selectedBankAccountId: string | null;
};

export type InvestmentDetailsOtherDataItem = {
    id: string;
    label: string;
    value: string;
};

export type GetInvestmentDetailsOtherDataRes = {
    otherData: Array<InvestmentDetailsOtherDataItem>;
    hasProgrammeCustomDataFields: boolean;
};

export const InvestmentDetailsTaxComplianceStatus = {
    REQUESTED: 'REQUESTED',
    SUBMITTED: 'SUBMITTED',
    APPROVED: 'APPROVED',
    REJECTED: 'REJECTED'
} as const;

export type InvestmentDetailsTaxComplianceStatus = typeof InvestmentDetailsTaxComplianceStatus[keyof typeof InvestmentDetailsTaxComplianceStatus];

export type InvestmentDetailsTaxComplianceItem = {
    id: string;
    name: string;
    subtitle: string | null;
    status: InvestmentDetailsTaxComplianceStatus;
};

export type GetInvestmentDetailsTaxComplianceRes = {
    taxCompliance: Array<InvestmentDetailsTaxComplianceItem>;
    hasProgrammeTaxComplianceForms: boolean;
};

export const KycFileType = {
    PROOF_OF_ADDRESS: 'PROOF_OF_ADDRESS',
    PROOF_OF_IDENTITY: 'PROOF_OF_IDENTITY',
    INVESTMENT_VEHICLE: 'INVESTMENT_VEHICLE',
    FORM: 'FORM',
    OTHER: 'OTHER'
} as const;

export type KycFileType = typeof KycFileType[keyof typeof KycFileType];

export type GetInvestmentsKycInfo = {
    id: string;
    type: KycFileType;
    status: AcceptanceStatus;
    isInherited: boolean;
};

export type GetInvestmentsExpectedKycItem = {
    type: KycFileType;
    isSubmitted: {
        [key: string]: unknown;
    } | null;
};

export const DeclarationType = {
    BENEFICIAL_OWNERSHIP: 'BENEFICIAL_OWNERSHIP',
    POLITICALLY_EXPOSED_PERSON: 'POLITICALLY_EXPOSED_PERSON',
    SOURCE_OF_FUNDS_SALARY: 'SOURCE_OF_FUNDS_SALARY',
    SOURCE_OF_FUNDS_INHERITANCE: 'SOURCE_OF_FUNDS_INHERITANCE',
    SOURCE_OF_FUNDS_INVESTMENT_INCOME: 'SOURCE_OF_FUNDS_INVESTMENT_INCOME',
    SOURCE_OF_FUNDS_PERSONAL_SAVINGS: 'SOURCE_OF_FUNDS_PERSONAL_SAVINGS',
    SOURCE_OF_FUNDS_OTHER: 'SOURCE_OF_FUNDS_OTHER'
} as const;

export type DeclarationType = typeof DeclarationType[keyof typeof DeclarationType];

export type GetInvestmentsDeclarationInfo = {
    id: string;
    type: DeclarationType;
    status: AcceptanceStatus;
    isInherited: boolean;
};

export type GetInvestmentDetailsKycStatusRes = {
    isKycRequired: boolean;
    kyc: Array<GetInvestmentsKycInfo>;
    expectedKyc: Array<GetInvestmentsExpectedKycItem>;
    declarations: Array<GetInvestmentsDeclarationInfo>;
};

export type SetTargetDatesDto = {
    targetStartDate?: string | null;
    targetCompletionDate?: string | null;
};

export type SetInvestmentDetailsPivDto = {
    pivPersonId: string | null;
};

export type SetSelectedBankAccountDto = {
    bankAccountId?: string | null;
};

export type InvestorBulkActionDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
};

export type ReleaseInvestmentWorkflowRes = {
    releaseTsaWorkflowHandle: string;
};

export type ReleaseInvestmentWorkflowDto = {
    [key: string]: unknown;
};

export const InvestmentKycFilterStatus = {
    APPROVED: 'APPROVED',
    PENDING: 'PENDING',
    REJECTED: 'REJECTED',
    REREQUESTED: 'REREQUESTED',
    EXPECTED: 'EXPECTED'
} as const;

export type InvestmentKycFilterStatus = typeof InvestmentKycFilterStatus[keyof typeof InvestmentKycFilterStatus];

export const DocumentStatus = {
    INCOMPLETE: 'INCOMPLETE',
    COMPLETE: 'COMPLETE',
    COMPLETED_OUTSIDE_DEALSTACK: 'COMPLETED_OUTSIDE_DEALSTACK',
    PENDING: 'PENDING',
    NA: 'NA'
} as const;

export type DocumentStatus = typeof DocumentStatus[keyof typeof DocumentStatus];

export type InvestmentsFilterDto = {
    /**
     * Filter by release status (isCompleted)
     */
    isReleased?: boolean;
    /**
     * search by investor displayName or email
     */
    investorSearch?: string;
    createdDate?: DateRangeDto;
    /**
     * Filter by the latest updated date across the investment and its related records
     */
    updatedDate?: DateRangeDto;
    investmentWorkflowType?: InvestmentWorkflowType;
    paymentStatus?: TransactionState;
    investmentStatus?: InvestmentWorkflowStatus;
    securityIds?: Array<string>;
    kycStatus?: InvestmentKycFilterStatus;
    contractName?: string;
    contractStatus?: DocumentStatus;
    /**
     * Filter by release eligibility (KYC completed, contracts signed, payment completed, completion step done)
     */
    isEligibleForRelease?: boolean;
    /**
     * Filter to investments whose allocations can still be updated (MIP-2481: not released, and no generated document that both carries an individual schedule and requires a signature)
     */
    isEligibleForAllocationsUpdate?: boolean;
    /**
     * Filter by specific TSA IDs
     */
    investmentWorkflowIds?: Array<string>;
    /**
     * Filter to specific investors by ID — the exact counterpart of investorSearch
     */
    investorIds?: Array<string>;
    /**
     * Filter by cohort (MipClassifier) IDs
     */
    mipClassifierIds?: Array<string>;
};

export type InvestmentsListQueryDto = {
    pagination?: PaginationDto;
    sortBy?: Array<SortDto>;
    search?: string;
    filter?: InvestmentsFilterDto;
};

export const ClassifierType = {
    VALUATION: 'VALUATION',
    DOCUMENT: 'DOCUMENT',
    VALUATION_INPUT: 'VALUATION_INPUT',
    VALUATION_PERSON_INPUT_SOURCE: 'VALUATION_PERSON_INPUT_SOURCE',
    VALUATION_PERSON_INPUT_USE: 'VALUATION_PERSON_INPUT_USE',
    INVESTOR_COHORT: 'INVESTOR_COHORT'
} as const;

export type ClassifierType = typeof ClassifierType[keyof typeof ClassifierType];

export type MipClassifierRes = {
    id: string;
    mipId: string;
    classifierId: string;
    name: string;
    classifiedType: ClassifierType;
    archived: boolean;
    updatedAt: string;
    createdAt: string;
};

export type GetInvestmentsInvestorInfo = {
    id: string;
    email: string;
    displayName: string;
    mipClassifiers: Array<MipClassifierRes>;
};

export type GetInvestmentsAllocationInfo = {
    securityId: string;
    securityName: string;
    securityType: SecurityType;
    securityIssuedIn: {
        [key: string]: unknown;
    };
    securityUnitDenominator: number;
    units: number;
    cost: number;
    currency: CurrencyType;
    expectedTransactionType?: ExpectedTransactionType | null;
};

export type GetInvestmentsLoanInfo = {
    loanDefinitionId: string;
    loanDefinitionName: string;
    type: LoanDefinitionType;
    currency: CurrencyType;
    cost: number;
};

export type GetInvestmentsExpectedFormItem = {
    templateId: string;
    formName: string;
    isSubmitted: {
        [key: string]: unknown;
    } | null;
    status: AcceptanceStatus;
    isInherited: boolean;
    kycFormWorkflowStateId: string | null;
};

export type GetInvestmentsContractInfo = {
    id: string;
    name: string;
    isSigned: boolean;
    status: DocumentStatus;
};

export type GetInvestmentsPaymentInfo = {
    cost: number;
    status: TransactionState;
};

export type GetInvestmentsForMipItem = {
    investmentWorkflowId: string;
    kycWorkflowId?: {
        [key: string]: unknown;
    } | null;
    isCompleted: boolean;
    investor: GetInvestmentsInvestorInfo;
    type: InvestmentWorkflowType;
    allocations: Array<GetInvestmentsAllocationInfo>;
    loans: Array<GetInvestmentsLoanInfo>;
    considerationCurrency: CurrencyType;
    isKycRequired: boolean;
    kyc: Array<GetInvestmentsKycInfo>;
    expectedKyc: Array<GetInvestmentsExpectedKycItem>;
    expectedForms: Array<GetInvestmentsExpectedFormItem>;
    declarations: Array<GetInvestmentsDeclarationInfo>;
    isBeneficialOwnershipRequired: boolean;
    isSourceOfFundsRequired: boolean;
    isPepRequired: boolean;
    contracts: Array<GetInvestmentsContractInfo>;
    payment: GetInvestmentsPaymentInfo;
    status: InvestmentWorkflowStatus;
    createdAt: string;
    updatedAt: string;
    isEligibleForRelease: boolean;
};

export type InvestmentStats = {
    investorCount: number;
    allocationsCount: {
        [key: string]: GetInvestmentsAllocationInfo;
    };
    loansCount: {
        [key: string]: GetInvestmentsLoanInfo;
    };
    kycStatusCounts: {
        [key: string]: number;
    };
    contractStatusCounts: {
        [key: string]: number;
    };
    fundsTransferTotal: number;
    fundsTransferCurrency: CurrencyType;
    createdAtUniqueCount: number;
};

export type GetInvestmentsForMipRes = {
    totalCount: number;
    hasNextPage: boolean;
    investments: Array<GetInvestmentsForMipItem>;
    stats: InvestmentStats;
};

export type GetInvestmentOrderedIdsRes = {
    ids: Array<string>;
};

export type BulkUpdateExpectedTransactionTypeDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: InvestmentsFilterDto;
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    expectedTransactionType: ExpectedTransactionType | null;
};

export type BulkUpdateExpectedTransactionTypeRes = {
    updatedCount: number;
};

export type DownloadInvestmentsExcelDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: InvestmentsFilterDto;
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    mipId: string;
    oneSchemaAllocationsTemplate?: boolean;
};

export type AddInvestmentAllocationDto = {
    securityId: string;
    units: number;
    cost: number;
    vestingTermId?: string | null;
    expectedTransactionType?: ExpectedTransactionType | null;
};

export type UpdateInvestmentAllocationDto = {
    securityId?: string;
    units?: number;
    cost?: number;
    vestingTermId?: string | null;
    expectedTransactionType?: ExpectedTransactionType | null;
};

export type AddInvestmentLoanDto = {
    loanDefinitionId: string;
    amount: number;
};

export type UpdateInvestmentLoanDto = {
    loanDefinitionId: string;
    amount: number;
};

export type UpsertShareAssociationsDto = {
    records: Array<OneSchemaShareAssociationRowValueDto>;
};

export const InvestorsSortingColumn = {
    INVESTOR: 'investor',
    INVESTMENT_STATUS: 'investment_status',
    APPROVAL_STATUS: 'approval_status',
    TOTAL_SECURITIES: 'total_securities',
    TOTAL_HOLDINGS: 'total_holdings',
    TOTAL_PENDING: 'total_pending',
    LAST_LOGIN: 'last_login',
    INVESTMENT_VEHICLE: 'investment_vehicle',
    CITIZENSHIP: 'citizenship',
    EMPLOYEE_ID: 'employee_id'
} as const;

export type InvestorsSortingColumn = typeof InvestorsSortingColumn[keyof typeof InvestorsSortingColumn];

export const SortingOrder = { ASC: 'asc', DESC: 'desc' } as const;

export type SortingOrder = typeof SortingOrder[keyof typeof SortingOrder];

export type InvestorsSortingQuery = {
    sortingColumn?: InvestorsSortingColumn;
    sortingOrder?: SortingOrder;
};

export type QueryRequestDtoV2 = {
    offset: number;
    limit: number;
    filterQuery?: InvestorsFilterQuery;
    sortingQuery: InvestorsSortingQuery;
    searchQuery?: string;
};

export type MinimalPersonRes = {
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
};

export type PivPersonRes = {
    firstName: string;
    lastName: string;
    displayName: string;
    email: string;
    /**
     * The vehicle person, for linking through to its details page
     */
    id: string;
    jurisdictionCountryCode?: string;
    registeredNumber?: string;
};

export type TaxResidenceSummaryRes = {
    countryCode: string;
    number: string | null;
};

export type InvestorCustomDetailSummaryRes = {
    customDetailId: string;
    name: string;
    value: string;
};

export type GetParsedInvestorRes = {
    person: MinimalPersonRes;
    pivPersons: Array<PivPersonRes>;
    id: string;
    processSettings?: InvestorProcessSettingsDto;
    hasActiveInvestmentWorkflow: boolean;
    activeInvestmentWorkflowId?: string;
    currency: {
        [key: string]: unknown;
    };
    totalHoldings?: number;
    programmeStatus: ProgrammeStatus;
    accountStatus: AccountStatus;
    lastLoginAt?: string | null;
    mipClassifiers: Array<MipClassifierRes>;
    countryOfBirth?: string | null;
    taxResidences: Array<TaxResidenceSummaryRes>;
    /**
     * Citizenship country codes
     */
    citizenships: Array<string>;
    /**
     * Employee identifiers, formatted as `employer:employee_id`
     */
    employeeIds: Array<string>;
    customDetails: Array<InvestorCustomDetailSummaryRes>;
};

export type InvestorsListStatsRes = {
    /**
     * Total unique investor count (across all pages)
     */
    investorCount: number;
    /**
     * Count of investors grouped by programme status
     */
    programmeStatusCounts: {
        [key: string]: number;
    };
    /**
     * Count of investors grouped by account status
     */
    accountStatusCounts: {
        [key: string]: number;
    };
    /**
     * Count of unique investment vehicles (PIVs) across all investors
     */
    investmentVehicleCount: number;
    /**
     * Sum of totalHoldings across all matching investors
     */
    totalHoldingsSum: number;
    totalHoldingsCurrency: CurrencyType;
};

export type InvestorCustomDetailColumnRes = {
    customDetailId: string;
    name: string;
    dataType: CustomDetailDataTypeEnum;
};

export type GetInvestorsListRes = {
    investors: Array<GetParsedInvestorRes>;
    stats: InvestorsListStatsRes;
    customDetailColumns: Array<InvestorCustomDetailColumnRes>;
};

export type GetInvestorOrderedIdsRes = {
    ids: Array<string>;
};

export type GetInvestorDataForSendModal = {
    id: string;
    person: MinimalPersonRes;
    linkedContractsName: Array<string>;
    willBeSSOUser: boolean;
};

export type GetInvestorForSendModalRes = {
    investors: Array<GetInvestorDataForSendModal>;
    totalRecord: number;
};

export type DataShareAssociationTct = {
    id: string;
    number: number;
    cost: number;
    isNegative: boolean;
    securityId: string;
    security: DataSecurityTct;
    vestingStartDate: {
        [key: string]: unknown;
    } | null;
    expectedTransactionType?: ExpectedTransactionType | null;
    createdAt: string;
    updatedAt: string;
};

export const KycEventLogAction = {
    SUBMITTED: 'SUBMITTED',
    REVIEWED: 'REVIEWED',
    DELETED: 'DELETED',
    ADDITIONAL_FILE_REQUESTED: 'ADDITIONAL_FILE_REQUESTED',
    ADDITIONAL_FILE_REQUEST_CANCELLED: 'ADDITIONAL_FILE_REQUEST_CANCELLED',
    CERTIFICATION_ATTESTED: 'CERTIFICATION_ATTESTED',
    CERTIFIER_NOMINATED: 'CERTIFIER_NOMINATED',
    CERTIFIED: 'CERTIFIED',
    CERTIFICATION_CANCELLED: 'CERTIFICATION_CANCELLED'
} as const;

export type KycEventLogAction = typeof KycEventLogAction[keyof typeof KycEventLogAction];

export type KycEventLogFile = {
    id: string;
    name: string;
};

export type KycEventLogPublicSigner = {
    email: string | null;
    role: DocumentSigningRoleType | null;
    fullName: string | null;
};

export type UserAction = {
    userSession: UserSession | null;
    publicSigner?: KycEventLogPublicSigner | null;
};

export type KycEventLogEntity = {
    id: string;
    action: KycEventLogAction;
    status: AcceptanceStatus;
    createdAt: string;
    file: KycEventLogFile | null;
    userAction: UserAction;
    comment: string | null;
    kycFileId?: string | null;
    templateId?: string | null;
};

export type DataDeclarationTct = {
    id: string;
    description: {
        [key: string]: unknown;
    } | null;
    rejectionComment: {
        [key: string]: unknown;
    } | null;
    checked: boolean;
    status: AcceptanceStatus;
    type: DeclarationType;
    subjectAction: SubjectAction | null;
    updatedAt: string;
    kycEventLog: Array<KycEventLogEntity>;
};

export type Decimal2 = {
    [key: string]: unknown;
};

export type DataSimpleInvestorTct = {
    id: string;
    state: {
        [key: string]: unknown;
    };
    user: DataUserInvestorTct;
    singleAddress: string;
    declarations: Array<DataDeclarationTct>;
    totalHoldings: Decimal2 | null;
    totalPending: Decimal2 | null;
    totalSecurities: number | null;
    investmentStatus: {
        [key: string]: unknown;
    };
};

export type DataInvestmentWorkflowTct = {
    id: string;
    shareAssociations: Array<DataShareAssociationTct>;
    paymentAnnotation: string;
    paymentStatus: TransactionState;
    type: InvestmentWorkflowType;
    createdAt: string;
    updatedAt: string;
    latestUpdatedAt: string;
    pivPersonId: {
        [key: string]: unknown;
    } | null;
    isCompleted: boolean;
    status: InvestmentWorkflowStatus;
    completionStep: InvestmentWorkflowCompletionStep;
    startedAt: string | null;
    approvedAt: string | null;
    createdById: string | null;
    targetStartDate: string | null;
    targetCompletionDate: string | null;
    selectedBankAccountId: string | null;
    investor: DataSimpleInvestorTct;
};

export type GetSelectedInvestorInstanceRes = {
    id: string;
    isEligibleForRelease: boolean;
    isEligibleForAllocations: boolean;
    isEligibleForLeavers: boolean;
    isEligibleForRemoval: boolean;
};

export type GetSelectedInvestorRes = {
    investors: Array<GetSelectedInvestorInstanceRes>;
    totalRecord: number;
};

export type InvestorsFilterQueryDto = {
    filterQuery?: InvestorsFilterQuery;
};

export const KycFileCertificationStatus = {
    UNCERTIFIED: 'UNCERTIFIED',
    SELF_ATTESTED: 'SELF_ATTESTED',
    PENDING_CERTIFIER: 'PENDING_CERTIFIER',
    CERTIFIED: 'CERTIFIED'
} as const;

export type KycFileCertificationStatus = typeof KycFileCertificationStatus[keyof typeof KycFileCertificationStatus];

export const KycCertificationState = {
    PENDING: 'PENDING',
    CERTIFIED: 'CERTIFIED',
    CANCELLED: 'CANCELLED'
} as const;

export type KycCertificationState = typeof KycCertificationState[keyof typeof KycCertificationState];

export type KycFileCertificationSummaryRes = {
    state: KycCertificationState;
    certifierName: string;
    certifierEmail: string;
    invitedAt: string | null;
    certifiedAt: string | null;
};

export type DataKycFileTct = {
    id: string;
    fileId: string;
    fileName: string;
    rejectionComment: {
        [key: string]: unknown;
    } | null;
    createdById: string;
    customDetailId: {
        [key: string]: unknown;
    } | null;
    type: KycFileType;
    status: AcceptanceStatus | null;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    kycWorkflowId: string;
    subjectAction: SubjectAction | null;
    certificationStatus: KycFileCertificationStatus;
    certificationAttestedAt: string | null;
    certification: KycFileCertificationSummaryRes | null;
};

export const InvestorInvitationStatus = {
    NOT_INVITED: 'NOT_INVITED',
    INVITED: 'INVITED',
    ACTIVE: 'ACTIVE'
} as const;

export type InvestorInvitationStatus = typeof InvestorInvitationStatus[keyof typeof InvestorInvitationStatus];

export type InvestorInvitationStatusAndDateRes = {
    status: InvestorInvitationStatus;
    invitedAt: string;
};

export const InvestorInvestmentStatus = { CREATED: 'CREATED', RELEASED: 'RELEASED' } as const;

export type InvestorInvestmentStatus = typeof InvestorInvestmentStatus[keyof typeof InvestorInvestmentStatus];

export type DataInvestorCustomDetailTct = {
    id: string;
    value: string;
    customDetailId: string;
    customDetail: DataCustomDetailTct;
};

export type PaymentInformationRes = {
    isAnyInvestmentWorkflowExist: boolean;
    isSingleInvestmentWorkflow: boolean;
    isAllPaymentsCompleted: boolean;
    isSomePaymentsPending: boolean;
    isSinglePaymentPending: boolean;
    investmentWorkflowId?: string;
};

export type OutstandingDocumentForReleaseRes = {
    name: string;
    status: {
        [key: string]: unknown;
    };
};

export type SessionInfo = {
    fullName: string;
    email: string;
    createdAt: string;
    ipAddress: string;
    /**
     * Country and city
     */
    location: string | null;
    /**
     * Browser, version, and OS
     */
    deviceInfo: string;
};

export type DataPersonWithTaxResidenceRes = {
    id: string;
    dateOfBirth: string | null;
    deleted: boolean;
    email: string | null;
    firstName?: string | null;
    displayName: string;
    gender: Gender | null;
    lastName?: string | null;
    userId: string | null;
    phoneNumber: string | null;
    placeOfBirth: string | null;
    countryOfBirth: string | null;
    citizenship: Array<string>;
    domicile: string | null;
    tags: Array<LegalPersonTags> | null;
    hasNomineeStructure: boolean;
    telephonePrefix: string | null;
    type: PersonType;
    providerDetailsFriendlyName: string | null;
    providerDetailsLegalForm: string | null;
    personRegistrationDetailsId: string | null;
    securities?: Array<DataSecurityTct>;
    addresses?: Array<AddressRes>;
    registrationDetails: RegistrationDetailsRes | null;
    updatedAt: string;
    createdAt: string;
    taxResidence: Array<GetPersonTaxInformationRes>;
};

export type GetInvestorDetailsWithPersonRes = {
    currency: CurrencyType;
    kycFiles: Array<DataKycFileTct>;
    declarations: Array<DataDeclarationTct>;
    investorInvitation: InvestorInvitationStatusAndDateRes;
    latestInvestmentStatus: InvestorInvestmentStatus;
    action: InvestmentWorkflowStatus;
    investmentStatus: InvestmentWorkflowStatus;
    programmeStatus: ProgrammeStatus;
    linkedContractsName: Array<string>;
    isUserActive: boolean;
    isKycRequired: boolean;
    investorCustomDetails: Array<DataInvestorCustomDetailTct>;
    paymentInformation: PaymentInformationRes;
    pivPerson?: DataPersonTct | null;
    pivPersons: Array<DataPersonTct>;
    representativePerson?: DataPersonTct | null;
    activeKycWorkflowId?: {
        [key: string]: unknown;
    } | null;
    fundAmount: number;
    isProofOfIdentityRequired?: boolean;
    isProofOfAddressRequired?: boolean;
    isProofOfInvestmentVehicleRequired?: boolean;
    canRelease?: boolean;
    outstandingDocumentsForRelease?: Array<OutstandingDocumentForReleaseRes>;
    lastLoginAt?: string | null;
    latestSession?: SessionInfo | null;
    person: DataPersonWithTaxResidenceRes;
    mipCustomDetails: Array<DataCustomDetailTct>;
};

export const TransactionType2 = { BUY: 'BUY', SELL: 'SELL' } as const;

export type TransactionType2 = typeof TransactionType2[keyof typeof TransactionType2];

export type GetInvestorTransactionDetailsRes = {
    id: string;
    investmentWorkflowComputedType: 'JOINER_CREATE' | 'JOINER' | 'ALLOCATION' | 'LEAVER' | 'PARTIAL_LEAVER';
    completedDate?: string;
    createdDate: string;
    transactionType?: TransactionType2;
    securityType?: SecurityType;
    securityUnitDenominator: {
        [key: string]: unknown;
    };
    /**
     * CURRENCY means totalVolume holds the amount. Null for a loan.
     */
    securityIssuedIn: SecurityIssuedIn | null;
    loanType?: LoanDefinitionType;
    isNegative?: boolean;
    vestingTermId?: string;
    vestingStartDate?: string;
    securityName: string;
    isSubjectToVesting: boolean;
    totalVolume: {
        [key: string]: unknown;
    };
    totalValue: number;
    /**
     * An ISSUE, or untyped as a joiner release leaves it; the only rows the vesting maths reads a term for.
     */
    isIssue?: boolean;
    /**
     * The term's own name, which may belong to another programme's term list.
     */
    vestingTermName?: string;
};

export const InvestmentApprovalStatus = { PENDING: 'PENDING', APPROVED: 'APPROVED' } as const;

export type InvestmentApprovalStatus = typeof InvestmentApprovalStatus[keyof typeof InvestmentApprovalStatus];

export type InvestmentSecurityRes = {
    id: string;
    name: string;
    type: SecurityType;
    isSubjectToVesting: boolean;
    vestingTermId: string | null;
    units: number;
    unitDenominator: number;
};

export type GetInvestorInvestmentDetailsRes = {
    totalInvestment: number;
    currency?: CurrencyType;
    hasShareAssociation: boolean;
    investmentUnits: {
        LOAN?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        PREFERENCE_SHARE?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        TRACKING_SHARE?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        PARTNERSHIP_UNIT?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        OPTIONS?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        ORDINARY_SHARE?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        VIRTUAL_EQUITY?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        OTHER?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        WARRANT?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        OTHER_EQUITY?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        BOND?: {
            value?: number;
            securityUnitDenominator?: number;
        };
        DEFERRED_SHARE?: {
            value?: number;
            securityUnitDenominator?: number;
        };
    };
    investmentId: string;
    vestingSaId: string | null;
    state: InvestmentApprovalStatus;
    completedDate?: string;
    createdDate: string;
    isPaymentCompleted: boolean;
    isPaymentPending: boolean;
    investmentWorkflowComputedType: 'JOINER_CREATE' | 'JOINER' | 'ALLOCATION' | 'LEAVER' | 'PARTIAL_LEAVER';
    vestingTermId: string;
    hasVestingSubjects: boolean;
    vestingStartDate?: string;
    investmentSecurities: Array<InvestmentSecurityRes>;
};

export type GetInvestorInvestmentsAndTransactionsRes = {
    transactionDetails: Array<GetInvestorTransactionDetailsRes>;
    investmentDetails: Array<GetInvestorInvestmentDetailsRes>;
    pendingTransactionDetails?: Array<GetInvestorTransactionDetailsRes>;
    pendingInvestmentDetails?: Array<GetInvestorInvestmentDetailsRes>;
    totalInvestmentValue: number;
    selectedBankAccountId: string | null;
};

export type InvestorDocumentWorkflowWitnessRes = {
    signedCount: number;
    requiredCount: number;
};

export type InvestorDocumentWorkflowInvestorSignatureRes = {
    status: DocumentWorkflowInstanceSignatureStatus | null;
    signedCount: number | null;
    totalCount: number | null;
    witness: InvestorDocumentWorkflowWitnessRes | null;
};

export type InvestorDocumentWorkflowCounterpartySignatureRes = {
    roleId: string;
    roleName: string | null;
    status: DocumentWorkflowInstanceSignatureStatus | null;
    witness: InvestorDocumentWorkflowWitnessRes | null;
};

export type InvestorDocumentWorkflowInvestmentWorkflowRes = {
    investmentWorkflowId: string;
    investmentWorkflowType: 'JOINER_CREATE' | 'JOINER' | 'ALLOCATION' | 'LEAVER';
    isReleased: boolean | null;
    date: string | null;
};

export type InvestorDocumentWorkflowDocumentRes = {
    documentWorkflowInstanceId: string;
    documentWorkflowInstanceSignatureId: string | null;
    documentName: string | null;
    fileId: string | null;
    fileName: string | null;
    signingScope: DocumentSigningScope;
    signatureType: SignatureType | null;
    eSignProvider: ESignProvider | null;
    investorSignature: InvestorDocumentWorkflowInvestorSignatureRes;
    counterpartySignatures: Array<InvestorDocumentWorkflowCounterpartySignatureRes>;
    workflowStatus: DocumentWorkflowInstanceStatus;
    investmentWorkflow: InvestorDocumentWorkflowInvestmentWorkflowRes | null;
    isPlainDocument: boolean;
    personId: string | null;
};

export type GetInvestorDocumentWorkflowsRes = {
    documents: Array<InvestorDocumentWorkflowDocumentRes>;
};

export type InviteDto = {
    investorId: string;
};

export type SendInvestorInviteDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
    invites?: Array<InviteDto>;
    customizedEmailBody?: string;
};

export type InvestorInviteRes = {
    investorInviteWorkflowHandle: string;
};

export type LoanDefinitionSimpleDto = {
    type: LoanDefinitionType;
    name: string;
};

export type DataJoinerInvestorGetTemplateDto = {
    investorId?: Array<string>;
    bulkAction?: InvestorBulkActionDto;
    pendingSecurities: Array<CreateSecurityDto>;
    loansDefinitions: Array<LoanDefinitionSimpleDto>;
};

export type PostInvestorJoinerSecurityInstance = {
    totalNumber: number;
    totalCost: number;
    name: string;
    securityId: string;
    type: SecurityType;
};

export type PostInvestorJoinerLoanInstance = {
    amount: number;
    name: string;
    loanDefinitionId: string;
    type: LoanDefinitionType;
    currency?: CurrencyType;
};

export type PostInvestorJoinerInvestorInstance = {
    firstName: string;
    lastName: string;
    email: string;
    isEligibleForNewInvestmentWorkflow: boolean;
    securities: Array<PostInvestorJoinerSecurityInstance>;
    loans: Array<PostInvestorJoinerLoanInstance>;
};

export type PostInvestorJoinerStatisticsBySecurity = {
    totalCost: number;
    totalNumber: number;
    name: string;
    securityId: string;
    type: SecurityType;
};

export type PostInvestorJoinerStatistics = {
    investorsCount: number;
    bySecurity: Array<PostInvestorJoinerStatisticsBySecurity>;
};

export type PostInvestorJoinerParseTemplateRes = {
    data: Array<PostInvestorJoinerInvestorInstance>;
    isValid: boolean;
    statistics: PostInvestorJoinerStatistics;
};

export type PostInvestorLeaverSecurityInstance = {
    totalNumber: number;
    currentHoldings: number;
    totalCost: number;
    name: string;
    securityId: string;
    type: SecurityType;
};

export type PostInvestorLeaverLoanInstance = {
    amountRemaining: number;
    amount: number;
    name: string;
    loanDefinitionId: string;
    type: LoanDefinitionType;
};

export type PostInvestorLeaverInvestorInstance = {
    firstName: string;
    lastName: string;
    email: string;
    securities: Array<PostInvestorLeaverSecurityInstance>;
    loans: Array<PostInvestorLeaverLoanInstance>;
};

export type PostInvestorLeaverStatisticsBySecurity = {
    totalCost: number;
    totalNumber: number;
    name: string;
    securityId: string;
    type: SecurityType;
};

export type PostInvestorLeaverStatistics = {
    investorsCount: number;
    bySecurity: Array<PostInvestorLeaverStatisticsBySecurity>;
};

export type PostInvestorLeaverParseTemplateRes = {
    data: Array<PostInvestorLeaverInvestorInstance>;
    isValid: boolean;
    statistics: PostInvestorLeaverStatistics;
};

export type BulkRevokeInvestmentWorkflowDto = {
    investmentWorkflowIds: Array<string>;
};

export type InvestorCustomDetailValueDto = {
    customDetailId: string;
    /**
     * Empty clears the value; the card then shows a dash
     */
    value: string;
};

export type UpdateInvestorCustomDetailsDto = {
    values: Array<InvestorCustomDetailValueDto>;
};

export type VestingChartDataRes = {
    date: number;
    units: number;
    percentage: number;
    unitDenominator: number;
};

export type VestingTermSummaryRes = {
    name: string;
    vestingTermGraded: Array<VestingTermGradedRes>;
    type: VestingTermType;
    vestingTermStraightLine: VestingTermStraightLineRes;
};

export type GetSecurityVestingRes = {
    vestedPercentage?: number;
    chartData?: Array<VestingChartDataRes>;
    vestingTerms?: Array<VestingTermSummaryRes>;
    earliestTsaDate?: string;
};

export type GetValuationsRes = {
    volume: number;
    cost: number;
    value?: number | null;
    name: string;
    securityUnitDenominator: number;
    securityId: string;
    securityCurrency: CurrencyType;
    isSubjectToVesting: boolean;
    type: SecurityType;
    vestedPercentage?: number;
    chartData?: Array<VestingChartDataRes>;
    vestingTerms?: Array<VestingTermSummaryRes>;
    earliestTsaDate?: string;
};

export type GetLoansRes = {
    /**
     * The loan security id — unique per borrower, not per funder
     */
    id: string;
    loanDefinitionId: string;
    type: LoanDefinitionType;
    name: string;
    funder: string;
    /**
     * Person id of the funder, for linking to their holdings
     */
    funderId: string;
    /**
     * The borrower: the investor, or a vehicle acting for them
     */
    issuerId: string;
    issuerName: string | null;
    /**
     * True when a vehicle took the loan on for the investor
     */
    isViaVehicle: boolean;
    currency: CurrencyType;
    totalValue: number;
    isNegative?: boolean;
    hardcodedBalanceReached?: boolean;
};

export type GetInvestorValuationsRes = {
    valuations: Array<GetValuationsRes>;
    loans: Array<GetLoansRes>;
    currency: CurrencyType;
    entityName?: string | null;
    programmeName?: string | null;
    targetName: string;
    securityValuationDate?: {
        [key: string]: unknown;
    };
    investorId: string;
    shareWithInvestorSecurityValuation?: boolean;
};

export type GetInvestmentVehicleValuationsRes = {
    valuations: Array<GetValuationsRes>;
    loans: Array<GetLoansRes>;
    currency: CurrencyType;
};

export type RelatedInvestorRes = {
    id: string;
    displayName: string | null;
    relationId: string;
    email: string | null;
    customRelationType: string | null;
    taxResidence: Array<GetPersonTaxInformationRes>;
    investorId: string | null;
};

export type GetInvestmentVehicleRelatedPeopleRes = {
    PIV: Array<RelatedInvestorRes>;
    REPRESENTATIVE: Array<RelatedPersonRes>;
    UBO: Array<RelatedPersonRes>;
    PSC: Array<RelatedPersonRes>;
    DIRECTOR: Array<RelatedPersonRes>;
    TRUSTEE: Array<RelatedPersonRes>;
    SETTLER_OR_GRANTOR: Array<RelatedPersonRes>;
    PROTECTOR_OR_ENFORCER: Array<RelatedPersonRes>;
    BENEFICIARY: Array<RelatedPersonRes>;
    OTHER: Array<RelatedPersonRes>;
};

export type InvestorHoldingRes = {
    /**
     * Stable row key — the balance-bearing transaction
     */
    transactionId: string;
    /**
     * Investor or the vehicle holding on their behalf
     */
    holderId: string;
    holderName: string | null;
    /**
     * True when a vehicle holds these units for the investor
     */
    isViaVehicle: boolean;
    /**
     * The investor the units are held for. Set on the vehicle view.
     */
    heldForName: string | null;
    /**
     * That investor's row in this programme, which the vesting panel reads
     */
    heldForInvestorId: string | null;
    /**
     * Issuing person (a MIP entity)
     */
    issuerId: string | null;
    issuerName: string | null;
    securityId: string;
    securityName: string;
    securityType: SecurityType;
    currency: CurrencyType;
    securityUnitDenominator: number;
    /**
     * Units currently held
     */
    units: number;
    /**
     * Actual acquisition cost of the units held
     */
    cost: number;
    /**
     * Average acquisition cost per unit, disposed lots included
     */
    averageAcquisitionCostPerUnit: number | null;
    /**
     * That average times the units held
     */
    averageAcquisitionTotalCost: number | null;
    /**
     * Surviving lots basis per unit held
     */
    actualCostPerUnit: number | null;
    currentValue: number | null;
    isSubjectToVesting: boolean;
    /**
     * Null for a holding outside any programme, and on the vehicle view.
     */
    investmentProgrammeId: string | null;
    /**
     * Acquisitions and disposals behind the balance. Null on the vehicle view.
     */
    transactionCount: number | null;
    /**
     * CURRENCY means units holds the amount, not a unit count.
     */
    securityIssuedIn: SecurityIssuedIn;
};

export type GetInvestorHoldingsRes = {
    holdings: Array<InvestorHoldingRes>;
    securityValuationDate?: string | null;
};

export type GetInvestmentVehicleQuickLinksRes = {
    /**
     * Investments of this investor; the tile links to the same list
     */
    investments: number;
    /**
     * KYC workflows of this investor
     */
    kyc: number;
    /**
     * Document workflows of this investor
     */
    documents: number;
    /**
     * Payments of this investor
     */
    payments: number;
    /**
     * Investors the vehicle holds for; the destination pages filter by these
     */
    investorIds: Array<string>;
};

export type GetInvestorQuickLinksRes = {
    /**
     * Investments of this investor; the tile links to the same list
     */
    investments: number;
    /**
     * KYC workflows of this investor
     */
    kyc: number;
    /**
     * Document workflows of this investor
     */
    documents: number;
    /**
     * Payments of this investor
     */
    payments: number;
};

export const JourneyKind = {
    INVESTMENT: 'INVESTMENT',
    STANDALONE_KYC: 'STANDALONE_KYC',
    DOCUMENT: 'DOCUMENT'
} as const;

export type JourneyKind = typeof JourneyKind[keyof typeof JourneyKind];

export const JourneyIndicatorKey = {
    KYC: 'KYC',
    CONTRACTS: 'CONTRACTS',
    PAYMENTS: 'PAYMENTS',
    PROOFS: 'PROOFS',
    DECLARATIONS: 'DECLARATIONS',
    FORMS: 'FORMS',
    INVESTOR_SIGNATURES: 'INVESTOR_SIGNATURES',
    COUNTERPARTY_SIGNATURES: 'COUNTERPARTY_SIGNATURES'
} as const;

export type JourneyIndicatorKey = typeof JourneyIndicatorKey[keyof typeof JourneyIndicatorKey];

export const JourneyIndicatorStatus = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING'
} as const;

export type JourneyIndicatorStatus = typeof JourneyIndicatorStatus[keyof typeof JourneyIndicatorStatus];

export type JourneyIndicatorCountRes = {
    status: JourneyIndicatorStatus;
    count: number;
};

export type JourneyIndicatorRes = {
    key: JourneyIndicatorKey;
    counts: Array<JourneyIndicatorCountRes>;
};

export type InvestorJourneyRes = {
    id: string;
    kind: JourneyKind;
    investmentType: InvestmentWorkflowType | null;
    documentName: string | null;
    indicators: Array<JourneyIndicatorRes>;
};

export type GetInvestorJourneysRes = {
    journeys: Array<InvestorJourneyRes>;
};

export type GetPersonForFilteringRes = {
    firstName: {
        [key: string]: unknown;
    } | null;
    lastName: {
        [key: string]: unknown;
    } | null;
    displayName: string;
};

export type GetInvestorNamesForFiltering = {
    id: string;
    person: GetPersonForFilteringRes;
    state: InvestorState;
    programmeStatus: ProgrammeStatus;
};

export type GetInvestorNamesForFilteringRes = {
    investors: Array<GetInvestorNamesForFiltering>;
    nextCursor?: {
        [key: string]: unknown;
    } | null;
};

export type GetNamesOfPersonWithPivRelationRes = {
    names: Array<NamesOfPersonWithRelation>;
    nextCursor: {
        [key: string]: unknown;
    } | null;
};

export type RequestKycDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
    customizedEmailBody?: string;
    /**
     * Whether to email the investor when the KYC workflow is created. Defaults to true.
     */
    sendNotification?: boolean;
};

export type PostInvestorDraftSecurityRes = {
    totalNumber: number;
    totalCost: number;
    name: string;
    securityId: string;
    type: SecurityType;
    currency?: CurrencyType;
    isSubjectToVesting: boolean;
    unitDenominator: number;
};

export type PostInvestorDraftLoanRes = {
    amount: number;
    name: string;
    loanDefinitionId: string;
    type: LoanDefinitionType;
};

export type PostInvestorDraftInstanceRes = {
    firstName: string;
    lastName: string;
    email: string;
    securities: Array<PostInvestorDraftSecurityRes>;
    loans: Array<PostInvestorDraftLoanRes>;
};

export type PostInvestorDraftStatisticsInstanceRes = {
    totalCost: number;
    totalNumber: number;
    name: string;
    securityId: string;
    type: SecurityType;
    currency?: CurrencyType;
    isSubjectToVesting: boolean;
};

export type PostInvestorDraftStatisticsRes = {
    investorsCount: number;
    bySecurity: Array<PostInvestorDraftStatisticsInstanceRes>;
};

export type PostInvestorDraftRes = {
    data: Array<PostInvestorDraftInstanceRes>;
    isValid: boolean;
    statistics: PostInvestorDraftStatisticsRes;
};

export type GetInvestorDraftStatisticsBySecurityRes = {
    totalNumber: number;
    totalCost: number;
    name: string;
    securityId: string;
    type: SecurityType;
    currency: CurrencyType;
    isSubjectToVesting: boolean;
    unitDenominator: number;
};

export type GetInvestorDraftStatisticsRes = {
    investorsCount: number;
    bySecurity: Array<GetInvestorDraftStatisticsBySecurityRes>;
};

export type GetInvestorStatisticsByLoanRes = {
    name: string;
    type: LoanDefinitionType;
    amount: number;
    loanDefinitionId: string;
    currency?: CurrencyType;
};

export type GetInvestorDraftInstanceRes = {
    firstName: string;
    lastName: string;
    email: string;
    id: string;
    vestingTermId?: string | null;
    contracts: Array<DataContractTct>;
    securities: Array<GetInvestorDraftStatisticsBySecurityRes>;
    loans: Array<GetInvestorStatisticsByLoanRes>;
};

export type GetInvestorDraftRes = {
    statistics: GetInvestorDraftStatisticsRes;
    investors: Array<GetInvestorDraftInstanceRes>;
};

export type DataInvestorSecurityDto = {
    totalNumber: number;
    totalCost: number;
    name: string;
    type: SecurityType;
    isSubjectToVesting?: boolean;
    securityId: string;
};

export type PutLoanDto = {
    amount: number;
    loanDefinitionId: string;
};

export type DataInvestorDto = {
    email: string;
    firstName: string;
    lastName: string;
    securities: Array<DataInvestorSecurityDto>;
    contracts: Array<string>;
    loans: Array<PutLoanDto>;
    vestingTermId?: string;
};

export type InvestorDraftDto = {
    data: Array<DataInvestorDto>;
    isValid: boolean;
};

export type GetPaymentStatisticsRes = {
    paymentCount: number;
    byStatus: {
        [key: string]: number;
    };
};

export type MipPaymentBankIdentifierRes = {
    key: string;
    label: string;
    value: string;
};

export type DataMipPaymentRes = {
    id: string;
    investorId: string;
    investorName: string;
    investorEmail: string;
    bankName?: string;
    bankCountry?: string;
    bankAccountNumber?: string;
    bankIban?: string;
    bankIdentifiers?: Array<MipPaymentBankIdentifierRes>;
    paymentStatus: TransactionState;
    paymentAnnotation?: {
        [key: string]: unknown;
    } | null;
    createdAt: string;
    updatedAt: string;
    totalCost: number;
    currency: CurrencyType;
    isInvestmentWorkflowCompleted: boolean;
    isNegative: boolean;
};

export type GetPaymentRes = {
    statistics: GetPaymentStatisticsRes;
    payments: Array<DataMipPaymentRes>;
};

export type BulkPatchPaymentDto = {
    ids: Array<string>;
    annotation?: string;
    status: TransactionState;
};

export type BulkUpdatePaymentRes = {
    count: number;
};

export type PatchPaymentDto = {
    annotation?: string;
    status?: TransactionState;
};

export type LoanDefinitionDto = {
    type: LoanDefinitionType;
    name: string;
    mipId: string;
    /**
     * Funder person ID if selecting existing, or person name if creating new
     */
    funderPersonId?: string;
    /**
     * Name of the funder person to create (if funderPersonId is a new)
     */
    funderPersonNameToCreate?: string;
};

export type LoanDefinitionDataDto = {
    loansDefinitions: Array<LoanDefinitionDto>;
};

export type UpdateArchivedCustomDetailDto = {
    archived: boolean;
};

export type CreateCustomDetailDto = {
    name: string;
    instruction: string;
    type: CustomDetailEnum;
    fileId?: {
        [key: string]: unknown;
    } | null;
    isChecked?: boolean;
    dataType: CustomDetailDataTypeEnum;
    category?: CustomDetailCategory | null;
    /**
     * Triggers investor reevaluation when true
     */
    triggerInvestorReevaluate?: boolean;
};

export type UpdateCustomDetailDto = {
    name: string;
    instruction: string;
    isChecked?: boolean;
    category?: CustomDetailCategory | null;
    /**
     * Triggers investor reevaluation when true
     */
    triggerInvestorReevaluate?: boolean;
};

export type KycWorkflowCustomDetailResponseDto = {
    customDetailId: string;
    name: string;
    instruction: {
        [key: string]: unknown;
    } | null;
    type: CustomDetailEnum;
    isRequired: boolean;
};

export type UpdateKycWorkflowCustomDetailDto = {
    customDetailId: string;
    isRequired: boolean;
};

export type CreateOrganizationDto = {
    /**
     * Name of the organization
     */
    name: string;
    /**
     * Contact email for the organization
     */
    contactEmail?: string;
    /**
     * Email domains associated with the organization.
     */
    emailDomains?: Array<string>;
    /**
     * Add owner into organization
     */
    ownerEmail: string;
};

/**
 * Sponsor / Advisor / Agent classification. Null for organizations that have never been classified. Only SPONSOR organizations can define Programme Defaults
 */
export const OrganizationType = {
    SPONSOR: 'SPONSOR',
    ADVISOR: 'ADVISOR',
    AGENT: 'AGENT'
} as const;

/**
 * Sponsor / Advisor / Agent classification. Null for organizations that have never been classified. Only SPONSOR organizations can define Programme Defaults
 */
export type OrganizationType = typeof OrganizationType[keyof typeof OrganizationType];

export type OrganizationRes = {
    /**
     * Has the organization enabled SS0
     */
    ssoEnabled?: boolean;
    /**
     * Has the organization enabled 2FA
     */
    auth2FAEnabled: boolean;
    /**
     * Soft delete flag
     */
    deleted: boolean;
    /**
     * Database id. Absent for WorkOs-only organizations that have no matching DB record
     */
    id?: string;
    /**
     * WorkOs organization id
     */
    authenticationProviderOrgId?: string;
    /**
     * Organization name
     */
    name: string;
    /**
     * Organization contact email address
     */
    contactEmail?: string | null;
    /**
     * WorkOs domains associated with the organization
     */
    emailDomains?: Array<string>;
    /**
     * Sponsor / Advisor / Agent classification. Null for organizations that have never been classified. Only SPONSOR organizations can define Programme Defaults
     */
    type?: OrganizationType | null;
};

export type OrganizationListRes = {
    rows: Array<OrganizationRes>;
    /**
     * Total organizations matching the search
     */
    total: number;
    /**
     * 1-based page number
     */
    page: number;
    /**
     * Page size actually applied
     */
    limit: number;
};

export type WorkOsOrganizationLookupItemRes = {
    /**
     * WorkOs organization id
     */
    authenticationProviderOrgId: string;
    /**
     * Organization name in WorkOs
     */
    name: string;
    /**
     * WorkOs domains associated with the organization
     */
    emailDomains: Array<string>;
    /**
     * True when a DealStack organization already references this WorkOs org
     */
    alreadyImported: boolean;
    /**
     * Database id of the organization when it is already imported
     */
    id?: string | null;
};

export type WorkOsOrganizationLookupRes = {
    organizations: Array<WorkOsOrganizationLookupItemRes>;
    /**
     * True when more organizations matched the domain than the cap returns
     */
    truncated: boolean;
    /**
     * Maximum number of organizations returned
     */
    cap: number;
};

export type UpdateOrganizationDto = {
    /**
     * Name of the organization
     */
    name: string;
    /**
     * Contact email for the organization
     */
    contactEmail: {
        [key: string]: unknown;
    };
};

export type UpdateOrganizationTypeDto = {
    /**
     * Sponsor / Advisor / Agent. Null clears the classification
     */
    type: OrganizationType | null;
};

export const BankAccountApprovalMode = {
    MANUAL_APPROVAL: 'MANUAL_APPROVAL',
    AUTO_APPROVE_VALIDATED: 'AUTO_APPROVE_VALIDATED',
    AUTO_APPROVE_ALL: 'AUTO_APPROVE_ALL'
} as const;

export type BankAccountApprovalMode = typeof BankAccountApprovalMode[keyof typeof BankAccountApprovalMode];

export type MipKycSettingResponseDto = {
    isProofOfIdentityRequired: boolean;
    isProofOfAddressRequired: boolean;
    isProofOfInvestmentVehicleRequired: boolean;
    /**
     * Mirror of the per-proof certification flags.
     *
     * @deprecated
     */
    requestCertifiedCopiesOfDocuments?: boolean | null;
    isProofOfIdentityCertificationRequired: boolean;
    isProofOfAddressCertificationRequired: boolean;
    isProofOfInvestmentVehicleCertificationRequired: boolean;
    certificationText: string | null;
    isKycRequired: boolean;
    isInvestorBankAccountRequired: boolean;
    isVehicleBankAccountRequired: boolean;
    isControllingPartyInfoRequired: boolean;
    isTinRequired: boolean;
    isTaxResidenceRequired: boolean;
    isPlaceOfBirthRequired: boolean;
    isCountryOfBirthRequired: boolean;
    isEmployeeIdRequired: boolean;
    isCitizenshipRequired: boolean;
    isBeneficialOwnershipRequired: boolean;
    isSourceOfFundsRequired: boolean;
    isPepRequired: boolean;
    bankAccountApprovalMode: BankAccountApprovalMode;
};

export type UpdateMipKycSettingDto = {
    isProofOfIdentityRequired?: boolean;
    isProofOfAddressRequired?: boolean;
    isProofOfInvestmentVehicleRequired?: boolean;
    isProofOfIdentityCertificationRequired?: boolean;
    isProofOfAddressCertificationRequired?: boolean;
    isProofOfInvestmentVehicleCertificationRequired?: boolean;
    certificationText?: string | null;
    isKycRequired?: boolean;
    isInvestorBankAccountRequired?: boolean;
    isVehicleBankAccountRequired?: boolean;
    isControllingPartyInfoRequired?: boolean;
    isTinRequired?: boolean;
    isTaxResidenceRequired?: boolean;
    isPlaceOfBirthRequired?: boolean;
    isCountryOfBirthRequired?: boolean;
    isEmployeeIdRequired?: boolean;
    isCitizenshipRequired?: boolean;
    isBeneficialOwnershipRequired?: boolean;
    isSourceOfFundsRequired?: boolean;
    isPepRequired?: boolean;
    /**
     * How a bank account submitted inside this programme is treated on save. AUTO_APPROVE_VALIDATED approves only when the identifier lookup for that submission came back verified.
     */
    bankAccountApprovalMode?: BankAccountApprovalMode;
};

export type KycWorkflowSettingResponseDto = {
    isProofOfIdentityRequired: boolean;
    isProofOfAddressRequired: boolean;
    isProofOfInvestmentVehicleRequired: boolean;
    isProofOfIdentityCertificationRequired: boolean;
    isProofOfAddressCertificationRequired: boolean;
    isProofOfInvestmentVehicleCertificationRequired: boolean;
    certificationText: string | null;
    isKycRequired: boolean;
    isInvestorBankAccountRequired: boolean;
    isVehicleBankAccountRequired: boolean;
    isControllingPartyInfoRequired: boolean;
    isTinRequired: boolean;
    isTaxResidenceRequired: boolean;
    isPlaceOfBirthRequired: boolean;
    isCountryOfBirthRequired: boolean;
    isEmployeeIdRequired: boolean;
    isCitizenshipRequired: boolean;
    isBeneficialOwnershipRequired: boolean;
    isSourceOfFundsRequired: boolean;
    isPepRequired: boolean;
};

export type UpdateKycWorkflowSettingDto = {
    isProofOfIdentityRequired?: boolean;
    isProofOfAddressRequired?: boolean;
    isProofOfInvestmentVehicleRequired?: boolean;
    isProofOfIdentityCertificationRequired?: boolean;
    isProofOfAddressCertificationRequired?: boolean;
    isProofOfInvestmentVehicleCertificationRequired?: boolean;
    certificationText?: string | null;
    isKycRequired?: boolean;
    isInvestorBankAccountRequired?: boolean;
    isVehicleBankAccountRequired?: boolean;
    isControllingPartyInfoRequired?: boolean;
    isTinRequired?: boolean;
    isTaxResidenceRequired?: boolean;
    isPlaceOfBirthRequired?: boolean;
    isCountryOfBirthRequired?: boolean;
    isEmployeeIdRequired?: boolean;
    isCitizenshipRequired?: boolean;
    isBeneficialOwnershipRequired?: boolean;
    isSourceOfFundsRequired?: boolean;
    isPepRequired?: boolean;
};

export const KycMasterFilter = { IN_PROGRESS: 'IN_PROGRESS', COMPLETED: 'COMPLETED' } as const;

export type KycMasterFilter = typeof KycMasterFilter[keyof typeof KycMasterFilter];

export type KycWorkflowInvestorRes = {
    firstName: string;
    lastName: string;
    email: string;
};

export const KycWorkflowStatus = {
    OPEN: 'OPEN',
    DEFINITION_COMPLETE: 'DEFINITION_COMPLETE',
    IN_PROGRESS: 'IN_PROGRESS',
    APPROVED: 'APPROVED',
    WITHDRAWN: 'WITHDRAWN'
} as const;

export type KycWorkflowStatus = typeof KycWorkflowStatus[keyof typeof KycWorkflowStatus];

export type KycWorkflowFileItemRes = {
    id: string;
    fileName: string;
    status: AcceptanceStatus | null;
    isInherited: boolean;
    isAwaitingCertifier: boolean;
};

export type GetKycWorkflowRowRes = {
    id: string;
    investorId: string;
    investmentWorkflowId: string;
    investmentType: {
        [key: string]: unknown;
    } | null;
    investor: KycWorkflowInvestorRes;
    cohorts: Array<MipClassifierRes>;
    declarationsStatus: {
        [key: string]: unknown;
    } | null;
    proofOfIdentityStatus: {
        [key: string]: unknown;
    } | null;
    proofOfAddressStatus: {
        [key: string]: unknown;
    } | null;
    investmentVehicleStatus: {
        [key: string]: unknown;
    } | null;
    formsStatus: {
        [key: string]: unknown;
    } | null;
    status: KycWorkflowStatus;
    vehicleFiles: Array<KycWorkflowFileItemRes>;
    formFiles: Array<KycWorkflowFileItemRes>;
    poiFiles: Array<KycWorkflowFileItemRes>;
    poaFiles: Array<KycWorkflowFileItemRes>;
    declarationItems: Array<KycWorkflowFileItemRes>;
    createdAt: string;
};

export type GetKycWorkflowsRes = {
    totalRecord: number;
    workflows: Array<GetKycWorkflowRowRes>;
};

export type GetInvestorUserRes = {
    firstName: string;
    lastName: string;
    email: string;
    id: string;
    address: AddressRes;
    birthDate: string;
    telephonePrefix: string;
    phoneNumber: string;
};

export type FileEntity = {
    id: string;
    extension: string;
    md5: {
        [key: string]: unknown;
    } | null;
    mimeType: string;
    name: string;
    s3key: string;
    createdAt: string;
    updatedAt: string;
    deleted: boolean;
};

export type ManagerKycFileCertificationRes = {
    state: KycCertificationState;
    certifierName: string;
    certifierEmail: string;
    invitedAt: string | null;
    certifiedAt: string | null;
    certifierFullName: string | null;
    certifierAddress: string | null;
    professionalCapacity: string | null;
    certificationText: string;
    signingMethod: string | null;
    originalFileId: string;
};

export type DataKycFileTctWithFile = {
    id: string;
    fileId: string;
    fileName: string;
    rejectionComment: {
        [key: string]: unknown;
    } | null;
    createdById: string;
    customDetailId: {
        [key: string]: unknown;
    } | null;
    type: KycFileType;
    status: AcceptanceStatus | null;
    updatedAt: string;
    createdAt: string;
    deleted: boolean;
    kycWorkflowId: string;
    subjectAction: SubjectAction | null;
    certificationStatus: KycFileCertificationStatus;
    certificationAttestedAt: string | null;
    certification: KycFileCertificationSummaryRes | null;
    file: FileEntity;
    certificationRequired: boolean;
    certificationReview: ManagerKycFileCertificationRes | null;
};

export type KycEventLogHistoryRes = {
    PROOF_OF_ADDRESS: Array<KycEventLogEntity>;
    INVESTMENT_VEHICLE: Array<KycEventLogEntity>;
    FORM: Array<KycEventLogEntity>;
    PROOF_OF_IDENTITY: Array<KycEventLogEntity>;
    OTHER: Array<KycEventLogEntity>;
};

export type GetKycInvestorInstanceRes = {
    user: GetInvestorUserRes;
    status: KycWorkflowStatus;
    isInvestmentCompleted: boolean;
    piv: boolean;
    docsUploaded: boolean;
    declarationsProvided: boolean;
    kycFiles: Array<DataKycFileTctWithFile>;
    kycHistory: KycEventLogHistoryRes;
    isEligibleForNewInvestmentWorkflow: boolean;
    declarations: Array<DataDeclarationTct>;
    id: string;
    processSettings: InvestorProcessSettingsDto;
    singleAddress: string;
    investmentType: {
        [key: string]: unknown;
    } | null;
    investmentWorkflowId: {
        [key: string]: unknown;
    } | null;
};

export type GetKycRes = {
    totalRecord: number;
    investors: Array<GetKycInvestorInstanceRes>;
};

export type GetKycStatisticsRes = {
    byStatus: {
        [key: string]: number;
    };
};

export type UpdateAcceptanceStatusDto = {
    status: AcceptanceStatus;
    rejectionComment: string;
};

export type KycFileCertificationRes = {
    kycFileId: string;
    certificationStatus: KycFileCertificationStatus;
    certificationAttestedAt: string | null;
    certifierName: string | null;
    certifierEmail: string | null;
    invitedAt: string | null;
};

export type UpdateKycFileDto = {
    fileId: string;
};

export type PatchDeclarationsDto = {
    beneficialOwnership: boolean;
    sourceOfFundsSalary: boolean;
    sourceOfFundsInheritence: boolean;
    sourceOfFundsInvestmentIncome: boolean;
    sourceOfFundsPersonalSavings: boolean;
    sourceOfFundsOther: boolean;
    politicallyExposedPerson: boolean;
    politicallyExposedPersonDescription: string;
    sourceOfFundsOtherDescription: string;
};

export type BulkDownloadKycDto = {
    sortBy?: string;
    sortDesc?: boolean;
    investmentType?: Array<string>;
    cohortIds?: Array<string>;
    status?: Array<'OPEN' | 'DEFINITION_COMPLETE' | 'IN_PROGRESS' | 'APPROVED' | 'WITHDRAWN'>;
    investorIds?: Array<string>;
    masterFilter?: KycMasterFilter;
    declarationsStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
    proofOfIdentityStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
    proofOfAddressStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
    investmentVehicleStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
    formsStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
    allSelected?: boolean;
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
};

export type CreateKycFileViaKycAdminDto = {
    fileId: string;
    templateId: string;
    userId: string;
    /**
     * The kyc type to update association for
     */
    type: KycFileType;
    kycWorkflowId: string;
};

export const AuthKitScreenHint = { SIGN_IN: 'sign-in', SIGN_UP: 'sign-up' } as const;

export type AuthKitScreenHint = typeof AuthKitScreenHint[keyof typeof AuthKitScreenHint];

export type CanChangeCredentialsRes = {
    password: boolean;
    email: boolean;
    setup2FA: boolean;
    authenticationFactorId?: string;
};

export type ChangeEmailDto = {
    /**
     * Code from the email sent to the new address.
     */
    code: string;
};

export type ChangeEmailRequestDto = {
    newEmail: string;
    password: string;
    /**
     * Code from the authenticator app. Required when the account has a second factor enrolled.
     */
    totpCode?: string;
    applicationType?: ApplicationType;
};

export type DeleteChangeEmailRequestDto = {
    newEmail: string;
};

export type CancelChangeEmailDto = {
    cancelToken: string;
};

export type RenewInvitationDto = {
    invitationToken: string;
    applicationType: ApplicationType;
};

export const InvitationRenewalOutcome = {
    SENT: 'SENT',
    SIGN_IN: 'SIGN_IN',
    INVITATION_PENDING: 'INVITATION_PENDING',
    CONTACT_INVITER: 'CONTACT_INVITER'
} as const;

export type InvitationRenewalOutcome = typeof InvitationRenewalOutcome[keyof typeof InvitationRenewalOutcome];

export type InvitationRenewalRes = {
    outcome: InvitationRenewalOutcome;
};

export type Challenge = {
    object: string;
    id: string;
    createdAt: string;
    updatedAt: string;
    expiresAt?: string;
    code?: string;
    authenticationFactorId: string;
};

export type TotpWithSecrets = {
    issuer: string;
    user: string;
    qrCode: string;
    secret: string;
    uri: string;
};

export type FactorWithSecrets = {
    object: string;
    id: string;
    createdAt: string;
    updatedAt: string;
    type: string;
    totp: TotpWithSecrets;
    userId: string;
};

export type Auth2FaChallengeAndFactorResponse = {
    authenticationChallenge: Challenge;
    authenticationFactor: FactorWithSecrets;
};

export type VerifyChallenge2FaDto = {
    /**
     * Code from the authenticator app being enrolled.
     */
    code: string;
    authenticationChallengeId: string;
};

export type VerifyChallengeResponse = {
    isValid: boolean;
};

export type DeleteAuthFactorDto = {
    authenticationFactorId: string;
    /**
     * Code from the authenticator app. Required when the account has a second factor enrolled.
     */
    totpCode?: string;
};

export type ChangePasswordDto = {
    /**
     * Password must be at least 8 character and contain at least one uppercase, one lowercase, one symbol and  one number
     */
    newPassword: string;
    oldPassword: string;
    email: string;
    /**
     * Code from the authenticator app. Required when the account has a second factor enrolled.
     */
    totpCode?: string;
};

export type SessionStatusResponse = {
    /**
     * Seconds until the session expires if the user does nothing further. Slides forward on activity, never past absoluteExpiresInSeconds.
     */
    idleExpiresInSeconds: number;
    /**
     * Seconds until the hard end of the session lifetime. Never extended.
     */
    absoluteExpiresInSeconds: number;
    /**
     * How long before the idle deadline the client should warn the user.
     */
    idleWarningSeconds: number;
    /**
     * The configured idle window, for display purposes.
     */
    idleTimeoutSeconds: number;
};

export type SendVerificationDto = {
    /**
     * Email address to send verification to
     */
    email: string;
};

export type ValidateMagicCodeDto = {
    email: string;
    /**
     * Code from the verification email.
     */
    magicCode: string;
};

export type ValidateAuthResponse = {
    isValid: boolean;
};

export type UpdatePhoneDto = {
    /**
     * Users country telephone prefix
     */
    telephonePrefix: string;
    /**
     * Users phone number
     */
    phoneNumber: string;
};

export type CreateDealDto = {
    name: string;
    targetName: string;
    currency?: CurrencyType;
    internalDealTag?: InternalDealTag;
    organizationId?: string;
};

export type SummaryDealMip = {
    id: string;
    entityName: {
        [key: string]: unknown;
    };
    entityId: {
        [key: string]: unknown;
    };
    programmeName: {
        [key: string]: unknown;
    };
    numberOfInvestors: number;
    state: MipState;
    currency: CurrencyType;
    isLocked: boolean;
};

export type SummaryDealExtendedTct = {
    id: string;
    name: string;
    currency: CurrencyType;
    internalDealTag: InternalDealTag | null;
    organizationId?: string | null;
    capTableId: string;
    targetName: string;
    /**
     * When true, DealStack Support users do not get inherited access; access requires an explicit grant.
     */
    isRestricted: boolean;
    /**
     * Authoritative deal-level "supports nominee structures" switch (stored on Deal).
     */
    hasNomineeStructure: boolean;
    /**
     * When true, the current user sees this deal through inherited DealStack Support access rather than an explicit deal grant.
     */
    isVisibleThroughDealStackSupportAccess: boolean;
    /**
     * Whether this Deal is a Fund (parent deal)
     */
    isFund: boolean;
    /**
     * The Fund ID if this Deal is a Fund
     */
    fundId?: string;
    mips: Array<SummaryDealMip>;
};

export type UpdateDealDto = {
    name?: string;
    targetName?: string;
    currency?: CurrencyType;
    internalDealTag?: InternalDealTag;
    /**
     * Authoritative deal-level "supports nominee structures" switch. When true, the deal supports separate Legal Title / Beneficial Interest ownership across its securities.
     */
    hasNomineeStructure?: boolean;
    /**
     * The Sponsor organisation this deal belongs to. DealStack support only; omitted leaves it unchanged.
     */
    organizationId?: string;
};

export type SetDealRestrictionDto = {
    /**
     * When true, DealStack Support users lose inherited access to this deal/fund; access then requires an explicit OpenFGA grant (owner or invited user).
     */
    isRestricted: boolean;
};

export type DealClassifierFiltersDto = {
    /**
     * The deal classifier filters by classifier names
     */
    classifierName?: string;
    /**
     * Get all available deals when this is set to true
     */
    getAll?: boolean;
};

export type DealClassifiersFiltersDto = {
    pagination: PaginationDto;
    sortBy: SortDto;
    filter: DealClassifierFiltersDto;
};

export type DealClassifierTct = {
    classifierId: string;
    classifierParentId: {
        [key: string]: unknown;
    } | null;
    dealId: {
        [key: string]: unknown;
    };
    id: string;
    name: string;
    deleted: boolean;
    nbrDocuments: number;
    value: string;
    children: Array<DealClassifierTct>;
};

export type FindDealClassifiersRes = {
    dealClassifiers: Array<DealClassifierTct>;
    meta: {
        [key: string]: unknown;
    };
};

export type UpdateDealClassifierDto = {
    /**
     * New name of the classifier
     */
    name: string;
    /**
     * parentId classifierId to assign this classifier to
     */
    classifierParentId: {
        [key: string]: unknown;
    } | null;
    /**
     * archive the classifier for a deal
     */
    archive: boolean;
};

export type CreateDealClassifierDto = {
    /**
     * name of the classifier
     */
    name: string;
    /**
     * parentId classifier id to assign this deal classifier to
     */
    classifierParentId: {
        [key: string]: unknown;
    } | null;
};

export type UpdateCompanyRepresentativeDto = {
    userId: string;
    jobTitle?: string;
};

export type ProjectRepresentativeUserEntityRes = {
    id: string;
    userId: string;
    user: DataUserTct;
    dealId: string;
    jobTitle?: string;
};

export type BasicUserWithPermissionRolesRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    deleted: boolean;
    telephonePrefix?: string;
    phoneNumber?: string;
    permissionRoles: Array<PermissionRoleWithOwnerEnum>;
};

export const PermissionRole = {
    ADMIN: 'admin',
    USER_ADMIN: 'userAdmin',
    KYC_ADMIN: 'kycAdmin',
    EDITOR: 'editor',
    EXPORT_VIEWER: 'exportViewer',
    VIEWER: 'viewer'
} as const;

export type PermissionRole = typeof PermissionRole[keyof typeof PermissionRole];

export type BaseInviteOptionsDto = {
    skipEmail?: boolean;
};

export type InviteUserToDealDto = {
    email: string;
    firstName?: string;
    lastName?: string;
    permissionRoles?: Array<PermissionRole>;
    options?: BaseInviteOptionsDto;
};

export const ResourceType = {
    PLATFORM: 'platform',
    USER: 'user',
    DEAL: 'deal',
    PROGRAMME: 'programme',
    ORGANIZATION: 'organization'
} as const;

export type ResourceType = typeof ResourceType[keyof typeof ResourceType];

export type PermissionWithOwnerRes = {
    resourceType: ResourceType;
    resourceId: string;
    permissionRole: PermissionRoleWithOwnerEnum;
    isImplicit: boolean;
};

export type BasicUserWithPermissionsRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    deleted: boolean;
    telephonePrefix?: string;
    phoneNumber?: string;
    permissions: Array<PermissionWithOwnerRes>;
};

export type ProgrammeUserWithPermissionRolesRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    deleted: boolean;
    telephonePrefix?: string;
    phoneNumber?: string;
    permissionRoles: Array<PermissionRoleWithOwnerEnum>;
    userProgrammeId: string;
    isContactPerson: boolean;
    canBeRemoved: boolean;
};

export type InviteUserToProgrammeDto = {
    email: string;
    firstName?: string;
    lastName?: string;
    isContactPerson: boolean;
    permissionRoles?: Array<PermissionRole>;
    options?: BaseInviteOptionsDto;
};

export type ProgrammeUserWithPermissionsRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    deleted: boolean;
    telephonePrefix?: string;
    phoneNumber?: string;
    permissions: Array<PermissionWithOwnerRes>;
    userProgrammeId: string;
    isContactPerson: boolean;
    canBeRemoved: boolean;
};

export type UpdateProgrammeUserDto = {
    /**
     * Whether the user is a contact person for the MIP
     */
    isContactPerson: boolean;
    firstName?: string;
    lastName?: string;
};

export const ExcelFormat = { CSV: 'csv', XLSX: 'xlsx' } as const;

export type ExcelFormat = typeof ExcelFormat[keyof typeof ExcelFormat];

export const CapTableRail = { LEGAL: 'LEGAL', BENEFICIAL: 'BENEFICIAL' } as const;

export type CapTableRail = typeof CapTableRail[keyof typeof CapTableRail];

export type GetCapTableDataDto = {
    filterDate?: string;
    securityIds?: Array<string>;
    /**
     * Enable master view for Fund deals
     */
    isMasterView?: boolean;
    /**
     * Fund ID for master view
     */
    fundId?: string;
    rail?: CapTableRail;
};

export type Receiver = {
    id: string;
    heldForId?: string;
    name: string;
    heldForName?: string;
    color: string;
    tags?: Array<LegalPersonTags>;
    ipId?: string;
    isIPColumn?: boolean;
    investorsKeys?: Array<string>;
    mipName?: string;
    isLender?: boolean;
};

export type SecurityEventFlags = {
    hasAssignment: boolean;
    hasPledge: boolean;
};

export type HolderValues = {
    amount: number;
    amountPercent?: number;
    votes?: number;
    votesPercent?: number;
    totalCost: number | null;
    totalCostPercent?: number;
};

export type Holder = {
    strict: HolderValues;
    nonStrict: HolderValues;
};

export type HoldingTotalsStrict = {
    totalAmount: number;
    totalCost: number | null;
    totalVotes?: number;
};

export type HoldingTotalsNonStrict = {
    totalAmount: number;
    totalCost: number;
    totalVotes?: number;
};

export type HoldingTotals = {
    strict: HoldingTotalsStrict;
    nonStrict: HoldingTotalsNonStrict;
};

export type SecurityHolding = {
    securityId: string;
    securityName: string;
    securityType: SecurityType;
    issuerMipGroupId?: string;
    currency: CurrencyType;
    securityIssuedIn: SecurityIssuedIn;
    /**
     * Totals of all holdings within security
     */
    totals: HoldingTotals;
    /**
     * Mapping of holders to their holdings within security, key is the holder id and held for id
     */
    securityHolders: {
        [key: string]: Holder;
    };
    issuerId: string;
    color: string;
    /**
     * Event flags per holder
     */
    securityEventsFlags?: {
        [key: string]: SecurityEventFlags;
    };
};

export type SecurityTypeHolding = {
    securityType: SecurityType;
    securityIssuedIn: SecurityIssuedIn;
    currency: CurrencyType;
    /**
     * Totals of all holdings within security type
     */
    totals: HoldingTotals;
    /**
     * Mapping of holders to their holdings within security type, key is the holder id
     */
    securityTypeSummarizedHolders: {
        [key: string]: Holder;
    };
    /**
     * Mapping of securities to their holdings data, key is the security id
     */
    securitiesHoldings: {
        [key: string]: SecurityHolding;
    };
    color: string;
};

export type SecurityTypesHoldingsMap = {
    LOAN?: SecurityTypeHolding;
    PREFERENCE_SHARE?: SecurityTypeHolding;
    TRACKING_SHARE?: SecurityTypeHolding;
    PARTNERSHIP_UNIT?: SecurityTypeHolding;
    OPTIONS?: SecurityTypeHolding;
    ORDINARY_SHARE?: SecurityTypeHolding;
    VIRTUAL_EQUITY?: SecurityTypeHolding;
    OTHER?: SecurityTypeHolding;
    WARRANT?: SecurityTypeHolding;
    OTHER_EQUITY?: SecurityTypeHolding;
    BOND?: SecurityTypeHolding;
    DEFERRED_SHARE?: SecurityTypeHolding;
};

export type IssuerHolding = {
    issuerId: string;
    /**
     * Totals of all holdings within all securities issued by issuer
     */
    totals: HoldingTotals;
    issuerName: string;
    color: string;
    issuerTags: Array<LegalPersonTags>;
    /**
     * Mapping of holders to their holdings within all securities issued by issuer, key is the holder id
     */
    issuerSummarizedHolders: {
        [key: string]: Holder;
    };
    /**
     * Mapping of securities types to their holdings data, key is the security type
     */
    securityTypesHoldings: SecurityTypesHoldingsMap;
    isLender?: boolean;
};

export type MipGroupHoldingResponse = {
    mipId: string;
    mipName: string;
    color: string;
    mipEntityId?: string;
    issuersHoldings: Array<IssuerHolding>;
};

export type NomineeFlags = {
    hasNomineeStructure: boolean;
    hasTitleSplit: boolean;
};

export type GetCapTableDataRes = {
    /**
     * Array of issuer objects that can be either MipGroupHoldingResponse or IssuerHolding
     */
    issuers: Array<MipGroupHoldingResponse | IssuerHolding>;
    /**
     * Mapping of mip to list of holders (investors) under this mip, key is the mip id
     */
    ipGroupsReceiversDictionary: {
        [key: string]: Array<Receiver>;
    };
    receivers: Array<Receiver>;
    nomineeFlags?: NomineeFlags;
};

export const LegalFormType = {
    PARTNERSHIP: 'partnership',
    COMPANY: 'company',
    TRUST: 'trust',
    PASSTHROUGH: 'passthrough',
    OTHER: 'other'
} as const;

export type LegalFormType = typeof LegalFormType[keyof typeof LegalFormType];

export type Node = {
    id: string;
    name: string;
    legalFormType?: LegalFormType | null;
    jurisdiction?: string;
    registrationNumber?: string;
    isMipGroup: boolean;
};

export const EdgeType = { LOAN: 'loan', OWNERSHIP: 'ownership' } as const;

export type EdgeType = typeof EdgeType[keyof typeof EdgeType];

export type Edge = {
    fromNodeId: string;
    toNodeId: string;
    type: EdgeType;
    votes: number;
    totalHeld: number;
    cost: number;
    votesPercent: number;
    costPercent: number;
    securityTotal: number;
};

export type GetGroupStructureDataRes = {
    nodes: Array<Node>;
    edges: Array<Edge>;
    nomineeFlags?: NomineeFlags;
};

export type ChartSecurityPersonTct = {
    id: string;
    displayName: string;
    tags: Array<LegalPersonTags>;
};

export type SecuritySummary = {
    id: string;
    type: SecurityType;
    name: string;
    votesPerUnit: number | null;
};

export type ChartSecurityTct = {
    LOAN?: Array<SecuritySummary>;
    TRACKING_SHARE?: Array<SecuritySummary>;
    ORDINARY_SHARE?: Array<SecuritySummary>;
    PREFERENCE_SHARE?: Array<SecuritySummary>;
    WARRANT?: Array<SecuritySummary>;
    VIRTUAL_EQUITY?: Array<SecuritySummary>;
    PARTNERSHIP_UNIT?: Array<SecuritySummary>;
    OPTIONS?: Array<SecuritySummary>;
    OTHER?: Array<SecuritySummary>;
    OTHER_EQUITY?: Array<SecuritySummary>;
};

export type ChartSecuritiesTct = {
    person: ChartSecurityPersonTct | null;
    securities: ChartSecurityTct;
};

export type UpdateGroupStructurePositionsDto = {
    positions: {
        [key: string]: unknown;
    };
};

export type GetGroupStructurePositionsDataRes = {
    positions: {
        [key: string]: unknown;
    };
    hash: string;
};

export type GetCapDetailsRes = {
    id: string;
    dealId: string;
};

export type GetCapTransactionsValidationDetailsRes = {
    isAllTransactionValidInDeal: boolean;
    firstEntityWithInvalidTransactionsId: {
        [key: string]: unknown;
    } | null;
};

export type DealExtractSecurityRes = {
    id: string;
    name: string;
    type: string;
    currency: string;
    initialNominalValuePerUnit?: number;
    nominalValuePerUnit?: number;
    initialVotesPerUnit?: number;
    votesPerUnit?: number;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractCountryRes = {
    name?: string;
    'iso3166-1'?: {
        [key: string]: unknown;
    } | null;
};

export type DealExtractAddressRes = {
    id: string;
    addressLine1: string;
    addressLine2: string;
    city: string;
    region: string;
    postCode: string;
    country: DealExtractCountryRes;
    classifiers: Array<string>;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractTaxRegistrationRes = {
    id: string;
    country: DealExtractCountryRes;
    type?: string;
    value?: string;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractBankAccountRes = {
    id: string;
    accountHolderName: string;
    currency?: CurrencyType;
    iban?: string;
    bankName?: string;
    accountNumber?: string;
    swiftBic?: string;
    country?: DealExtractCountryRes;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractRelatedPersonRes = {
    relatedPersonId: string;
    relationship: string;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractNaturalPersonRes = {
    id: string;
    type: string;
    displayName: string;
    authorisedSecurities: Array<DealExtractSecurityRes>;
    addresses: Array<DealExtractAddressRes>;
    taxRegistrations: Array<DealExtractTaxRegistrationRes>;
    bankAccounts: Array<DealExtractBankAccountRes>;
    relatedPersons: Array<DealExtractRelatedPersonRes>;
    classifiers: Array<string>;
    createdAt: string;
    updatedAt: string;
    firstName: string;
    lastName: string;
    dateOfBirth?: string;
    placeOfBirth?: string;
    countryOfBirth: DealExtractCountryRes;
    emailAddresses: Array<string>;
    phoneNumbers: Array<string>;
};

export type DealExtractLegalPersonRes = {
    id: string;
    type: string;
    displayName: string;
    authorisedSecurities: Array<DealExtractSecurityRes>;
    addresses: Array<DealExtractAddressRes>;
    taxRegistrations: Array<DealExtractTaxRegistrationRes>;
    bankAccounts: Array<DealExtractBankAccountRes>;
    relatedPersons: Array<DealExtractRelatedPersonRes>;
    classifiers: Array<string>;
    createdAt: string;
    updatedAt: string;
    registeredName: string;
    registeredNumber?: string;
    jurisiction: DealExtractCountryRes;
    legalForm?: string;
    lei?: string;
    gics?: string;
};

export type DealExtractHoldingEventAssignmentRes = {
    assigmentSubject?: string;
    assignmentStartDate?: string;
    assignmentEndDate?: string;
    assignedTo?: string;
    note?: string;
};

export type DealExtractHoldingEventAssignmentContainerRes = {
    assignment: DealExtractHoldingEventAssignmentRes;
};

export type DealExtractHoldingEventIssueOfCertificateRes = {
    issueDate?: string;
    note?: string;
};

export type DealExtractHoldingEventIssueOfCertificateContainerRes = {
    issueOfCertificate: DealExtractHoldingEventIssueOfCertificateRes;
};

export type DealExtractHoldingEventNoteContainerRes = {
    note: string;
};

export type DealExtractHoldingEventPledgeRes = {
    pledgeStartDate?: string;
    pledgeEndDate?: string;
    pledgedTo?: string;
    pledgedAgainst?: string;
    note?: string;
};

export type DealExtractHoldingEventPledgeContainerRes = {
    pledge: DealExtractHoldingEventPledgeRes;
};

export type DealExtractHoldingAcquisitionCostRes = {
    currency: string;
    value: number;
};

export type DealExtractHoldingUnitsHeldRes = {
    blockStart: number;
    blockEnd: number;
};

export type DealExtractShareHoldingRes = {
    holderId: string;
    heldForId?: string;
    scope?: string;
    securityId: string;
    acquisitionCost: DealExtractHoldingAcquisitionCostRes;
    percentageHeld: number;
    events: Array<DealExtractHoldingEventAssignmentContainerRes | DealExtractHoldingEventIssueOfCertificateContainerRes | DealExtractHoldingEventNoteContainerRes | DealExtractHoldingEventPledgeContainerRes>;
    units: number;
    unitsHeld: Array<DealExtractHoldingUnitsHeldRes>;
    startOfHolding?: string;
};

export const DealExtractValidationStatusRes = { VALID: 'VALID', INVALID: 'INVALID' } as const;

export type DealExtractValidationStatusRes = typeof DealExtractValidationStatusRes[keyof typeof DealExtractValidationStatusRes];

export type DealExtractProgrammeRes = {
    id: string;
    name: string;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractDealRes = {
    id: string;
    name: string;
    validationStatus: DealExtractValidationStatusRes;
    programmes: Array<DealExtractProgrammeRes>;
    persons: Array<DealExtractNaturalPersonRes | DealExtractLegalPersonRes>;
    holdings: Array<DealExtractShareHoldingRes>;
    createdAt: string;
    updatedAt: string;
};

export type DealExtractRes = {
    extractDate: string;
    holdingsDate: string;
    rail: CapTableRail;
    deal: DealExtractDealRes;
};

export const EmailTemplateType = {
    INVITE_USER_INVESTOR: 'invite_user_investor',
    INVITE_USER_EXISTING_INVESTOR: 'invite_user_existing_investor',
    KYC_REJECTION: 'kyc_rejection',
    KYC_INFO_REQUEST: 'kyc_info_request',
    PASSWORD_RESET_REQUEST: 'password_reset_request',
    PASSWORD_RESET_CONFIRMATION: 'password_reset_confirmation',
    IP_ADDITIONAL_ALLOCATION: 'ip_additional_allocation',
    IP_LEAVER: 'ip_leaver',
    FUNDS_TRANSFER_REJECTION: 'funds_transfer_rejection',
    DOCUMENT_SIGNATURE_REQUEST: 'document_signature_request',
    CHANGE_EMAIL_REQUEST: 'change_email_request',
    CHANGE_EMAIL_NOTIFICATION: 'change_email_notification',
    BANK_ACCOUNT_REJECTION: 'bank_account_rejection',
    BANK_ACCOUNT_UPDATE_CONFIRMATION: 'bank_account_update_confirmation',
    SEND_SDW_DOCUMENTS: 'send_sdw_documents',
    SEND_DOWNLOAD_LINK: 'send_download_link',
    GENERATE_CONTRACT: 'generate_contract',
    INVITE_USER_SEND_DOCUMENT: 'invite_user_send_document',
    INVITE_ORGANIZATION_EXISTING_USER: 'invite_organization_existing_user',
    INVITE_ORGANIZATION_NEW_USER: 'invite_organization_new_user',
    REINVITE_USER: 'reinvite_user',
    INVITE_NEW_USER_TO_PROGRAMME: 'invite_new_user_to_programme',
    INVITE_EXISTING_USER_TO_PROGRAMME: 'invite_existing_user_to_programme',
    INVITE_NEW_USER_TO_DEAL: 'invite_new_user_to_deal',
    INVITE_EXISTING_USER_TO_DEAL: 'invite_existing_user_to_deal',
    INVITE_INVESTOR_SSO: 'invite_investor_SSO',
    INVITE_ADMIN_SSO: 'invite_admin_SSO',
    EMAIL_VERIFICATION: 'email_verification',
    WITNESS_SIGNING_INVITATION: 'witness_signing_invitation',
    REPRESENTATIVE_SIGNING_INVITATION: 'representative_signing_invitation',
    AUTHORISED_SIGNATORY_SIGNING_INVITATION: 'authorised_signatory_signing_invitation',
    KYC_CERTIFIER_INVITATION: 'kyc_certifier_invitation',
    SEND_KYC_REQUEST: 'send_kyc_request',
    FUNDS_TRANSFER_CONFIRMATION: 'funds_transfer_confirmation',
    DOCUMENT_SIGNATURE_REJECTION: 'document_signature_rejection',
    SEND_INVESTMENT_REMINDER: 'send_investment_reminder',
    SECOND_FACTOR_REMOVED: 'second_factor_removed'
} as const;

export type EmailTemplateType = typeof EmailTemplateType[keyof typeof EmailTemplateType];

export type EmailTemplateSummaryRes = {
    templateType: EmailTemplateType;
    name: string;
    description: string;
    /**
     * Whether the body may be edited by an admin in v1.
     */
    editable: boolean;
    /**
     * Per-template send toggle for this programme or deal.
     */
    enabled: boolean;
    /**
     * True when this programme or deal has overridden the subject, body, or background.
     */
    isCustomized: boolean;
    /**
     * True when the Dealstack default has changed since this override was last edited.
     */
    isStale: boolean;
    /**
     * Resolved subject (override if customized, else the default).
     */
    subject: string;
    /**
     * When the override was last updated, or null if not customized.
     */
    updatedAt: string | null;
    /**
     * Who last updated the override, or null if not customized.
     */
    updatedBy: string | null;
};

export type EmailTemplateContentRes = {
    subject: string;
    /**
     * Content fragment (HTML-with-Liquid) — inner content only.
     */
    contentHtml: string;
    /**
     * Editor document for `contentHtml`; the editor loads this, not the HTML.
     */
    contentJson: {
        [key: string]: unknown;
    } | null;
};

export type EmailTemplateDetailRes = {
    templateType: EmailTemplateType;
    name: string;
    description: string;
    editable: boolean;
    enabled: boolean;
    /**
     * Page background colour for this template.
     */
    backgroundColor: string;
    isCustomized: boolean;
    /**
     * True when the Dealstack default has changed since this override was last edited.
     */
    isStale: boolean;
    /**
     * When the override was last updated, or null if not customized.
     */
    updatedAt: string | null;
    /**
     * Who last updated the override, or null if not customized.
     */
    updatedBy: string | null;
    /**
     * Allowed merge variables for this template.
     */
    variables: Array<string>;
    /**
     * Sample values for every variable, used to render the live preview.
     */
    sampleData: {
        [key: string]: string;
    };
    /**
     * Dealstack default.
     */
    default: EmailTemplateContentRes;
    /**
     * Resolved content in effect (override if customized, else default).
     */
    current: EmailTemplateContentRes;
};

export type PreviewEmailTemplateDto = {
    subject?: string | null;
    body?: string | null;
    backgroundColor?: string | null;
    /**
     * Variable values to render the preview with (merged over the sample data).
     */
    values?: {
        [key: string]: string;
    };
};

export type EmailTemplatePreviewRes = {
    /**
     * Rendered subject with sample data applied.
     */
    subject: string;
    /**
     * Rendered, sanitized full HTML email document.
     */
    html: string;
};

export type UpdateEmailTemplateDto = {
    /**
     * Override subject; null clears it back to the Dealstack default.
     */
    subject?: string | null;
    /**
     * Content fragment (HTML-with-Liquid). Validated against the variable manifest; null clears it back to the Dealstack default.
     */
    body?: string | null;
    /**
     * Editor document for `body`. Required whenever `body` is sent, and must be null when `body` is null.
     */
    bodyJson?: {
        [key: string]: unknown;
    } | null;
    /**
     * Page background colour for this template; null restores the default.
     */
    backgroundColor?: string | null;
    /**
     * Per-template send toggle for this programme or deal.
     */
    enabled?: boolean;
};

export type EmailTemplateTestSendRes = {
    /**
     * Rendered subject of the email that was sent.
     */
    subject: string;
    /**
     * Address the test email was sent to (always the caller).
     */
    sentTo: string;
};

export type OrganizationDealClassifierRes = {
    classifierId: string;
    name: string;
};

export type OrganizationDealClassifierListRes = {
    isCustomized: boolean;
    classifiers: Array<OrganizationDealClassifierRes>;
};

export type SetOrganizationDealClassifiersDto = {
    names: Array<string>;
};

export type CreateFundDto = {
    /**
     * Id of the organization the fund belongs to
     */
    organizationId: string;
    /**
     * Fund name
     */
    name: string;
    /**
     * Target company name (for the underlying Deal)
     */
    targetName: string;
    currency?: CurrencyType;
    /**
     * Fund Manager (Legal Person ID)
     */
    fundManagerId?: string;
};

export const FundStatus = {
    ACTIVE: 'ACTIVE',
    CLOSED: 'CLOSED',
    LIQUIDATING: 'LIQUIDATING'
} as const;

export type FundStatus = typeof FundStatus[keyof typeof FundStatus];

export type FundRes = {
    id: string;
    dealId: string;
    fundManagerId: {
        [key: string]: unknown;
    } | null;
    status: FundStatus;
    createdAt: string;
    updatedAt: string;
};

export type UpdateFundDto = {
    /**
     * Fund name
     */
    name: string;
    /**
     * Target company name (for the underlying Deal)
     */
    targetName: string;
    currency?: CurrencyType;
};

export type FundDealSummaryRes = {
    id: string;
    name: string;
    targetName: string;
    currency: CurrencyType | null;
};

export type FundWithDealRes = {
    id: string;
    dealId: string;
    fundManagerId: {
        [key: string]: unknown;
    } | null;
    status: FundStatus;
    createdAt: string;
    updatedAt: string;
    deal: FundDealSummaryRes;
    /**
     * When true, DealStack Support users do not get inherited access to this fund; access requires an explicit grant.
     */
    isRestricted: boolean;
    /**
     * When true, the current user sees this fund through inherited DealStack Support access rather than an explicit deal grant.
     */
    isVisibleThroughDealStackSupportAccess: boolean;
};

export type FundDealWithDealRes = {
    id: string;
    fundId: string;
    dealId: string;
    deal: FundDealSummaryRes;
};

export type AvailableDealsForPersonFundLinkRes = {
    /**
     * The fund ID
     */
    fundId: string;
    /**
     * The fund name
     */
    fundName: string;
    /**
     * Deals available for linking
     */
    deals: Array<FundDealSummaryRes>;
};

export type LinkFundToDealDto = {
    /**
     * Fund ID that is investing
     */
    fundId: string;
    /**
     * Deal ID that the fund is investing in
     */
    dealId: string;
};

export type FundDealRes = {
    id: string;
    fundId: string;
    dealId: string;
    fund: FundWithDealRes;
};

export type LinkPersonToFundDto = {
    /**
     * Person ID to link
     */
    personId: string;
    /**
     * Deal ID where the person is being linked
     */
    dealId: string;
    /**
     * Fund ID to link the person from
     */
    fundId: string;
};

export type FundDealLinkRes = {
    /**
     * The deal ID
     */
    dealId: string;
    /**
     * The deal name
     */
    dealName: string;
    /**
     * Whether this person is a management entity in this deal
     */
    isManagementEntity: boolean;
    /**
     * Whether this person can issue securities in this deal
     */
    canIssueSecurities: boolean;
};

export type PersonFundLinkRes = {
    /**
     * The fund ID
     */
    fundId: string;
    /**
     * The fund name
     */
    fundName: string;
    /**
     * Current status of the fund
     */
    fundStatus: FundStatus;
    /**
     * Deals where this person appears through this fund
     */
    deals: Array<FundDealLinkRes>;
};

export type EmailWorkflowProgressRes = {
    inactiveEmailsSent: number;
    activeEmailsSent: number;
    inactiveEmailsFailed: number;
    inactiveEmailsFailedAddresses: Array<string>;
    activeEmailsFailed: number;
    activeEmailsFailedAddresses: Array<string>;
    totalActiveUsers: number;
    totalInActiveUsers: number;
    completed: boolean;
};

export type UpdateMipDataDto = {
    programmeName?: string;
    securityValuationDate?: string | null;
    currency?: CurrencyType;
};

export type MipProgrammeEntityRes = {
    id: string;
    entityId: string;
    displayName: string;
    entityCurrency: {
        [key: string]: unknown;
    } | null;
    securitiesCount: number;
    canDelete: boolean;
    deleteBlockReason: {
        [key: string]: unknown;
    } | null;
};

export type AddMipProgrammeEntityDto = {
    entityId: string;
};

export type PostJoinerCustomDetailDto = {
    individual: Array<CreateCustomDetailDto>;
    vehicle: Array<CreateCustomDetailDto>;
};

export type PostJoinerInviteTemplateDto = {
    invitationText?: string;
};

export type JoinerLeaverContractDto = {
    id: string;
    name: string;
    type: ContractType;
    signatureType: SignatureType;
    file: CreateFileAssociationDto;
    counterparties: Array<CreateCounterpartyDto>;
    applicability: Array<InvestmentWorkflowType>;
    instruction: string;
    requiredWitnesses: number;
};

export type LoanJoinerDto = {
    amount: number;
    name: string;
    type: LoanDefinitionType;
    loanDefinitionId: string;
};

export type DataJoinerInvestorSecurityDto = {
    totalNumber: number;
    totalCost: number;
    name: string;
    type: SecurityType;
    isSubjectToVesting?: boolean;
    /**
     * optional because it might be based on security that will be created in same payload
     */
    securityId?: string;
};

export type JoinerInvestorDto = {
    email: string;
    firstName: string;
    lastName: string;
    contracts: Array<string>;
    loans: Array<LoanJoinerDto>;
    vestingTermId?: string;
    securities: Array<DataJoinerInvestorSecurityDto>;
};

export type PostJoinerAdditionalAllocationMipDto = {
    securitiesDto: BulkCreateSecuritiesDto;
    loansDefinitions: Array<LoanDefinitionDto>;
    customDetails: PostJoinerCustomDetailDto;
    inviteTemplate?: PostJoinerInviteTemplateDto;
    contracts: Array<JoinerLeaverContractDto>;
    investorAllocations: Array<JoinerInvestorDto>;
};

export type PostJoinerAllocationsRes = {
    postJoinerAllocationsWorkflowHandle: string;
};

export type InvestmentWorkflowProcessSettingsDto = {
    isKycRequired?: boolean;
    isBankAccountRequired?: boolean;
    isProofOfIdentityCertificationRequired?: boolean;
    isProofOfAddressCertificationRequired?: boolean;
    isProofOfInvestmentVehicleCertificationRequired?: boolean;
};

export type PostLeaverInviteTemplateDto = {
    invitationText?: string;
};

export type PostLeaverNegativeAllocationMipDto = {
    processSettings?: InvestmentWorkflowProcessSettingsDto;
    contracts?: Array<JoinerLeaverContractDto>;
    investorAllocations: Array<DataInvestorDto>;
    inviteTemplate?: PostLeaverInviteTemplateDto;
};

export type PostLeaverNegativeAllocationsRes = {
    postLeaverNegativeWorkflowHandle: {
        [key: string]: unknown;
    };
};

export type MipSettingsDto = {
    defaultRequireCertifiedCopiesOfDocuments?: boolean;
    shareWithInvestorSecurityValuation?: boolean;
};

export type GetProgrammesQueryDto = {
    /**
     * Whether to use fallback if no MIPs found
     */
    fallback?: {
        [key: string]: unknown;
    };
};

export type Object = {
    [key: string]: unknown;
};

export type GetInvestmentProgrammeByPersonIdDto = {
    sellerId: string;
    securityId: string;
    transactionDate: string;
    transactionId?: string;
};

export type GetInvestmentProgrammeByPersonIdRes = {
    id: string;
    name: string;
};

export type GetPivDetailsForInvestorRes = {
    investorId: string;
    representativeFirstName: string;
    representativeLastName: string;
    representativeEmail: string;
    pivName: string;
};

export type GetInvestorsPivDetailsRes = {
    /**
     * Mapping of investors to their piv details, key is the investor id
     */
    investorsMapping: {
        [key: string]: GetPivDetailsForInvestorRes;
    };
};

export type CreateActiveProgrammeDto = {
    programmeName: string;
    entityId?: string;
    currency: CurrencyType;
};

export type UpdateMipDraftGeneralDealInputsDto = {
    entityId?: {
        [key: string]: unknown;
    } | null;
    entityNameToCreate?: {
        [key: string]: unknown;
    } | null;
    programmeName: string;
    currency: CurrencyType;
};

export const MipDraftSteps = {
    GENERAL: 'GENERAL',
    PERSONAL: 'PERSONAL',
    KYC: 'KYC',
    SECURITIES: 'SECURITIES',
    CONTRACTS: 'CONTRACTS',
    SCHEDULE: 'SCHEDULE',
    PREVIEW: 'PREVIEW',
    INVESTORS: 'INVESTORS',
    COLLABORATE: 'COLLABORATE',
    SUMMARY: 'SUMMARY'
} as const;

export type MipDraftSteps = typeof MipDraftSteps[keyof typeof MipDraftSteps];

export const MipDraftStepsStatus = {
    ERROR_MISSING_DATA: 'ERROR_MISSING_DATA',
    ERROR_INVALID_DATA: 'ERROR_INVALID_DATA',
    WARNING: 'WARNING',
    VALID: 'VALID',
    ERROR_MAX_LENGTH: 'ERROR_MAX_LENGTH'
} as const;

export type MipDraftStepsStatus = typeof MipDraftStepsStatus[keyof typeof MipDraftStepsStatus];

export type GetMipDraftStepStatusRes = {
    step: MipDraftSteps;
    status: MipDraftStepsStatus;
    code: number;
};

export type SortByDto = {
    key: string;
    desc: boolean;
};

export type CreatedAtRange = {
    /**
     * The date from to search and include results on/after the given date
     */
    from?: string;
    /**
     * The date to search and include results on/before the given date
     */
    to?: string;
};

export type FilterFieldDto = {
    createdAtRange?: CreatedAtRange;
    name?: string;
};

export type GetMessagesFiltersDto = {
    searchQuery?: string;
    pagination?: PaginationDto;
    sortBy?: SortByDto;
    fieldFilter?: FilterFieldDto;
};

/**
 * Latest status of the email sent
 */
export const EmailSentEventStatusResponse = {
    ATTEMPTED: 'Attempted',
    BOUNCED: 'Bounced',
    CLICKED: 'Clicked',
    CONVERTED: 'Converted',
    DELIVERED: 'Delivered',
    FAILED: 'Failed',
    OPENED: 'Opened',
    SENT: 'Sent',
    SPAM: 'Spam',
    SUPPRESSED: 'Suppressed',
    UNDELIVERED: 'Undelivered',
    UNSUBSCRIBED: 'Unsubscribed',
    UNKNOWN: 'Unknown'
} as const;

/**
 * Latest status of the email sent
 */
export type EmailSentEventStatusResponse = typeof EmailSentEventStatusResponse[keyof typeof EmailSentEventStatusResponse];

export type MessageRes = {
    /**
     * Unique identifier for the message
     */
    id: string;
    /**
     * Subject of the message
     */
    subject: string | null;
    /**
     * Latest status of the email sent
     */
    latestStatus: EmailSentEventStatusResponse;
    /**
     * Date when the message was sent
     */
    sendDate: string;
    /**
     * Name of the sender
     */
    senderFullName: string;
};

export type InvestorMessagesRes = {
    /**
     * List of messages an investor has been sent
     */
    messages: Array<MessageRes>;
    /**
     * Total number of messages sent
     */
    total: number;
    /**
     * Date of the first message
     */
    dateOfFirstMessage: string | null;
};

export type SendHistory = {
    /**
     * Status of the email sent
     */
    status: EmailSentEventStatusResponse;
    createdAt: string;
};

export type InvestorMessageRes = {
    /**
     * Subject of the message
     */
    subject: string | null;
    /**
     * Latest status of the email sent
     */
    latestStatus: EmailSentEventStatusResponse;
    /**
     * Date when the message was sent
     */
    sendDate: string;
    /**
     * Name of the sender
     */
    senderFullName: string;
    session: SessionInfo | null;
    body: string | null;
    sendHistory: Array<SendHistory>;
    /**
     * Email address of the sender
     */
    senderEmail: string;
    /**
     * Email address of recipient
     */
    recipientEmail: string | null;
};

export type BankAccountDto = {
    accountHolder?: string;
    bankName?: string;
    accountNumber?: string;
    swiftCode?: string;
    iban?: string;
    investorInstructions?: string;
    currency?: CurrencyType | null;
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode?: {
        [key: string]: unknown;
    } | null;
    /**
     * BankAccountFormatRule the identifiers were entered against
     */
    formatRuleId?: string;
    identifiers?: Array<BankAccountIdentifierEntryDto>;
};

export type DocumentWorkflowMasterDocumentsFilterDto = {
    id?: string;
    name?: string;
    type?: Array<DocumentWorkflowTemplateType>;
    signatureType?: Array<SignatureType>;
    requiredWitnesses?: Array<string>;
    classifiers?: Array<string>;
    counterpartyName?: string;
};

export type DocumentWorkflowCounterparty = {
    id: string;
    name: string;
    documentWorkflowId: string;
    amount: number;
    requiresWitness: boolean;
    deleted: boolean;
    updatedAt: string;
    createdAt: string;
};

export type TemplateSettingLocksRes = {
    useManualSignaturePlacement: TemplateSettingLockRes;
    signaturePlacements: TemplateSettingLockRes;
    showStampMetadata: TemplateSettingLockRes;
    requiresSignature: TemplateSettingLockRes;
    sourceFormat: TemplateSettingLockRes;
    witnessRequired: TemplateSettingLockRes;
};

export type DocumentWorkflowTemplateInfo = {
    id: string;
    mipId: string | null;
    name: string;
    signatureType: SignatureType;
    type: DocumentWorkflowTemplateType;
    visibleIn: Array<DocumentWorkflowTemplateVisibleIn>;
    instruction?: {
        [key: string]: unknown;
    };
    requiredWitnesses?: {
        [key: string]: unknown;
    };
    /**
     * True if any PARTY/PIV/REPRESENTATIVE role on the template has requiresWitness=true.
     */
    witnessRequired: boolean;
    isExpired: boolean;
    archived: boolean;
    isRejected: boolean;
    file: DataFileTct | null;
    counterparties: Array<DocumentWorkflowCounterparty>;
    classifiers: Array<string>;
    individualScheduleRequired: boolean;
    individualInstances: boolean;
    /**
     * When true, signing prepare uses admin-placed stamp positions instead of auto-allocating signature pages.
     */
    useManualSignaturePlacement: boolean;
    /**
     * When true (default), rendered signature stamps include the metadata block (name / date / id). When false, only the border + header + scribble are drawn.
     */
    showStampMetadata: boolean;
    /**
     * When true, documents issued from this template must be post-dated by a counter-signer after signing completes.
     */
    requiresPostDating: boolean;
    /**
     * What was uploaded. DOCX templates bind named fields and are re-laid out at generation; PDF templates bind coordinate boxes on the uploaded file.
     */
    sourceFormat: DocumentWorkflowTemplateSourceFormat;
    createdAt: string;
    updatedAt: string;
    /**
     * The GlobalDocumentTemplate this Master Document was attached from. Provenance only — never read at generation time.
     */
    globalDocumentTemplateId: string | null;
    /**
     * Every non-deleted document ever issued from this template, terminal ones included. Answers "has this been sent", not "is anything still in flight".
     */
    issuedDocumentCount: number;
    /**
     * Issued documents still in flight — COMPLETED, CANCELLED and EXPIRED excluded. Drives the "changes here apply to N documents" warning, which issuedDocumentCount overstated on long-lived templates.
     */
    liveDocumentCount: number;
    /**
     * Per-setting lock state. A setting is locked once a document issued from this template carries a signature or has had a signing prepare run: changing it then would break a signature already given, so the API refuses it and the UI should disable the control and say why.
     */
    settingLocks: TemplateSettingLocksRes;
};

export type GetAllDocumentWorkflowTemplatesRes = {
    documentWorkflowTemplates: Array<DocumentWorkflowTemplateInfo>;
    total: number;
    hasNextPage: boolean;
};

export type CreateDocumentWorkflowTemplateCounterpartyRoleDto = {
    /**
     * Display name of the counterparty role
     */
    name: string;
    /**
     * Number of signatures required for this counterparty (1 or 2)
     */
    numberOfSignaturesRequired: number;
    /**
     * Whether signers of this role require a witness signature
     */
    requiresWitness?: boolean;
};

export type CreateDocumentWorkflowTemplateDto = {
    id?: string;
    name: string;
    type: DocumentWorkflowTemplateType;
    /**
     * File ID for the template document
     */
    fileId?: string;
    /**
     * File reference (alternative to fileId)
     */
    file?: {
        [key: string]: unknown;
    };
    signatureType: SignatureType;
    /**
     * Counterparty signing roles (name + number of signatures required). Aligns with investment flow configuration.
     */
    counterparties: Array<CreateDocumentWorkflowTemplateCounterpartyRoleDto>;
    visibleIn?: Array<DocumentWorkflowTemplateVisibleIn>;
    classifiers?: Array<string>;
    instruction?: string;
    requiredWitnesses?: boolean;
    individualScheduleRequired?: boolean;
    individualInstances?: boolean;
    /**
     * Attach a published GlobalDocumentTemplate instead of uploading a file. Mutually exclusive with fileId.
     */
    globalDocumentTemplateId?: string;
};

export type DatePlacementDto = {
    /**
     * Id of the existing placement this box is, echoed back from the slots endpoint. Omit for a newly drawn box. Rows are matched on this rather than placementIndex, so a dated position keeps its ledger history when the set is reordered.
     */
    id?: string;
    /**
     * Author-chosen order; must be contiguous from 0 across the set
     */
    placementIndex: number;
    /**
     * 1-based PDF page number
     */
    pageNum: number;
    /**
     * PDF-native X (origin bottom-left, points)
     */
    x: number;
    /**
     * PDF-native Y (origin bottom-left, points)
     */
    y: number;
    /**
     * Date stamp width in PDF points
     */
    width: number;
    /**
     * Date stamp height in PDF points
     */
    height: number;
};

export type UpdateDocumentWorkflowTemplatePropertiesDto = {
    /**
     * Array of transaction share association types for template applicability (visibleIn)
     */
    visibleIn?: Array<'INVESTMENT_WORKFLOWS_BUYING' | 'INVESTMENT_WORKFLOWS_SELLING' | 'NON_INVESTMENT_WORKFLOWS' | 'KYC_INDIVIDUAL' | 'KYC_VEHICLE'>;
    classifiers?: Array<Array<string>>;
    /**
     * Signature type for the document workflow template
     */
    signatureType?: SignatureType;
    instruction?: string;
    individualScheduleRequired?: boolean;
    individualInstances?: boolean;
    /**
     * When set, updates only PARTY/PIV/REPRESENTATIVE signing roles' requiresWitness flag to this value. Does NOT touch counterparty roles. The backend adds/removes the WITNESS role row to keep the template consistent.
     */
    witnessRequired?: boolean;
    name?: string;
    /**
     * Replacement list of counterparty roles. Roles in the existing template that are not in this list are soft-deleted; roles present here are upserted by name.
     */
    counterparties?: Array<CreateDocumentWorkflowTemplateCounterpartyRoleDto>;
    /**
     * When true, signing prepare skips auto-allocated signatures pages and uses the admin-placed stamp positions from `signaturePlacements`.
     */
    useManualSignaturePlacement?: boolean;
    /**
     * When true (default), rendered signature stamps include the metadata block (name / date / id). When false, only the border + header + scribble are drawn.
     */
    showStampMetadata?: boolean;
    /**
     * Atomic-replace set of stamp positions for this template. When provided, validated against the slot list derived from signing roles; missing or aspect-ratio-violating placements reject the request.
     */
    signaturePlacements?: Array<SignaturePlacementDto>;
    /**
     * When true, documents issued from this template must be post-dated by a counter-signer after signing completes. Requires an eID Easy signing config; independent of useManualSignaturePlacement.
     */
    requiresPostDating?: boolean;
    /**
     * Atomic-replace set of date-stamp positions for this template. Indexes must be contiguous from 0; geometry is validated against the same stamp aspect ratio as signature placements.
     */
    datePlacements?: Array<DatePlacementDto>;
};

export type UpdateArchivedDocumentWorkflowTemplateDto = {
    /**
     * Whether the template is archived (true) or active (false)
     */
    archived: boolean;
};

export type BulkArchiveDocumentWorkflowTemplatesDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    /**
     * Whether to archive (true) or unarchive (false) the templates
     */
    archived: boolean;
};

export type BulkActionPayloadDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: {
        [key: string]: unknown;
    };
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
};

export type BulkDeleteDocumentWorkflowTemplatesRes = {
    deletedCount: number;
    failedCount: number;
};

export const BankAccountVerificationBucketFilter = {
    COMPLETE: 'COMPLETE',
    PENDING: 'PENDING',
    DECLINED: 'DECLINED'
} as const;

export type BankAccountVerificationBucketFilter = typeof BankAccountVerificationBucketFilter[keyof typeof BankAccountVerificationBucketFilter];

export const BankAccountValidationOutcomeFilter = {
    COMPLIANT: 'COMPLIANT',
    FAILED: 'FAILED',
    INCONCLUSIVE: 'INCONCLUSIVE',
    NOT_CHECKED: 'NOT_CHECKED'
} as const;

export type BankAccountValidationOutcomeFilter = typeof BankAccountValidationOutcomeFilter[keyof typeof BankAccountValidationOutcomeFilter];

export type InvestorBankAccountFilterQueryDto = {
    accountHolder?: string;
    ownerName?: string;
    verificationStatuses?: Array<BankAccountVerificationBucketFilter>;
    validationOutcomes?: Array<BankAccountValidationOutcomeFilter>;
};

export const InvestorBankAccountSortField = {
    OWNER_NAME: 'ownerName',
    VERIFICATION_STATUS: 'verificationStatus',
    UPDATED_AT: 'updatedAt',
    CREATED_AT: 'createdAt'
} as const;

export type InvestorBankAccountSortField = typeof InvestorBankAccountSortField[keyof typeof InvestorBankAccountSortField];

export const InvestorBankAccountSortOrder = { ASC: 'asc', DESC: 'desc' } as const;

export type InvestorBankAccountSortOrder = typeof InvestorBankAccountSortOrder[keyof typeof InvestorBankAccountSortOrder];

export type InvestorBankAccountSortingQueryDto = {
    field: InvestorBankAccountSortField;
    order: InvestorBankAccountSortOrder;
};

export type ListInvestorBankAccountsDto = {
    offset?: number;
    limit?: number;
    /**
     * Matches account holder, bank name or owner
     */
    searchQuery?: string;
    filterQuery?: InvestorBankAccountFilterQueryDto;
    sortingQuery?: InvestorBankAccountSortingQueryDto;
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
};

export type MipInvestorBankAccountIdentifierRes = {
    /**
     * Identifier key as stored, e.g. sort_code
     */
    key: string;
    /**
     * Display label for the key, e.g. Sort code
     */
    label: string;
    value: string;
};

export const VerificationResult = {
    MATCH: 'MATCH',
    CLOSE_MATCH: 'CLOSE_MATCH',
    NO_MATCH: 'NO_MATCH',
    VERIFIED: 'VERIFIED',
    INCONCLUSIVE: 'INCONCLUSIVE',
    NOT_VERIFIED: 'NOT_VERIFIED',
    ERROR: 'ERROR'
} as const;

export type VerificationResult = typeof VerificationResult[keyof typeof VerificationResult];

export type MipInvestorBankAccountValidationRes = {
    validationType: ValidationType;
    result: VerificationResult;
    provider: string | null;
    checkedAt: string;
};

export type MipInvestorBankAccountDataGapRes = {
    /**
     * Stable key of the check that could not run
     */
    key: string;
    /**
     * Reviewer-facing explanation of what is missing
     */
    message: string;
};

export type DataMipInvestorBankAccountRes = {
    id: string;
    /**
     * Person the account belongs to; may be a legal entity. Empty for the programme's own account
     */
    personId: string;
    /**
     * The programme's own bank account rather than an investor's; owned by the Mip, so it has no owning person
     */
    isProgrammeAccount: boolean;
    /**
     * Held by a personal investment vehicle (PIV) an investor invests through, so the owner is the vehicle rather than a natural person
     */
    isPivAccount: boolean;
    /**
     * Name captured on the account, not the owning person
     */
    accountHolder: string;
    bankName?: string;
    countryCode: string | null;
    currency: CurrencyType | null;
    accountNumber?: string;
    iban?: string;
    identifiers: Array<MipInvestorBankAccountIdentifierRes>;
    status: BankAccountStatus;
    /**
     * Newest data-validation lookup; null when none has run
     */
    validation: MipInvestorBankAccountValidationRes | null;
    /**
     * How many risk rules fired. Advisory only — a reviewer can approve or decline regardless. Data gaps are NOT counted here.
     */
    riskCount: number;
    /**
     * Checks that could not run because the value they compare against is absent. Not risk — shown beside the owner, never counted in riskCount.
     */
    dataGaps: Array<MipInvestorBankAccountDataGapRes>;
    ownerName: string;
    ownerEmail: string | null;
    createdAt: string;
    updatedAt: string;
};

export type InvestorBankAccountsStatsRes = {
    /**
     * Accounts matching the filter, across all pages
     */
    total: number;
    /**
     * Distinct account owners within the filtered set
     */
    ownerCount: number;
    /**
     * Filtered accounts per verification bucket
     */
    byVerificationStatus: {
        [key: string]: number;
    };
    /**
     * Filtered accounts per validation outcome
     */
    byValidationOutcome: {
        [key: string]: number;
    };
    /**
     * Filtered accounts with at least one risk rule fired
     */
    riskCount: number;
    /**
     * Filtered accounts with no risk rule fired
     */
    noRiskCount: number;
};

export type GetInvestorBankAccountsRes = {
    bankAccounts: Array<DataMipInvestorBankAccountRes>;
    stats: InvestorBankAccountsStatsRes;
};

export type MipInvestorBankAccountReviewRes = {
    /**
     * Status the decision put the account into
     */
    decision: BankAccountStatus;
    decidedByName: string | null;
    decidedAt: string;
    reason: string | null;
};

export type MipInvestorBankAccountRiskFactorRes = {
    /**
     * Stable key of the rule that fired
     */
    key: string;
    /**
     * Reviewer-facing explanation of why the rule fired
     */
    message: string;
};

export type MipInvestorBankAccountDetailRes = {
    id: string;
    /**
     * Person the account belongs to; may be a legal entity. Empty for the programme's own account
     */
    personId: string;
    /**
     * The programme's own bank account rather than an investor's; owned by the Mip, so it has no owning person
     */
    isProgrammeAccount: boolean;
    /**
     * Held by a personal investment vehicle (PIV) an investor invests through, so the owner is the vehicle rather than a natural person
     */
    isPivAccount: boolean;
    /**
     * Name captured on the account, not the owning person
     */
    accountHolder: string;
    bankName?: string;
    countryCode: string | null;
    currency: CurrencyType | null;
    accountNumber?: string;
    iban?: string;
    identifiers: Array<MipInvestorBankAccountIdentifierRes>;
    status: BankAccountStatus;
    /**
     * Newest data-validation lookup; null when none has run
     */
    validation: MipInvestorBankAccountValidationRes | null;
    /**
     * How many risk rules fired. Advisory only — a reviewer can approve or decline regardless. Data gaps are NOT counted here.
     */
    riskCount: number;
    /**
     * Checks that could not run because the value they compare against is absent. Not risk — shown beside the owner, never counted in riskCount.
     */
    dataGaps: Array<MipInvestorBankAccountDataGapRes>;
    ownerName: string;
    ownerEmail: string | null;
    createdAt: string;
    updatedAt: string;
    /**
     * Entry format: "IBAN", or the country format rule name for local formats
     */
    accountType: string | null;
    /**
     * The standing admin decision; null while the account is still pending
     */
    review: MipInvestorBankAccountReviewRes | null;
    /**
     * The risk rules that fired, one entry each. Advisory: they carry no resolved state and never block a decision.
     */
    riskFactors: Array<MipInvestorBankAccountRiskFactorRes>;
};

export const AuditAction = {
    CREATE: 'CREATE',
    UPDATE: 'UPDATE',
    DELETE: 'DELETE',
    RESTORE: 'RESTORE'
} as const;

export type AuditAction = typeof AuditAction[keyof typeof AuditAction];

export type AuditTct = {
    id: string;
    tableName: string;
    recordId: string;
    action: AuditAction;
    userId?: string;
    userEmail?: string;
    userDisplayName?: string;
    sessionId?: string;
    dealId?: string;
    /**
     * Previous state of the record before the change
     */
    oldData?: {
        [key: string]: unknown;
    };
    /**
     * New state of the record after the change
     */
    newData?: {
        [key: string]: unknown;
    };
    createdAt: string;
    /**
     * Session details when the audit action was performed
     */
    userSession?: SessionInfo;
};

export const BankAccountReviewAction = {
    APPROVE: 'APPROVE',
    DECLINE: 'DECLINE',
    REVOKE: 'REVOKE'
} as const;

export type BankAccountReviewAction = typeof BankAccountReviewAction[keyof typeof BankAccountReviewAction];

export type ReviewBankAccountDto = {
    action: BankAccountReviewAction;
    /**
     * Recorded against the state transition. Required on DECLINE — it is what the rejection email tells the account holder.
     */
    reason?: string;
};

export type ProgrammeSettingResponseDto = {
    shareWithInvestorSecurityValuation: boolean;
};

export type UpdateProgrammeSettingDto = {
    shareWithInvestorSecurityValuation?: boolean;
};

export type OrganizationKycSettingResponseDto = {
    isProofOfIdentityRequired: boolean;
    isProofOfAddressRequired: boolean;
    isProofOfInvestmentVehicleRequired: boolean;
    /**
     * Mirror of the per-proof certification flags.
     *
     * @deprecated
     */
    requestCertifiedCopiesOfDocuments?: boolean | null;
    isProofOfIdentityCertificationRequired: boolean;
    isProofOfAddressCertificationRequired: boolean;
    isProofOfInvestmentVehicleCertificationRequired: boolean;
    certificationText: string | null;
    isKycRequired: boolean;
    isInvestorBankAccountRequired: boolean;
    isVehicleBankAccountRequired: boolean;
    isControllingPartyInfoRequired: boolean;
    isTinRequired: boolean;
    isTaxResidenceRequired: boolean;
    isPlaceOfBirthRequired: boolean;
    isCountryOfBirthRequired: boolean;
    isEmployeeIdRequired: boolean;
    isCitizenshipRequired: boolean;
    isBeneficialOwnershipRequired: boolean;
    isSourceOfFundsRequired: boolean;
    isPepRequired: boolean;
    bankAccountApprovalMode: BankAccountApprovalMode;
};

export type UpdateOrganizationKycSettingDto = {
    isProofOfIdentityRequired?: boolean;
    isProofOfAddressRequired?: boolean;
    isProofOfInvestmentVehicleRequired?: boolean;
    isProofOfIdentityCertificationRequired?: boolean;
    isProofOfAddressCertificationRequired?: boolean;
    isProofOfInvestmentVehicleCertificationRequired?: boolean;
    certificationText?: string | null;
    isKycRequired?: boolean;
    isInvestorBankAccountRequired?: boolean;
    isVehicleBankAccountRequired?: boolean;
    isControllingPartyInfoRequired?: boolean;
    isTinRequired?: boolean;
    isTaxResidenceRequired?: boolean;
    isPlaceOfBirthRequired?: boolean;
    isCountryOfBirthRequired?: boolean;
    isEmployeeIdRequired?: boolean;
    isCitizenshipRequired?: boolean;
    isBeneficialOwnershipRequired?: boolean;
    isSourceOfFundsRequired?: boolean;
    isPepRequired?: boolean;
    /**
     * How a bank account submitted inside this programme is treated on save. AUTO_APPROVE_VALIDATED approves only when the identifier lookup for that submission came back verified.
     */
    bankAccountApprovalMode?: BankAccountApprovalMode;
};

export type OrganizationCustomFieldResponseDto = {
    id: string;
    name: string;
    instruction: string | null;
    type: CustomDetailEnum;
    isChecked: boolean;
};

export type CreateOrganizationCustomFieldDto = {
    name: string;
    instruction?: string | null;
    /**
     * Which investor type the field applies to
     */
    type: CustomDetailEnum;
    isChecked?: boolean;
};

export type UpdateOrganizationCustomFieldDto = {
    name?: string;
    instruction?: string | null;
    isChecked?: boolean;
};

export type ArchiveKycFormTemplateDto = {
    archived: boolean;
};

export type DeleteKycFormTemplatesDto = {
    templateIds: Array<string>;
};

export type DownloadOrganizationFileDto = {
    fileName?: string;
};

export type DownloadPreSignedUrlDto = {
    fileId: string;
    downloadUrl: string;
};

export const ScheduledEmailType = { DOCUMENT_SIGNING_REMINDER: 'DOCUMENT_SIGNING_REMINDER' } as const;

export type ScheduledEmailType = typeof ScheduledEmailType[keyof typeof ScheduledEmailType];

export type ProgrammeEmailScheduleConfigRes = {
    type: ScheduledEmailType;
    enabled: boolean;
    initialDelayDays: number;
    intervalDays: number;
    maxFires: number;
    endDate?: string | null;
};

export type UpdateEmailScheduleConfigDto = {
    type: ScheduledEmailType;
    enabled: boolean;
    /**
     * Days to wait after the target is issued before the first fire
     */
    initialDelayDays: number;
    /**
     * Days between subsequent fires
     */
    intervalDays: number;
    /**
     * Maximum number of times this schedule will fire
     */
    maxFires: number;
    endDate?: string | null;
};

export const ProgrammeDefaultsCategoryKey = {
    KYC_SETTING: 'KYC_SETTING',
    INVESTOR_DATA_CUSTOM_FIELDS: 'INVESTOR_DATA_CUSTOM_FIELDS',
    VESTING_TERMS: 'VESTING_TERMS',
    MASTER_DOCUMENTS: 'MASTER_DOCUMENTS',
    TAX_AND_COMPLIANCE: 'TAX_AND_COMPLIANCE',
    EMAIL_TEMPLATES: 'EMAIL_TEMPLATES',
    EMAIL_REMINDERS: 'EMAIL_REMINDERS',
    MEMBERS: 'MEMBERS'
} as const;

export type ProgrammeDefaultsCategoryKey = typeof ProgrammeDefaultsCategoryKey[keyof typeof ProgrammeDefaultsCategoryKey];

export type ProgrammeDefaultsCategorySummaryRes = {
    category: ProgrammeDefaultsCategoryKey;
    configured: boolean;
};

export type ProgrammeDefaultsSummaryRes = {
    organizationId: string;
    organizationName: string;
    hasAnyConfigured: boolean;
    categories: Array<ProgrammeDefaultsCategorySummaryRes>;
};

export type CreateMipClassifierDto = {
    name: string;
};

export type UpdateMipClassifierDto = {
    name?: string;
    archived?: boolean;
};

export type InvestorAssignmentDto = {
    investorIds: Array<string>;
};

export type CreateTagDto = {
    name: string;
    mipClassifierIds?: Array<string>;
};

export type TagRes = {
    id: string;
    mipId: string;
    name: string;
    archived: boolean;
    classifiers: Array<MipClassifierRes>;
    updatedAt: string;
    createdAt: string;
};

export type UpdateTagDto = {
    name?: string;
    archived?: boolean;
};

export type ClassifierAssignmentDto = {
    mipClassifierIds: Array<string>;
};

export type TaskDto = {
    sortBy?: Array<SortDto>;
    pagination?: PaginationDto;
};

export const TaskStatus = {
    PENDING: 'PENDING',
    IN_PROGRESS: 'IN_PROGRESS',
    CANCELLED: 'CANCELLED',
    ERROR: 'ERROR',
    DONE: 'DONE'
} as const;

export type TaskStatus = typeof TaskStatus[keyof typeof TaskStatus];

export type GetTaskRes = {
    status: TaskStatus;
    date: string;
    programmeName: string;
    entityName: string;
    projectName: string;
    fileKey?: string;
    /**
     * The name of the file to download. If not provided, defaults to a generated name with .zip extension for backwards compatibility.
     */
    fileName?: string;
    /**
     * The file extension (e.g., "xlsx", "zip"). If not provided, defaults to "zip" for backwards compatibility.
     */
    fileExtension?: string;
};

export type GetTasksRes = {
    record: Array<GetTaskRes>;
    totalRecord: number;
};

export type TransactionFilterDto = {
    id?: string;
    dateFrom?: string;
    dateTo?: string;
    types?: TransactionType | null;
    titles?: Array<TransactionTitle>;
    sourceIds?: Array<string | null> | null;
    destinationIds?: Array<string | null> | null;
    boughtForIds?: Array<string | null> | null;
    soldForIds?: Array<string | null> | null;
    isTransactionValid?: boolean;
    securityIds?: Array<string> | null;
    units?: number | null;
    cost?: number | null;
    excludeType?: TransactionType | null;
    buyerMipIds?: Array<string | null> | null;
    sellerMipIds?: Array<string | null> | null;
};

export type TransactionListQueryDto = {
    pagination?: PaginationDto;
    sortBy?: Array<SortDto>;
    search?: string;
    personId: string;
    filter?: TransactionFilterDto;
    fetchDeleted: boolean;
};

export type TransactionCountsDto = {
    uniqueDateCount: number;
    uniqueSecurityCount: number;
    uniqueTypeCount: number;
    uniqueBuyerCount: number;
    uniqueSellerCount: number;
    uniqueBoughtForCount: number;
    uniqueSoldForCount: number;
    totalAmount: number;
    totalPrice: number;
    totalRows: number;
};

export type GetTransactionsRes = {
    totalCount: number;
    hasNextPage: boolean;
    transactions: Array<GetTransactionRes>;
    deletedTransactions: Array<GetTransactionRes>;
    totalCountDeleted?: number;
    transactionCounts: TransactionCountsDto;
    deletedTransactionCounts: TransactionCountsDto;
};

export type GetTransactionDetailsDto = {
    [key: string]: unknown;
};

export type TransactionWithSecurityTct = {
    id: string;
    date: string;
    securityId: string;
    destinationId?: string;
    sourceId?: string;
    fromMipId?: string;
    soldForId?: string;
    boughtForId?: string;
    order?: number;
    pgSaId?: string;
    toMipId?: string;
    type?: TransactionType;
    title?: TransactionTitle;
    interestPairId?: string;
    redemptionGroupId?: string;
    interestPairSibling?: InterestPairSiblingRes;
    createdAt: string;
    updatedAt: string;
    isTransactionValid?: boolean;
    transactionError?: string;
    isPossibleRedemption?: boolean;
    originalTransactionBeforeSplitId?: string;
    sourcePgTsaId?: string;
    destinationPgTsaId?: string;
    transactionOneBeforePairId?: string;
    transactionTwoBeforePairId?: string;
    participationThresholdExpressedAs: TransactionThresholdExpressedAs;
    participationThreshold?: number;
    units?: number;
    cost?: number;
    sourceBalanceStrict?: number;
    sourceBalanceNonStrict?: number;
    destBalanceStrict?: number;
    destBalanceNonStrict?: number;
    deleted: boolean;
    security?: DataSecurityWithIssuerTct;
    conversionTargetSecurityId?: string;
};

export type DownloadTransactionsDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: TransactionFilterDto;
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
};

export type CreateTransactionDto = {
    date: string;
    destinationId?: string | null;
    fromMipId?: string | null;
    sourceId: string;
    toMipId?: string | null;
    type: TransactionType;
    units: number;
    cost: number;
    securityId: string;
    conversionTargetSecurityId?: string | null;
    soldForId?: string | null;
    boughtForId?: string | null;
    title?: TransactionTitle;
};

export type TransactionTct = {
    id: string;
    date: string;
    securityId: string;
    destinationId?: string;
    sourceId?: string;
    fromMipId?: string;
    soldForId?: string;
    boughtForId?: string;
    order?: number;
    pgSaId?: string;
    toMipId?: string;
    type?: TransactionType;
    title?: TransactionTitle;
    interestPairId?: string;
    redemptionGroupId?: string;
    interestPairSibling?: InterestPairSiblingRes;
    createdAt: string;
    updatedAt: string;
    isTransactionValid?: boolean;
    transactionError?: string;
    isPossibleRedemption?: boolean;
    originalTransactionBeforeSplitId?: string;
    sourcePgTsaId?: string;
    destinationPgTsaId?: string;
    transactionOneBeforePairId?: string;
    transactionTwoBeforePairId?: string;
    participationThresholdExpressedAs: TransactionThresholdExpressedAs;
    participationThreshold?: number;
    units?: number;
    cost?: number;
    sourceBalanceStrict?: number;
    sourceBalanceNonStrict?: number;
    destBalanceStrict?: number;
    destBalanceNonStrict?: number;
    deleted: boolean;
};

export type TransferCounterpartPreviewRes = {
    /**
     * Whether this transfer would write a counterpart leg at all. False for Both-titled rows, non-nominee securities, self-addressed rows, and holdings whose counterpart nobody holds.
     */
    writesCounterpart: boolean;
    /**
     * Holder whose counterpart title is split at the same boundary. Equals the seller on a deal that has never split title, where the seller is their own counterpart.
     */
    counterpartHolderId?: string | null;
    /**
     * Units of the counterpart rail the linked leg carries
     */
    units?: number | null;
    /**
     * Programme the counterpart position sits in, if any
     */
    counterpartMipId?: string | null;
    /**
     * Beneficial owner the counterpart position is held for, if any
     */
    counterpartHeldForId?: string | null;
};

export type CreatePairedIssueDto = {
    date: string;
    securityId: string;
    nomineeId: string;
    beneficialBuyerId: string;
    units: number;
    cost: number;
    /**
     * Programme the holding sits inside, applying to both interests
     */
    toMipId?: string | null;
    /**
     * Natural person the LEGAL-interest holder holds for, when that holder is a PIV
     */
    legalBoughtForId?: string | null;
    /**
     * Natural person the BENEFICIAL-interest holder holds for, when that holder is a PIV
     */
    beneficialBoughtForId?: string | null;
};

export type RedemptionLegFingerprintDto = {
    counterpartHolderId: string;
    start: number;
    end: number;
    units: number;
};

export type CreateInseparableRedemptionDto = {
    date: string;
    securityId: string;
    holderId: string;
    interest: CapTableRail;
    type?: TransactionType;
    units: number;
    cost: number;
    replacesRedemptionGroupId?: string | null;
    /**
     * Programme the redeemed holding sits inside, when the holder has more than one
     */
    fromMipId?: string | null;
    /**
     * Natural person the redeeming holder holds for, when that holder is a PIV
     */
    soldForId?: string | null;
    /**
     * Legs a preview disclosed to the user, which this write must still resolve to
     */
    disclosedLegs?: Array<RedemptionLegFingerprintDto>;
};

export type InseparableRedemptionLegRes = {
    /**
     * Holder whose counterpart title is retired by this leg
     */
    counterpartHolderId: string;
    /**
     * Display name of the counterpart holder
     */
    counterpartHolderName: string;
    /**
     * Units retired by this leg, as counted by the engine. Never re-derive it from the serial range
     */
    units: number;
    /**
     * First serial this leg retires
     */
    start: number;
    /**
     * Last serial this leg retires
     */
    end: number;
    sourceMipId?: string | null;
    sourceHeldForId?: string | null;
    counterpartMipId?: string | null;
    counterpartHeldForId?: string | null;
};

export type InseparableRedemptionPreviewRes = {
    legs: Array<InseparableRedemptionLegRes>;
};

export type InseparableRedemptionCounterpartRes = {
    /**
     * Holder whose counterpart title this leg retires
     */
    holderId: string;
    units: number;
    title: TransactionTitle;
};

export type InseparableRedemptionGroupRes = {
    redemptionGroupId: string;
    securityId: string;
    /**
     * The holder whose interest is being redeemed
     */
    holderId: string;
    interest: CapTableRail;
    type: TransactionType;
    /**
     * Total units retired on the redeemed rail
     */
    units: number;
    /**
     * Total consideration across the group
     */
    cost: number;
    date: string;
    fromMipId?: string | null;
    soldForId?: string | null;
    /**
     * How many positions the take is spread across
     */
    segmentCount: number;
    counterparts: Array<InseparableRedemptionCounterpartRes>;
};

export type UpdateInseparableRedemptionDto = {
    date: string;
    securityId: string;
    holderId: string;
    interest: CapTableRail;
    type?: TransactionType;
    units: number;
    cost: number;
    replacesRedemptionGroupId?: string | null;
    /**
     * Programme the redeemed holding sits inside, when the holder has more than one
     */
    fromMipId?: string | null;
    /**
     * Natural person the redeeming holder holds for, when that holder is a PIV
     */
    soldForId?: string | null;
    /**
     * Legs a preview disclosed to the user, which this write must still resolve to
     */
    disclosedLegs?: Array<RedemptionLegFingerprintDto>;
    redemptionGroupId: string;
};

export type SplitTransactionDto = {
    id: string;
    units1: number;
    units2: number;
    cost1: number;
    cost2: number;
};

export type SplitInterestTransactionDto = {
    id: string;
};

export type GetPairTransactionDto = {
    id?: string;
    date: string;
    sourceId?: {
        [key: string]: unknown;
    };
    destinationId?: {
        [key: string]: unknown;
    };
    securityId: string;
    units: number;
    cost: number;
};

export type TransactionWithSecurityUnitDenominatorTct = {
    id: string;
    date: string;
    securityId: string;
    destinationId?: string;
    sourceId?: string;
    fromMipId?: string;
    soldForId?: string;
    boughtForId?: string;
    order?: number;
    pgSaId?: string;
    toMipId?: string;
    type?: TransactionType;
    title?: TransactionTitle;
    interestPairId?: string;
    redemptionGroupId?: string;
    interestPairSibling?: InterestPairSiblingRes;
    createdAt: string;
    updatedAt: string;
    isTransactionValid?: boolean;
    transactionError?: string;
    isPossibleRedemption?: boolean;
    originalTransactionBeforeSplitId?: string;
    sourcePgTsaId?: string;
    destinationPgTsaId?: string;
    transactionOneBeforePairId?: string;
    transactionTwoBeforePairId?: string;
    participationThresholdExpressedAs: TransactionThresholdExpressedAs;
    participationThreshold?: number;
    units?: number;
    cost?: number;
    sourceBalanceStrict?: number;
    sourceBalanceNonStrict?: number;
    destBalanceStrict?: number;
    destBalanceNonStrict?: number;
    deleted: boolean;
    securityUnitDenominator: number;
};

export type PairTransactionDto = {
    transactionOneId: string;
    transactionTwoId: string;
};

export type PairTransactionRes = {
    newTransactionId: string;
};

export type UpdateTransactionDto = {
    id: string;
    date: string;
    destinationId?: string | null;
    fromMipId?: string | null;
    soldForId?: string | null;
    boughtForId?: string | null;
    sourceId: string;
    toMipId?: string | null;
    type: TransactionType;
    units: number;
    cost: number;
    securityId: string;
    conversionTargetSecurityId?: string | null;
    title?: TransactionTitle;
    participationThresholdExpressedAs?: TransactionThresholdExpressedAs | null;
    participationThreshold?: number | null;
    confirmPairSync?: boolean;
};

export type RestoreTransactionDto = {
    id: string;
};

export const OrderType = { ABOVE: 'above', BELOW: 'below' } as const;

export type OrderType = typeof OrderType[keyof typeof OrderType];

export type ReorderTransactionDto = {
    sourceId: string;
    destId: string;
    orderDestinationType: OrderType;
};

export type AutoReorderTransactionDto = {
    transactionId: string;
};

export type BulkUploadTransactionTct = {
    type: TransactionType;
    amount: number;
    price: number;
    date: string;
    fromMipName?: {
        [key: string]: unknown;
    } | null;
    toMipName?: {
        [key: string]: unknown;
    } | null;
    securityName: string;
    securityType: SecurityType;
    source: string;
    destination: string;
    soldFor?: {
        [key: string]: unknown;
    } | null;
    boughtFor?: {
        [key: string]: unknown;
    } | null;
};

export type BulkUploadTransactionsDto = {
    transactions: Array<BulkUploadTransactionTct>;
    entityId: string;
    oneSchemaSessionId: string;
};

export type ManagementLoansBulkUploadDto = {
    records: Array<OneSchemaManagementLoanRowValueDto>;
    funderId: string;
};

export type UploadRowError = {
    rowIndex: number;
    error: string;
    transaction: {
        [key: string]: unknown;
    };
};

export type GetBulkUploadStatusRes = {
    status?: string;
    total?: number;
    progress?: Decimal2;
    totalProcessed?: number;
    rowErrors?: Array<UploadRowError>;
    systemError?: string;
};

export type BulkUpdateTransactionDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: TransactionFilterDto;
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    destinationId?: string;
    sourceId?: string;
    soldForId?: string;
    boughtForId?: string;
    fromMipId?: string;
    toMipId?: string;
    type?: {
        [key: string]: unknown;
    };
    date?: string;
    deleted?: boolean;
};

export type BulkUpdateTransactionsRes = {
    count?: number;
};

export type DeleteTransactionDto = {
    transactionId: string;
};

export type BulkDeleteTransactionsDto = {
    /**
     * Specific entity IDs to include. When provided, filters/search are ignored.
     */
    selectedIds?: Array<string>;
    /**
     * Entity IDs to exclude. Only works with personId filter mode.
     */
    excludedIds?: Array<string>;
    /**
     * Person/Entity ID to filter by. Required when not using selectedIds.
     */
    personId?: string;
    /**
     * Filter criteria (type depends on resource)
     */
    filter?: TransactionFilterDto;
    /**
     * Search string for text filtering
     */
    search?: string;
    /**
     * Sorting criteria
     */
    sortBy?: Array<SortDto>;
    /**
     * If true, query all items (respecting filters, search, excludedIds). If false, only fetch by specific selectedIds.
     */
    allItems?: boolean;
    forceDelete?: boolean;
};

export type FolderEntityClassType = {
    Person?: string;
    Transaction?: string;
    HoldingEvent?: string;
};

export type PreSignedUrlDto = {
    fileData: Array<UploadFileInfo>;
    entityMap: FolderEntityClassType;
};

export type DocumentLinkTargetDto = {
    /**
     * The Person to link the document to
     */
    personId?: string;
    /**
     * The Transaction to link the document to
     */
    transactionId?: string;
};

export type FileWithMetaData = {
    md5: string;
    fileName: string;
    fileKey: string;
    mimeType: string;
    fileExtension: string;
    dealClassifierId?: string;
    documentLinks?: Array<DocumentLinkTargetDto>;
};

export type DocumentLinkCreateDto = {
    /**
     * The Person to link the document to
     */
    personId?: string;
    /**
     * The Transaction to link the document to
     */
    transactionId?: string;
    /**
     * the Document.id to create the link to
     */
    documentId: string;
};

export type CreateDocumentsDto = {
    fileData: Array<FileWithMetaData>;
    documentsToLink: Array<DocumentLinkCreateDto>;
    dealId?: string;
    linkTarget?: DocumentLinkTargetDto;
};

export type DocumentFieldFilterDto = {
    /**
     * The classifier field names
     */
    classifiers?: Array<string>;
    /**
     * The inclusive dates to search between, from or up to
     */
    updatedAt: DateRangeDto;
    /**
     * The name field of the document
     */
    name?: string;
    /**
     * Document links (related to)
     */
    documentLinks?: string;
    /**
     * Related to entities (legal and individual) persons
     */
    relatedToIds?: Array<string>;
    /**
     * MIP ids to filter by. Use "NONE" sentinel to match documents with no linked MIP.
     */
    mipIds?: Array<string>;
};

export type DocumentClassifier = {
    dealClassifierId: string;
    classifierId: string;
    name: string;
};

export type DocumentLinkRes = {
    /**
     * Set when the document is linked to a person
     */
    personId: string | null;
    /**
     * Set when the document is linked to a transaction
     */
    transactionId: string | null;
    documentId: string;
    /**
     * The name of the sellerName if related to a transaction
     */
    sellerName?: string;
    /**
     * The name of the buyerName if related to a transaction
     */
    buyerName?: string;
    /**
     * The name of the security issuer if related to a transaction
     */
    name?: string;
};

export type DocumentRes = {
    documentId: string;
    fileExtension: string;
    name: string;
    updatedAt: string;
    classifiers: Array<DocumentClassifier>;
    fileId: string;
    links: Array<DocumentLinkRes>;
};

export type DocumentMeta = {
    rowCount: number;
    classifiers: Array<string>;
};

export type GetDocumentsRes = {
    documents: Array<DocumentRes>;
    meta: DocumentMeta;
};

/**
 * Type of the field
 */
export const DocumentFields = {
    CLASSIFIERS: 'classifiers',
    DOCUMENT_TITLE: 'documentTitle',
    FILE_NAME: 'fileName',
    FILE_SIZE: 'fileSize',
    UPLOAD_DATE: 'uploadDate',
    RELATED_PEOPLE: 'relatedPeople',
    ASSOCIATED_TRANSACTIONS: 'associatedTransactions'
} as const;

/**
 * Type of the field
 */
export type DocumentFields = typeof DocumentFields[keyof typeof DocumentFields];

/**
 * Type of the field
 */
export const DocumentFieldType = {
    TEXT: 'text',
    NUMBER: 'number',
    DATE: 'date',
    MULTI_SELECT: 'multiSelect',
    SELECT: 'select',
    MULTI_SELECT_WITH_NESTED_COLLAPSABLE_CHILDREN: 'multiSelectWithNestedCollapsableChildren',
    BOOLEAN: 'boolean',
    LIST: 'list'
} as const;

/**
 * Type of the field
 */
export type DocumentFieldType = typeof DocumentFieldType[keyof typeof DocumentFieldType];

/**
 * If the click edit field has an action
 */
export const DocumentFormAction = { OPEN_LINK_MODAL: 'openLinkModal', VIEW_ALL_RELATED_PEOPLE: 'viewAllRelatedPeople' } as const;

/**
 * If the click edit field has an action
 */
export type DocumentFormAction = typeof DocumentFormAction[keyof typeof DocumentFormAction];

export type DocumentFieldRes = {
    /**
     * Type of the field
     */
    fieldKey: DocumentFields;
    /**
     * Label for the field
     */
    label: string;
    /**
     * Type of the field
     */
    type: DocumentFieldType;
    /**
     * Indicates if the field is required
     */
    required?: boolean;
    /**
     * Options for select fields
     */
    options?: Array<string>;
    /**
     * Whether the field is read-only
     */
    readOnly?: boolean;
    /**
     * If the click edit field has an action
     */
    action?: DocumentFormAction;
    /**
     * Label for the action button
     */
    actionLabel?: string;
};

export type GetMetaRes = {
    /**
     * Fields that will map to the frontends inputs
     */
    fields: Array<DocumentFieldRes>;
};

/**
 * Type of the person relation
 */
export const DocumentPersonType = {
    LINK: 'link',
    SELLER: 'seller',
    BUYER: 'buyer',
    ISSUER: 'issuer'
} as const;

/**
 * Type of the person relation
 */
export type DocumentPersonType = typeof DocumentPersonType[keyof typeof DocumentPersonType];

export type DocumentPersonRelationRes = {
    /**
     * Unique identifier for the person
     */
    personId: string;
    /**
     * Name of the person
     */
    personName: string;
    /**
     * Type of the person
     */
    personType: PersonType;
    /**
     * Type of the person relation
     */
    documentPersonType: DocumentPersonType;
    /**
     * DC-494: whether this person sees the document in the investor portal. Only set for Person links; absent for persons derived from a transaction (buyer/seller/issuer).
     */
    visibleToInvestor?: boolean;
};

export type DocumentRelationRes = {
    /**
     * Unique identifier for the document
     */
    documentId: string;
    /**
     * Name of the document
     */
    documentName: string;
    /**
     * Unique identifier for the file
     */
    fileId: string;
    /**
     * MD5 hash of the file
     */
    md5: string;
    /**
     * Set when the document link points at a person
     */
    personId: string | null;
    /**
     * Set when the document link points at a transaction
     */
    linkedTransactionId: string | null;
    /**
     * Unique identifier for the transaction
     */
    transactionId: string;
    /**
     * Unique identifier for the issuer
     */
    issuerId: string;
    /**
     * Type of the issuer
     */
    issuerType: PersonType;
    /**
     * Name of the issuer
     */
    issuerName: string;
    /**
     * Unique identifier for the buyer
     */
    buyerId: string;
    /**
     * Type of the buyer
     */
    buyerType: PersonType;
    /**
     * Name of the buyer
     */
    buyerName: string;
    /**
     * Unique identifier for the seller
     */
    sellerId: string;
    /**
     * Type of the seller
     */
    sellerType: PersonType;
    /**
     * Name of the seller
     */
    sellerName: string;
    /**
     * Date of the transaction
     */
    transactionDate: string;
    /**
     * Type of the transaction
     */
    transactionType: TransactionType;
    /**
     * Name of the seller
     */
    units: number;
    /**
     * Cost of the transaction
     */
    cost: number;
    /**
     * Type of the security
     */
    securityName: string;
    /**
     * Type of the security
     */
    securityType: SecurityType;
    /**
     * Unit denominator of the security
     */
    securityUnitDenominator: number;
    /**
     * Currency of the security
     */
    securityCurrency: CurrencyType | null;
    /**
     * Whether the security is issued in currency or units
     */
    securityIssuedIn: SecurityIssuedIn | null;
};

export type DocumentDetailsRes = {
    /**
     * Unique identifier for the document
     */
    documentId: string;
    /**
     * Title of the document
     */
    documentTitle: string;
    /**
     * Classifiers for the document
     */
    classifiers: Array<string>;
    /**
     * Name of the file
     */
    fileName: string;
    /**
     * Date when the file was uploaded
     */
    uploadDate: string;
    /**
     * All the related people to the document
     */
    relatedPeople: Array<DocumentPersonRelationRes>;
    /**
     * All the related transactions to the document
     */
    associatedTransactions: Array<DocumentRelationRes>;
};

export type GetDocumentRes = {
    /**
     * Metadata about the document
     */
    meta: GetMetaRes;
    /**
     * The details of the document
     */
    documentDetails: DocumentDetailsRes;
};

export type FileData = {
    /**
     * md5 of the document
     */
    md5: string;
    /**
     * name of file
     */
    fileName: string;
    /**
     * classifierName of the document
     */
    classifierName?: string;
    /**
     * dealClassifierId to be related to
     */
    dealClassifierId?: string;
};

export type FindRelatedFileDto = {
    /**
     * The Person being uploaded to, when the upload started from a person
     */
    personId?: string;
    /**
     * The Transaction being uploaded to, when the upload started from a transaction
     */
    transactionId?: string;
    /**
     * md5 of the document
     */
    fileData: Array<FileData>;
};

export type RelatedTransactions = {
    transactionId: string;
    cost: number;
    units: number;
    sellerName: string;
    buyerName: string;
    transactionDate: string;
    transactionType: TransactionType;
    securityType: SecurityType;
    securityName: string;
    securityUnitDenominator: number;
    securityIssuedIn: SecurityIssuedIn | null;
    securityCurrency: CurrencyType | null;
    issuerName: string;
    shouldLink: boolean;
    documentId?: string;
    mipId?: string;
    mipName?: string | null;
};

export type MatchedDocumentsRes = {
    transactionId: string;
    cost: number;
    units: number;
    sellerName: string;
    buyerName: string;
    transactionDate: string;
    transactionType: TransactionType;
    securityType: SecurityType;
    securityName: string;
    securityUnitDenominator: number;
    securityIssuedIn: SecurityIssuedIn | null;
    securityCurrency: CurrencyType | null;
    issuerName: string;
    documentId: string;
    md5: string;
    fileId: string;
    documentName: string;
    personId: string | null;
    linkedTransactionId: string | null;
};

export type FindRelatedFilesRes = {
    /**
     * md5 of the document
     */
    md5: string;
    /**
     * fileId of the document
     */
    fileName: string;
    /**
     * classifierName of the document
     */
    classifierName?: string;
    /**
     * dealClassifierId of the document
     */
    dealClassifierId?: string;
    relatedTransactions: Array<RelatedTransactions>;
    matchedDocuments: Array<MatchedDocumentsRes>;
};

export type DocumentLink = {
    /**
     * linkId of the document link
     */
    id: string;
    /**
     * Set when the document link points at a person
     */
    personId: string | null;
    /**
     * Set when the document link points at a transaction
     */
    transactionId: string | null;
};

export type FindRelatedDocumentsRes = {
    /**
     * Transaction id
     */
    transactionId: string;
    /**
     * Transaction date
     */
    transactionDate: string;
    /**
     * Transaction type
     */
    transactionType: TransactionType;
    /**
     * Transaction cost
     */
    cost: number;
    /**
     * Transaction units
     */
    units: number;
    /**
     * Transaction Buyer name
     */
    buyerName: string;
    /**
     * Transaction Seller name
     */
    sellerName: string;
    /**
     * Transaction security issuer name
     */
    issuerName: string;
    /**
     * Security name of the security
     */
    securityName: string;
    /**
     * Unit denominator of the security
     */
    securityUnitDenominator: number;
    /**
     * property to toggle if the document is linked
     */
    isLinkedToEntity: boolean;
    /**
     * Document links
     */
    documentLinks: Array<DocumentLink>;
};

export type UpdateRelatedDocumentDto = {
    /**
     * The transaction id
     */
    transactionId: string;
    /**
     * Whether the document is linked to the entity
     */
    isLinkedToEntity: boolean;
    /**
     * The document id
     */
    documentId: string;
};

export type ClassifierRes = {
    /**
     * Classifier ID
     */
    id: string;
    name: string;
    /**
     * The location the classifier is supposed to be used on.
     */
    classifiedType: ClassifierType;
    /**
     * Specifies the group this classifier belongs to. For most of the classifiers, we expect the namespace to be 'dealstack.io'.
     */
    namespace: string;
    deleted: boolean;
};

export type DocumentRelatedPersonsRes = {
    /**
     * Name of the person linked to the document
     */
    name: string;
    /**
     * Name of the buyer linked to the document
     */
    buyerName: string;
    /**
     * Name of the seller linked to the document
     */
    sellerName: string;
    /**
     * Name of the issuer linked to the document
     */
    issuerName: string;
};

export type MipRefRes = {
    /**
     * Unique identifier of the MIP
     */
    id: string;
    /**
     * Programme name of the MIP (may be null for draft MIPs)
     */
    programmeName: {
        [key: string]: unknown;
    } | null;
};

export type DocumentsFindByDealRes = {
    /**
     * Unique identifier of the document
     */
    id: string;
    /**
     * Name of the document
     */
    name: string;
    /**
     * Creation timestamp
     */
    createdAt: string;
    /**
     * Last update timestamp
     */
    updatedAt: string;
    /**
     * Array of classifiers associated with the document
     */
    classifiers: Array<ClassifierRes>;
    /**
     * Array of related persons associated with the document
     */
    documentLinks: Array<DocumentRelatedPersonsRes>;
    /**
     * MIME type of the file associated with the document
     */
    mimeType: string;
    /**
     * File extension of the file associated with the document
     */
    extension: string;
    /**
     * Indicates if the document is deleted
     */
    deleted: boolean;
    /**
     * ID of the issuer contract file associated with the document
     */
    s3key: string;
    /**
     * ID of the file associated with the document
     */
    fileId: string;
    /**
     * ID of the deal associated with the document
     */
    dealId: string;
    /**
     * Array of MIPs linked to the document via transactions → investors
     */
    mips: Array<MipRefRes>;
    /**
     * True if the document was generated by a workflow (signature output, generated SPA, share certificate, etc). Such documents cannot be deleted via the bulk-delete flow.
     */
    isWorkflowGenerated: boolean;
};

export type DocumentsRes = {
    documents: Array<DocumentsFindByDealRes>;
    meta: {
        [key: string]: unknown;
    };
};

/**
 * Action to perform on the documents
 */
export const BulkUpdateDocumentClassifierAction = { ADD: 'add', REMOVE: 'remove' } as const;

/**
 * Action to perform on the documents
 */
export type BulkUpdateDocumentClassifierAction = typeof BulkUpdateDocumentClassifierAction[keyof typeof BulkUpdateDocumentClassifierAction];

export type BulkUpdateDocumentClassifiersDto = {
    /**
     * Array of document IDs to update
     */
    documentIdsToUpdate: Array<string>;
    /**
     * Array of deal classifier IDs to apply
     */
    dealClassifierIdsToUpdate: Array<string>;
    /**
     * Action to perform on the documents
     */
    action: BulkUpdateDocumentClassifierAction;
    /**
     * Bulk updates using the given filters, used for multipage updates
     */
    bulkUpdateUsingFilters: boolean;
};

export const ClassificationGroupType = { COMPLETED_DOCUMENTS: 'COMPLETED_DOCUMENTS', UNCLASSIFIED: 'UNCLASSIFIED' } as const;

export type ClassificationGroupType = typeof ClassificationGroupType[keyof typeof ClassificationGroupType];

export type DealClassifierGroupRes = {
    dealId: string;
    classifierId: string;
    classifierParentId?: string | null;
    dealClassifierId: string;
    name: string;
    groupType: ClassificationGroupType;
    groupName: string;
};

export type BulkDocumentLibraryFiltersDto = {
    /**
     * The search query to filter by
     */
    searchQuery?: string;
    /**
     * The classification ID to filter by
     */
    classificationId?: string;
    /**
     * The classification group to filter by
     */
    classificationGroup?: ClassificationGroupType;
    /**
     * The inclusive dates to search between, from or up to
     */
    dateRange?: DateRangeDto;
    /**
     * Related to entities (legal and individual) persons
     */
    relatedToIds?: Array<string>;
    /**
     * MIP ids to filter by. Use "NONE" sentinel to match documents with no linked MIP.
     */
    mipIds?: Array<string>;
};

export type BulkDownloadDto = {
    /**
     * If true, query all items (respecting filters, search, excludeIds). If false, only fetch by specific selectedIds (ignore filters/search,excludeIds).
     */
    allDocumentsSelected?: boolean;
    /**
     * List of IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentIds?: Array<string>;
    /**
     * List of IDs to fetch when allDocumentsSelected = false
     */
    selectedDocumentIds?: Array<string>;
    /**
     * Filters to apply to the documents to be added to
     */
    filters?: BulkDocumentLibraryFiltersDto;
};

export type BulkDeleteDto = {
    /**
     * If true, target all documents matching the filters minus excludedDocumentIds. If false, target only selectedDocumentIds.
     */
    allDocumentsSelected?: boolean;
    /**
     * List of document IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentIds?: Array<string>;
    /**
     * List of document IDs to delete when allDocumentsSelected = false
     */
    selectedDocumentIds?: Array<string>;
    /**
     * Filters used to scope which documents to delete when allDocumentsSelected = true
     */
    filters?: BulkDocumentLibraryFiltersDto;
};

export type BulkDeleteRes = {
    /**
     * IDs of documents that were soft-deleted
     */
    deleted: Array<string>;
    /**
     * IDs of documents that were skipped because they are workflow-generated and cannot be deleted via this flow
     */
    skippedWorkflowGenerated: Array<string>;
};

export type PersonData = {
    label: string;
    value: string;
};

export type FindPersonsInDealRes = {
    persons: Array<PersonData>;
};

export type RemovePersonsFromDocumentDto = {
    personsToRemove: Array<string>;
};

export type AddPersonsToDocumentDto = {
    personsToAdd: Array<string>;
};

export type SetPersonDocumentVisibilityDto = {
    /**
     * Person ids whose link to this document should change visibility
     */
    personIds: Array<string>;
    /**
     * Whether the document is shown to these persons in the investor portal
     */
    visibleToInvestor: boolean;
};

export type PersonsToDocumentsDto = {
    /**
     * If true, query all items (respecting filters, search, excludeIds). If false, only fetch by specific selectedIds (ignore filters/search,excludeIds).
     */
    allDocumentsSelected?: boolean;
    /**
     * List of IDs to exclude when allDocumentsSelected = true
     */
    excludedDocumentIds?: Array<string>;
    /**
     * List of IDs to fetch when allDocumentsSelected = false
     */
    selectedDocumentIds?: Array<string>;
    personIds: Array<string>;
    /**
     * Filters to apply to the documents to be added to
     */
    filters?: BulkDocumentLibraryFiltersDto;
};

export type ExtractionDocumentDto = {
    /**
     * The File row ID of the previously uploaded document
     */
    fileId: string;
};

export type RichCanonicalEntityDto = {
    /**
     * The canonical name as it should be persisted on the document
     */
    canonical: string;
    /**
     * Optional alternative names to match against during NER resolution
     */
    aliases?: Array<string>;
};

export type StartDocumentExtractionDto = {
    /**
     * The deal ID
     */
    dealId: string;
    /**
     * The person/entity ID
     */
    personId?: string;
    /**
     * Optional batch title
     */
    batchTitle?: string;
    /**
     * Array of documents to process max 10 documents
     */
    documents: Array<ExtractionDocumentDto>;
    /**
     * Canonical-entity hints for securities, applied to every document in the batch (NER resolution in stage 4)
     */
    knownSecurities?: Array<RichCanonicalEntityDto>;
    /**
     * Canonical-entity hints for persons, applied to every document in the batch (NER resolution in stage 4)
     */
    knownPersons?: Array<RichCanonicalEntityDto>;
};

export type StartExtractionRes = {
    /**
     * The task ID to use for polling status
     */
    taskId: string;
    /**
     * The batch ID grouping these extractions
     */
    batchId: string;
};

export const ExtractionDocumentTaskStatus = {
    PENDING: 'pending',
    RUNNING: 'running',
    COMPLETED: 'completed',
    FAILED: 'failed'
} as const;

export type ExtractionDocumentTaskStatus = typeof ExtractionDocumentTaskStatus[keyof typeof ExtractionDocumentTaskStatus];

export type ExtractionDocumentStatus = {
    documentId: string;
    fileName: string;
    workflowId: string;
    status: ExtractionDocumentTaskStatus;
    pipelineStatus?: {
        [key: string]: unknown;
    };
    error?: string;
};

export type GetExtractionStatusRes = {
    /**
     * The task ID
     */
    taskId: string;
    /**
     * The batch ID
     */
    batchId?: string;
    /**
     * The batch title
     */
    batchTitle?: string;
    status: TaskStatus;
    totalDocuments: number;
    totalProcessed: number;
    documents: Array<ExtractionDocumentStatus>;
    error?: string;
};

export type GetExtractionResultRes = {
    /**
     * The task ID
     */
    taskId: string;
    results: Array<string>;
};

export type BatchListDocumentItemRes = {
    id: string;
    workflowId: string;
    fileName: string;
    status: string;
    errorMessage?: {
        [key: string]: unknown;
    };
};

export type BatchListItemRes = {
    id: string;
    title?: string;
    status: TaskStatus;
    documentCount: number;
    createdAt: string;
    documents: Array<BatchListDocumentItemRes>;
};

export type ListBatchesRes = {
    batches: Array<BatchListItemRes>;
};

export type UpdateBatchTitleDto = {
    /**
     * The new batch title
     */
    title: string;
};

export type BatchDocumentTransactionRes = {
    transactionId: string;
    transactionType: string;
    description: string;
    transactionDate?: {
        [key: string]: unknown;
    };
    sellers: Array<string>;
    buyers: Array<string>;
    buyerHolding?: {
        [key: string]: unknown;
    };
    securityType?: {
        [key: string]: unknown;
    };
    numberOfUnits: number;
    priceCost: {
        [key: string]: unknown;
    };
    confidence: number;
    /**
     * Person.id of the issuing company inferred from buyers/sellers. Used by the merge flow to scope security lookup by issuer.
     */
    inferredIssuerPersonId?: {
        [key: string]: unknown;
    };
    /**
     * User-supplied overrides for fields the AI missed (date, units, cost). Already pre-applied to the response fields; this object exposes the raw override so the UI can flag user-supplied vs. AI-extracted values if needed.
     */
    fieldOverrides?: {
        [key: string]: unknown;
    };
    /**
     * Id of the existing Transaction on the deal that matches this extraction by fingerprint (security + parties + date + units + cost). Non-null means the tx is already in the deal — whether from a prior merge or from another source — so merging again would create a duplicate.
     */
    existingDealTransactionId?: {
        [key: string]: unknown;
    };
};

export type BatchDocumentRes = {
    documentId: string;
    fileName: string;
    fileUrl?: {
        [key: string]: unknown;
    };
    transactions: Array<BatchDocumentTransactionRes>;
};

export type DocumentFetchErrorRes = {
    documentId: string;
    fileName: string;
    /**
     * Why the summary-api data for this document could not be loaded.
     */
    error: string;
};

export type GetBatchTransactionsRes = {
    batchId: string;
    documents: Array<BatchDocumentRes>;
    /**
     * Documents whose extraction data could not be fetched from the summary-api. Their entries in `documents` render with empty transactions — without this signal an outage is indistinguishable from "nothing extracted".
     */
    fetchErrors?: Array<DocumentFetchErrorRes>;
};

export type BatchOverviewRes = {
    batchId: string;
    title: string;
    documentCount: number;
    extractedCount: number;
    partialExtractionCount: number;
    unrelatedCount: number;
    documentTypeCounts: {
        [key: string]: unknown;
    };
    securitiesCount?: number;
    securitiesMatchedCount?: number;
    securitiesNewCount?: number;
    securitiesUnmatchedCount?: number;
    peopleCount?: number;
    peopleMatchedCount?: number;
    peopleNewCount?: number;
    peopleUnmatchedCount?: number;
    /**
     * Custom system prompt last used on a Re-extract run for this batch.
     */
    customSystemPrompt?: {
        [key: string]: unknown;
    };
    /**
     * Completed documents whose extraction data could not be fetched from the summary-api. Counted separately from unrelatedCount so an outage does not masquerade as "unrelated documents".
     */
    fetchFailedCount: number;
    fetchErrors?: Array<DocumentFetchErrorRes>;
};

export type BatchDocumentItemRes = {
    documentId: string;
    fileName: string;
    fileUrl?: {
        [key: string]: unknown;
    };
    documentType: string;
    transactionCount: number;
    peopleCount: number;
    status: string;
};

export type GetBatchDocumentsRes = {
    totalCount: number;
    hasNextPage: boolean;
    documents: Array<BatchDocumentItemRes>;
    documentTypeCounts: {
        [key: string]: unknown;
    };
};

export type SaveExtractionOverridesDto = {
    /**
     * Map of extractionTransactionId → field overrides. Shallow-merged into the document's extractionOverrides JSON column; missing keys are preserved.
     */
    overrides: {
        [key: string]: unknown;
    };
};

export type SaveExtractionOverridesRes = {
    success: boolean;
    /**
     * Extraction transaction ids whose overrides could not be mapped to a document in the batch (stale after a re-extract) and were therefore not saved.
     */
    skippedTxIds: Array<string>;
};

export const BatchSecurityMatchStatus = {
    MATCHED: 'matched',
    NEW: 'new',
    UNMATCHED: 'unmatched',
    POTENTIAL_MATCH: 'potential_match'
} as const;

export type BatchSecurityMatchStatus = typeof BatchSecurityMatchStatus[keyof typeof BatchSecurityMatchStatus];

export type BatchSecurityItemRes = {
    /**
     * The extracted security name from documents
     */
    extractedName: string;
    matchStatus: BatchSecurityMatchStatus;
    transactionCount: number;
    documentCount: number;
    matchedSecurityId?: {
        [key: string]: unknown;
    };
    matchedSecurityName?: {
        [key: string]: unknown;
    };
    /**
     * Inferred issuer (company) display name for this security
     */
    issuerName?: {
        [key: string]: unknown;
    };
    /**
     * Inferred issuer (company) Person.id for this security
     */
    issuerPersonId?: {
        [key: string]: unknown;
    };
    /**
     * Simplified status: needs_review or merged
     */
    reviewStatus: string;
};

export type GetBatchSecuritiesRes = {
    securities: Array<BatchSecurityItemRes>;
    total: number;
    statusCounts: {
        [key: string]: unknown;
    };
    fetchErrors?: Array<DocumentFetchErrorRes>;
};

export const BatchPersonMatchStatus = {
    MATCHED: 'matched',
    NEW: 'new',
    UNMATCHED: 'unmatched',
    POTENTIAL_MATCH: 'potential_match'
} as const;

export type BatchPersonMatchStatus = typeof BatchPersonMatchStatus[keyof typeof BatchPersonMatchStatus];

export type BatchPersonItemRes = {
    /**
     * The extracted person name from documents
     */
    extractedName: string;
    matchStatus: BatchPersonMatchStatus;
    /**
     * Total buyer+seller appearances across transactions
     */
    entryCount: number;
    documentCount: number;
    matchedPersonId?: {
        [key: string]: unknown;
    };
    matchedPersonName?: {
        [key: string]: unknown;
    };
    /**
     * Simplified status: needs_review or merged
     */
    reviewStatus: string;
};

export type GetBatchPeopleRes = {
    people: Array<BatchPersonItemRes>;
    total: number;
    statusCounts: {
        [key: string]: unknown;
    };
    fetchErrors?: Array<DocumentFetchErrorRes>;
};

export type MatchExtractedPersonDto = {
    /**
     * The extracted person name to link.
     */
    extractedName: string;
    /**
     * The id of the existing Person on the deal to link this extracted name to. Pass null to clear an existing override.
     */
    matchedPersonId?: {
        [key: string]: unknown;
    } | null;
};

export type MatchExtractedSecurityDto = {
    /**
     * The extracted security name to link.
     */
    extractedName: string;
    /**
     * The inferred issuer Person.id this extracted security belongs to. Securities are issuer-scoped, so the override key uses this value to disambiguate identical names across issuers. Pass null for entries with no inferred issuer.
     */
    issuerPersonId?: {
        [key: string]: unknown;
    } | null;
    /**
     * The id of the existing Security on the deal to link this extracted name to. Pass null to clear an existing override.
     */
    matchedSecurityId?: {
        [key: string]: unknown;
    } | null;
};

export type ReextractBatchDto = {
    /**
     * Free-form prompt appended to the extraction LLM system prompt. Use to steer how transactions are interpreted on the next run.
     */
    customSystemPrompt: string;
};

export type DealClassifierRes = {
    dealId: string;
    dealClassifierId: string;
    classifierId: string;
    /**
     * Classifier parent ID
     */
    classifierParentId: {
        [key: string]: unknown;
    } | null;
    name: string;
};

export const DealEventCategory = {
    CAPITAL: 'CAPITAL',
    PARTICIPANT: 'PARTICIPANT',
    ADMIN: 'ADMIN',
    MESSAGE: 'MESSAGE',
    ACCESS: 'ACCESS',
    AUTH: 'AUTH'
} as const;

export type DealEventCategory = typeof DealEventCategory[keyof typeof DealEventCategory];

export const DealEventStatus = {
    COMPLETED: 'COMPLETED',
    IN_PROGRESS: 'IN_PROGRESS',
    PENDING: 'PENDING',
    APPROVED: 'APPROVED',
    DRAFT: 'DRAFT',
    FAILED: 'FAILED',
    CANCELLED: 'CANCELLED',
    SUCCESS: 'SUCCESS',
    SENT: 'SENT',
    DELIVERED: 'DELIVERED',
    OPENED: 'OPENED',
    READ: 'READ',
    BOUNCED: 'BOUNCED',
    WARNING: 'WARNING',
    EXPIRED: 'EXPIRED',
    REJECTED: 'REJECTED'
} as const;

export type DealEventStatus = typeof DealEventStatus[keyof typeof DealEventStatus];

export const DealEventSource = {
    AUDIT: 'AUDIT',
    LEDGER: 'LEDGER',
    INVESTMENT_WORKFLOW: 'INVESTMENT_WORKFLOW',
    KYC: 'KYC',
    DOCUMENT_WORKFLOW: 'DOCUMENT_WORKFLOW',
    BANK_ACCOUNT_VERIFICATION: 'BANK_ACCOUNT_VERIFICATION',
    BANK_ACCOUNT_STATE: 'BANK_ACCOUNT_STATE',
    ACCESS: 'ACCESS',
    AUTH: 'AUTH',
    EMAIL_SENT: 'EMAIL_SENT'
} as const;

export type DealEventSource = typeof DealEventSource[keyof typeof DealEventSource];

export type DealEventActorTct = {
    id?: string;
    displayName?: string;
    email?: string;
    isSystem: boolean;
};

export type DealEventEntityTct = {
    type: string;
    id: string;
};

export type DealEventCapitalTct = {
    securityId?: string;
    securityName?: string;
    currency?: CurrencyType;
    transactionType?: TransactionType;
    units?: number;
    /**
     * Drives how many decimals the units are shown to
     */
    unitDenominator?: number;
    cost?: number;
    /**
     * Ledger date, not the date of the change
     */
    date?: string;
    fromName?: string;
    toName?: string;
    issuerName?: string;
    /**
     * Person the security is issued by; links to its page
     */
    issuerId?: string;
    loanDefinitionName?: string;
    /**
     * Whether the record still exists; a deleted one has no page to open
     */
    deleted?: boolean;
};

export const HoldingEventType = {
    ISSUANCE_OF_SHARE_CERTIFICATES: 'ISSUANCE_OF_SHARE_CERTIFICATES',
    PLEDGING_OF_SHARES: 'PLEDGING_OF_SHARES',
    ASSIGNMENT_OF_VOTING_RIGHTS: 'ASSIGNMENT_OF_VOTING_RIGHTS',
    NOTE: 'NOTE'
} as const;

export type HoldingEventType = typeof HoldingEventType[keyof typeof HoldingEventType];

export type DealEventHoldingTct = {
    eventType: HoldingEventType;
    /**
     * Date of the holding event, not the date of the change
     */
    date: string;
    deleted: boolean;
    holderId: string;
    holderName?: string;
    securityId: string;
    securityName?: string;
    pledgeToName?: string;
    pledgeAgainstName?: string;
    assignedToName?: string;
    note?: string;
};

export const InvestmentWorkflowEventType = {
    CREATED: 'CREATED',
    APPROVED: 'APPROVED',
    APPROVAL_CLEARED: 'APPROVAL_CLEARED',
    STARTED: 'STARTED',
    COMPLETION_STEP_CHANGED: 'COMPLETION_STEP_CHANGED',
    RELEASED: 'RELEASED'
} as const;

export type InvestmentWorkflowEventType = typeof InvestmentWorkflowEventType[keyof typeof InvestmentWorkflowEventType];

export type DealEventParticipantTct = {
    investorId?: string;
    /**
     * Person the workflow belongs to
     */
    participantName?: string;
    workflowEventType?: InvestmentWorkflowEventType;
    documentWorkflowInstanceId?: string;
    /**
     * Investment the event belongs to
     */
    investmentWorkflowId?: string;
    documentName?: string;
    bankAccountId?: string;
    /**
     * Outcome the event settled on, as the source records it
     */
    status?: string;
    comment?: string;
};

export type DealEventDirectoryTct = {
    /**
     * Person in the deal directory the change was about
     */
    personId: string;
    /**
     * Absent when the person has since been removed
     */
    personName?: string;
    /**
     * Counterparty of a relation or an employment
     */
    relatedPersonId?: string;
    relatedPersonName?: string;
};

export const AccessEventAction = {
    GRANT: 'GRANT',
    REVOKE: 'REVOKE',
    CHANGE: 'CHANGE'
} as const;

export type AccessEventAction = typeof AccessEventAction[keyof typeof AccessEventAction];

export const AccessEventSource = {
    INVITE: 'INVITE',
    REMOVE: 'REMOVE',
    ROLE_CHANGE: 'ROLE_CHANGE',
    RESOURCE_CREATED: 'RESOURCE_CREATED',
    USER_DEACTIVATED: 'USER_DEACTIVATED'
} as const;

export type AccessEventSource = typeof AccessEventSource[keyof typeof AccessEventSource];

export type DealEventAccessTct = {
    action: AccessEventAction;
    /**
     * User whose access changed
     */
    targetUserId: string;
    targetName?: string;
    targetEmail?: string;
    resourceType: ResourceType;
    resourceId: string;
    /**
     * Set when the change was on a programme of the deal
     */
    programmeName?: string;
    rolesBefore: Array<string>;
    rolesAfter: Array<string>;
    reason: AccessEventSource;
    /**
     * Shared by every event one user action produced
     */
    operationId: string;
};

export const AuthEventAction = {
    SIGN_IN_SUCCEEDED: 'SIGN_IN_SUCCEEDED',
    SIGN_IN_FAILED: 'SIGN_IN_FAILED',
    MFA_SUCCEEDED: 'MFA_SUCCEEDED',
    EMAIL_VERIFIED: 'EMAIL_VERIFIED',
    RISK_DETECTED: 'RISK_DETECTED',
    PASSWORD_RESET_REQUESTED: 'PASSWORD_RESET_REQUESTED',
    PASSWORD_RESET_SUCCEEDED: 'PASSWORD_RESET_SUCCEEDED'
} as const;

export type AuthEventAction = typeof AuthEventAction[keyof typeof AuthEventAction];

export const AuthEventMethod = {
    PASSWORD: 'PASSWORD',
    OAUTH: 'OAUTH',
    SSO: 'SSO',
    MAGIC_AUTH: 'MAGIC_AUTH',
    MFA: 'MFA',
    EMAIL_VERIFICATION: 'EMAIL_VERIFICATION'
} as const;

export type AuthEventMethod = typeof AuthEventMethod[keyof typeof AuthEventMethod];

export type DealEventAuthTct = {
    action: AuthEventAction;
    method?: AuthEventMethod;
    /**
     * WorkOS error code of a failed attempt
     */
    errorCode?: string;
};

export const EmailSentEventStatus = {
    ATTEMPTED: 'ATTEMPTED',
    BOUNCED: 'BOUNCED',
    CLICKED: 'CLICKED',
    CONVERTED: 'CONVERTED',
    DELIVERED: 'DELIVERED',
    FAILED: 'FAILED',
    OPENED: 'OPENED',
    SENT: 'SENT',
    SPAMMED: 'SPAMMED',
    SUPPRESSED: 'SUPPRESSED',
    UNDELIVERED: 'UNDELIVERED',
    UNSUBSCRIBED: 'UNSUBSCRIBED'
} as const;

export type EmailSentEventStatus = typeof EmailSentEventStatus[keyof typeof EmailSentEventStatus];

export type DealEventMessageTct = {
    recipientEmail: string;
    /**
     * Absent when the send was not linked to a person
     */
    recipientName?: string;
    subject?: string;
    /**
     * Template the message was rendered from
     */
    templateType: string;
    status: EmailSentEventStatus;
};

export type DealEventTct = {
    /**
     * Feed-wide identifier, unique across every event source
     */
    id: string;
    source: DealEventSource;
    /**
     * Identifier of the row in the source table
     */
    sourceId: string;
    category: DealEventCategory;
    /**
     * Source-agnostic event type, e.g. TRANSACTION_CREATE
     */
    type: string;
    action: AuditAction;
    status: DealEventStatus;
    /**
     * Plain-language summary: the event type and what it was about
     */
    description: string;
    occurredAt: string;
    actor: DealEventActorTct;
    entity: DealEventEntityTct;
    changedFields: Array<string>;
    oldData?: {
        [key: string]: unknown;
    };
    newData?: {
        [key: string]: unknown;
    };
    capital?: DealEventCapitalTct;
    holding?: DealEventHoldingTct;
    participant?: DealEventParticipantTct;
    /**
     * Present on ADMIN events: the directory person the audited record belongs to
     */
    directory?: DealEventDirectoryTct;
    access?: DealEventAccessTct;
    auth?: DealEventAuthTct;
    /**
     * The signed-in session the change was made from, where one was recorded
     */
    session?: SessionInfo;
    /**
     * Present on MESSAGE events only. Carries no message body.
     */
    message?: DealEventMessageTct;
};

export type DealEventFeedRes = {
    events: Array<DealEventTct>;
    /**
     * Absent when the last page has been reached
     */
    nextCursor?: string;
};

export type DealEventDailyCountTct = {
    /**
     * Calendar day, YYYY-MM-DD, in the requested time zone
     */
    date: string;
    count: number;
};

export type DealEventDailyCountsRes = {
    /**
     * Oldest first. Days without events are left out.
     */
    days: Array<DealEventDailyCountTct>;
    total: number;
};

export type DealEventRecipientTct = {
    /**
     * The address the feed filters on
     */
    email: string;
    /**
     * Absent when the email was not linked to a person
     */
    name?: string;
};

export type DealEventRecipientsRes = {
    /**
     * Distinct recipients, by display name where one is known
     */
    recipients: Array<DealEventRecipientTct>;
    /**
     * More recipients match than were returned
     */
    hasMore: boolean;
};

export type DealEventPersonTct = {
    /**
     * The user id the feed filters on
     */
    id: string;
    /**
     * Absent when the user has no name recorded
     */
    name?: string;
    email: string;
};

export type DealEventActorsRes = {
    /**
     * Users who can act on the deal's feed: its team and its investors
     */
    actors: Array<DealEventPersonTct>;
    /**
     * More users match than were returned
     */
    hasMore: boolean;
};

export type DealEventParticipantOptionTct = {
    /**
     * Every investment this participant holds on the deal, which the feed filters on
     */
    investorIds: Array<string>;
    /**
     * Display name of the person the investments belong to
     */
    name?: string;
};

export type DealEventParticipantsRes = {
    /**
     * Participants on the deal, for the event log participant filter
     */
    participants: Array<DealEventParticipantOptionTct>;
};

export type DealEventSendersRes = {
    /**
     * Users who sent the deal's messages, by display name
     */
    senders: Array<DealEventPersonTct>;
    /**
     * More users match than were returned
     */
    hasMore: boolean;
};

export type DealEventSubjectsRes = {
    /**
     * Users the deal's team and access events are about, by display name
     */
    subjects: Array<DealEventPersonTct>;
    /**
     * More users match than were returned
     */
    hasMore: boolean;
};

export type DealEventLogUnreadRes = {
    count: number;
    /**
     * More unread events exist than count
     */
    hasMore: boolean;
    /**
     * Absent until the user first opens the event log
     */
    lastViewedAt?: string;
};

export type DealEventLogViewRes = {
    lastViewedAt: string;
    /**
     * Absent on the first visit
     */
    previousViewedAt?: string;
};

export const SecurityEventType = {
    SPLIT: 'SPLIT',
    REVERSE_SPLIT: 'REVERSE_SPLIT',
    ADJUST: 'ADJUST',
    CONVERSION: 'CONVERSION'
} as const;

export type SecurityEventType = typeof SecurityEventType[keyof typeof SecurityEventType];

export type SecurityEventFilterDto = {
    id?: string;
    type?: SecurityEventType;
    postEventNominalValue?: number;
    preEventUnits?: number;
    postEventUnits?: number;
};

export type SecurityEventListQueryDto = {
    pagination?: PaginationDto;
    sortBy?: Array<SortDto>;
    search?: string;
    securityId: string;
    filter?: SecurityEventFilterDto;
};

export type SecurityEventRes = {
    id: string;
    date: string;
    preEventSecurityId: {
        [key: string]: unknown;
    };
    postEventSecurityId?: {
        [key: string]: unknown;
    };
    type: SecurityEventType;
    preEventUnits?: {
        [key: string]: unknown;
    };
    postEventUnits?: {
        [key: string]: unknown;
    };
    postEventNominalValue?: {
        [key: string]: unknown;
    };
    preEventNominalValue?: {
        [key: string]: unknown;
    };
};

export type GetSecurityEventsRes = {
    totalCount: number;
    hasNextPage: boolean;
    securityEvents: Array<SecurityEventRes>;
};

export type CreateSecurityEventDto = {
    date: string;
    preEventSecurityId: string;
    postEventSecurityId: string;
    type: SecurityEventType;
    preEventUnits?: number;
    postEventUnits?: number;
    postEventNominalValue?: number;
    preEventNominalValue?: number;
};

export type UpdateSecurityEventDto = {
    id: string;
    date: string;
    preEventSecurityId: string;
    postEventSecurityId: string;
    type: SecurityEventType;
    preEventUnits?: number;
    postEventUnits?: number;
    postEventNominalValue?: number;
    preEventNominalValue?: number;
};

export type DeleteSecurityEventDto = {
    id: string;
};

export type DeleteSecurityEventRes = {
    count?: number;
};

/**
 * Specifies the base multiplier for input values. For example, if this is set to MILLIONS, an input of 200 dollars will be seen as 200 million dollars in the later calculations.
 */
export const ValuationNumberFormat = {
    UNFORMATTED: 'UNFORMATTED',
    THOUSANDS: 'THOUSANDS',
    MILLIONS: 'MILLIONS',
    BILLIONS: 'BILLIONS'
} as const;

/**
 * Specifies the base multiplier for input values. For example, if this is set to MILLIONS, an input of 200 dollars will be seen as 200 million dollars in the later calculations.
 */
export type ValuationNumberFormat = typeof ValuationNumberFormat[keyof typeof ValuationNumberFormat];

export type CreateValuationDto = {
    name: string;
    /**
     * The default currency to be used in the valuation. If the user doesn't provide it, we set this to EUR.
     */
    defaultCurrency?: CurrencyType;
    /**
     * Specifies the base multiplier for input values. For example, if this is set to MILLIONS, an input of 200 dollars will be seen as 200 million dollars in the later calculations.
     */
    defaultNumberFormat: ValuationNumberFormat;
    classifierIds?: Array<string>;
    valuationDate?: string;
};

export type ValuationRes = {
    /**
     * Valuation ID
     */
    id: string;
    /**
     * Deal ID
     */
    dealId: string;
    /**
     * User ID of the creator
     */
    creatorUserId: string;
    name: string;
    valuationDate: string;
    createdAt: string;
    updatedAt: string;
    defaultCurrency: CurrencyType;
    defaultNumberFormat: ValuationNumberFormat;
    deleted: boolean;
};

export type ValuationWithClassifierRes = {
    /**
     * Valuation ID
     */
    id: string;
    /**
     * Deal ID
     */
    dealId: string;
    /**
     * User ID of the creator
     */
    creatorUserId: string;
    name: string;
    valuationDate: string;
    createdAt: string;
    updatedAt: string;
    defaultCurrency: CurrencyType;
    defaultNumberFormat: ValuationNumberFormat;
    deleted: boolean;
    classifiers: Array<ClassifierRes>;
    /**
     * Total equity value of all valuation inputs
     */
    totalEquityValue: string;
    /**
     * Total enterprise value of all valuation inputs. If any input is labelled as equity-valued, this value will be omitted.
     */
    totalEnterpriseValue?: string;
    /**
     * MOIC (Multiple on Invested Capital) of all fund nodes
     */
    moic?: string;
    /**
     * XIRR (Extended Internal Rate of Return) of all fund nodes
     */
    xirr?: string;
};

export type UpsertValuationDto = {
    name: string;
    defaultCurrency?: CurrencyType;
    defaultNumberFormat: ValuationNumberFormat;
    classifierIds?: Array<string>;
    valuationDate?: string;
};

export type UpdateValuationDto = {
    name?: string;
    /**
     * The default currency to be used in the valuation.
     */
    defaultCurrency?: CurrencyType;
    /**
     * Specifies the base multiplier for input values. For example, if this is set to MILLIONS, an input of 200 dollars will be seen as 200 million dollars in the later calculations.
     */
    defaultNumberFormat?: ValuationNumberFormat;
    classifierIds?: Array<string>;
    valuationDate?: string;
};

export type DuplicateValuationDto = {
    /**
     * New valuation ID
     */
    newValuationId: string;
};

/**
 * Determines how the equity value is computed. If you select EQUITY_VALUE, the currencyAmount is the equity value. Otherwise, we will have to account for the valuationInputAdjustments to get the equity value.
 */
export const ValuationInputType = { ENTERPRISE_VALUE: 'ENTERPRISE_VALUE', EQUITY_VALUE: 'EQUITY_VALUE' } as const;

/**
 * Determines how the equity value is computed. If you select EQUITY_VALUE, the currencyAmount is the equity value. Otherwise, we will have to account for the valuationInputAdjustments to get the equity value.
 */
export type ValuationInputType = typeof ValuationInputType[keyof typeof ValuationInputType];

export type ValuationInputAdjustmentWithClassifierRes = {
    /**
     * Valuation input adjustment ID
     */
    id: string;
    /**
     * Valuation input ID
     */
    valuationInputId: string;
    name: string;
    currency: CurrencyType;
    currencyAmount: number;
    classifierId: string;
    note: string | null;
    createdAt: string;
    updatedAt: string;
    deleted: boolean;
    classifier: ClassifierRes;
};

export type ValuationInputWithAdjustmentsRes = {
    /**
     * Valuation input ID
     */
    id: string;
    /**
     * Valuation ID
     */
    valuationId: string;
    /**
     * Legal person (company) ID
     */
    personId: string;
    currency: CurrencyType;
    currencyAmount: string;
    /**
     * Determines how the equity value is computed. If you select EQUITY_VALUE, the currencyAmount is the equity value. Otherwise, we will have to account for the valuationInputAdjustments to get the equity value.
     */
    inputType: ValuationInputType;
    ownedFraction: number;
    createdAt: string;
    updatedAt: string;
    deleted: boolean;
    valuationInputAdjustments: Array<ValuationInputAdjustmentWithClassifierRes>;
    /**
     * The legal person (company) that the valuation input is associated to. Such legal person must be at the bottom of the group structure chart, distributing money to the above nodes.
     */
    person: PersonLegalRes;
};

export type UpsertValuationInputItemDto = {
    id: string;
    currency?: CurrencyType;
    currencyAmount?: string;
    inputType?: ValuationInputType;
    ownedFraction?: number;
};

export type UpsertValuationInputAdjustmentItemDto = {
    id?: string;
    valuationInputId: string;
    name: string;
    currency: CurrencyType;
    currencyAmount: number;
    classifierId: string;
    note?: string | null;
};

export type UpsertValuationInputsDto = {
    inputs: Array<UpsertValuationInputItemDto>;
    adjustments: Array<UpsertValuationInputAdjustmentItemDto>;
};

export type UpsertValuationInputErrorRes = {
    id: string | null;
    /**
     * Zero-based index of the request item
     */
    index: number;
    property?: string;
    message: string;
    entityType: string;
};

export type UpsertValuationInputsRes = {
    state: Array<ValuationInputWithAdjustmentsRes>;
    errors: Array<UpsertValuationInputErrorRes>;
};

export type UpdateValuationInputDto = {
    currency?: CurrencyType;
    currencyAmount?: string;
    inputType?: ValuationInputType;
    ownedFraction?: number;
};

export type CreateValuationInputAdjustmentDto = {
    name: string;
    currency: CurrencyType;
    currencyAmount: number;
    classifierId: string;
    note?: string;
};

export type UpdateValuationInputAdjustmentDto = {
    name?: string;
    currency?: CurrencyType;
    currencyAmount?: number;
    classifierId?: string;
    note?: string | null;
};

export type LatestRate = {
    currency: CurrencyType;
    value: number | null;
};

export type LatestExchangeRateRes = {
    date: string;
    base: CurrencyType;
    rates: Array<LatestRate>;
};

export type HistoricalAndCustomRate = {
    currency: CurrencyType;
    /**
     * Historical rate
     */
    historical: number | null;
    /**
     * Custom foreign exchange rate
     */
    custom: number | null;
};

export type HistoricalAndCustomExchangeRateRes = {
    date: string;
    version: number | null;
    base: CurrencyType;
    rates: Array<HistoricalAndCustomRate>;
};

export type GetCurrenciesUsedInValuationRes = {
    currencies: Array<CurrencyType>;
};

export type CustomExchangeRate = {
    currency: CurrencyType;
    value: number;
};

export type PutCustomExchangeRateDto = {
    rates: Array<CustomExchangeRate>;
};

export type PutCustomExchangeRateRes = {
    version: number;
};

export type ValuationPersonInputRes = {
    /**
     * ID
     */
    id: string;
    /**
     * Valuation ID
     */
    valuationId: string;
    /**
     * Person ID
     */
    personId: string;
    /**
     * MIP ID
     */
    mipId?: string;
    name: string;
    currency: CurrencyType;
    currencyAmount: number;
    note: string | null;
    /**
     * Classifier ID
     */
    classifierId: string;
    classifier: ClassifierRes;
    createdAt: string;
    updatedAt: string;
    deleted: boolean;
};

export type CreateValuationPersonInputDto = {
    name: string;
    mipId?: string;
    currency: CurrencyType;
    currencyAmount: number;
    note?: string;
    classifierId: string;
};

export type UpsertValuationPersonInputItemDto = {
    id?: string;
    name: string;
    currency: CurrencyType;
    currencyAmount: number;
    classifierId: string;
};

export type UpsertValuationPersonInputsDto = {
    inputs: Array<UpsertValuationPersonInputItemDto>;
};

export type UpsertValuationPersonInputErrorRes = {
    id: string | null;
    /**
     * Zero-based index of the request item
     */
    index: number;
    property?: string;
    message: string;
};

export type UpsertValuationPersonInputsRes = {
    state: Array<ValuationPersonInputRes>;
    errors: Array<UpsertValuationPersonInputErrorRes>;
};

export type UpdateValuationPersonInputDto = {
    name?: string;
    currency?: CurrencyType;
    currencyAmount?: number;
    note?: string | null;
};

export type StartCalculateValuationRes = {
    /**
     * Temporal workflowId for this compute. Pass it to calculate-valuation/stream to receive live progress and the terminal result reference.
     */
    workflowId: string;
};

/**
 * Current compute stage
 */
export const ValuationComputeStage = {
    QUEUED: 'queued',
    LOADING_DATA: 'loading-data',
    COMPUTING: 'computing',
    PERSISTING: 'persisting'
} as const;

/**
 * Current compute stage
 */
export type ValuationComputeStage = typeof ValuationComputeStage[keyof typeof ValuationComputeStage];

export type ValuationComputeProgressRes = {
    /**
     * Current compute stage
     */
    stage: ValuationComputeStage;
    /**
     * SCC fixpoint passes poured so far
     */
    iterations: number;
};

/**
 * Why the linear ratchet solve stopped
 */
export const LinearSolveStop = {
    NOTHING_TO_GROW: 'nothing-to-grow',
    FILLED_TIER: 'filled-tier',
    LANDED: 'landed',
    BLOCKED: 'blocked',
    STARVED: 'starved',
    OVERRAN: 'overran',
    RESTART_LIMIT: 'restart-limit'
} as const;

/**
 * Why the linear ratchet solve stopped
 */
export type LinearSolveStop = typeof LinearSolveStop[keyof typeof LinearSolveStop];

/**
 * Where a solve that ran out of budget or restarts gave up
 */
export const LinearSolvePhase = {
    RANKING: 'ranking',
    SEARCH: 'search',
    RESTART: 'restart'
} as const;

/**
 * Where a solve that ran out of budget or restarts gave up
 */
export type LinearSolvePhase = typeof LinearSolvePhase[keyof typeof LinearSolvePhase];

export type ValuationLinearSolveRes = {
    /**
     * False when the linear ratchet solve stopped before it could prove its answer
     */
    converged: boolean;
    /**
     * Why the linear ratchet solve stopped
     */
    stop: LinearSolveStop;
    /**
     * Where a solve that ran out of budget or restarts gave up
     */
    phase?: LinearSolvePhase;
};

export type ValuationComputeResultRefRes = {
    /**
     * Id of the persisted ValuationComputeResult row
     */
    resultId: string;
    /**
     * False when the valuation did not fully converge
     */
    converged?: boolean;
    /**
     * Absent when no ratchet on the deal distributes until breakpoint
     */
    linearSolve?: ValuationLinearSolveRes;
    /**
     * Per-phase wall-clock breakdown of the compute (load / spawn / persist outside the worker, deserialize / compute / serialize inside it, plus total). Always present on the stream.
     */
    timings?: {
        [key: string]: unknown;
    };
};

export const ValuationPersonType = {
    SPONSOR: 'SPONSOR',
    INVESTOR: 'INVESTOR',
    HOLDING_COMPANY: 'HOLDING_COMPANY'
} as const;

export type ValuationPersonType = typeof ValuationPersonType[keyof typeof ValuationPersonType];

/**
 * Type of the valuation error
 */
export const ValuationErrorType = {
    OVERDISTRIBUTION_ERROR: 'OVERDISTRIBUTION_ERROR',
    BAD_DATA_ERROR: 'BAD_DATA_ERROR',
    INFINITE_LOOP_ERROR: 'INFINITE_LOOP_ERROR'
} as const;

/**
 * Type of the valuation error
 */
export type ValuationErrorType = typeof ValuationErrorType[keyof typeof ValuationErrorType];

/**
 * The component that caused over-distribution.
 */
export const OverdistributionErrorSourceEnum = {
    SOURCES: 'SOURCES',
    USES: 'USES',
    OVERRIDES: 'OVERRIDES',
    SECURITIES: 'SECURITIES'
} as const;

/**
 * The component that caused over-distribution.
 */
export type OverdistributionErrorSourceEnum = typeof OverdistributionErrorSourceEnum[keyof typeof OverdistributionErrorSourceEnum];

export type OverdistributionErrorSource = {
    /**
     * The component that caused over-distribution.
     */
    component: OverdistributionErrorSourceEnum;
    /**
     * Tier of the override. Set to 0 if the error source is not an override.
     */
    tier: number;
};

export type ValuationError = {
    /**
     * Type of the valuation error
     */
    type: ValuationErrorType;
    source: OverdistributionErrorSource;
};

export type SecurityBreakdown = {
    /**
     * Security ID
     */
    id: string;
    /**
     * Security name
     */
    name: string;
    /**
     * Security type
     */
    securityType: SecurityType;
    /**
     * Issuer ID
     */
    issuerId: string;
    /**
     * Issuer group ID, i.e. MIP ID
     */
    issuerGroupId: string | null;
    /**
     * Holder ID
     */
    holderId: string;
    /**
     * Holder group ID
     */
    holderGroupId: string | null;
    /**
     * Amount of money received from the security
     */
    amount: string;
    /**
     * Number of security units the holder holds
     */
    units: string;
    /**
     * Whether or not the security value is overridden
     */
    isOverridden: boolean;
    /**
     * Source exchange right ID if proceeds derived from exchange right
     */
    sourceExchangeId?: string;
    /**
     * Source exchange right name
     */
    sourceExchangeName?: string;
};

export type ReceivableBreakdown = {
    /**
     * Warrant security ID
     */
    exchangeSecurityId: string;
    /**
     * Warrant security name
     */
    exchangeSecurityName: string;
    /**
     * Holder ID who paid the exercise cost
     */
    holderId: string;
    /**
     * Holder MIP ID
     */
    holderMipId?: string;
    /**
     * Amount received
     */
    amount: string;
    /**
     * When true, this entry is for display only and excluded from totals
     */
    excludedFromTotal?: boolean;
};

export type Proceeds = {
    /**
     * Total proceeds
     */
    total: string;
    /**
     * Amount of money received from securities
     */
    securities: string;
    securitiesBreakdown: Array<SecurityBreakdown>;
    /**
     * Receivables
     */
    receivables: string;
    /**
     * Breakdown of warrant exercise receivables
     */
    receivablesBreakdown: Array<ReceivableBreakdown>;
    /**
     * Cash on balance sheet
     */
    cash: string;
};

export type PayableBreakdown = {
    /**
     * Warrant security ID
     */
    exchangeSecurityId: string;
    /**
     * Warrant security name
     */
    exchangeSecurityName: string;
    /**
     * Issuer ID who receives the exercise cost
     */
    issuerId: string;
    /**
     * Issuer MIP ID
     */
    issuerMipId?: string;
    /**
     * Amount paid
     */
    amount: string;
    /**
     * When true, this entry is for display only and excluded from totals
     */
    excludedFromTotal?: boolean;
};

export type Outflows = {
    /**
     * Total outflows
     */
    total: string;
    /**
     * Amount of money paid out to securities
     */
    securities: string;
    /**
     * Breakdown of securities paid out, ordered by seniority index descending
     */
    securitiesBreakdown: Array<SecurityBreakdown>;
    /**
     * Payables
     */
    payables: string;
    /**
     * Breakdown of warrant exercise payables
     */
    payablesBreakdown: Array<PayableBreakdown>;
};

export type Retained = {
    /**
     * Total retained
     */
    total: string;
    /**
     * Retained cash
     */
    cash: string;
};

export type PersonGroupSummary = {
    /**
     * Error of the scoped person
     */
    error?: ValuationError;
    /**
     * Group (MIP) ID
     */
    id: string | null;
    /**
     * Group (MIP) name
     */
    name: string | null;
    proceeds: Proceeds;
    outflows: Outflows;
    retained: Retained;
    /**
     * The sum of all transactions cost where the Person is a buyer
     */
    moneyIn?: string;
    /**
     * The sum of all transactions where the Person is named as a seller
     */
    moneyOut?: string;
    /**
     * Proceeds plus Money Out - (current position value + realised returns) / total invested
     */
    moic?: string;
    /**
     * The extended internal rate of return (xIRR)
     */
    xirr?: string;
};

export type PersonSummary = {
    /**
     * Minimum generation number of the person
     */
    minGeneration: number;
    id: string;
    displayName: string;
    personType: ValuationPersonType;
    classifiers: Array<LegalPersonTags>;
    groups: Array<PersonGroupSummary>;
};

export type ValuationSummaryGroupByPersonRes = {
    /**
     * Version of FX rates
     */
    version: number | null;
    currency: CurrencyType;
    valuationDate: string;
    totalProceeds: string;
    persons: Array<PersonSummary>;
};

export type GroupPersonSummary = {
    /**
     * Error of the scoped person
     */
    error?: ValuationError;
    id: string;
    displayName: string;
    classifiers: Array<LegalPersonTags>;
    proceeds: Proceeds;
    outflows: Outflows;
    retained: Retained;
};

export type GroupSummary = {
    /**
     * MIP ID
     */
    id?: string;
    /**
     * MIP name
     */
    name?: string;
    /**
     * Index of the group, when sorted topologically.
     */
    generation: number;
    persons: Array<GroupPersonSummary>;
};

export type ValuationSummaryGroupByMipRes = {
    /**
     * Version of FX rates
     */
    version: number | null;
    currency: CurrencyType;
    valuationDate: string;
    totalProceeds: string;
    groups: Array<GroupSummary>;
};

export type ValuationSummaryResultPayload = {
    byPerson: ValuationSummaryGroupByPersonRes;
    byMip: ValuationSummaryGroupByMipRes;
};

export type GetValuationSummaryResultRes = {
    result: ValuationSummaryResultPayload;
};

/**
 * If the flow is zero or not
 */
export const FlowOption = { NONE: 'none', SOME: 'some' } as const;

/**
 * If the flow is zero or not
 */
export type FlowOption = typeof FlowOption[keyof typeof FlowOption];

export type FlowDescription = {
    /**
     * If the flow is zero or not
     */
    option: FlowOption;
};

/**
 * If security is compounded or not
 */
export const CompoundOption = { SIMPLE: 'simple', COMPOUNDED: 'compounded' } as const;

/**
 * If security is compounded or not
 */
export type CompoundOption = typeof CompoundOption[keyof typeof CompoundOption];

export type SecurityDescription = {
    /**
     * If security is compounded or not
     */
    compoundOption: CompoundOption;
    /**
     * Day count convention of the security
     */
    dayCountConvention: DayCountConvention;
    /**
     * If start date is provided or not. Used for choosing the correct string in Phrase translations.
     */
    dateOption: number;
    /**
     * Start date
     */
    startDate: string;
    /**
     * The annual interest rate, typically between 0 and 1.
     */
    rate: number;
    /**
     * Compounding period index
     */
    compoundingPeriod: number;
};

/**
 * Component of the security
 */
export const SecurityValueOverrideComponent = {
    COMPONENT_TRACKING: 'COMPONENT_TRACKING',
    COMPONENT_INTEREST: 'COMPONENT_INTEREST',
    COMPONENT_PRINCIPAL: 'COMPONENT_PRINCIPAL',
    COMPONENT_LIQUIDATION_PREFERENCE: 'COMPONENT_LIQUIDATION_PREFERENCE',
    COMPONENT_CATCH_UP: 'COMPONENT_CATCH_UP',
    WHOLE_SECURITY: 'WHOLE_SECURITY',
    COMPONENT_RESIDUE: 'COMPONENT_RESIDUE'
} as const;

/**
 * Component of the security
 */
export type SecurityValueOverrideComponent = typeof SecurityValueOverrideComponent[keyof typeof SecurityValueOverrideComponent];

/**
 * Override field
 */
export const SecurityValueOverrideField = { VALUE_PER_UNIT: 'VALUE_PER_UNIT', VALUE_TOTAL_ISSUED: 'VALUE_TOTAL_ISSUED' } as const;

/**
 * Override field
 */
export type SecurityValueOverrideField = typeof SecurityValueOverrideField[keyof typeof SecurityValueOverrideField];

export type SecurityOverride = {
    /**
     * Security Override ID
     */
    id: string;
    /**
     * Override value
     */
    overrideValue: string;
    /**
     * Override field
     */
    overrideField: SecurityValueOverrideField;
    /**
     * Override note
     */
    note: string | null;
};

export type SecurityDetails = {
    /**
     * Security ID
     */
    securityId: string;
    /**
     * Security name
     */
    securityName: string;
    /**
     * Total units of the security
     */
    totalUnits: string;
    /**
     * Expected amount of equity that will be received, before pari-passu, overrides and other reductions.
     */
    totalValue: string;
    /**
     * Actual amount of equity that will be received, after pari-passu, overrides and other reductions.
     */
    totalProceeds: string;
    /**
     * Total accrued interest for this tranche
     */
    totalInterest?: string;
    /**
     * Description of the security
     */
    description?: SecurityDescription;
    /**
     * Component of the security
     */
    component: SecurityValueOverrideComponent;
    /**
     * Override for the security
     */
    override?: SecurityOverride;
    /**
     * TrancheKey of the security. Often just the issue date of the security component, if it is interest-related.
     */
    trancheKey?: string;
    /**
     * Source exchange right ID if proceeds derived from exchange right
     */
    sourceExchangeId?: string;
    /**
     * Source exchange right name
     */
    sourceExchangeName?: string;
};

export type TierDescription = {
    /**
     * Component of the security
     */
    component: SecurityValueOverrideComponent;
    /**
     * Security names
     */
    securityNames: Array<string>;
};

export type Tier = {
    /**
     * Seniority index
     */
    seniorityIndex: number;
    /**
     * Display name of the security rank this tier maps to, when the issuer has a matching rank definition
     */
    rankName?: string;
    securities: Array<SecurityDetails>;
    /**
     * Total proceeds
     */
    totalProceeds: string;
    /**
     * Participating units in the tier. Interest and principal are in the same tranche / same units, so they count once (WAT-693).
     */
    totalUnits: string;
    /**
     * Tier description
     */
    description: Array<TierDescription>;
};

/**
 * If all or some of the proceeds are to be distributed to the security
 */
export const ResidueOption = { ALL: 'all', SOME: 'some' } as const;

/**
 * If all or some of the proceeds are to be distributed to the security
 */
export type ResidueOption = typeof ResidueOption[keyof typeof ResidueOption];

export type ResidueTierDescription = {
    /**
     * If all or some of the proceeds are to be distributed to the security
     */
    option: ResidueOption;
    /**
     * Security names in residue tier
     */
    securityNames: Array<string>;
};

export type ResidueTier = {
    securities: Array<SecurityDetails>;
    /**
     * Total proceeds
     */
    totalProceeds: string;
    /**
     * Participating units in the residue tier
     */
    totalUnits: string;
    /**
     * Residue tier description. Actual description is stored in Phrase, accessed with option.
     */
    description?: ResidueTierDescription;
};

export type ExercisePriceBucketDetails = {
    /**
     * Units in this bucket
     */
    units: string;
    /**
     * Exercise price per unit (including accrued interest)
     */
    pricePerUnit: string;
    /**
     * Issue date(s) for units in this bucket
     */
    issueDates: Array<string>;
};

export type WarrantExerciseDetails = {
    /**
     * Warrant security ID
     */
    exchangeSecurityId: string;
    /**
     * Warrant security name
     */
    exchangeSecurityName: string;
    /**
     * Warrant units exercised
     */
    unitsExercised: string;
    /**
     * Underlying units received
     */
    underlyingUnitsReceived: string;
    /**
     * Total exercise cost paid
     */
    totalExerciseCost: string;
    /**
     * Average price per underlying unit
     */
    averagePricePerUnit: string;
    /**
     * Per-bucket breakdown of exercise price. Present when exercise price has interest and multiple issue dates.
     */
    buckets?: Array<ExercisePriceBucketDetails>;
};

/**
 * Why the received share differs from the final entitlement
 */
export const RatchetShareDifferenceReason = {
    UNITS_NOT_SHARING: 'UNITS_NOT_SHARING',
    SCALED_BACK: 'SCALED_BACK',
    SCALED_UP: 'SCALED_UP'
} as const;

/**
 * Why the received share differs from the final entitlement
 */
export type RatchetShareDifferenceReason = typeof RatchetShareDifferenceReason[keyof typeof RatchetShareDifferenceReason];

/**
 * Why distribute-until-breakpoint did not grow this ratchet, or stopped it short
 */
export const RatchetGrowthNoteKind = {
    SUBJECT_OWNS_RATCHET: 'SUBJECT_OWNS_RATCHET',
    FROZEN_OWN_TARGET: 'FROZEN_OWN_TARGET',
    STOPPED_BY_OTHER_TARGET: 'STOPPED_BY_OTHER_TARGET',
    STOPPED_EARLY: 'STOPPED_EARLY'
} as const;

/**
 * Why distribute-until-breakpoint did not grow this ratchet, or stopped it short
 */
export type RatchetGrowthNoteKind = typeof RatchetGrowthNoteKind[keyof typeof RatchetGrowthNoteKind];

export type RatchetGrowthNote = {
    /**
     * Why distribute-until-breakpoint did not grow this ratchet, or stopped it short
     */
    kind: RatchetGrowthNoteKind;
    /**
     * Names of the people whose holding or target the note is about
     */
    subjectNames?: Array<string>;
    /**
     * Metric of the target that stopped the growth (MOIC or XIRR)
     */
    metric?: RatchetMetricType;
    /**
     * Threshold of the target that stopped the growth
     */
    threshold?: string;
    /**
     * Why the search stopped early (STOPPED_EARLY only)
     */
    stop?: LinearSolveStop;
};

export type RatchetAppliedDetails = {
    /**
     * Security name the ratchet applies to
     */
    securityName: string;
    /**
     * Ratchet metric type (MOIC, XIRR, MOIC_AND_XIRR)
     */
    metricType: RatchetMetricType;
    /**
     * Initial entitlement percentage before ratchet
     */
    initialEntitlementPercentage: string;
    /**
     * Final entitlement percentage after ratchet evaluation
     */
    finalEntitlementPercentage: string;
    /**
     * Order of the active hurdle, null if at initial
     */
    activeHurdleOrder?: {
        [key: string]: unknown;
    };
    /**
     * Threshold of the active hurdle
     */
    activeHurdleThreshold?: {
        [key: string]: unknown;
    };
    /**
     * Actual computed metric value
     */
    metricValue?: {
        [key: string]: unknown;
    };
    /**
     * XIRR threshold of the active hurdle (present for MOIC_AND_XIRR)
     */
    activeHurdleXirrThreshold?: string | null;
    /**
     * Actual computed XIRR value (present for MOIC_AND_XIRR)
     */
    xirrValue?: string | null;
    /**
     * Threshold of the tier the cliff refused: its target was met before payment, but paying the tier would break it
     */
    refusedHurdleThreshold?: string;
    /**
     * XIRR threshold of the tier the cliff refused (present for MOIC_AND_XIRR)
     */
    refusedHurdleXirrThreshold?: string;
    /**
     * True when distribute-until-breakpoint paid the active tier partially
     */
    paidPartially?: boolean;
    /**
     * Metric of the target a partial payment stopped at (MOIC or XIRR)
     */
    partialTargetMetric?: RatchetMetricType;
    /**
     * Threshold of the target a partial payment stopped at
     */
    partialTargetThreshold?: string;
    /**
     * Share of the leftover money the ratcheted security received, in %, present only when it differs from the final entitlement
     */
    receivedSharePercentage?: string;
    /**
     * Why the received share differs from the final entitlement
     */
    shareDifferenceReason?: RatchetShareDifferenceReason;
    /**
     * Every ratchet entitlement on the issuer added up, in %, when they were scaled to share the leftover money
     */
    requestedTotalPercentage?: string;
    /**
     * Why distribute-until-breakpoint did not grow this ratchet, or stopped it short; replaces the refused-tier and partial-target fields
     */
    growthNote?: RatchetGrowthNote;
};

export type VestingAppliedDetails = {
    /**
     * Security name the vesting applies to
     */
    securityName: string;
    /**
     * Vesting metric type (MOIC, XIRR, MOIC_AND_XIRR)
     */
    metricType: PerformanceVestingMetricType;
    /**
     * Original units from performance-vesting block
     */
    originalUnits: string;
    /**
     * Effective units participating in waterfall
     */
    effectiveUnits: string;
    /**
     * Dormant units (original minus effective)
     */
    dormantUnits: string;
    /**
     * Vested percentage (0-100)
     */
    vestedPercentage: string;
    /**
     * Order of the highest hurdle whose threshold was met, null if none met
     */
    highestMetHurdleOrder?: {
        [key: string]: unknown;
    };
    /**
     * MOIC threshold of the met hurdle
     */
    metHurdleThreshold?: {
        [key: string]: unknown;
    };
    /**
     * XIRR threshold of the met hurdle (present for MOIC_AND_XIRR)
     */
    metHurdleXirrThreshold?: {
        [key: string]: unknown;
    };
    /**
     * Actual computed MOIC value
     */
    moicValue?: {
        [key: string]: unknown;
    };
    /**
     * Actual computed XIRR value
     */
    xirrValue?: {
        [key: string]: unknown;
    };
};

export type TimeBasedVestingAppliedDetails = {
    /**
     * Security name the vesting applies to
     */
    securityName: string;
    /**
     * Total units from the time-vested holding
     */
    totalUnits: string;
    /**
     * Vested percentage (0-100)
     */
    vestedPercentage: string;
};

export type BreakpointSummaryPayload = {
    /**
     * Starting balance
     */
    startingBalance: string;
    /**
     * Retained cash
     */
    retainedCash: string;
    /**
     * Retained cash description. Actual description is stored in Phrase, accessed with option.
     */
    retainedCashDescription: FlowDescription;
    /**
     * Warrant exercise-price paid by this warrant holder as a use (WAT-744 reflow).
     */
    warrantsPayoutProceeds: string;
    /**
     * Warrant exercise-price this holder got back via the sub-pour recirculation (WAT-744), added after the strike-paid use to reconcile the holder to its net.
     */
    warrantStrikeRecovered: string;
    /**
     * Outgoing payables
     */
    outgoingPayables: string;
    /**
     * Outgoing payables description. Actual description is stored in Phrase, accessed with option.
     */
    outgoingPayablesDescription: FlowDescription;
    /**
     * Tiers in descending order of seniority indices
     */
    tiers: Array<Tier>;
    /**
     * Residue tier
     */
    residueTier: ResidueTier;
    /**
     * Warrants exercised by this person
     */
    warrantsExercised?: Array<WarrantExerciseDetails>;
    /**
     * Ratchets applied to this person
     */
    ratchetsApplied?: Array<RatchetAppliedDetails>;
    /**
     * Performance vesting applied to this person
     */
    vestingApplied?: Array<VestingAppliedDetails>;
    /**
     * Time-based vesting applied to this person (units participate normally in waterfall)
     */
    timeBasedVestingApplied?: Array<TimeBasedVestingAppliedDetails>;
};

export type BreakpointSummaryRes = {
    result: BreakpointSummaryPayload | null;
};

export const SecurityValueOverrideScope = {
    COMPONENT_INTEREST: 'COMPONENT_INTEREST',
    COMPONENT_PRINCIPAL: 'COMPONENT_PRINCIPAL',
    COMPONENT_CATCH_UP: 'COMPONENT_CATCH_UP',
    COMPONENT_TRACKING: 'COMPONENT_TRACKING',
    WHOLE_SECURITY: 'WHOLE_SECURITY'
} as const;

export type SecurityValueOverrideScope = typeof SecurityValueOverrideScope[keyof typeof SecurityValueOverrideScope];

export type CreateSecurityValueOverrideDto = {
    securityId: string;
    overrideValue: number;
    overrideField: SecurityValueOverrideField;
    overrideScope: SecurityValueOverrideScope;
    note?: string;
    trancheKey?: string;
};

export type SecurityValueOverrideRes = {
    /**
     * Security Value Override ID
     */
    id: string;
    /**
     * Valuation ID
     */
    valuationId: string;
    /**
     * The ID of the security this object is overriding
     */
    securityId: string;
    /**
     * The value which overwrites the one in the existing security field. It is in the currency defined in the security.
     */
    overrideValue: number;
    /**
     * The field this object is overriding
     */
    overrideField: SecurityValueOverrideField;
    /**
     * The scope of the security that we are overriding
     */
    overrideScope: SecurityValueOverrideScope;
    /**
     * The note for the security value override
     */
    note: string | null;
    /**
     * The trancheKey is used to identify the override for a specific tranche. Currently we only identify per date issued
     */
    trancheKey: string | null;
    deleted: boolean;
    createdAt: string;
    updatedAt: string;
};

export type UpdateSecurityValueOverrideDto = {
    overrideValue?: number;
    overrideField?: SecurityValueOverrideField;
    note?: string | null;
};

export type GenerateShareRegisterRes = {
    fileId: string;
    fileName: string;
    downloadUrl: string;
};

export type GenerateShareRegisterPdfDto = {
    /**
     * The date to compute the share register for (ISO 8601 format). Defaults to current date.
     */
    date?: string;
};

export type CreateShareRegisterPdfTaskRes = {
    taskId: string;
};

export type ShareRegisterPdfTaskStatusRes = {
    status: TaskStatus;
    /**
     * Progress from 0 to 1
     */
    progress: number;
    /**
     * Presigned download URL, set when status is DONE
     */
    downloadUrl?: string;
    fileName?: string;
};

export type GetHoldingsListForPersonDto = {
    [key: string]: unknown;
};

export type ShareHoldingRes = {
    unitsAmount?: number;
    unitsPercentage?: number;
    votesAmount?: number;
    votesPercentage?: number;
    cost: number;
    totalShareCapital?: number;
    totalNominalValue?: number;
    totalSharePremium?: number;
};

export type BlockRange = {
    start: number;
    end: number;
    principal: number;
    issuerTxId?: string;
};

export type HoldingEventRes = {
    id: string;
    date: string;
    holderId: {
        [key: string]: unknown;
    };
    securityId: {
        [key: string]: unknown;
    };
    type: HoldingEventType;
    note?: {
        [key: string]: unknown;
    };
    pledgeToPersonId?: {
        [key: string]: unknown;
    };
    pledgeToString?: {
        [key: string]: unknown;
    };
    pledgeFromHolderId?: {
        [key: string]: unknown;
    };
    pledgeFromSecurityId?: {
        [key: string]: unknown;
    };
    pledgeFromString?: {
        [key: string]: unknown;
    };
    assignedToPersonId?: {
        [key: string]: unknown;
    };
    assignedToString?: {
        [key: string]: unknown;
    };
    description?: {
        [key: string]: unknown;
    };
    documentUrl?: {
        [key: string]: unknown;
    };
    documentName?: {
        [key: string]: unknown;
    };
    fileId?: {
        [key: string]: unknown;
    };
};

export type HoldingSecurityRes = {
    name: string;
    securityId: string;
    loanDefinitionId?: string;
    currency: CurrencyType;
    type: SecurityType;
    transactionId: string;
    date?: string;
    mipId?: string;
    shareHolding: ShareHoldingRes;
    associatedBlocks: Array<BlockRange>;
    securityPersonName: string;
    securityPersonId: string;
    securityUnitDenominator: number;
    securityIssuedIn: SecurityIssuedIn;
    events?: Array<HoldingEventRes>;
    totalSecurityShareCapital?: number;
    totalSecurityNominalValue?: number;
    totalSecuritySharePremium?: number;
};

export type HoldingRes = {
    mipName?: string;
    mipId?: string;
    holderId: string;
    holderName?: string;
    heldForId?: string;
    heldForDisplayName?: string;
    securities: Array<HoldingSecurityRes>;
    totalAcrossAllSecurities?: number;
    totalCost?: number;
    totalUnitsAcrossAllSecurities?: number;
    holderAddress?: string;
    holderJurisdiction?: string;
    holderJurisdictionCode?: string;
    holderLegalForm?: string;
    holderRegistrationNumber?: string;
    holderTaxCountry?: string;
    holderTaxAuthority?: string;
    holderTaxNumber?: string;
};

export type HoldingDetailRes = {
    mipName?: string;
    holderId?: string;
    holderName?: string;
    issuerName?: string;
    issuerId?: string;
    investmentProgrammeId?: string;
    security?: HoldingSecurityRes;
    hasNomineeStructure: boolean;
    securityName?: string;
};

export type HoldingEventDto = {
    date: string;
    type: TransactionType | null;
    units: number;
    transactionCost?: number;
    sourceCost?: number;
    destinationCost?: number;
    blocksMoving: Array<BlockRange>;
    sourceBlocksHeld: Array<BlockRange>;
    destinationBlocksHeld: Array<BlockRange>;
    source: string;
    destination: string;
    sourceDisplayName: string;
    destDisplayName: string;
    securityName: string;
    securityUnitDenominator: number;
    preEventSecurityName?: string;
    preEventHoldingUnits?: number;
    postEventHoldingUnits?: number;
    securityIssuedIn: SecurityIssuedIn;
    securityCurrency: CurrencyType;
};

export type GetWideViewHoldingsCsvDto = {
    [key: string]: unknown;
};

export type GetRegularViewHoldingsCsvDto = {
    [key: string]: unknown;
};

export type CreateHoldingEventDto = {
    date: string;
    type: HoldingEventType;
    note?: string;
    pledgeToPersonId?: string | null;
    pledgeToString?: string;
    pledgeFromHolderId?: string | null;
    pledgeFromSecurityId?: string | null;
    pledgeFromString?: string;
    assignedToPersonId?: string | null;
    assignedToString?: string;
    documentUrl?: string;
    documentName?: string;
    holderId: string;
    securityId: string;
    fileId?: string;
};

export type HoldingItem = {
    holderId: string;
    securityId: string;
};

export type BulkCreateHoldingEventDto = {
    date: string;
    type: HoldingEventType;
    note?: string;
    pledgeToPersonId?: string | null;
    pledgeToString?: string;
    pledgeFromHolderId?: string | null;
    pledgeFromSecurityId?: string | null;
    pledgeFromString?: string;
    assignedToPersonId?: string | null;
    assignedToString?: string;
    documentUrl?: string;
    documentName?: string;
    holdings: Array<HoldingItem>;
    documentMd5?: string;
};

export type UpdateHoldingEventDto = {
    id: string;
    date?: string;
    holderId?: string;
    securityId?: string;
    type?: HoldingEventType;
    note?: string;
    pledgeToPersonId?: string | null;
    pledgeToString?: string;
    pledgeFromHolderId?: string | null;
    pledgeFromSecurityId?: string | null;
    pledgeFromString?: string;
    assignedToPersonId?: string | null;
    assignedToString?: string;
    description?: string;
    documentUrl?: string | null;
    documentName?: string | null;
    documentMd5?: string | null;
    fileId?: string;
};

export type DeleteHoldingEventDto = {
    ids: Array<string>;
};

export type WarmupPoolDto = {
    /**
     * Namespace prefix for pool user emails
     */
    namespace: string;
    password: string;
    /**
     * Unique run identifier to isolate pool users across concurrent CI runs
     */
    runId?: string;
};

export type CreateE2eUserDto = {
    email: string;
    firstName: string;
    lastName: string;
    /**
     * Password must be at least 8 character and contain at least one uppercase, one lowercase
     */
    password: string;
    platforms: Array<ApplicationType>;
    storeUserPermissions: boolean;
    usePool?: boolean;
    /**
     * Unique run identifier to isolate pool users across concurrent CI runs
     */
    runId?: string;
    /**
     * Grant dealstackSupport role on all organizations
     */
    isDealstackSupport?: boolean;
};

export type CreateE2eUserRes = {
    id: string;
    email?: string;
    dealstackToken?: string;
    refreshToken?: string;
    /**
     * Id of the DealStack support organization created for this user. Only set when the user was created with isDealstackSupport=true.
     */
    organizationId?: string;
};

export type AuthenticateDealstackUserDto = {
    email: string;
    password: string;
};

export type AuthenticationRes = {
    dealstackToken: string;
    refreshToken: string;
};

export type ChangeEmailVerificationCodeDto = {
    email: string;
    newEmail: string;
};

export type ChangeEmailVerificationCodeRes = {
    code: string;
};

export type WorkOsMailLookupDto = {
    /**
     * The address WorkOS sent the mail to.
     */
    email: string;
    /**
     * Only consider WorkOS events created at or after this ISO-8601 instant.
     */
    since: string;
};

export type WorkOsEmailVerificationCodeRes = {
    code: string;
};

export type WorkOsPasswordResetLinkRes = {
    url: string;
};

export type SsoFixtureOrganizationRes = {
    /**
     * Which standing fixture this is: A, B, C.
     */
    label: {
        [key: string]: unknown;
    };
    /**
     * The domain the fixture contract assigns this label.
     */
    domain: string;
    /**
     * Whether a spec may write this organisation. Only B and C are mutable; A is read-only so the PR lane cannot be disturbed.
     */
    mutable: boolean;
    /**
     * The pinned WorkOS organization id (SSO_A/B/C_ORG_ID).
     */
    workOsOrgId: string;
    /**
     * The DealStack organization row linked to it.
     */
    dbOrganizationId: string;
    /**
     * The name of that DealStack organization row.
     */
    dbOrganizationName: string;
    /**
     * The registered, active user this label owns - a member of this organisation only. Login routing is only assertable through a user the platform knows.
     */
    canonicalUserEmail: string;
    /**
     * Domains attached to the WorkOS organisation now - a mutation spec moves these.
     */
    workOsDomains: Array<string>;
    /**
     * State of its hand-linked GenericSAML connection; null when nothing is linked, which is a fixture problem rather than a state.
     */
    connectionState: {
        [key: string]: unknown;
    } | null;
    /**
     * Domains WorkOS reports on that connection. They follow the organisation’s domains, so they are what decides SSO routing.
     */
    connectionDomains: Array<string>;
};

export type SsoFixtureRes = {
    /**
     * The canonical SSO user of this environment, inside fixture A. Already registered and active, so a login lands on the dashboard without a registration round trip.
     */
    canonicalUserEmail: string;
    organizations: Array<SsoFixtureOrganizationRes>;
};

export type ResetSsoOrganizationDto = {
    /**
     * Domains to attach as Verified instead of the fixture contract domain. Omit to reset to the known state.
     */
    domains?: Array<string>;
};

export type E2eSentEmail = {
    from: string;
    to: string;
    subject: string;
    text: string;
    sentAt: string;
};

export type E2eSentEmailsRes = {
    emails: Array<E2eSentEmail>;
};

export type E2eWorkOsUserOrganizationRes = {
    /**
     * The WorkOS organization the membership points at.
     */
    workOsOrgId: string;
    /**
     * Which pinned fixture organisation this is (A, B, C), or null when it is not one - so a spec asserts ['B'] instead of an opaque org id.
     */
    label: {
        [key: string]: unknown;
    } | null;
    /**
     * Membership status exactly as WorkOS reports it.
     */
    status: string;
};

export type E2eWorkOsUserRes = {
    workOsUserId: string;
    email: string;
    emailVerified: boolean;
    /**
     * Active and pending memberships. Empty on the email-change response, which deliberately makes no membership call - re-read GET /e2e/workos-user once the event pipeline has run.
     */
    organizations: Array<E2eWorkOsUserOrganizationRes>;
};

export type CreateWorkOsUserDto = {
    /**
     * The address the new WorkOS user answers to.
     */
    email: string;
    firstName: string;
    lastName: string;
};

export type ChangeWorkOsUserEmailDto = {
    /**
     * The address the WorkOS user answers to now.
     */
    email: string;
    /**
     * The address to move the WorkOS identity to.
     */
    newEmail: string;
};

export type AcceptWorkOsInvitationDto = {
    invitationToken: string;
};

export type E2eWorkOsInvitationRes = {
    invitationId: string;
    state: string;
};

export type E2eWorkOsEventsPollRes = {
    /**
     * Verbatim outcome of one ingest pass - one of ran, lock-busy, disabled. `disabled` means ingestion is off on this stack, which a spec must see rather than pass silently.
     */
    outcome: {
        [key: string]: unknown;
    };
    /**
     * Verbatim outcome of the sweep that followed - one of ran, lock-busy. `lock-busy` means another sweep held the lock, so nothing was applied on this pass.
     */
    sweepOutcome: {
        [key: string]: unknown;
    };
};

export type CustomSignatureImageWebhookDto = {
    [key: string]: unknown;
};

export type MockVerifyOtpDto = {
    [key: string]: unknown;
};

export type MockCompleteDto = {
    [key: string]: unknown;
};

export type OrganizationDefaultMemberRes = {
    userId: string;
    email: string;
    firstName?: string;
    lastName?: string;
    permissionRole: string;
};

export type AddOrganizationDefaultMemberDto = {
    email: string;
    firstName?: string;
    lastName?: string;
    permissionRole: PermissionRole;
};

export type InviteUserToOrganizationDto = {
    email: string;
    firstName?: string;
    lastName?: string;
    permissionRoles?: Array<PermissionRole>;
    options?: BaseInviteOptionsDto;
};

export type BasicUserRes = {
    id: string;
    email: string;
    firstName: string;
    lastName: string;
    active: boolean;
    deleted: boolean;
    telephonePrefix?: string;
    phoneNumber?: string;
};

export type DeploymentInfoRes = {
    key: string;
    metaData: {
        [key: string]: unknown;
    };
};

export const KycCertificationChoiceMode = { SELF_ATTESTED: 'SELF_ATTESTED', CERTIFIER: 'CERTIFIER' } as const;

export type KycCertificationChoiceMode = typeof KycCertificationChoiceMode[keyof typeof KycCertificationChoiceMode];

export type KycFileCertificationChoiceDto = {
    mode: KycCertificationChoiceMode;
    attested?: boolean;
    certifierName?: string;
    certifierEmail?: string;
};

export type CreateKycFileDto = {
    fileId: string;
    templateId: string;
    certification?: KycFileCertificationChoiceDto;
};

export type GetStandaloneKycMetadataRes = {
    mipId: string;
    dealId: string;
    mipName: string;
    kycSetting?: MipKycSettingResponseDto | null;
    isPiv: boolean;
};

export type ShareholderInvestorPersonBankAccountsRes = {
    personId: string;
    personDisplayName?: string | null;
    dealId: string | null;
    dealName: string;
    bankAccounts: Array<BankAccountRes>;
    userBankAccount?: BankAccountRes;
};

export type PatchShareholderInvestorBankAccountDto = {
    accountHolder?: string;
    id?: string;
    bankName?: string;
    accountNumber?: string;
    iban?: string;
    swiftCode?: string;
    currency?: CurrencyType;
    /**
     * ISO 3166-1 alpha-2 country code
     */
    countryCode?: {
        [key: string]: unknown;
    } | null;
    /**
     * BankAccountFormatRule the identifiers were entered against
     */
    formatRuleId?: string;
    identifiers?: Array<BankAccountIdentifierEntryDto>;
    /**
     * The investment whose bank-account step is saving. Those flows (joiner/leaver) run without the emailed confirmation code, so the save submits the account for admin review instead of resting at draft. Rejected unless the workflow is the caller’s own, still open, and collects an account from the person being saved.
     */
    investmentWorkflowId?: string;
    /**
     * The standalone KYC workflow whose bank-account step is saving, for a KYC requested without an investment. Carries the same code-free save as the investment flows, under the same proof: the workflow must be the caller’s own, still open, and collect an account from the person being saved. Mutually exclusive with investmentWorkflowId.
     */
    kycWorkflowId?: string;
};

export type UpsertBankAccountRes = {
    id: string;
    status: BankAccountStatus;
};

export type ConfirmBankAccountCodeDto = {
    magicCode: string;
};

export type ConfirmBankAccountRes = {
    confirmed: boolean;
    status: BankAccountStatus;
};

export type GetShareholderCustomDetailInvestorValue = {
    id: string;
    customDetailId: string;
    investorId: string;
    value: string;
};

export type GetShareholderCustomDetailRes = {
    definitions: Array<DataCustomDetailTct>;
    values: Array<GetShareholderCustomDetailInvestorValue>;
};

export type ShareholderInvestorCustomDetailValueDto = {
    /**
     * Id of custom detail (question to investor)
     */
    customDetailId: string;
    /**
     * Investor value of custom detail (answer from investor)
     */
    value: string;
    taxId: string;
    /**
     * Data type of custom detail (type of value investor need to provide)
     */
    customDetailDataType: CustomDetailDataTypeEnum;
};

export type PatchShareholderInvestorCustomDetailDto = {
    data: Array<ShareholderInvestorCustomDetailValueDto>;
};

export const ContractsReadinessStatus = {
    NOT_READY: 'NOT_READY',
    INCORRECT_PHONE_NUMBER: 'INCORRECT_PHONE_NUMBER',
    READY: 'READY'
} as const;

export type ContractsReadinessStatus = typeof ContractsReadinessStatus[keyof typeof ContractsReadinessStatus];

export type WitnessSigningData = {
    signatureId?: string;
    status: DocumentWorkflowInstanceSignatureStatus | null;
    email?: string;
    hasWitnessRole: boolean;
    requiredWitnesses: number;
};

export type PivSigningData = {
    signatureId?: string;
    /**
     * The PIV entity's name, for display in investor-facing signing copy.
     */
    pivName?: string;
    status: DocumentWorkflowInstanceSignatureStatus | null;
    witness?: WitnessSigningData;
    /**
     * Resolved security level for the PIV signer: explicit signer override falling back to template config default.
     */
    effectiveSecurityLevel?: DocumentSigningSecurityLevel;
};

export type RepresentativeSigningData = {
    signatureId: string;
    status: DocumentWorkflowInstanceSignatureStatus;
    email?: string;
    name?: string;
    inviteSent: boolean;
    witness?: WitnessSigningData;
    /**
     * Resolved security level for the REPRESENTATIVE signer: explicit signer override falling back to template config default.
     */
    effectiveSecurityLevel?: DocumentSigningSecurityLevel;
};

export const DocumentWorkflowTemplatePurpose = {
    AGREEMENT: 'AGREEMENT',
    DEAL: 'DEAL',
    DECLARATION: 'DECLARATION',
    SCHEDULE: 'SCHEDULE',
    OTHER: 'OTHER',
    SIDE_LETTER: 'SIDE_LETTER',
    FORM: 'FORM',
    POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
    ANNUAL_REPORT: 'ANNUAL_REPORT',
    VALUATION: 'VALUATION',
    RESOLUTION: 'RESOLUTION',
    UK_DEED: 'UK_DEED',
    AGREEMENT_ADVANCED_SIGNATURE: 'AGREEMENT_ADVANCED_SIGNATURE',
    NOTICE: 'NOTICE',
    NOTICE_REQUIRING_ACKNOWLEDGMENT: 'NOTICE_REQUIRING_ACKNOWLEDGMENT',
    PRE_FILLABLE_FORM: 'PRE_FILLABLE_FORM',
    GDPR_NOTICE: 'GDPR_NOTICE',
    FORM_S431: 'FORM_S431',
    FATCA: 'FATCA',
    CRS: 'CRS',
    TAX_RESIDENCY: 'TAX_RESIDENCY',
    CUSTOM: 'CUSTOM'
} as const;

export type DocumentWorkflowTemplatePurpose = typeof DocumentWorkflowTemplatePurpose[keyof typeof DocumentWorkflowTemplatePurpose];

export type SignableContractTemplate = {
    type: DocumentWorkflowTemplateType;
    purpose: DocumentWorkflowTemplatePurpose;
    fileId: string;
};

export type SignableContract = {
    id: string;
    documentWorkflowInstanceId: string;
    status: DocumentWorkflowInstanceSignatureStatus;
    fileId: string;
    fileName: string;
    instruction: string | null;
    signatureType: SignatureType;
    eSignProvider: ESignProvider | null;
    isSignableForm: boolean;
    formSubmitted: boolean;
    canRemoveSubmittedForm: boolean;
    piv?: PivSigningData;
    representative?: RepresentativeSigningData;
    witness?: WitnessSigningData;
    template: SignableContractTemplate;
    /**
     * Resolved security level for the investor (PARTY) signer: explicit signer override falling back to template config default. BASIC includes DRAW; ADVANCED is strong methods only.
     */
    effectiveSecurityLevel: DocumentSigningSecurityLevel;
    /**
     * Role type of the investor (PARTY) signer for this contract row.
     */
    signerRoleType: DocumentSigningRoleType;
};

export type GetSignableContractsRes = {
    status: ContractsReadinessStatus;
    contracts?: Array<SignableContract>;
    friendlyMessage?: string;
    systemMessage?: string;
};

export type ReviewableContractFile = {
    id: string;
    name: string;
    mimeType: string;
    extension: string;
};

export type ReviewableContractTemplate = {
    id: string;
    name: string;
    type: DocumentWorkflowTemplateType;
    purpose: DocumentWorkflowTemplatePurpose;
};

export type ReviewableContract = {
    id: string;
    fileId: string;
    status: DocumentWorkflowInstanceStatus;
    file: ReviewableContractFile;
    documentWorkflowTemplate: ReviewableContractTemplate;
};

export type GetSignableContractsAndInvestorPhoneStatusRes = {
    signableContracts: GetSignableContractsRes;
    reviewableContracts: Array<ReviewableContract>;
    isPhoneNumberInvalid: boolean;
};

export type LatestTransactionSummaryWithoutCost = {
    currency: CurrencyType;
    type: InvestmentWorkflowType;
    createdAt: string;
};

export const KycDocumentStatus = {
    NOT_UPLOADED: 'NOT_UPLOADED',
    NOT_REQUIRED: 'NOT_REQUIRED',
    UPLOADED_NOT_VERIFIED: 'UPLOADED_NOT_VERIFIED',
    UPLOADED_REJECTED: 'UPLOADED_REJECTED',
    UPLOADED_APPROVED: 'UPLOADED_APPROVED',
    MORE_DOCUMENTS_REQUESTED: 'MORE_DOCUMENTS_REQUESTED'
} as const;

export type KycDocumentStatus = typeof KycDocumentStatus[keyof typeof KycDocumentStatus];

export type GetInvestmentDetailsRes = {
    userId: string;
    investorId: string;
    investmentWorkflowId: string;
    isKycRequired: boolean;
    isPiv: boolean;
    entityName?: string | null;
    latestTransaction: LatestTransactionSummaryWithoutCost;
    isDeclarationsRejected: boolean;
    pivStatus: KycDocumentStatus;
    formStatus: KycDocumentStatus;
    proofOfAddressStatus: KycDocumentStatus;
    proofOfIdentityStatus: KycDocumentStatus;
    isBankAccountRequired?: boolean;
    /**
     * Active InvestmentWorkflow ID for this investment
     */
    activeInvestmentWorkflowId?: string;
    /**
     * Active KYC workflow ID for this investment (the kycWorkflow scoped to the active investmentWorkflow)
     */
    activeKycWorkflowId?: {
        [key: string]: unknown;
    } | null;
};

export type LatestTransactionSummary = {
    currency: CurrencyType;
    cost: number;
    type: InvestmentWorkflowType;
    createdAt: string;
};

export const ShareholderInvestmentStatus = {
    NEW_OFFER: 'NEW_OFFER',
    NEEDS_ATTENTION: 'NEEDS_ATTENTION',
    PENDING_APPROVAL: 'PENDING_APPROVAL',
    COMPLETED: 'COMPLETED',
    PENDING: 'PENDING'
} as const;

export type ShareholderInvestmentStatus = typeof ShareholderInvestmentStatus[keyof typeof ShareholderInvestmentStatus];

export type SecuritiesTotalCosts = {
    totalCost: number;
    investmentWorkflowCompletedTotalCost: number;
    investmentWorkflowNotCompletedTotalCost: number;
};

export type GetInvestorStatisticsBySecurityRes = {
    totalNumber: number;
    totalCosts: SecuritiesTotalCosts;
    name: string;
    securityId: string;
    type: SecurityType;
    currency: CurrencyType;
    issuedIn: SecurityIssuedIn;
    votesPerUnit: number;
    nominalValue: number;
    fairMarketValuePerUnit?: number | null;
    isSubjectToVesting: boolean;
};

export type GetInvestorHoldingsStatisticsRes = {
    totalNumber: number;
    totalCost: number;
    name: string;
    securityId: string;
    issuedIn: SecurityIssuedIn;
};

export type GetShareholderInvestmentEntryRes = {
    investorId: string;
    investmentWorkflowId: string;
    areMorePivDocsRequested?: boolean;
    dealId: string;
    mipId: string;
    isInvestorVoided: boolean;
    bankDetails?: DataBankAccountTct;
    entityName?: string | null;
    latestTransaction: LatestTransactionSummary;
    investmentStatus: ShareholderInvestmentStatus;
    completionStep: InvestmentWorkflowCompletionStep | null;
    isLeaverInvestmentWorkflow: boolean;
    securities: Array<GetInvestorStatisticsBySecurityRes>;
    holdings: Array<GetInvestorHoldingsStatisticsRes>;
    showBankDetails: boolean;
    updatedAt: string;
    hasOutstandingDocuments: boolean;
    hasOutstandingKyc: boolean;
};

export type GetShareholderSdwDocumentRes = {
    isAllInvestorAndPIVSigned: boolean;
    createdAt: string;
    updatedAt: string;
    companyName: string;
    investorId: string;
    dealId?: string;
    mipId?: string;
};

export type StandaloneKycWorkflowRes = {
    kycWorkflowId: string;
    investorId: string;
    mipId: string;
    dealId: string;
    companyName: string;
    status: KycWorkflowStatus;
    updatedAt: string;
};

export type GetShareholderInvestmentEntryWithSdwDocumentRes = {
    investment?: GetShareholderInvestmentEntryRes;
    document?: GetShareholderSdwDocumentRes;
    standaloneKyc?: StandaloneKycWorkflowRes | null;
};

export type GetUserInvestmentsListItemRes = {
    investorId: string;
    dealId: string;
    contactPeople: Array<UserWithOnlyEmailAndNameRes>;
    entityName?: {
        [key: string]: unknown;
    } | null;
    programmeName?: {
        [key: string]: unknown;
    } | null;
};

export type PatchInvestmentSelectedBankAccountDto = {
    bankAccountId: string;
};

export type PermissionRolesDto = {
    /**
     * The unique identifier of the user
     */
    userId: string;
    /**
     * The permission roles of the user
     */
    permissionRoles: Array<PermissionRole>;
};

export type ProgrammeSecurityAllocationTct = {
    id: string;
    securityId: string;
    mipId: string;
    allocation: number;
    mipName?: {
        [key: string]: unknown;
    };
};

export type UpdateProgrammeSecurityAllocationDto = {
    mipId: string;
    securityId: string;
    allocation: number;
};

export type SanitySlug = {
    _type: string;
    current: string;
};

export type SanityReference = {
    _type: string;
    _ref: string;
};

export type SanityImageRef = {
    _type: string;
    asset: SanityReference;
};

export type ArticleAuthorRes = {
    name: string;
    slug: SanitySlug;
    image: SanityImageRef | null;
    position: string | null;
};

export type ArticleNameSlugField = {
    name: string;
    slug: SanitySlug;
};

export type ArticleTocRes = {
    text: string;
    key: string;
};

export type ArticleRes = {
    id: string;
    language: string;
    title: string;
    entryPoints: Array<string>;
    slug: SanitySlug;
    author: ArticleAuthorRes;
    category: ArticleNameSlugField;
    createdAt: string;
    image: SanityImageRef | null;
    body: Array<{
        [key: string]: unknown;
    }>;
    previewSummary: Array<{
        [key: string]: unknown;
    }>;
    estimatedWordCount: number;
    estimatedReadingTimeMinutes: number;
    toc: Array<ArticleTocRes>;
};

export type EntrypointArticlesRes = {
    slug: SanitySlug;
    entrypoints: Array<string>;
};

export type CategoryRes = {
    id: string;
    language: string;
    name: string;
    slug: SanitySlug;
    image: SanityImageRef;
    body: Array<{
        [key: string]: unknown;
    }>;
    createdAt: string;
    postsCount: number;
};

export type AuthorRes = {
    id: string;
    name: string;
    position: string | null;
    slug: SanitySlug;
    image: SanityImageRef | null;
    body: Array<{
        [key: string]: unknown;
    }>;
    createdAt: string;
    postsCount: number;
};

export type DocumentWorkflowFileTct = {
    id: string;
    /**
     * Underlying File primary key for download / preview by file id.
     */
    fileId: string;
    name: string;
    canDelete: boolean;
    createdAt: string;
    isGDPR: boolean;
    isPreFillableForm: boolean;
    isGeneratableDocument: boolean;
    generatableDocumentWorkflowTemplateType?: GeneratableDocumentWorkflowTemplateType;
};

export type GetDocumentWorkflowFilesRes = {
    documentFiles: Array<DocumentWorkflowFileTct>;
    nextCursor: string;
    totalRecord: number;
    hasGDPRDocumentFile: boolean;
};

export type DocumentWorkflowFileDto = {
    fileId: string;
};

export type CreateDocumentWorkflowFileRes = {
    id: string;
};

export const DocumentTemplateType = {
    CUSTOM: 'CUSTOM',
    NOTICE: 'NOTICE',
    NOTICE_REQUIRING_ACKNOWLEDGMENT: 'NOTICE_REQUIRING_ACKNOWLEDGMENT',
    AGREEMENT: 'AGREEMENT',
    AGREEMENT_ADVANCED_SIGNATURE: 'AGREEMENT_ADVANCED_SIGNATURE',
    SCHEDULE: 'SCHEDULE',
    FORM: 'FORM',
    UK_DEED: 'UK_DEED',
    POWER_OF_ATTORNEY: 'POWER_OF_ATTORNEY',
    SIDE_LETTER: 'SIDE_LETTER',
    ANNUAL_REPORT: 'ANNUAL_REPORT',
    VALUATION: 'VALUATION',
    RESOLUTION: 'RESOLUTION',
    PRE_FILLABLE_FORM: 'PRE_FILLABLE_FORM',
    GDPR_NOTICE: 'GDPR_NOTICE',
    FORM_S431: 'FORM_S431'
} as const;

export type DocumentTemplateType = typeof DocumentTemplateType[keyof typeof DocumentTemplateType];

export const DocumentSignatureType = {
    ELECTRONIC: 'ELECTRONIC',
    WET_INK: 'WET_INK',
    REVIEW: 'REVIEW',
    SUBMITTABLE: 'SUBMITTABLE'
} as const;

export type DocumentSignatureType = typeof DocumentSignatureType[keyof typeof DocumentSignatureType];

export type CreateDocumentWorkflowCounterpartyDto = {
    name: string;
    amount: number;
};

export type PendingSignaturePlacementDto = {
    roleType: DocumentSigningRoleType;
    /**
     * For COUNTERPARTY roles; empty for PARTY-family roles.
     */
    roleName?: string;
    isWitness: boolean;
    signatureIndex: number;
    pageNum: number;
    x: number;
    y: number;
    width: number;
    height: number;
};

export type CreateDocumentWorkflowDto = {
    documentWorkflowFileId: string;
    templateType: DocumentTemplateType;
    requiredWitnesses: number;
    signatureType: DocumentSignatureType;
    isSignatureAdvanced: boolean;
    individualScheduleRequired: boolean;
    isToBeSubmitted?: boolean;
    emailText: string | null;
    guidanceNoteFileId: string | null;
    counterparties: Array<CreateDocumentWorkflowCounterpartyDto>;
    useManualSignaturePlacement?: boolean;
    showStampMetadata?: boolean;
    signaturePlacements?: Array<PendingSignaturePlacementDto>;
};

export type CreateDocumentWorkflowsDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
    documents: Array<CreateDocumentWorkflowDto>;
};

export type CreateDocumentWorkflowRes = {
    [key: string]: unknown;
};

export type SendMasterDocumentDto = {
    documentWorkflowTemplateId: string;
};

export type SendMasterDocumentsDto = {
    selectedIds?: Array<string>;
    excludedIds?: Array<string>;
    filterQuery?: InvestorsFilterQuery;
    searchQuery?: string;
    documents: Array<SendMasterDocumentDto>;
    emailText?: string;
};

export type SendMasterDocumentsRes = {
    investorInviteWorkflowHandle: string;
    correlationId: string;
    /**
     * Document instances created across all selected investors.
     */
    instanceCount: number;
};

export type CreateSecurityRankDefinitionDto = {
    displayName: string;
    issuerId: string;
    isTracking?: boolean;
    isResidue?: boolean;
};

export type UpdateSecurityRankDefinitionDto = {
    displayName?: string;
    newSortOrder?: number;
};

export type UpsertSecurityRankDto = {
    securityId: string;
    featureType: SecurityFeatureType;
    rankId?: string;
    issuerId: string;
};

export type UpsertSecurityIncomeRanksDto = {
    securityId: string;
    rankId?: string;
    issuerId: string;
};

export type CreateUpdateSecurityRatchetScheduleEntryDto = {
    order: number;
    moicThreshold?: number | null;
    xirrThreshold?: number | null;
    entitlementPercentage: number;
};

export type CreateUpdateSecurityRatchetMetricSubjectDto = {
    personId: string;
};

export type CreateUpdateSecurityRatchetScheduleDto = {
    metricType: RatchetMetricType;
    initialEntitlementPercentage: number;
    distributeUntilBreakpoint?: boolean;
    entries: Array<CreateUpdateSecurityRatchetScheduleEntryDto>;
    metricSubjects: Array<CreateUpdateSecurityRatchetMetricSubjectDto>;
};

export const ScheduledEmailStatus = {
    ACTIVE: 'ACTIVE',
    PROCESSING: 'PROCESSING',
    COMPLETED: 'COMPLETED',
    CANCELLED: 'CANCELLED',
    FAILED: 'FAILED'
} as const;

export type ScheduledEmailStatus = typeof ScheduledEmailStatus[keyof typeof ScheduledEmailStatus];

export const ScheduledEmailCompletionReason = {
    ALL_RESOLVED: 'ALL_RESOLVED',
    MAX_FIRES_REACHED: 'MAX_FIRES_REACHED',
    CANCELLED_BY_ADMIN: 'CANCELLED_BY_ADMIN',
    REPEATED_FAILURE: 'REPEATED_FAILURE',
    END_DATE_REACHED: 'END_DATE_REACHED'
} as const;

export type ScheduledEmailCompletionReason = typeof ScheduledEmailCompletionReason[keyof typeof ScheduledEmailCompletionReason];

export type ScheduledEmailRes = {
    id: string;
    type: ScheduledEmailType;
    status: ScheduledEmailStatus;
    documentWorkflowInstanceId: string;
    nextFireAt: string;
    fireCount: number;
    maxFires: number;
    lastPendingCount?: number | null;
    completionReason?: ScheduledEmailCompletionReason | null;
    endDate?: string | null;
    createdAt: string;
    targetName?: string;
};

export type CreateScheduledEmailDto = {
    documentWorkflowInstanceId: string;
};

export type RescheduleScheduledEmailDto = {
    /**
     * The new absolute fire time (ISO 8601)
     */
    nextFireAt: string;
};

export type SetScheduledEmailEndDateDto = {
    endDate?: string | null;
};

export const LeaverInvestmentWorkflowType = { LEAVER: 'LEAVER', PARTIAL_LEAVER: 'PARTIAL_LEAVER' } as const;

export type LeaverInvestmentWorkflowType = typeof LeaverInvestmentWorkflowType[keyof typeof LeaverInvestmentWorkflowType];

export type SwaggerExtraEnums = {
    leaverTsaType: LeaverInvestmentWorkflowType;
};

export type UserControllerGetCurrentUserDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user';
};

export type UserControllerGetCurrentUserDataResponses = {
    default: DataUserResponse;
};

export type UserControllerGetCurrentUserDataResponse = UserControllerGetCurrentUserDataResponses[keyof UserControllerGetCurrentUserDataResponses];

export type UserControllerGetUserOrganizationData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/organization';
};

export type UserControllerGetUserOrganizationResponses = {
    default: UserOrganizationRes;
};

export type UserControllerGetUserOrganizationResponse = UserControllerGetUserOrganizationResponses[keyof UserControllerGetUserOrganizationResponses];

export type UserControllerGetUserProfileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/profile';
};

export type UserControllerGetUserProfileResponses = {
    default: GetUserProfileRes;
};

export type UserControllerGetUserProfileResponse = UserControllerGetUserProfileResponses[keyof UserControllerGetUserProfileResponses];

export type UserControllerGetUserPersonsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/persons';
};

export type UserControllerGetUserPersonsResponses = {
    default: GetUserPersonsRes;
};

export type UserControllerGetUserPersonsResponse = UserControllerGetUserPersonsResponses[keyof UserControllerGetUserPersonsResponses];

export type UserControllerUpdatePersonalDetailsData = {
    body: UpdateUserPersonalDetailsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/personal-details';
};

export type UserControllerUpdatePersonalDetailsResponses = {
    200: unknown;
};

export type UserControllerDeleteUserSignatureData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/signature';
};

export type UserControllerDeleteUserSignatureResponses = {
    204: void;
};

export type UserControllerDeleteUserSignatureResponse = UserControllerDeleteUserSignatureResponses[keyof UserControllerDeleteUserSignatureResponses];

export type UserControllerGetUserSignatureData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/signature';
};

export type UserControllerGetUserSignatureResponses = {
    /**
     * Saved signature found
     */
    200: UserSignatureRes;
    /**
     * No saved signature
     */
    204: void;
};

export type UserControllerGetUserSignatureResponse = UserControllerGetUserSignatureResponses[keyof UserControllerGetUserSignatureResponses];

export type UserControllerUpdateUserSignatureData = {
    body: UpdateUserSignatureDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/signature';
};

export type UserControllerUpdateUserSignatureResponses = {
    200: unknown;
};

export type UserControllerUpdateShareholderInvestorVehicleDataWithoutMipData = {
    body: UpdateUserVehicleDataDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/vehicle-data-without-mip-id';
};

export type UserControllerUpdateShareholderInvestorVehicleDataWithoutMipResponses = {
    200: unknown;
};

export type UserControllerUpdateUserLegalRepresentativeWithoutMipData = {
    body: UpdateUserRepresentativeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/user/legal-representative-without-mip-id';
};

export type UserControllerUpdateUserLegalRepresentativeWithoutMipResponses = {
    200: unknown;
};

export type UserControllerGetAllInvestorsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        limit: number;
        searchQuery: string;
    };
    url: '/user/all';
};

export type UserControllerGetAllInvestorsResponses = {
    default: Array<UserWithOnlyEmailAndNameRes>;
};

export type UserControllerGetAllInvestorsResponse = UserControllerGetAllInvestorsResponses[keyof UserControllerGetAllInvestorsResponses];

export type ShareholderInvestorControllerGetShareholderInvestorDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/investor';
};

export type ShareholderInvestorControllerGetShareholderInvestorDataResponses = {
    default: DataShareholderInvestorWithPersonRes;
};

export type ShareholderInvestorControllerGetShareholderInvestorDataResponse = ShareholderInvestorControllerGetShareholderInvestorDataResponses[keyof ShareholderInvestorControllerGetShareholderInvestorDataResponses];

export type ShareholderInvestorControllerUpdateShareholderInvestorDataData = {
    body: PutShareholderInvestorDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investor';
};

export type ShareholderInvestorControllerUpdateShareholderInvestorDataResponses = {
    200: unknown;
};

export type ShareholderInvestorControllerGetShareholderInvestorDataByUserIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investor/user/{userId}';
};

export type ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponses = {
    default: DataShareholderInvestorTct;
};

export type ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponse = ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponses[keyof ShareholderInvestorControllerGetShareholderInvestorDataByUserIdResponses];

export type ShareholderInvestorControllerGetInvestorDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        investorId?: string;
    };
    url: '/shareholder/investor/user-investment-documents';
};

export type ShareholderInvestorControllerGetInvestorDocumentsResponses = {
    default: Array<GetUserInvestmentDocumentsRes>;
};

export type ShareholderInvestorControllerGetInvestorDocumentsResponse = ShareholderInvestorControllerGetInvestorDocumentsResponses[keyof ShareholderInvestorControllerGetInvestorDocumentsResponses];

export type ShareholderInvestorControllerGetInvestorDealDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investor/deal-documents';
};

export type ShareholderInvestorControllerGetInvestorDealDocumentsResponses = {
    default: Array<GetInvestorDealDocumentsRes>;
};

export type ShareholderInvestorControllerGetInvestorDealDocumentsResponse = ShareholderInvestorControllerGetInvestorDealDocumentsResponses[keyof ShareholderInvestorControllerGetInvestorDealDocumentsResponses];

export type ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataData = {
    body: PatchShareholderInvestorVehicleDataDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investor/vehicle-data';
};

export type ShareholderInvestorControllerUpdateShareholderInvestorVehicleDataResponses = {
    200: unknown;
};

export type ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataData = {
    body: PatchShareholderInvestorCompletionStepDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investor/completion-step';
};

export type ShareholderInvestorControllerUpdateShareholderInvestorCompletedStepsDataResponses = {
    200: unknown;
};

export type ShareholderInvestorControllerGetInvestorRepresentativeData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/shareholder/investor/{investorId}/representative';
};

export type ShareholderInvestorControllerGetInvestorRepresentativeResponses = {
    default: DataPersonTct;
};

export type ShareholderInvestorControllerGetInvestorRepresentativeResponse = ShareholderInvestorControllerGetInvestorRepresentativeResponses[keyof ShareholderInvestorControllerGetInvestorRepresentativeResponses];

export type ShareholderInvestorControllerGetInvestmentTransactionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        investorId: string;
    };
    url: '/shareholder/investor/transactions';
};

export type ShareholderInvestorControllerGetInvestmentTransactionsResponses = {
    default: GetInvestorTransactionsRes;
};

export type ShareholderInvestorControllerGetInvestmentTransactionsResponse = ShareholderInvestorControllerGetInvestmentTransactionsResponses[keyof ShareholderInvestorControllerGetInvestmentTransactionsResponses];

export type PersonControllerCreateNaturalEntityData = {
    body: CreateSimplePersonNaturalDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/person/create-natural';
};

export type PersonControllerCreateNaturalEntityResponses = {
    default: PersonNaturalRes;
};

export type PersonControllerCreateNaturalEntityResponse = PersonControllerCreateNaturalEntityResponses[keyof PersonControllerCreateNaturalEntityResponses];

export type PersonControllerCreateLegalEntityData = {
    body: CreatePersonLegalDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/person/create-legal';
};

export type PersonControllerCreateLegalEntityResponses = {
    default: PersonLegalRes;
};

export type PersonControllerCreateLegalEntityResponse = PersonControllerCreateLegalEntityResponses[keyof PersonControllerCreateLegalEntityResponses];

export type PersonControllerUpdateLegalPersonDetailsData = {
    body: UpdatePersonDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/legal';
};

export type PersonControllerUpdateLegalPersonDetailsResponses = {
    200: unknown;
};

export type PersonControllerUpdateNaturalPersonDetailsData = {
    body: UpdateNaturalPersonDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/natural';
};

export type PersonControllerUpdateNaturalPersonDetailsResponses = {
    200: unknown;
};

export type PersonControllerUpdateNaturalPersonEmailData = {
    body: UpdateNaturalPersonEmailDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/natural/email';
};

export type PersonControllerUpdateNaturalPersonEmailResponses = {
    200: unknown;
};

export type PersonControllerLookupPersonByEmailData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query: {
        email: string;
    };
    url: '/person/lookup-by-email';
};

export type PersonControllerLookupPersonByEmailResponses = {
    default: PersonByEmailLookupRes;
};

export type PersonControllerLookupPersonByEmailResponse = PersonControllerLookupPersonByEmailResponses[keyof PersonControllerLookupPersonByEmailResponses];

export type PersonControllerGetEntityDataData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}';
};

export type PersonControllerGetEntityDataResponses = {
    default: GetPersonByIdRes;
};

export type PersonControllerGetEntityDataResponse = PersonControllerGetEntityDataResponses[keyof PersonControllerGetEntityDataResponses];

export type PersonControllerDeletePersonRelatedPersonData = {
    body: DeletePersonRelatedPersonDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/related-people';
};

export type PersonControllerDeletePersonRelatedPersonResponses = {
    default: GetRelatedPeopleForPerson;
};

export type PersonControllerDeletePersonRelatedPersonResponse = PersonControllerDeletePersonRelatedPersonResponses[keyof PersonControllerDeletePersonRelatedPersonResponses];

export type PersonControllerGetPersonRelatedPeopleData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/related-people';
};

export type PersonControllerGetPersonRelatedPeopleResponses = {
    default: GetRelatedPeopleForPerson;
};

export type PersonControllerGetPersonRelatedPeopleResponse = PersonControllerGetPersonRelatedPeopleResponses[keyof PersonControllerGetPersonRelatedPeopleResponses];

export type PersonControllerCreateRelatedPeopleForPersonData = {
    body: CreatePersonRelatedPeopleDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/related-people';
};

export type PersonControllerCreateRelatedPeopleForPersonResponses = {
    201: unknown;
};

export type PersonControllerGetAvailableRelatedPeopleForPersonData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/available-related-people';
};

export type PersonControllerGetAvailableRelatedPeopleForPersonResponses = {
    default: Array<NamesOfPersonWithRelation>;
};

export type PersonControllerGetAvailableRelatedPeopleForPersonResponse = PersonControllerGetAvailableRelatedPeopleForPersonResponses[keyof PersonControllerGetAvailableRelatedPeopleForPersonResponses];

export type PersonControllerAddRelatedPersonByEmailData = {
    body: AddRelatedPersonByEmailDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/related-people/by-email';
};

export type PersonControllerAddRelatedPersonByEmailResponses = {
    201: unknown;
};

export type PersonControllerUpdateRelatedPersonRelationData = {
    body: UpdateRelatedPersonRelationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
        relationId: string;
    };
    query?: never;
    url: '/person/{personId}/related-people/{relationId}';
};

export type PersonControllerUpdateRelatedPersonRelationResponses = {
    200: unknown;
};

export type PersonControllerGetAllEntitiesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/persons';
};

export type PersonControllerGetAllEntitiesResponses = {
    200: unknown;
};

export type PersonControllerGetAllLegalEntitiesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: {
        onlyIssuers?: boolean;
        pivOfPersonId?: string;
    };
    url: '/person/deal/{dealId}/legal-persons';
};

export type PersonControllerGetAllLegalEntitiesResponses = {
    default: Array<GetPersonByIdRes>;
};

export type PersonControllerGetAllLegalEntitiesResponse = PersonControllerGetAllLegalEntitiesResponses[keyof PersonControllerGetAllLegalEntitiesResponses];

export type PersonControllerGetPersonsForCapData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/persons-for-cap';
};

export type PersonControllerGetPersonsForCapResponses = {
    default: Array<GetPersonForCapRes>;
};

export type PersonControllerGetPersonsForCapResponse = PersonControllerGetPersonsForCapResponses[keyof PersonControllerGetPersonsForCapResponses];

export type PersonControllerGetPersonTagsForDealData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/person-tags';
};

export type PersonControllerGetPersonTagsForDealResponses = {
    default: Array<PersonTagRes>;
};

export type PersonControllerGetPersonTagsForDealResponse = PersonControllerGetPersonTagsForDealResponses[keyof PersonControllerGetPersonTagsForDealResponses];

export type PersonControllerDeleteEntitiesData = {
    body: Array<string>;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query: {
        force: boolean;
    };
    url: '/person/delete-entities';
};

export type PersonControllerDeleteEntitiesResponses = {
    201: unknown;
};

export type PersonControllerIsThereInvestmentWorkflowData = {
    body: Array<string>;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/person/is-there-investmentWorkflow';
};

export type PersonControllerIsThereInvestmentWorkflowResponses = {
    default: IsInvestmentWorkflowExistsRes;
};

export type PersonControllerIsThereInvestmentWorkflowResponse = PersonControllerIsThereInvestmentWorkflowResponses[keyof PersonControllerIsThereInvestmentWorkflowResponses];

export type PersonControllerBulkCreateLegalPersonsData = {
    body: BulkUploadPersonLegalsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/create-legal-bulk';
};

export type PersonControllerBulkCreateLegalPersonsResponses = {
    201: unknown;
};

export type PersonControllerBulkCreateNaturalPersonsData = {
    body: BulkUploadPersonNaturalDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/person/deal/{dealId}/create-natural-bulk';
};

export type PersonControllerBulkCreateNaturalPersonsResponses = {
    201: unknown;
};

export type PersonControllerCreateAddressData = {
    body: CreatePersonAddressDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/create-address';
};

export type PersonControllerCreateAddressResponses = {
    default: CreatePersonAddressDto;
};

export type PersonControllerCreateAddressResponse = PersonControllerCreateAddressResponses[keyof PersonControllerCreateAddressResponses];

export type PersonControllerUpdateAddressData = {
    body: UpdatePersonAddressDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/update-address';
};

export type PersonControllerUpdateAddressResponses = {
    default: UpdatePersonAddressDto;
};

export type PersonControllerUpdateAddressResponse = PersonControllerUpdateAddressResponses[keyof PersonControllerUpdateAddressResponses];

export type PersonControllerDeleteAddressData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personAddressId: string;
    };
    query?: never;
    url: '/person/{personAddressId}/delete-address';
};

export type PersonControllerDeleteAddressResponses = {
    200: unknown;
};

export type PersonControllerGetNaturalPersonsByPivIdData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        pivPersonId: string;
    };
    query?: never;
    url: '/person/{pivPersonId}/natural-persons-by-piv';
};

export type PersonControllerGetNaturalPersonsByPivIdResponses = {
    default: Array<PersonNameWithIdRes>;
};

export type PersonControllerGetNaturalPersonsByPivIdResponse = PersonControllerGetNaturalPersonsByPivIdResponses[keyof PersonControllerGetNaturalPersonsByPivIdResponses];

export type PersonControllerIsPersonUserInvitedToPlatformData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/is-user-invited';
};

export type PersonControllerIsPersonUserInvitedToPlatformResponses = {
    default: IsPersonEmailInUseRes;
};

export type PersonControllerIsPersonUserInvitedToPlatformResponse = PersonControllerIsPersonUserInvitedToPlatformResponses[keyof PersonControllerIsPersonUserInvitedToPlatformResponses];

export type PersonBankAccountControllerGetPersonBankAccountsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/bankAccount';
};

export type PersonBankAccountControllerGetPersonBankAccountsResponses = {
    default: Array<BankAccountRes>;
};

export type PersonBankAccountControllerGetPersonBankAccountsResponse = PersonBankAccountControllerGetPersonBankAccountsResponses[keyof PersonBankAccountControllerGetPersonBankAccountsResponses];

export type PersonBankAccountControllerCreatePersonBankAccountData = {
    body: CreatePersonBankAccountDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/bankAccount';
};

export type PersonBankAccountControllerCreatePersonBankAccountResponses = {
    default: BankAccountRes;
};

export type PersonBankAccountControllerCreatePersonBankAccountResponse = PersonBankAccountControllerCreatePersonBankAccountResponses[keyof PersonBankAccountControllerCreatePersonBankAccountResponses];

export type PersonBankAccountControllerDeletePersonBankAccountData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
        bankAccountId: string;
    };
    query?: never;
    url: '/person/{personId}/bankAccount/{bankAccountId}';
};

export type PersonBankAccountControllerDeletePersonBankAccountResponses = {
    default: BankAccountRes;
};

export type PersonBankAccountControllerDeletePersonBankAccountResponse = PersonBankAccountControllerDeletePersonBankAccountResponses[keyof PersonBankAccountControllerDeletePersonBankAccountResponses];

export type PersonBankAccountControllerUpdatePersonBankAccountData = {
    body: CreatePersonBankAccountDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
        bankAccountId: string;
    };
    query?: never;
    url: '/person/{personId}/bankAccount/{bankAccountId}';
};

export type PersonBankAccountControllerUpdatePersonBankAccountResponses = {
    default: BankAccountRes;
};

export type PersonBankAccountControllerUpdatePersonBankAccountResponse = PersonBankAccountControllerUpdatePersonBankAccountResponses[keyof PersonBankAccountControllerUpdatePersonBankAccountResponses];

export type PersonBankAccountControllerValidatePersonBankAccountData = {
    body: VerifyBankIdentifiersDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
        bankAccountId: string;
    };
    query?: never;
    url: '/person/{personId}/bankAccount/{bankAccountId}/validate';
};

export type PersonBankAccountControllerValidatePersonBankAccountResponses = {
    default: VerifyBankIdentifiersRes;
};

export type PersonBankAccountControllerValidatePersonBankAccountResponse = PersonBankAccountControllerValidatePersonBankAccountResponses[keyof PersonBankAccountControllerValidatePersonBankAccountResponses];

export type PersonTaxControllerGetPersonTaxInformationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/tax';
};

export type PersonTaxControllerGetPersonTaxInformationResponses = {
    default: Array<GetPersonTaxInformationRes>;
};

export type PersonTaxControllerGetPersonTaxInformationResponse = PersonTaxControllerGetPersonTaxInformationResponses[keyof PersonTaxControllerGetPersonTaxInformationResponses];

export type PersonTaxControllerCreatePersonTaxInformationData = {
    body: CreatePersonTaxInformationDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/tax';
};

export type PersonTaxControllerCreatePersonTaxInformationResponses = {
    default: GetPersonTaxInformationRes;
};

export type PersonTaxControllerCreatePersonTaxInformationResponse = PersonTaxControllerCreatePersonTaxInformationResponses[keyof PersonTaxControllerCreatePersonTaxInformationResponses];

export type PersonTaxControllerDeletePersonTaxInformationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
        taxId: string;
    };
    query?: never;
    url: '/person/{personId}/tax/{taxId}';
};

export type PersonTaxControllerDeletePersonTaxInformationResponses = {
    default: GetPersonTaxInformationRes;
};

export type PersonTaxControllerDeletePersonTaxInformationResponse = PersonTaxControllerDeletePersonTaxInformationResponses[keyof PersonTaxControllerDeletePersonTaxInformationResponses];

export type PersonTaxControllerUpdatePersonTaxInformationData = {
    body: CreatePersonTaxInformationDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
        taxId: string;
    };
    query?: never;
    url: '/person/{personId}/tax/{taxId}';
};

export type PersonTaxControllerUpdatePersonTaxInformationResponses = {
    default: GetPersonTaxInformationRes;
};

export type PersonTaxControllerUpdatePersonTaxInformationResponse = PersonTaxControllerUpdatePersonTaxInformationResponses[keyof PersonTaxControllerUpdatePersonTaxInformationResponses];

export type PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/mip';
};

export type PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponses = {
    default: Array<GetPersonInvestmentProgrammesRes>;
};

export type PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponse = PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponses[keyof PersonInvestmentProgrammeControllerGetInvestmentProgrammesForPersonResponses];

export type PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/mip/available-for-linking';
};

export type PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponses = {
    default: Array<SummaryMipNameTct>;
};

export type PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponse = PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponses[keyof PersonInvestmentProgrammeControllerGetAvailableInvestmentProgrammesForPersonResponses];

export type PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
        mipId: string;
    };
    query: {
        isUnlink: boolean;
    };
    url: '/person/{personId}/mip/{mipId}/transactions';
};

export type PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponses = {
    default: Array<GetTransactionRes>;
};

export type PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponse = PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponses[keyof PersonInvestmentProgrammeControllerCheckAvailableTransactionsForPersonForMipResponses];

export type PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
        mipId: string;
    };
    query?: never;
    url: '/person/{personId}/mip/{mipId}/open-tsa-warning';
};

export type PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponses = {
    default: GetPersonMipOpenTsaWarningRes;
};

export type PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponse = PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponses[keyof PersonInvestmentProgrammeControllerGetOpenTsaWarningForPersonForMipResponses];

export type PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
        mipId: string;
    };
    query: {
        linkTransactions: boolean;
    };
    url: '/person/{personId}/mip/{mipId}/link';
};

export type PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponses = {
    default: GetPersonInvestmentProgrammesRes;
};

export type PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponse = PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponses[keyof PersonInvestmentProgrammeControllerLinkPersonToInvestmentProgrammeRequestResponses];

export type PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
        mipId: string;
    };
    query: {
        unlinkTransactions: boolean;
    };
    url: '/person/{personId}/mip/{mipId}/unlink';
};

export type PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponses = {
    default: GetPersonInvestmentProgrammesRes;
};

export type PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponse = PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponses[keyof PersonInvestmentProgrammeControllerUnlinkPersonToInvestmentProgrammeRequestResponses];

export type PersonEmploymentRecordControllerListEmploymentRecordsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/persons/{personId}/employment-records';
};

export type PersonEmploymentRecordControllerListEmploymentRecordsResponses = {
    default: Array<EmploymentRecordRes>;
};

export type PersonEmploymentRecordControllerListEmploymentRecordsResponse = PersonEmploymentRecordControllerListEmploymentRecordsResponses[keyof PersonEmploymentRecordControllerListEmploymentRecordsResponses];

export type PersonEmploymentRecordControllerCreateEmploymentRecordData = {
    body: CreateEmploymentRecordDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/persons/{personId}/employment-records';
};

export type PersonEmploymentRecordControllerCreateEmploymentRecordResponses = {
    default: EmploymentRecordRes;
};

export type PersonEmploymentRecordControllerCreateEmploymentRecordResponse = PersonEmploymentRecordControllerCreateEmploymentRecordResponses[keyof PersonEmploymentRecordControllerCreateEmploymentRecordResponses];

export type PersonEmploymentControllerGetPersonEmploymentData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/employment';
};

export type PersonEmploymentControllerGetPersonEmploymentResponses = {
    default: Array<PersonEmploymentRes>;
};

export type PersonEmploymentControllerGetPersonEmploymentResponse = PersonEmploymentControllerGetPersonEmploymentResponses[keyof PersonEmploymentControllerGetPersonEmploymentResponses];

export type PersonEmploymentControllerUpsertPersonEmploymentData = {
    body: UpsertPersonEmploymentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/person/{personId}/employment';
};

export type PersonEmploymentControllerUpsertPersonEmploymentResponses = {
    default: PersonEmploymentRes;
};

export type PersonEmploymentControllerUpsertPersonEmploymentResponse = PersonEmploymentControllerUpsertPersonEmploymentResponses[keyof PersonEmploymentControllerUpsertPersonEmploymentResponses];

export type EmploymentEmployersControllerGetEmployersData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/employment/employers';
};

export type EmploymentEmployersControllerGetEmployersResponses = {
    default: Array<EmploymentEmployerRes>;
};

export type EmploymentEmployersControllerGetEmployersResponse = EmploymentEmployersControllerGetEmployersResponses[keyof EmploymentEmployersControllerGetEmployersResponses];

export type EmploymentRecordControllerDeleteEmploymentRecordData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        employmentRecordId: string;
    };
    query?: never;
    url: '/employment-records/{employmentRecordId}';
};

export type EmploymentRecordControllerDeleteEmploymentRecordResponses = {
    default: EmploymentRecordRes;
};

export type EmploymentRecordControllerDeleteEmploymentRecordResponse = EmploymentRecordControllerDeleteEmploymentRecordResponses[keyof EmploymentRecordControllerDeleteEmploymentRecordResponses];

export type EmploymentRecordControllerGetEmploymentRecordData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        employmentRecordId: string;
    };
    query?: never;
    url: '/employment-records/{employmentRecordId}';
};

export type EmploymentRecordControllerGetEmploymentRecordResponses = {
    default: EmploymentRecordRes;
};

export type EmploymentRecordControllerGetEmploymentRecordResponse = EmploymentRecordControllerGetEmploymentRecordResponses[keyof EmploymentRecordControllerGetEmploymentRecordResponses];

export type EmploymentRecordControllerUpdateEmploymentRecordData = {
    body: UpdateEmploymentRecordDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        employmentRecordId: string;
    };
    query?: never;
    url: '/employment-records/{employmentRecordId}';
};

export type EmploymentRecordControllerUpdateEmploymentRecordResponses = {
    default: EmploymentRecordRes;
};

export type EmploymentRecordControllerUpdateEmploymentRecordResponse = EmploymentRecordControllerUpdateEmploymentRecordResponses[keyof EmploymentRecordControllerUpdateEmploymentRecordResponses];

export type BankAccountLifecycleDebugControllerGetVerificationLogsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/bank-account-lifecycle-debug/{id}/verification-logs';
};

export type BankAccountLifecycleDebugControllerGetVerificationLogsResponses = {
    200: unknown;
};

export type BankAccountLifecycleDebugControllerGetStateTransitionsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/bank-account-lifecycle-debug/{id}/state-transitions';
};

export type BankAccountLifecycleDebugControllerGetStateTransitionsResponses = {
    200: unknown;
};

export type ValidationControllerVerifyBankIdentifiersData = {
    body: VerifyBankIdentifiersDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/validation/bank-identifiers';
};

export type ValidationControllerVerifyBankIdentifiersResponses = {
    default: VerifyBankIdentifiersRes;
};

export type ValidationControllerVerifyBankIdentifiersResponse = ValidationControllerVerifyBankIdentifiersResponses[keyof ValidationControllerVerifyBankIdentifiersResponses];

export type ValidationControllerValidateTinData = {
    body: ValidateTinDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/validation/tin';
};

export type ValidationControllerValidateTinResponses = {
    default: ValidateTinRes;
};

export type ValidationControllerValidateTinResponse = ValidationControllerValidateTinResponses[keyof ValidationControllerValidateTinResponses];

export type VestingControllerGetVestingTermsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term';
};

export type VestingControllerGetVestingTermsResponses = {
    default: Array<VestingTermRes>;
};

export type VestingControllerGetVestingTermsResponse = VestingControllerGetVestingTermsResponses[keyof VestingControllerGetVestingTermsResponses];

export type VestingControllerCreateVestingTermData = {
    body: CreateVestingTermDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term';
};

export type VestingControllerCreateVestingTermResponses = {
    default: VestingTermSimplifiedRes;
};

export type VestingControllerCreateVestingTermResponse = VestingControllerCreateVestingTermResponses[keyof VestingControllerCreateVestingTermResponses];

export type VestingControllerGetSimplifiedVestingTermsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/names';
};

export type VestingControllerGetSimplifiedVestingTermsResponses = {
    default: Array<VestingTermSimplifiedRes>;
};

export type VestingControllerGetSimplifiedVestingTermsResponse = VestingControllerGetSimplifiedVestingTermsResponses[keyof VestingControllerGetSimplifiedVestingTermsResponses];

export type VestingControllerApplyVestingStartDateToInvestmentWorkflowData = {
    body: ApplyVestingStartDateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/mip/vesting-term/vesting-start-investmentWorkflow/{investmentWorkflowId}';
};

export type VestingControllerApplyVestingStartDateToInvestmentWorkflowResponses = {
    201: unknown;
};

export type VestingControllerApplyVestingStartDateToTransactionData = {
    body: ApplyVestingStartDateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        transactionId: string;
    };
    query?: never;
    url: '/mip/vesting-term/vesting-start-transaction/{transactionId}';
};

export type VestingControllerApplyVestingStartDateToTransactionResponses = {
    201: unknown;
};

export type VestingControllerSaveTransactionVestingData = {
    body: SaveTransactionVestingDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        transactionId: string;
    };
    query?: never;
    url: '/mip/vesting-term/transaction/{transactionId}';
};

export type VestingControllerSaveTransactionVestingResponses = {
    200: unknown;
};

export type VestingControllerApplyVestingTermToInvestmentWorkflowData = {
    body: ApplyVestingTermDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/apply-to-investmentWorkflow';
};

export type VestingControllerApplyVestingTermToInvestmentWorkflowResponses = {
    201: unknown;
};

export type VestingControllerApplyVestingTermToTransactionData = {
    body: ApplyVestingTermToTransactionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/apply-to-transaction';
};

export type VestingControllerApplyVestingTermToTransactionResponses = {
    201: unknown;
};

export type VestingControllerRemoveVestingTermFromInvestmentWorkflowData = {
    body: RemoveVestingTermDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/remove-from-investmentWorkflow';
};

export type VestingControllerRemoveVestingTermFromInvestmentWorkflowResponses = {
    200: unknown;
};

export type VestingControllerRemoveVestingTermFromTransactionData = {
    body: RemoveVestingTermFromTransactionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/remove-from-transaction';
};

export type VestingControllerRemoveVestingTermFromTransactionResponses = {
    200: unknown;
};

export type VestingControllerBulkUpdateInvestorsVestingData = {
    body: BulkUpdateInvestorsVestingDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/investors/bulk-update';
};

export type VestingControllerBulkUpdateInvestorsVestingResponses = {
    201: unknown;
};

export type VestingControllerDeleteVestingTermData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/{id}';
};

export type VestingControllerDeleteVestingTermResponses = {
    200: unknown;
};

export type VestingControllerUpdateVestingTermData = {
    body: UpdateVestingTermDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/{id}';
};

export type VestingControllerUpdateVestingTermResponses = {
    default: VestingTermSimplifiedRes;
};

export type VestingControllerUpdateVestingTermResponse = VestingControllerUpdateVestingTermResponses[keyof VestingControllerUpdateVestingTermResponses];

export type VestingControllerCreateVestingTermGradedData = {
    body: CreateVestingTermGradedDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/graded';
};

export type VestingControllerCreateVestingTermGradedResponses = {
    default: VestingTermGradedRes;
};

export type VestingControllerCreateVestingTermGradedResponse = VestingControllerCreateVestingTermGradedResponses[keyof VestingControllerCreateVestingTermGradedResponses];

export type VestingControllerDeleteVestingTermGradedData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/graded/{id}';
};

export type VestingControllerDeleteVestingTermGradedResponses = {
    200: unknown;
};

export type VestingControllerUpdateVestingTermGradedData = {
    body: UpdateVestingTermGradedDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/graded/{id}';
};

export type VestingControllerUpdateVestingTermGradedResponses = {
    default: VestingTermGradedRes;
};

export type VestingControllerUpdateVestingTermGradedResponse = VestingControllerUpdateVestingTermGradedResponses[keyof VestingControllerUpdateVestingTermGradedResponses];

export type VestingControllerCreateVestingTermStraightLineData = {
    body: CreateVestingTermStraightLineDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/straight-line';
};

export type VestingControllerCreateVestingTermStraightLineResponses = {
    default: VestingTermStraightLineRes;
};

export type VestingControllerCreateVestingTermStraightLineResponse = VestingControllerCreateVestingTermStraightLineResponses[keyof VestingControllerCreateVestingTermStraightLineResponses];

export type VestingControllerDeleteVestingTermStraightLineData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/straight-line/{id}';
};

export type VestingControllerDeleteVestingTermStraightLineResponses = {
    200: unknown;
};

export type VestingControllerUpdateVestingTermStraightLineData = {
    body: UpdateVestingTermStraightLineDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/straight-line/{id}';
};

export type VestingControllerUpdateVestingTermStraightLineResponses = {
    default: VestingTermStraightLineRes;
};

export type VestingControllerUpdateVestingTermStraightLineResponse = VestingControllerUpdateVestingTermStraightLineResponses[keyof VestingControllerUpdateVestingTermStraightLineResponses];

export type VestingControllerCreateVestingTermLeaverProvisionData = {
    body: CreateVestingTermLeaverProvisionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/leaver-provision';
};

export type VestingControllerCreateVestingTermLeaverProvisionResponses = {
    default: VestingTermLeaverProvisionRes;
};

export type VestingControllerCreateVestingTermLeaverProvisionResponse = VestingControllerCreateVestingTermLeaverProvisionResponses[keyof VestingControllerCreateVestingTermLeaverProvisionResponses];

export type VestingControllerDeleteVestingTermLeaverProvisionData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/leaver-provision/{id}';
};

export type VestingControllerDeleteVestingTermLeaverProvisionResponses = {
    200: unknown;
};

export type VestingControllerUpdateVestingTermLeaverProvisionData = {
    body: UpdateVestingTermLeaverProvisionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/vesting-term/leaver-provision/{id}';
};

export type VestingControllerUpdateVestingTermLeaverProvisionResponses = {
    default: VestingTermLeaverProvisionRes;
};

export type VestingControllerUpdateVestingTermLeaverProvisionResponse = VestingControllerUpdateVestingTermLeaverProvisionResponses[keyof VestingControllerUpdateVestingTermLeaverProvisionResponses];

export type VestingControllerUpsertPerformanceVestingData = {
    body: UpsertPerformanceVestingDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/vesting-term/performance-vesting';
};

export type VestingControllerUpsertPerformanceVestingResponses = {
    default: PerformanceVestingTermRes;
};

export type VestingControllerUpsertPerformanceVestingResponse = VestingControllerUpsertPerformanceVestingResponses[keyof VestingControllerUpsertPerformanceVestingResponses];

export type VestingControllerDeletePerformanceVestingData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        performanceVestingTermId: string;
    };
    query?: never;
    url: '/mip/vesting-term/performance-vesting/{performanceVestingTermId}';
};

export type VestingControllerDeletePerformanceVestingResponses = {
    200: unknown;
};

export type BankAccountFormatRuleControllerGetSupportedCountriesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/bank-account/supported-countries';
};

export type BankAccountFormatRuleControllerGetSupportedCountriesResponses = {
    default: Array<BankAccountSupportedCountryRes>;
};

export type BankAccountFormatRuleControllerGetSupportedCountriesResponse = BankAccountFormatRuleControllerGetSupportedCountriesResponses[keyof BankAccountFormatRuleControllerGetSupportedCountriesResponses];

export type BankAccountFormatRuleControllerGetFormatRulesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        countryCode: string;
    };
    query?: never;
    url: '/bank-account/format-rules/{countryCode}';
};

export type BankAccountFormatRuleControllerGetFormatRulesResponses = {
    default: Array<BankAccountFormatRuleRes>;
};

export type BankAccountFormatRuleControllerGetFormatRulesResponse = BankAccountFormatRuleControllerGetFormatRulesResponses[keyof BankAccountFormatRuleControllerGetFormatRulesResponses];

export type OneSchemaControllerCreateOneSchemaTransactionsSessionData = {
    body: CreateOneSchemaTransactionsSessionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/transactions/create-one-schema-session';
};

export type OneSchemaControllerCreateOneSchemaTransactionsSessionResponses = {
    default: CreateOneSchemaSessionSuccessRes;
};

export type OneSchemaControllerCreateOneSchemaTransactionsSessionResponse = OneSchemaControllerCreateOneSchemaTransactionsSessionResponses[keyof OneSchemaControllerCreateOneSchemaTransactionsSessionResponses];

export type OneSchemaControllerValidateOneSchemaTransactionRowsData = {
    body: OneSchemaValidateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/transactions/validate-transactions-for-bulk-upload';
};

export type OneSchemaControllerValidateOneSchemaTransactionRowsResponses = {
    default: Array<OneSchemaInvalidRowRes>;
};

export type OneSchemaControllerValidateOneSchemaTransactionRowsResponse = OneSchemaControllerValidateOneSchemaTransactionRowsResponses[keyof OneSchemaControllerValidateOneSchemaTransactionRowsResponses];

export type OneSchemaControllerCreateOneSchemaPersonsSessionData = {
    body: CreateOneSchemaPersonSessionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/persons/create-one-schema-session';
};

export type OneSchemaControllerCreateOneSchemaPersonsSessionResponses = {
    default: CreateOneSchemaSessionSuccessRes;
};

export type OneSchemaControllerCreateOneSchemaPersonsSessionResponse = OneSchemaControllerCreateOneSchemaPersonsSessionResponses[keyof OneSchemaControllerCreateOneSchemaPersonsSessionResponses];

export type OneSchemaControllerValidateOneSchemaLegalPersonsRowsData = {
    body: OneSchemaValidateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/persons/validate-legal';
};

export type OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponses = {
    default: Array<OneSchemaInvalidRowRes>;
};

export type OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponse = OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponses[keyof OneSchemaControllerValidateOneSchemaLegalPersonsRowsResponses];

export type OneSchemaControllerValidateOneSchemaNaturalPersonsRowsData = {
    body: OneSchemaValidateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/persons/validate-natural';
};

export type OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponses = {
    default: Array<OneSchemaInvalidRowRes>;
};

export type OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponse = OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponses[keyof OneSchemaControllerValidateOneSchemaNaturalPersonsRowsResponses];

export type OneSchemaControllerPrepareOneSchemaManagementLoansCacheData = {
    body: PrepareOneSchemaManagementLoansCacheDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/management-loans/prepare-cache';
};

export type OneSchemaControllerPrepareOneSchemaManagementLoansCacheResponses = {
    201: unknown;
};

export type OneSchemaControllerValidateOneSchemaManagementLoansRowsData = {
    body: OneSchemaValidateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/management-loans/validate-management-loans-for-bulk-upload';
};

export type OneSchemaControllerValidateOneSchemaManagementLoansRowsResponses = {
    default: Array<OneSchemaInvalidRowRes>;
};

export type OneSchemaControllerValidateOneSchemaManagementLoansRowsResponse = OneSchemaControllerValidateOneSchemaManagementLoansRowsResponses[keyof OneSchemaControllerValidateOneSchemaManagementLoansRowsResponses];

export type OneSchemaControllerPrepareOneSchemaShareAssociationsCacheData = {
    body: PrepareOneSchemaShareAssociationsCacheDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/investment-allocations/prepare-cache';
};

export type OneSchemaControllerPrepareOneSchemaShareAssociationsCacheResponses = {
    201: unknown;
};

export type OneSchemaControllerValidateOneSchemaShareAssociationRowsData = {
    body: OneSchemaValidateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/one-schema/investment-allocations/validate-investment-allocations-for-bulk-upload';
};

export type OneSchemaControllerValidateOneSchemaShareAssociationRowsResponses = {
    default: Array<OneSchemaInvalidRowRes>;
};

export type OneSchemaControllerValidateOneSchemaShareAssociationRowsResponse = OneSchemaControllerValidateOneSchemaShareAssociationRowsResponses[keyof OneSchemaControllerValidateOneSchemaShareAssociationRowsResponses];

export type FileControllerCreateFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/file';
};

export type FileControllerCreateFileResponses = {
    default: DataFileTct;
};

export type FileControllerCreateFileResponse = FileControllerCreateFileResponses[keyof FileControllerCreateFileResponses];

export type FileControllerDownloadFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/file/{id}';
};

export type FileControllerDownloadFileResponses = {
    /**
     * Returns requested file
     */
    default: unknown;
};

export type FileControllerDownloadPreSignedUrlData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/file/{id}/deal/{dealId}/download-pre-signed-url';
};

export type FileControllerDownloadPreSignedUrlResponses = {
    /**
     * Returns requested file url
     */
    default: unknown;
};

export type FileControllerBulkDownloadFilesData = {
    body: BulkDownloadFilesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/file/bulk-download';
};

export type FileControllerBulkDownloadFilesResponses = {
    /**
     * Returns zip archive with files
     */
    default: unknown;
};

export type FileControllerGetFileDownloadUrlData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        s3Key: string;
    };
    query: {
        fileName: string;
    };
    url: '/file/export/{s3Key}';
};

export type FileControllerGetFileDownloadUrlResponses = {
    200: unknown;
};

export type FileControllerCreateSignatureFileData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/file/signature-file';
};

export type FileControllerCreateSignatureFileResponses = {
    default: DataFileTct;
};

export type FileControllerCreateSignatureFileResponse = FileControllerCreateSignatureFileResponses[keyof FileControllerCreateSignatureFileResponses];

export type GodmodeControllerPostReassignInvestorData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/reasignInvestor';
};

export type GodmodeControllerPostReassignInvestorResponses = {
    /**
     * Revoke requested InvestmentWorkflow
     */
    default: unknown;
};

export type GodmodeControllerGetAllInvestorsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        searchQuery: string;
        limit: string;
    };
    url: '/godmode/users/all';
};

export type GodmodeControllerGetAllInvestorsResponses = {
    200: unknown;
};

export type GodmodeControllerGetActiveMipsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/mips/active';
};

export type GodmodeControllerGetActiveMipsResponses = {
    default: Array<DataSimpleMipTct>;
};

export type GodmodeControllerGetActiveMipsResponse = GodmodeControllerGetActiveMipsResponses[keyof GodmodeControllerGetActiveMipsResponses];

export type GodmodeControllerDownloadFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/file/{id}';
};

export type GodmodeControllerDownloadFileResponses = {
    /**
     * Returns requested file
     */
    default: unknown;
};

export type GodmodeControllerPostRevokeTsaData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/godmode/revoke/{investmentWorkflowId}';
};

export type GodmodeControllerPostRevokeTsaResponses = {
    /**
     * Revoke requested InvestmentWorkflow
     */
    default: unknown;
};

export type GodmodeControllerPostSoftDeleteTsaData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/godmode/soft-delete-investmentWorkflow/{investmentWorkflowId}';
};

export type GodmodeControllerPostSoftDeleteTsaResponses = {
    /**
     * Soft delete requested InvestmentWorkflow
     */
    default: unknown;
};

export type GodmodeControllerPostRemoveInvestorData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/godmode/remove-investor/{investorId}';
};

export type GodmodeControllerPostRemoveInvestorResponses = {
    /**
     * Remove investor
     */
    default: unknown;
};

export type GodmodeControllerDeleteUserSoftData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/user/{userId}/soft';
};

export type GodmodeControllerDeleteUserSoftResponses = {
    /**
     * Soft delete user and change his email
     */
    default: unknown;
};

export type GodmodeControllerReplaceFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fileId: string;
    };
    query?: never;
    url: '/godmode/file/{fileId}/replace';
};

export type GodmodeControllerReplaceFileResponses = {
    201: unknown;
};

export type GodmodeControllerIsAnyActiveInvestorInMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/is-any-investor-active';
};

export type GodmodeControllerIsAnyActiveInvestorInMipResponses = {
    default: DataIsAnyInvestorActiveInMipTct;
};

export type GodmodeControllerIsAnyActiveInvestorInMipResponse = GodmodeControllerIsAnyActiveInvestorInMipResponses[keyof GodmodeControllerIsAnyActiveInvestorInMipResponses];

export type GodmodeControllerIsAnyInvitedInvestorInMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/is-any-investor-invited';
};

export type GodmodeControllerIsAnyInvitedInvestorInMipResponses = {
    default: DataIsAnyInvitedInvestorInMipTct;
};

export type GodmodeControllerIsAnyInvitedInvestorInMipResponse = GodmodeControllerIsAnyInvitedInvestorInMipResponses[keyof GodmodeControllerIsAnyInvitedInvestorInMipResponses];

export type GodmodeControllerGetFileInfoData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/file/{id}/info';
};

export type GodmodeControllerGetFileInfoResponses = {
    200: unknown;
};

export type GodmodeControllerGetAllInvestorDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/investor/{userId}';
};

export type GodmodeControllerGetAllInvestorDataResponses = {
    default: Array<DataUserTct>;
};

export type GodmodeControllerGetAllInvestorDataResponse = GodmodeControllerGetAllInvestorDataResponses[keyof GodmodeControllerGetAllInvestorDataResponses];

export type GodmodeControllerUpdateInvestorPersonalDetailsData = {
    body: UpdateInvestorPersonalDetailsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/investor/{userId}';
};

export type GodmodeControllerUpdateInvestorPersonalDetailsResponses = {
    200: unknown;
};

export type GodmodeControllerGetAllInvestorsForMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/investors';
};

export type GodmodeControllerGetAllInvestorsForMipResponses = {
    default: Array<DataUserTct>;
};

export type GodmodeControllerGetAllInvestorsForMipResponse = GodmodeControllerGetAllInvestorsForMipResponses[keyof GodmodeControllerGetAllInvestorsForMipResponses];

export type GodmodeControllerGetUserDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/user/{userId}';
};

export type GodmodeControllerGetUserDataResponses = {
    default: Array<DataUserTct>;
};

export type GodmodeControllerGetUserDataResponse = GodmodeControllerGetUserDataResponses[keyof GodmodeControllerGetUserDataResponses];

export type GodmodeControllerGetMipDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}';
};

export type GodmodeControllerGetMipDataResponses = {
    default: DataSimpleMipTct;
};

export type GodmodeControllerGetMipDataResponse = GodmodeControllerGetMipDataResponses[keyof GodmodeControllerGetMipDataResponses];

export type GodmodeControllerGetInvestorsFromMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query: {
        search: string;
    };
    url: '/godmode/mip/{mipId}/investors-investmentWorkflow';
};

export type GodmodeControllerGetInvestorsFromMipResponses = {
    default: Array<InvestorWithInvestmentWorkflowRes>;
};

export type GodmodeControllerGetInvestorsFromMipResponse = GodmodeControllerGetInvestorsFromMipResponses[keyof GodmodeControllerGetInvestorsFromMipResponses];

export type GodmodeControllerGetMipCustomDetailsDataWithoutFormsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/custom-details-without-form/{mipId}';
};

export type GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponses = {
    default: Array<DataCustomDetailWithoutFormTct>;
};

export type GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponse = GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponses[keyof GodmodeControllerGetMipCustomDetailsDataWithoutFormsResponses];

export type GodmodeControllerGetInvestorPersonalDetailsDataByUserIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/investor/{userId}/personal-details';
};

export type GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponses = {
    default: GetInvestorPersonalInformationRes;
};

export type GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponse = GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponses[keyof GodmodeControllerGetInvestorPersonalDetailsDataByUserIdResponses];

export type GodmodeControllerRemoveInvestorPersonalDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/investor-personal-details/{userId}';
};

export type GodmodeControllerRemoveInvestorPersonalDetailsResponses = {
    200: unknown;
};

export type GodmodeControllerUpdateCustomDetailTypeData = {
    body: UpdateCustomDetailTypeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        customDetailId: string;
    };
    query?: never;
    url: '/godmode/update-custom-detail-type/{customDetailId}';
};

export type GodmodeControllerUpdateCustomDetailTypeResponses = {
    200: unknown;
};

export type GodmodeControllerGetAllNotDeletedProjectsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/projects';
};

export type GodmodeControllerGetAllNotDeletedProjectsResponses = {
    default: Array<DealBasicDataTct>;
};

export type GodmodeControllerGetAllNotDeletedProjectsResponse = GodmodeControllerGetAllNotDeletedProjectsResponses[keyof GodmodeControllerGetAllNotDeletedProjectsResponses];

export type GodmodeControllerGetDealsListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/deals';
};

export type GodmodeControllerGetDealsListResponses = {
    default: Array<SummaryDealTct>;
};

export type GodmodeControllerGetDealsListResponse = GodmodeControllerGetDealsListResponses[keyof GodmodeControllerGetDealsListResponses];

export type GodmodeControllerGetDealData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/deals/{mipId}';
};

export type GodmodeControllerGetDealResponses = {
    default: SummaryDealTct;
};

export type GodmodeControllerGetDealResponse = GodmodeControllerGetDealResponses[keyof GodmodeControllerGetDealResponses];

export type GodmodeControllerChangeDealData = {
    body: ChangeDealDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/deals/{mipId}';
};

export type GodmodeControllerChangeDealResponses = {
    200: unknown;
};

export type GodmodeControllerUpdateUserNameData = {
    body: UpdateUserNameDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/update-user-name/{userId}';
};

export type GodmodeControllerUpdateUserNameResponses = {
    200: unknown;
};

export type GodmodeControllerUpdateUserEmailData = {
    body: UpdateUserEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/godmode/update-user-email/{userId}';
};

export type GodmodeControllerUpdateUserEmailResponses = {
    200: unknown;
};

export type GodmodeControllerUnArchiveDealAndMipsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/godmode/deal/{dealId}/deal-draft-mips';
};

export type GodmodeControllerUnArchiveDealAndMipsResponses = {
    200: unknown;
};

export type GodmodeControllerSoftDeleteMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/mip-investors';
};

export type GodmodeControllerSoftDeleteMipResponses = {
    200: unknown;
};

export type GodmodeControllerUpdateMipKycOptionalData = {
    body: UpdateMipIsKycRequiredDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/kyc-required';
};

export type GodmodeControllerUpdateMipKycOptionalResponses = {
    200: unknown;
};

export type GodmodeControllerUpdateIsLockedData = {
    body: UpdateMipIsLockedDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/locked';
};

export type GodmodeControllerUpdateIsLockedResponses = {
    200: unknown;
};

export type GodmodeControllerGetMipListOfInvestmentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/investments';
};

export type GodmodeControllerGetMipListOfInvestmentsResponses = {
    200: unknown;
};

export type GodmodeControllerPostBulkEditMipInvestmentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/investments/edit/bulk';
};

export type GodmodeControllerPostBulkEditMipInvestmentsResponses = {
    default: Array<string>;
};

export type GodmodeControllerPostBulkEditMipInvestmentsResponse = GodmodeControllerPostBulkEditMipInvestmentsResponses[keyof GodmodeControllerPostBulkEditMipInvestmentsResponses];

export type GodmodeControllerUpdateDealMipsInvestorsDeletedData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/godmode/deal/{dealId}/deal-mips-investors';
};

export type GodmodeControllerUpdateDealMipsInvestorsDeletedResponses = {
    200: unknown;
};

export type GodmodeControllerGetDealWithActiveMipsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/godmode/deal/{dealId}';
};

export type GodmodeControllerGetDealWithActiveMipsResponses = {
    default: DealEntity;
};

export type GodmodeControllerGetDealWithActiveMipsResponse = GodmodeControllerGetDealWithActiveMipsResponses[keyof GodmodeControllerGetDealWithActiveMipsResponses];

export type GodmodeControllerGetInvestmentWorkflowsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/godmode/transaction-share-association/{investmentWorkflowId}';
};

export type GodmodeControllerGetInvestmentWorkflowsResponses = {
    default: Array<GetInvestorShareAssociationsDataRes>;
};

export type GodmodeControllerGetInvestmentWorkflowsResponse = GodmodeControllerGetInvestmentWorkflowsResponses[keyof GodmodeControllerGetInvestmentWorkflowsResponses];

export type GodmodeControllerUpdateShareAssociationsData = {
    body: UpdateShareAssociationsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/share-association';
};

export type GodmodeControllerUpdateShareAssociationsResponses = {
    200: unknown;
};

export type GodmodeControllerUploadPdfFileData = {
    body: UploadFileDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/file';
};

export type GodmodeControllerUploadPdfFileResponses = {
    default: DataFileTct;
};

export type GodmodeControllerUploadPdfFileResponse = GodmodeControllerUploadPdfFileResponses[keyof GodmodeControllerUploadPdfFileResponses];

export type GodmodeControllerGetMipListOfLoansData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/loans';
};

export type GodmodeControllerGetMipListOfLoansResponses = {
    default: DataLoanDefinitionWithLoansTct;
};

export type GodmodeControllerGetMipListOfLoansResponse = GodmodeControllerGetMipListOfLoansResponses[keyof GodmodeControllerGetMipListOfLoansResponses];

export type GodmodeControllerPostBulkUpdateMipLoansData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/loans/edit/bulk';
};

export type GodmodeControllerPostBulkUpdateMipLoansResponses = {
    201: unknown;
};

export type GodmodeControllerBulkCreateTsaForMipData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/investments/bulk-create';
};

export type GodmodeControllerBulkCreateTsaForMipResponses = {
    201: unknown;
};

export type GodmodeControllerCreateCustomDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/godmode/mip/{mipId}/custom-details';
};

export type GodmodeControllerCreateCustomDetailsResponses = {
    201: unknown;
};

export type GodmodeControllerSoftDeleteKycFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        kycFileId: string;
    };
    query?: never;
    url: '/godmode/kyc-file/{kycFileId}';
};

export type GodmodeControllerSoftDeleteKycFileResponses = {
    200: unknown;
};

export type WorkOsEventsAdminControllerListWorkOsEventsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        status?: WorkOsEventStatus;
        type?: string;
        take?: number;
        skip?: number;
    };
    url: '/godmode/workos-events';
};

export type WorkOsEventsAdminControllerListWorkOsEventsResponses = {
    default: WorkOsEventListRes;
};

export type WorkOsEventsAdminControllerListWorkOsEventsResponse = WorkOsEventsAdminControllerListWorkOsEventsResponses[keyof WorkOsEventsAdminControllerListWorkOsEventsResponses];

export type WorkOsEventsAdminControllerReplayWorkOsEventData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/workos-events/{id}/replay';
};

export type WorkOsEventsAdminControllerReplayWorkOsEventResponses = {
    default: WorkOsEventRes;
};

export type WorkOsEventsAdminControllerReplayWorkOsEventResponse = WorkOsEventsAdminControllerReplayWorkOsEventResponses[keyof WorkOsEventsAdminControllerReplayWorkOsEventResponses];

export type EmailChangeEligibilityControllerGetEmailChangeEligibilityData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: {
        targetEmail?: string;
    };
    url: '/godmode/user/{userId}/email-change-eligibility';
};

export type EmailChangeEligibilityControllerGetEmailChangeEligibilityResponses = {
    default: EmailChangeEligibilityRes;
};

export type EmailChangeEligibilityControllerGetEmailChangeEligibilityResponse = EmailChangeEligibilityControllerGetEmailChangeEligibilityResponses[keyof EmailChangeEligibilityControllerGetEmailChangeEligibilityResponses];

export type ContractControllerGetContractAndDocumentWorkflowFileNamesData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        cursor?: string;
        limit?: string;
        search?: string;
    };
    url: '/mip/contract/names-filtering';
};

export type ContractControllerGetContractAndDocumentWorkflowFileNamesResponses = {
    default: GetContractAndDocumentWorkflowFileNamesRes;
};

export type ContractControllerGetContractAndDocumentWorkflowFileNamesResponse = ContractControllerGetContractAndDocumentWorkflowFileNamesResponses[keyof ContractControllerGetContractAndDocumentWorkflowFileNamesResponses];

export type ContractDraftControllerGetContractsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/contract-draft';
};

export type ContractDraftControllerGetContractsResponses = {
    default: Array<DataContractTct>;
};

export type ContractDraftControllerGetContractsResponse = ContractDraftControllerGetContractsResponses[keyof ContractDraftControllerGetContractsResponses];

export type ContractDraftControllerCreateContractData = {
    body: CreateContractDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/contract-draft';
};

export type ContractDraftControllerCreateContractResponses = {
    default: DataContractTct;
};

export type ContractDraftControllerCreateContractResponse = ContractDraftControllerCreateContractResponses[keyof ContractDraftControllerCreateContractResponses];

export type ContractDraftControllerDeleteContractData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/contract-draft/{id}';
};

export type ContractDraftControllerDeleteContractResponses = {
    200: unknown;
};

export type ContractDraftControllerUpdateContractData = {
    body: CreateContractDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/contract-draft/{id}';
};

export type ContractDraftControllerUpdateContractResponses = {
    default: DataContractTct;
};

export type ContractDraftControllerUpdateContractResponse = ContractDraftControllerUpdateContractResponses[keyof ContractDraftControllerUpdateContractResponses];

export type DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: {
        /**
         * Filter by flow: INVESTMENT_WORKFLOWS_BUYING (joiner/allocation) or INVESTMENT_WORKFLOWS_SELLING (leaver). Defaults to INVESTMENT_WORKFLOWS_BUYING.
         */
        visibleIn?: Array<DocumentWorkflowTemplateVisibleIn>;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/draft-templates';
};

export type DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponses = {
    default: Array<DataContractTct>;
};

export type DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponse = DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponses[keyof DocumentWorkflowDraftInvestmentControllerGetDraftTemplatesResponses];

export type DocumentWorkflowControllerStreamProgrammeDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/stream';
};

export type DocumentWorkflowControllerStreamProgrammeDocumentsResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: {
        pagination?: PaginationDto;
        sortBy?: BaseSortByDto;
        fieldFilter?: InvestmentProgrammeDocumentsFieldFilterQueryDto;
        quickFilters?: BaseQuickFiltersDto;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/list';
};

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponses = {
    default: InvestmentProgrammeDocumentsRes;
};

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponse = DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponses[keyof DocumentWorkflowControllerFindInvestmentProgrammeDocumentsResponses];

export type DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/signing-roles';
};

export type DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponses = {
    default: InvestmentProgrammeSigningRolesRes;
};

export type DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponse = DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponses[keyof DocumentWorkflowControllerFindInvestmentProgrammeSigningRolesResponses];

export type DocumentWorkflowControllerBulkExportToExcelData = {
    /**
     * Bulk download/export to excel dto
     */
    body: BulkDownloadFileDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: {
        pagination?: PaginationDto;
        sortBy?: BaseSortByDto;
        fieldFilter?: InvestmentProgrammeDocumentsFieldFilterQueryDto;
        quickFilters?: BaseQuickFiltersDto;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-export-to-excel';
};

export type DocumentWorkflowControllerBulkExportToExcelResponses = {
    default: string;
};

export type DocumentWorkflowControllerBulkExportToExcelResponse = DocumentWorkflowControllerBulkExportToExcelResponses[keyof DocumentWorkflowControllerBulkExportToExcelResponses];

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}';
};

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponses = {
    default: InvestmentProgrammeDocumentDetailsRes;
};

export type DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponse = DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponses[keyof DocumentWorkflowControllerFindInvestmentProgrammeDocumentResponses];

export type DocumentWorkflowControllerFindDocumentWorkflowEventsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/events';
};

export type DocumentWorkflowControllerFindDocumentWorkflowEventsResponses = {
    default: Array<DocumentWorkflowEventLogEntity>;
};

export type DocumentWorkflowControllerFindDocumentWorkflowEventsResponse = DocumentWorkflowControllerFindDocumentWorkflowEventsResponses[keyof DocumentWorkflowControllerFindDocumentWorkflowEventsResponses];

export type DocumentWorkflowControllerReplaceDocumentFileData = {
    body: ReplaceDocumentFileDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/replace-file';
};

export type DocumentWorkflowControllerReplaceDocumentFileResponses = {
    204: void;
};

export type DocumentWorkflowControllerReplaceDocumentFileResponse = DocumentWorkflowControllerReplaceDocumentFileResponses[keyof DocumentWorkflowControllerReplaceDocumentFileResponses];

export type DocumentWorkflowControllerCloseDocumentWithoutSignatureData = {
    body: CloseDocumentWithoutSignatureDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/close-without-signature';
};

export type DocumentWorkflowControllerCloseDocumentWithoutSignatureResponses = {
    204: void;
};

export type DocumentWorkflowControllerCloseDocumentWithoutSignatureResponse = DocumentWorkflowControllerCloseDocumentWithoutSignatureResponses[keyof DocumentWorkflowControllerCloseDocumentWithoutSignatureResponses];

export type DocumentWorkflowControllerAssignUserToSignerData = {
    body: AssignSignerDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/assign';
};

export type DocumentWorkflowControllerAssignUserToSignerResponses = {
    default: InvestmentProgrammeDocumentDetailsRes;
};

export type DocumentWorkflowControllerAssignUserToSignerResponse = DocumentWorkflowControllerAssignUserToSignerResponses[keyof DocumentWorkflowControllerAssignUserToSignerResponses];

export type DocumentWorkflowControllerUnassignUserFromSignerData = {
    body: UnassignSignerDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/unassign';
};

export type DocumentWorkflowControllerUnassignUserFromSignerResponses = {
    default: InvestmentProgrammeDocumentDetailsRes;
};

export type DocumentWorkflowControllerUnassignUserFromSignerResponse = DocumentWorkflowControllerUnassignUserFromSignerResponses[keyof DocumentWorkflowControllerUnassignUserFromSignerResponses];

export type DocumentWorkflowControllerGetAddInvestorEligibilityData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-investor-eligibility';
};

export type DocumentWorkflowControllerGetAddInvestorEligibilityResponses = {
    default: AddInvestorEligibilityRes;
};

export type DocumentWorkflowControllerGetAddInvestorEligibilityResponse = DocumentWorkflowControllerGetAddInvestorEligibilityResponses[keyof DocumentWorkflowControllerGetAddInvestorEligibilityResponses];

export type DocumentWorkflowControllerAddInvestorsData = {
    body: AddInvestorsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-investors';
};

export type DocumentWorkflowControllerAddInvestorsResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerGetAddCounterpartyEligibilityData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-counterparty-eligibility';
};

export type DocumentWorkflowControllerGetAddCounterpartyEligibilityResponses = {
    default: AddCounterpartyEligibilityRes;
};

export type DocumentWorkflowControllerGetAddCounterpartyEligibilityResponse = DocumentWorkflowControllerGetAddCounterpartyEligibilityResponses[keyof DocumentWorkflowControllerGetAddCounterpartyEligibilityResponses];

export type DocumentWorkflowControllerAddCounterpartyData = {
    body: AddCounterpartyDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/add-counterparty';
};

export type DocumentWorkflowControllerAddCounterpartyResponses = {
    default: AddCounterpartyRes;
};

export type DocumentWorkflowControllerAddCounterpartyResponse = DocumentWorkflowControllerAddCounterpartyResponses[keyof DocumentWorkflowControllerAddCounterpartyResponses];

export type DocumentWorkflowControllerRemoveSignerData = {
    body: RemoveSignerDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/remove-signer';
};

export type DocumentWorkflowControllerRemoveSignerResponses = {
    204: void;
};

export type DocumentWorkflowControllerRemoveSignerResponse = DocumentWorkflowControllerRemoveSignerResponses[keyof DocumentWorkflowControllerRemoveSignerResponses];

export type DocumentWorkflowControllerSignWetInkDocumentUploadData = {
    body: SignWetInkDocumentUploadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/sign-wet-ink-upload';
};

export type DocumentWorkflowControllerSignWetInkDocumentUploadResponses = {
    default: GetPreSignedUrl;
};

export type DocumentWorkflowControllerSignWetInkDocumentUploadResponse = DocumentWorkflowControllerSignWetInkDocumentUploadResponses[keyof DocumentWorkflowControllerSignWetInkDocumentUploadResponses];

export type DocumentWorkflowControllerSignWetInkDocumentData = {
    body: SignWetInkDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/sign-wet-ink/{signingRoleType}';
};

export type DocumentWorkflowControllerSignWetInkDocumentResponses = {
    201: unknown;
};

export type DocumentWorkflowControllerClaimSignerData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
        signerId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/signer/{signerId}/claim';
};

export type DocumentWorkflowControllerClaimSignerResponses = {
    201: unknown;
};

export type DocumentWorkflowControllerSubmitFormUploadData = {
    body: SubmitFormUploadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submit-form-upload';
};

export type DocumentWorkflowControllerSubmitFormUploadResponses = {
    default: GetPreSignedUrl;
};

export type DocumentWorkflowControllerSubmitFormUploadResponse = DocumentWorkflowControllerSubmitFormUploadResponses[keyof DocumentWorkflowControllerSubmitFormUploadResponses];

export type DocumentWorkflowControllerSubmitFormData = {
    body: SubmitFormDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submit-form';
};

export type DocumentWorkflowControllerSubmitFormResponses = {
    201: unknown;
};

export type DocumentWorkflowControllerRemoveSubmittedFormData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
        programmeId: string;
    };
    query: {
        investorId: string;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/submitted-form';
};

export type DocumentWorkflowControllerRemoveSubmittedFormResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerBulkDownloadFilesData = {
    /**
     * Bulk download files dto
     */
    body: BulkDownloadFileDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-download';
};

export type DocumentWorkflowControllerBulkDownloadFilesResponses = {
    /**
     * Response when zip file is ready for download or being generated in the background
     */
    200: BulkDownloadFileSyncRes | BulkDownloadFileAsyncRes;
};

export type DocumentWorkflowControllerBulkDownloadFilesResponse = DocumentWorkflowControllerBulkDownloadFilesResponses[keyof DocumentWorkflowControllerBulkDownloadFilesResponses];

export type DocumentWorkflowControllerBulkRevokeSimpleDocumentsData = {
    /**
     * Bulk revoke documents dto
     */
    body: BulkRevokeDocumentsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-revoke';
};

export type DocumentWorkflowControllerBulkRevokeSimpleDocumentsResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerBulkReissueDocumentsData = {
    /**
     * Bulk reissue documents dto
     */
    body: BulkReissueDocumentsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-reissue';
};

export type DocumentWorkflowControllerBulkReissueDocumentsResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerBulkAssignCounterpartiesPreviewData = {
    /**
     * Bulk assign counterparties preview dto
     */
    body: BulkAssignCounterpartiesPreviewDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparties-preview';
};

export type DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponses = {
    default: BulkAssignCounterpartiesPreviewRes;
};

export type DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponse = DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponses[keyof DocumentWorkflowControllerBulkAssignCounterpartiesPreviewResponses];

export type DocumentWorkflowControllerBulkAssignCounterpartyData = {
    /**
     * Bulk assign counterparty dto
     */
    body: BulkAssignCounterpartyDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparty';
};

export type DocumentWorkflowControllerBulkAssignCounterpartyResponses = {
    default: StartBulkAssignCounterpartyRes;
};

export type DocumentWorkflowControllerBulkAssignCounterpartyResponse = DocumentWorkflowControllerBulkAssignCounterpartyResponses[keyof DocumentWorkflowControllerBulkAssignCounterpartyResponses];

export type DocumentWorkflowControllerBulkAssignCounterpartyStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-assign-counterparty-status/{jobId}';
};

export type DocumentWorkflowControllerBulkAssignCounterpartyStatusResponses = {
    default: BulkAssignCounterpartyJobStatusRes;
};

export type DocumentWorkflowControllerBulkAssignCounterpartyStatusResponse = DocumentWorkflowControllerBulkAssignCounterpartyStatusResponses[keyof DocumentWorkflowControllerBulkAssignCounterpartyStatusResponses];

export type DocumentWorkflowControllerBulkAddCounterpartyPreviewData = {
    /**
     * Bulk add counterparty preview dto
     */
    body: BulkAddCounterpartyPreviewDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty-preview';
};

export type DocumentWorkflowControllerBulkAddCounterpartyPreviewResponses = {
    default: BulkAddCounterpartyPreviewRes;
};

export type DocumentWorkflowControllerBulkAddCounterpartyPreviewResponse = DocumentWorkflowControllerBulkAddCounterpartyPreviewResponses[keyof DocumentWorkflowControllerBulkAddCounterpartyPreviewResponses];

export type DocumentWorkflowControllerBulkAddCounterpartyData = {
    /**
     * Bulk add counterparty dto
     */
    body: BulkAddCounterpartyDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty';
};

export type DocumentWorkflowControllerBulkAddCounterpartyResponses = {
    default: StartBulkAddCounterpartyRes;
};

export type DocumentWorkflowControllerBulkAddCounterpartyResponse = DocumentWorkflowControllerBulkAddCounterpartyResponses[keyof DocumentWorkflowControllerBulkAddCounterpartyResponses];

export type DocumentWorkflowControllerBulkAddCounterpartyStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-add-counterparty-status/{jobId}';
};

export type DocumentWorkflowControllerBulkAddCounterpartyStatusResponses = {
    default: BulkAddCounterpartyJobStatusRes;
};

export type DocumentWorkflowControllerBulkAddCounterpartyStatusResponse = DocumentWorkflowControllerBulkAddCounterpartyStatusResponses[keyof DocumentWorkflowControllerBulkAddCounterpartyStatusResponses];

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewData = {
    body: BulkInviteAuthorisedSignatoriesPreviewDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-invite-authorised-signatories-preview';
};

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponses = {
    default: BulkInviteAuthorisedSignatoriesPreviewRes;
};

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponse = DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponses[keyof DocumentWorkflowControllerBulkInviteAuthorisedSignatoriesPreviewResponses];

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoryData = {
    body: BulkInviteAuthorisedSignatoryDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-invite-authorised-signatory';
};

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponses = {
    default: BulkInviteAuthorisedSignatoryRes;
};

export type DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponse = DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponses[keyof DocumentWorkflowControllerBulkInviteAuthorisedSignatoryResponses];

export type DocumentWorkflowControllerBulkRemindSignersData = {
    /**
     * Bulk remind signers dto
     */
    body: BulkRemindSignersDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-remind-signers';
};

export type DocumentWorkflowControllerBulkRemindSignersResponses = {
    default: StartBulkRemindSignersRes;
};

export type DocumentWorkflowControllerBulkRemindSignersResponse = DocumentWorkflowControllerBulkRemindSignersResponses[keyof DocumentWorkflowControllerBulkRemindSignersResponses];

export type DocumentWorkflowControllerBulkRemindSignersStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
        programmeId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-remind-signers-status/{jobId}';
};

export type DocumentWorkflowControllerBulkRemindSignersStatusResponses = {
    default: BulkRemindSignersJobStatusRes;
};

export type DocumentWorkflowControllerBulkRemindSignersStatusResponse = DocumentWorkflowControllerBulkRemindSignersStatusResponses[keyof DocumentWorkflowControllerBulkRemindSignersStatusResponses];

export type DocumentWorkflowControllerBulkApplyDateData = {
    /**
     * Bulk apply date dto
     */
    body: BulkApplyDateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-apply-date';
};

export type DocumentWorkflowControllerBulkApplyDateResponses = {
    default: StartBulkApplyDateRes;
};

export type DocumentWorkflowControllerBulkApplyDateResponse = DocumentWorkflowControllerBulkApplyDateResponses[keyof DocumentWorkflowControllerBulkApplyDateResponses];

export type DocumentWorkflowControllerBulkApplyDateStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        jobId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-apply-date-status/{jobId}';
};

export type DocumentWorkflowControllerBulkApplyDateStatusResponses = {
    default: BulkApplyDateJobStatusRes;
};

export type DocumentWorkflowControllerBulkApplyDateStatusResponse = DocumentWorkflowControllerBulkApplyDateStatusResponses[keyof DocumentWorkflowControllerBulkApplyDateStatusResponses];

export type DocumentWorkflowControllerBulkClaimOnBehalfPreviewData = {
    body: BulkClaimOnBehalfPreviewDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-on-behalf-preview';
};

export type DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponses = {
    default: BulkClaimOnBehalfPreviewRes;
};

export type DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponse = DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponses[keyof DocumentWorkflowControllerBulkClaimOnBehalfPreviewResponses];

export type DocumentWorkflowControllerBulkClaimOnBehalfData = {
    body: BulkClaimOnBehalfDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-on-behalf';
};

export type DocumentWorkflowControllerBulkClaimOnBehalfResponses = {
    default: BulkClaimOnBehalfRes;
};

export type DocumentWorkflowControllerBulkClaimOnBehalfResponse = DocumentWorkflowControllerBulkClaimOnBehalfResponses[keyof DocumentWorkflowControllerBulkClaimOnBehalfResponses];

export type DocumentWorkflowControllerBulkClaimGenerationStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
        programmeId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/bulk-claim-generation-status/{jobId}';
};

export type DocumentWorkflowControllerBulkClaimGenerationStatusResponses = {
    default: BulkClaimGenerationJobStatusRes;
};

export type DocumentWorkflowControllerBulkClaimGenerationStatusResponse = DocumentWorkflowControllerBulkClaimGenerationStatusResponses[keyof DocumentWorkflowControllerBulkClaimGenerationStatusResponses];

export type DocumentWorkflowControllerEidEasyPrepareData = {
    body: EidEasyPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/eid-easy/prepare';
};

export type DocumentWorkflowControllerEidEasyPrepareResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerEidEasyCompleteData = {
    body: EidEasyCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/eid-easy/complete';
};

export type DocumentWorkflowControllerEidEasyCompleteResponses = {
    200: EidEasyCompleteRes;
};

export type DocumentWorkflowControllerEidEasyCompleteResponse = DocumentWorkflowControllerEidEasyCompleteResponses[keyof DocumentWorkflowControllerEidEasyCompleteResponses];

export type DocumentWorkflowControllerApplyDatePrepareData = {
    body: ApplyDatePrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/apply-date/prepare';
};

export type DocumentWorkflowControllerApplyDatePrepareResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerApplyDateCompleteData = {
    body: ApplyDateCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/apply-date/complete';
};

export type DocumentWorkflowControllerApplyDateCompleteResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerBulkSetSignerRequiresWitnessData = {
    body: BulkSetSignerRequiresWitnessDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        instanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/by-role';
};

export type DocumentWorkflowControllerBulkSetSignerRequiresWitnessResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerBulkSetSignerSecurityLevelData = {
    body: BulkSetSignerSecurityLevelDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        instanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/by-role/security-level';
};

export type DocumentWorkflowControllerBulkSetSignerSecurityLevelResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerSetSignerRequiresWitnessData = {
    body: SetSignerRequiresWitnessDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        instanceId: string;
        signerId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/{signerId}/requires-witness';
};

export type DocumentWorkflowControllerSetSignerRequiresWitnessResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerSetSignerSecurityLevelData = {
    body: SetSignerSecurityLevelDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        instanceId: string;
        signerId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/document-workflow-instances/{instanceId}/signers/{signerId}/security-level';
};

export type DocumentWorkflowControllerSetSignerSecurityLevelResponses = {
    200: unknown;
};

export type DocumentWorkflowControllerInviteWitnessData = {
    body: InviteWitnessDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-witness';
};

export type DocumentWorkflowControllerInviteWitnessResponses = {
    /**
     * Witness invitation sent
     */
    200: unknown;
};

export type DocumentWorkflowControllerInviteRepresentativeData = {
    body: InviteRepresentativeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-representative';
};

export type DocumentWorkflowControllerInviteRepresentativeResponses = {
    /**
     * Representative invitation sent
     */
    200: unknown;
};

export type DocumentWorkflowControllerInviteAuthorisedSignatoryData = {
    body: InviteAuthorisedSignatoryDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/invite-authorised-signatory';
};

export type DocumentWorkflowControllerInviteAuthorisedSignatoryResponses = {
    /**
     * Authorised signatory invitation sent
     */
    200: unknown;
};

export type DocumentWorkflowControllerCancelAuthorisedSignatoryData = {
    body: CancelAuthorisedSignatoryDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/cancel-authorised-signatory';
};

export type DocumentWorkflowControllerCancelAuthorisedSignatoryResponses = {
    /**
     * Authorised signatory invitation cancelled
     */
    200: unknown;
};

export type DocumentWorkflowControllerResendInvitationData = {
    body: ResendInvitationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        documentWorkflowInstanceId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/{documentWorkflowInstanceId}/resend-invitation';
};

export type DocumentWorkflowControllerResendInvitationResponses = {
    /**
     * Invitation resent
     */
    200: unknown;
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareData = {
    /**
     * Bulk eID Easy prepare dto
     */
    body: BulkEidEasyPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-prepare';
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkPrepareResponses = {
    200: unknown;
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteData = {
    /**
     * eID Easy bulk complete dto
     */
    body: EidEasyCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-complete';
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkCompleteResponses = {
    200: unknown;
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateData = {
    body: BulkEidEasyPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/initiate';
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignInitiateResponses = {
    200: unknown;
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/{jobId}/status';
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponses = {
    default: BulkSignJobStatusRes;
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponse = DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponses[keyof DocumentWorkflowBulkSigningControllerEidEasyBulkSignStatusResponses];

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/eid-easy/bulk-sign/{jobId}/signed';
};

export type DocumentWorkflowBulkSigningControllerEidEasyBulkSignCompleteResponses = {
    200: unknown;
};

export type DocumentWorkflowKycFormControllerGetFormsForKycWorkflowData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycWorkflowId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}';
};

export type DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponses = {
    default: Array<MipFormAttachmentRes>;
};

export type DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponse = DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponses[keyof DocumentWorkflowKycFormControllerGetFormsForKycWorkflowResponses];

export type DocumentWorkflowKycFormControllerAttachFormData = {
    body: AttachKycFormDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycWorkflowId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}';
};

export type DocumentWorkflowKycFormControllerAttachFormResponses = {
    204: void;
};

export type DocumentWorkflowKycFormControllerAttachFormResponse = DocumentWorkflowKycFormControllerAttachFormResponses[keyof DocumentWorkflowKycFormControllerAttachFormResponses];

export type DocumentWorkflowKycFormControllerRemoveFormData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycFormWorkflowStateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/{kycFormWorkflowStateId}';
};

export type DocumentWorkflowKycFormControllerRemoveFormResponses = {
    204: void;
};

export type DocumentWorkflowKycFormControllerRemoveFormResponse = DocumentWorkflowKycFormControllerRemoveFormResponses[keyof DocumentWorkflowKycFormControllerRemoveFormResponses];

export type DocumentWorkflowKycFormControllerReviewFormData = {
    body: ReviewKycFormDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycWorkflowId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/review';
};

export type DocumentWorkflowKycFormControllerReviewFormResponses = {
    204: void;
};

export type DocumentWorkflowKycFormControllerReviewFormResponse = DocumentWorkflowKycFormControllerReviewFormResponses[keyof DocumentWorkflowKycFormControllerReviewFormResponses];

export type DocumentWorkflowKycFormControllerResetFormData = {
    body: ResetKycFormDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycWorkflowId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/reset';
};

export type DocumentWorkflowKycFormControllerResetFormResponses = {
    204: void;
};

export type DocumentWorkflowKycFormControllerResetFormResponse = DocumentWorkflowKycFormControllerResetFormResponses[keyof DocumentWorkflowKycFormControllerResetFormResponses];

export type DocumentWorkflowKycFormControllerGetInvestorFormsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        kycWorkflowId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/kyc-forms/kyc-workflow/{kycWorkflowId}/investor-forms';
};

export type DocumentWorkflowKycFormControllerGetInvestorFormsResponses = {
    default: Array<InvestorKycFormRes>;
};

export type DocumentWorkflowKycFormControllerGetInvestorFormsResponse = DocumentWorkflowKycFormControllerGetInvestorFormsResponses[keyof DocumentWorkflowKycFormControllerGetInvestorFormsResponses];

export type KycFormTemplateControllerDeleteData = {
    body: DeleteProgrammeKycFormTemplatesDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-workflow/kyc-form-templates';
};

export type KycFormTemplateControllerDeleteResponses = {
    204: void;
};

export type KycFormTemplateControllerDeleteResponse = KycFormTemplateControllerDeleteResponses[keyof KycFormTemplateControllerDeleteResponses];

export type KycFormTemplateControllerListData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        archived: string;
    };
    url: '/document-workflow/kyc-form-templates';
};

export type KycFormTemplateControllerListResponses = {
    default: Array<KycFormTemplateRes>;
};

export type KycFormTemplateControllerListResponse = KycFormTemplateControllerListResponses[keyof KycFormTemplateControllerListResponses];

export type KycFormTemplateControllerCreateData = {
    body: CreateKycFormTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-workflow/kyc-form-templates';
};

export type KycFormTemplateControllerCreateResponses = {
    204: void;
};

export type KycFormTemplateControllerCreateResponse = KycFormTemplateControllerCreateResponses[keyof KycFormTemplateControllerCreateResponses];

export type KycFormTemplateControllerListLibraryData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        type: CustomDetailEnum;
        category?: CustomDetailCategory;
    };
    url: '/document-workflow/kyc-form-templates/library';
};

export type KycFormTemplateControllerListLibraryResponses = {
    default: Array<KycLibraryTemplateRes>;
};

export type KycFormTemplateControllerListLibraryResponse = KycFormTemplateControllerListLibraryResponses[keyof KycFormTemplateControllerListLibraryResponses];

export type KycFormTemplateControllerUpdateData = {
    body: UpdateKycFormTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}';
};

export type KycFormTemplateControllerUpdateResponses = {
    204: void;
};

export type KycFormTemplateControllerUpdateResponse = KycFormTemplateControllerUpdateResponses[keyof KycFormTemplateControllerUpdateResponses];

export type KycFormTemplateControllerSignatureSlotsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/signature-slots';
};

export type KycFormTemplateControllerSignatureSlotsResponses = {
    default: GetSignatureSlotsRes;
};

export type KycFormTemplateControllerSignatureSlotsResponse = KycFormTemplateControllerSignatureSlotsResponses[keyof KycFormTemplateControllerSignatureSlotsResponses];

export type KycFormTemplateControllerUpdateSignaturePlacementData = {
    body: UpdateKycSignaturePlacementDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/signature-placement';
};

export type KycFormTemplateControllerUpdateSignaturePlacementResponses = {
    204: void;
};

export type KycFormTemplateControllerUpdateSignaturePlacementResponse = KycFormTemplateControllerUpdateSignaturePlacementResponses[keyof KycFormTemplateControllerUpdateSignaturePlacementResponses];

export type KycFormTemplateControllerFieldBindingsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings';
};

export type KycFormTemplateControllerFieldBindingsResponses = {
    default: Array<FieldBindingRes>;
};

export type KycFormTemplateControllerFieldBindingsResponse = KycFormTemplateControllerFieldBindingsResponses[keyof KycFormTemplateControllerFieldBindingsResponses];

export type KycFormTemplateControllerUpdateFieldBindingsData = {
    body: UpdateFieldBindingsDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings';
};

export type KycFormTemplateControllerUpdateFieldBindingsResponses = {
    204: void;
};

export type KycFormTemplateControllerUpdateFieldBindingsResponse = KycFormTemplateControllerUpdateFieldBindingsResponses[keyof KycFormTemplateControllerUpdateFieldBindingsResponses];

export type KycFormTemplateControllerFieldBindingCatalogueData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        investorId?: string;
    };
    url: '/document-workflow/kyc-form-templates/field-binding-catalogue';
};

export type KycFormTemplateControllerFieldBindingCatalogueResponses = {
    default: FieldBindingCatalogueRes;
};

export type KycFormTemplateControllerFieldBindingCatalogueResponse = KycFormTemplateControllerFieldBindingCatalogueResponses[keyof KycFormTemplateControllerFieldBindingCatalogueResponses];

export type KycFormTemplateControllerPreviewFieldBindingsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query: {
        investorId: string;
    };
    url: '/document-workflow/kyc-form-templates/{templateId}/field-bindings/preview';
};

export type KycFormTemplateControllerPreviewFieldBindingsResponses = {
    default: FieldBindingPreviewRes;
};

export type KycFormTemplateControllerPreviewFieldBindingsResponse = KycFormTemplateControllerPreviewFieldBindingsResponses[keyof KycFormTemplateControllerPreviewFieldBindingsResponses];

export type KycFormTemplateControllerDocxDocumentData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-document';
};

export type KycFormTemplateControllerDocxDocumentResponses = {
    default: DocxFlowDocumentRes;
};

export type KycFormTemplateControllerDocxDocumentResponse = KycFormTemplateControllerDocxDocumentResponses[keyof KycFormTemplateControllerDocxDocumentResponses];

export type KycFormTemplateControllerSaveDocxDocumentData = {
    body: SaveDocxFlowDocumentDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-document';
};

export type KycFormTemplateControllerSaveDocxDocumentResponses = {
    default: DocxFlowDocumentRes;
};

export type KycFormTemplateControllerSaveDocxDocumentResponse = KycFormTemplateControllerSaveDocxDocumentResponses[keyof KycFormTemplateControllerSaveDocxDocumentResponses];

export type KycFormTemplateControllerRenderDocxFieldsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-render/fields';
};

export type KycFormTemplateControllerRenderDocxFieldsResponses = {
    default: DocxRenderRes;
};

export type KycFormTemplateControllerRenderDocxFieldsResponse = KycFormTemplateControllerRenderDocxFieldsResponses[keyof KycFormTemplateControllerRenderDocxFieldsResponses];

export type KycFormTemplateControllerRenderDocxData = {
    body: RenderDocxTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: {
        /**
         * Omit to render the fields view with each field shown by name.
         */
        investorId?: string;
    };
    url: '/document-workflow/kyc-form-templates/{templateId}/docx-render';
};

export type KycFormTemplateControllerRenderDocxResponses = {
    default: DocxRenderRes;
};

export type KycFormTemplateControllerRenderDocxResponse = KycFormTemplateControllerRenderDocxResponses[keyof KycFormTemplateControllerRenderDocxResponses];

export type KycFormTemplateControllerArchiveData = {
    body: ArchiveProgrammeKycFormTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/archive';
};

export type KycFormTemplateControllerArchiveResponses = {
    204: void;
};

export type KycFormTemplateControllerArchiveResponse = KycFormTemplateControllerArchiveResponses[keyof KycFormTemplateControllerArchiveResponses];

export type KycFormTemplateControllerInstanceCountData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query?: never;
    url: '/document-workflow/kyc-form-templates/{templateId}/instance-count';
};

export type KycFormTemplateControllerInstanceCountResponses = {
    default: KycFormTemplateInstanceCountRes;
};

export type KycFormTemplateControllerInstanceCountResponse = KycFormTemplateControllerInstanceCountResponses[keyof KycFormTemplateControllerInstanceCountResponses];

export type PublicSigningControllerGetSigningInfoData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/info';
};

export type PublicSigningControllerGetSigningInfoResponses = {
    200: unknown;
};

export type PublicSigningControllerGetDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/document';
};

export type PublicSigningControllerGetDocumentResponses = {
    200: unknown;
};

export type PublicSigningControllerSaveWitnessDetailsData = {
    body: WitnessDetailsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/witness-details';
};

export type PublicSigningControllerSaveWitnessDetailsResponses = {
    200: unknown;
};

export type PublicSigningControllerInviteWitnessData = {
    body: WitnessInviteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/invite-witness';
};

export type PublicSigningControllerInviteWitnessResponses = {
    200: unknown;
};

export type PublicSigningControllerPrepareData = {
    body: PublicSigningPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/prepare';
};

export type PublicSigningControllerPrepareResponses = {
    200: unknown;
};

export type PublicSigningControllerCompleteData = {
    body: PublicSigningCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/complete';
};

export type PublicSigningControllerCompleteResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerGetProgrammeDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/programme/documents';
};

export type PublicBulkSigningControllerGetProgrammeDocumentsResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerGetProgrammeDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        signatureId: string;
    };
    url: '/public-signing/programme/document';
};

export type PublicBulkSigningControllerGetProgrammeDocumentResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerGetSignatureTokenData = {
    body: ProgrammeSignatureTokenDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/programme/signature-token';
};

export type PublicBulkSigningControllerGetSignatureTokenResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerBulkPrepareData = {
    body: PublicBulkPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/programme/bulk-prepare';
};

export type PublicBulkSigningControllerBulkPrepareResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerBulkCompleteData = {
    body: EidEasyCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/programme/bulk-complete';
};

export type PublicBulkSigningControllerBulkCompleteResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerBulkSignInitiateData = {
    body: PublicBulkPrepareDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/programme/bulk-sign/initiate';
};

export type PublicBulkSigningControllerBulkSignInitiateResponses = {
    200: unknown;
};

export type PublicBulkSigningControllerBulkSignStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/public-signing/programme/bulk-sign/{jobId}/status';
};

export type PublicBulkSigningControllerBulkSignStatusResponses = {
    default: BulkSignJobStatusRes;
};

export type PublicBulkSigningControllerBulkSignStatusResponse = PublicBulkSigningControllerBulkSignStatusResponses[keyof PublicBulkSigningControllerBulkSignStatusResponses];

export type PublicBulkSigningControllerBulkSignCompleteData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        jobId: string;
    };
    query?: never;
    url: '/public-signing/programme/bulk-sign/{jobId}/signed';
};

export type PublicBulkSigningControllerBulkSignCompleteResponses = {
    200: unknown;
};

export type PublicCertificationControllerSaveCertifierDetailsData = {
    body: CertifierDetailsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/certifier-details';
};

export type PublicCertificationControllerSaveCertifierDetailsResponses = {
    default: StatusOkRes;
};

export type PublicCertificationControllerSaveCertifierDetailsResponse = PublicCertificationControllerSaveCertifierDetailsResponses[keyof PublicCertificationControllerSaveCertifierDetailsResponses];

export type PublicCertificationControllerUpdateCertificationTextData = {
    body: CertificationTextDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/public-signing/certification-text';
};

export type PublicCertificationControllerUpdateCertificationTextResponses = {
    default: CertificationTextRes;
};

export type PublicCertificationControllerUpdateCertificationTextResponse = PublicCertificationControllerUpdateCertificationTextResponses[keyof PublicCertificationControllerUpdateCertificationTextResponses];

export type DocumentTemplatesControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-templates';
};

export type DocumentTemplatesControllerListResponses = {
    default: Array<GlobalDocumentTemplateRes>;
};

export type DocumentTemplatesControllerListResponse = DocumentTemplatesControllerListResponses[keyof DocumentTemplatesControllerListResponses];

export type DocumentTemplatesControllerCreateData = {
    body: CreateGlobalDocumentTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-templates';
};

export type DocumentTemplatesControllerCreateResponses = {
    default: GlobalDocumentTemplateRes;
};

export type DocumentTemplatesControllerCreateResponse = DocumentTemplatesControllerCreateResponses[keyof DocumentTemplatesControllerCreateResponses];

export type DocumentTemplatesControllerSoftDeleteData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}';
};

export type DocumentTemplatesControllerSoftDeleteResponses = {
    200: unknown;
};

export type DocumentTemplatesControllerGetByIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}';
};

export type DocumentTemplatesControllerGetByIdResponses = {
    default: GlobalDocumentTemplateRes;
};

export type DocumentTemplatesControllerGetByIdResponse = DocumentTemplatesControllerGetByIdResponses[keyof DocumentTemplatesControllerGetByIdResponses];

export type DocumentTemplatesControllerUpdateData = {
    body: UpdateGlobalDocumentTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}';
};

export type DocumentTemplatesControllerUpdateResponses = {
    default: GlobalDocumentTemplateRes;
};

export type DocumentTemplatesControllerUpdateResponse = DocumentTemplatesControllerUpdateResponses[keyof DocumentTemplatesControllerUpdateResponses];

export type DocumentTemplatesControllerGetAvailabilityData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/availability';
};

export type DocumentTemplatesControllerGetAvailabilityResponses = {
    default: TemplateAvailabilityRes;
};

export type DocumentTemplatesControllerGetAvailabilityResponse = DocumentTemplatesControllerGetAvailabilityResponses[keyof DocumentTemplatesControllerGetAvailabilityResponses];

export type DocumentTemplatesControllerSetAvailabilityData = {
    body: SetTemplateAvailabilityDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/availability';
};

export type DocumentTemplatesControllerSetAvailabilityResponses = {
    default: TemplateAvailabilityRes;
};

export type DocumentTemplatesControllerSetAvailabilityResponse = DocumentTemplatesControllerSetAvailabilityResponses[keyof DocumentTemplatesControllerSetAvailabilityResponses];

export type DocumentTemplatesControllerGetFieldBindingsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/field-bindings';
};

export type DocumentTemplatesControllerGetFieldBindingsResponses = {
    default: Array<FieldBindingRes>;
};

export type DocumentTemplatesControllerGetFieldBindingsResponse = DocumentTemplatesControllerGetFieldBindingsResponses[keyof DocumentTemplatesControllerGetFieldBindingsResponses];

export type DocumentTemplatesControllerUpdateFieldBindingsData = {
    body: UpdateFieldBindingsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/field-bindings';
};

export type DocumentTemplatesControllerUpdateFieldBindingsResponses = {
    200: unknown;
};

export type DocumentTemplatesControllerGetFieldBindingCatalogueData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-templates/{id}/field-binding-catalogue';
};

export type DocumentTemplatesControllerGetFieldBindingCatalogueResponses = {
    default: FieldBindingCatalogueRes;
};

export type DocumentTemplatesControllerGetFieldBindingCatalogueResponse = DocumentTemplatesControllerGetFieldBindingCatalogueResponses[keyof DocumentTemplatesControllerGetFieldBindingCatalogueResponses];

export type DocumentTemplatesControllerPreviewFieldBindingsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/field-bindings/preview';
};

export type DocumentTemplatesControllerPreviewFieldBindingsResponses = {
    default: FieldBindingPreviewRes;
};

export type DocumentTemplatesControllerPreviewFieldBindingsResponse = DocumentTemplatesControllerPreviewFieldBindingsResponses[keyof DocumentTemplatesControllerPreviewFieldBindingsResponses];

export type DocumentTemplatesControllerGetDocxFlowDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/docx-document';
};

export type DocumentTemplatesControllerGetDocxFlowDocumentResponses = {
    /**
     * The editable reflow document for a Word document template.
     */
    default: DocxFlowDocumentRes;
};

export type DocumentTemplatesControllerGetDocxFlowDocumentResponse = DocumentTemplatesControllerGetDocxFlowDocumentResponses[keyof DocumentTemplatesControllerGetDocxFlowDocumentResponses];

export type DocumentTemplatesControllerSaveDocxFlowDocumentData = {
    body: SaveDocxFlowDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/docx-document';
};

export type DocumentTemplatesControllerSaveDocxFlowDocumentResponses = {
    /**
     * Saved the edited document, and re-read its fields.
     */
    default: DocxFlowDocumentRes;
};

export type DocumentTemplatesControllerSaveDocxFlowDocumentResponse = DocumentTemplatesControllerSaveDocxFlowDocumentResponses[keyof DocumentTemplatesControllerSaveDocxFlowDocumentResponses];

export type DocumentTemplatesControllerRenderDocxTemplateData = {
    body: RenderDocxTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/document-templates/{id}/docx-render';
};

export type DocumentTemplatesControllerRenderDocxTemplateResponses = {
    /**
     * Rendered the Word template to a PDF with sample values filled in.
     */
    default: DocxRenderRes;
};

export type DocumentTemplatesControllerRenderDocxTemplateResponse = DocumentTemplatesControllerRenderDocxTemplateResponses[keyof DocumentTemplatesControllerRenderDocxTemplateResponses];

export type DealDocumentTemplatesControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-templates';
};

export type DealDocumentTemplatesControllerListResponses = {
    default: Array<DealDocumentTemplateSummaryRes>;
};

export type DealDocumentTemplatesControllerListResponse = DealDocumentTemplatesControllerListResponses[keyof DealDocumentTemplatesControllerListResponses];

export type PreFillableFormsControllerGetTemplatesForProjectData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/pre-fillable-forms/templates-for-project';
};

export type PreFillableFormsControllerGetTemplatesForProjectResponses = {
    default: DataPreFillableFormTemplateTct;
};

export type PreFillableFormsControllerGetTemplatesForProjectResponse = PreFillableFormsControllerGetTemplatesForProjectResponses[keyof PreFillableFormsControllerGetTemplatesForProjectResponses];

export type GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/templates';
};

export type GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponses = {
    default: Array<DataGeneratableDocumentTemplateWithAllRelationsTct>;
};

export type GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponse = GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponses[keyof GeneratableDocumentsControllerGetAllGeneratableDocumentsTemplatesResponses];

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/generatable-documents/template/{id}';
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponses = {
    default: DataGeneratableDocumentWorkflowTemplateTct;
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponse = GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponses[keyof GeneratableDocumentsControllerGetGeneratableDocumentsTemplateResponses];

export type GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateData = {
    body: UpdateGeneratableDocumentTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/template/update';
};

export type GeneratableDocumentsControllerUpdateGeneratableDocumentTemplateResponses = {
    201: unknown;
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/generatable-documents/template/{id}/assigned-projects';
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponses = {
    default: Array<GetGeneratableDocumentsTemplateAssignedProjectRes>;
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponse = GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponses[keyof GeneratableDocumentsControllerGetGeneratableDocumentsTemplateAssignedProjectsResponses];

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/generatable-documents/template/{id}/smart-fields';
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponses = {
    default: Array<DataGeneratableDocumentWorkflowTemplateFieldTct>;
};

export type GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponse = GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponses[keyof GeneratableDocumentsControllerGetGeneratableDocumentsTemplateSmartFieldsResponses];

export type GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsData = {
    body: UpdateGeneratableDocumentTemplateSmartFieldsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/template/smart-fields';
};

export type GeneratableDocumentsControllerUpdateGeneratableDocumentsTemplateSmartFieldsResponses = {
    200: unknown;
};

export type GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateData = {
    body: AssignProjectToGeneratableDocumentTemplateDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/template/assign-project';
};

export type GeneratableDocumentsControllerAssignProjectToGeneratableDocumentTemplateResponses = {
    201: unknown;
};

export type GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateData = {
    body: UnassignProjectFromGeneratableDocumentTemplateDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/template/unassign-project';
};

export type GeneratableDocumentsControllerUnassignProjectToGeneratableDocumentTemplateResponses = {
    201: unknown;
};

export type GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/file/{type}';
};

export type GeneratableDocumentsControllerDownloadGeneratableDocumentsTemplateFileByTypeResponses = {
    /**
     * Returns generatable document template file
     */
    default: unknown;
};

export type GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/generatable-documents/template/{id}/custom-details-definitions';
};

export type GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponses = {
    default: Array<GdwtCustomDetailDefinitionTct>;
};

export type GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponse = GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponses[keyof GeneratableDocumentsControllerGetGdwtCustomDetailsDefinitionsResponses];

export type GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsData = {
    body: DeleteGdwtCustomDetailsDefinitionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/custom-details-definitions';
};

export type GeneratableDocumentsControllerDeleteCustomDetailsDefinitionsResponses = {
    200: unknown;
};

export type GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsData = {
    body: CreateGdwtCustomDetailsDefinitionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/custom-details-definitions';
};

export type GeneratableDocumentsControllerCreateGdwtCustomDetailsDefinitionsResponses = {
    201: unknown;
};

export type GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsData = {
    body: UpdateGdwtCustomDetailDefinitionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/generatable-documents/custom-details-definitions';
};

export type GeneratableDocumentsControllerUpdateGdwtCustomDetailsDefinitionsResponses = {
    200: unknown;
};

export type PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/list';
};

export type PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponses = {
    default: Array<DataPreFillableFormTemplateWithProjectsTct>;
};

export type PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponse = PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponses[keyof PreFillableFormTemplateControllerGetAllPreFillableFormTemplatesResponses];

export type PreFillableFormTemplateControllerGetOrganizationOptionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/organizations';
};

export type PreFillableFormTemplateControllerGetOrganizationOptionsResponses = {
    default: Array<PreFillableFormOrganizationOptionRes>;
};

export type PreFillableFormTemplateControllerGetOrganizationOptionsResponse = PreFillableFormTemplateControllerGetOrganizationOptionsResponses[keyof PreFillableFormTemplateControllerGetOrganizationOptionsResponses];

export type PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/upload-file';
};

export type PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponses = {
    default: UploadPreFillableFormTemplateFileRes;
};

export type PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponse = PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponses[keyof PreFillableFormTemplateControllerUploadPreFillableFormTemplateFileResponses];

export type PreFillableFormTemplateControllerCreatePreFillableFormTemplateData = {
    body: CreatePreFillableFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/create';
};

export type PreFillableFormTemplateControllerCreatePreFillableFormTemplateResponses = {
    201: unknown;
};

export type PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsData = {
    body: DeleteCustomDetailsDefinitionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/custom-details-definitions';
};

export type PreFillableFormTemplateControllerDeleteCustomDetailsDefinitionsResponses = {
    200: unknown;
};

export type PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateData = {
    body: CreateManyCustomDetailsDefinitionsForPreFillableFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/custom-details-definitions';
};

export type PreFillableFormTemplateControllerCreateManyCustomDetailsDefinitionsForPreFillableFormTemplateResponses = {
    201: unknown;
};

export type PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsData = {
    body: UpdateCustomDetailsDefinitionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/custom-details-definitions';
};

export type PreFillableFormTemplateControllerUpdateCustomDetailsDefinitionsResponses = {
    200: unknown;
};

export type PreFillableFormTemplateControllerUpdatePreFillableFormTemplateData = {
    body: UpdatePreFillableFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/godmode/pre-fillable-form-template/update';
};

export type PreFillableFormTemplateControllerUpdatePreFillableFormTemplateResponses = {
    201: unknown;
};

export type PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/pre-fillable-form-template/soft-delete/{id}';
};

export type PreFillableFormTemplateControllerSoftDeletePreFillableFormTemplateResponses = {
    200: unknown;
};

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/pre-fillable-form-template/{id}';
};

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateResponses = {
    default: DataPreFillableFormTemplateWithAllRelationsTct;
};

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateResponse = PreFillableFormTemplateControllerGetPreFillableFormTemplateResponses[keyof PreFillableFormTemplateControllerGetPreFillableFormTemplateResponses];

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/godmode/pre-fillable-form-template/{id}/custom-details-definitions';
};

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponses = {
    default: PreFillableFormTemplateCustomDetailsDefinitionsRes;
};

export type PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponse = PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponses[keyof PreFillableFormTemplateControllerGetPreFillableFormTemplateCustomDetailsDefinitionsResponses];

export type SecurityControllerGetLoanDefinitionsForDealData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/loan-definitions';
};

export type SecurityControllerGetLoanDefinitionsForDealResponses = {
    default: Array<GetLoanDefinitionForDealRes>;
};

export type SecurityControllerGetLoanDefinitionsForDealResponse = SecurityControllerGetLoanDefinitionsForDealResponses[keyof SecurityControllerGetLoanDefinitionsForDealResponses];

export type SecurityControllerGetSecuritiesByDealIdData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/deal';
};

export type SecurityControllerGetSecuritiesByDealIdResponses = {
    default: Array<DataSecurityWithIssuerTct>;
};

export type SecurityControllerGetSecuritiesByDealIdResponse = SecurityControllerGetSecuritiesByDealIdResponses[keyof SecurityControllerGetSecuritiesByDealIdResponses];

export type SecurityControllerGetSecurityData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: {
        date?: string;
    };
    url: '/security/{securityId}';
};

export type SecurityControllerGetSecurityResponses = {
    default: DataSecurityWithAllFeaturesAndRanksTct;
};

export type SecurityControllerGetSecurityResponse = SecurityControllerGetSecurityResponses[keyof SecurityControllerGetSecurityResponses];

export type SecurityControllerGetSecuritiesDataForMipData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: {
        issuerId?: string;
    };
    url: '/security/mip-securities/{mipId}';
};

export type SecurityControllerGetSecuritiesDataForMipResponses = {
    default: Array<GetSecurityDataForMipRes>;
};

export type SecurityControllerGetSecuritiesDataForMipResponse = SecurityControllerGetSecuritiesDataForMipResponses[keyof SecurityControllerGetSecuritiesDataForMipResponses];

export type SecurityControllerGetPersonSecuritiesData = {
    body: GetSecurityListFilterDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: {
        date?: string;
    };
    url: '/security/person-securities/{personId}';
};

export type SecurityControllerGetPersonSecuritiesResponses = {
    default: GetPersonSecuritiesRes;
};

export type SecurityControllerGetPersonSecuritiesResponse = SecurityControllerGetPersonSecuritiesResponses[keyof SecurityControllerGetPersonSecuritiesResponses];

export type SecurityControllerDoesPersonHaveSecuritiesData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/security/does-person-have-securities/{personId}';
};

export type SecurityControllerDoesPersonHaveSecuritiesResponses = {
    default: DoesPersonHaveSecuritiesRes;
};

export type SecurityControllerDoesPersonHaveSecuritiesResponse = SecurityControllerDoesPersonHaveSecuritiesResponses[keyof SecurityControllerDoesPersonHaveSecuritiesResponses];

export type SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: {
        splitIds?: Array<string>;
    };
    url: '/security/security-ranks/{personId}';
};

export type SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponses = {
    default: GetPersonSecuritiesWithFeaturesAndRanksRes;
};

export type SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponse = SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponses[keyof SecurityControllerGetPersonSecuritiesWithFeaturesAndRanksResponses];

export type SecurityControllerIsSecuritiesUsedInAnyMipData = {
    body: Array<string>;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/is-securities-used-in-any-mip';
};

export type SecurityControllerIsSecuritiesUsedInAnyMipResponses = {
    default: IsSecuritiesUsedInAnyMipRes;
};

export type SecurityControllerIsSecuritiesUsedInAnyMipResponse = SecurityControllerIsSecuritiesUsedInAnyMipResponses[keyof SecurityControllerIsSecuritiesUsedInAnyMipResponses];

export type SecurityControllerCreateSecurityData = {
    body: CreateSecurityDto;
    headers?: {
        'deal-id'?: string;
        'mip-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security';
};

export type SecurityControllerCreateSecurityResponses = {
    default: DataSecurityTct;
};

export type SecurityControllerCreateSecurityResponse = SecurityControllerCreateSecurityResponses[keyof SecurityControllerCreateSecurityResponses];

export type SecurityControllerUpdateSecurityData = {
    body: UpdateSecurityDto;
    headers?: {
        'deal-id'?: string;
        'mip-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security';
};

export type SecurityControllerUpdateSecurityResponses = {
    default: DataSecurityTct;
};

export type SecurityControllerUpdateSecurityResponse = SecurityControllerUpdateSecurityResponses[keyof SecurityControllerUpdateSecurityResponses];

export type SecurityControllerBulkCreateSecuritiesData = {
    body: BulkCreateSecuritiesDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/bulk';
};

export type SecurityControllerBulkCreateSecuritiesResponses = {
    default: Array<DataSecurityTct>;
};

export type SecurityControllerBulkCreateSecuritiesResponse = SecurityControllerBulkCreateSecuritiesResponses[keyof SecurityControllerBulkCreateSecuritiesResponses];

export type SecurityControllerBulkUpdateSecuritiesData = {
    body: BulkUpdateSecuritiesDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/bulk';
};

export type SecurityControllerBulkUpdateSecuritiesResponses = {
    default: BulkOperationResult;
};

export type SecurityControllerBulkUpdateSecuritiesResponse = SecurityControllerBulkUpdateSecuritiesResponses[keyof SecurityControllerBulkUpdateSecuritiesResponses];

export type SecurityControllerBulkUpdateTrackedSecuritiesData = {
    body: BulkUpdateTrackedSecuritiesDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/tracking';
};

export type SecurityControllerBulkUpdateTrackedSecuritiesResponses = {
    default: BulkOperationResult;
};

export type SecurityControllerBulkUpdateTrackedSecuritiesResponse = SecurityControllerBulkUpdateTrackedSecuritiesResponses[keyof SecurityControllerBulkUpdateTrackedSecuritiesResponses];

export type SecurityControllerBulkDeleteTrackedSecuritiesData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
        trackingSecurityIssuerId: string;
    };
    query?: never;
    url: '/security/{securityId}/tracking/{trackingSecurityIssuerId}';
};

export type SecurityControllerBulkDeleteTrackedSecuritiesResponses = {
    default: BulkOperationResult;
};

export type SecurityControllerBulkDeleteTrackedSecuritiesResponse = SecurityControllerBulkDeleteTrackedSecuritiesResponses[keyof SecurityControllerBulkDeleteTrackedSecuritiesResponses];

export type SecurityControllerUpdateCurrencyForPersonSecuritiesData = {
    body: UpdateCurrencyForPersonSecurities;
    headers?: {
        'deal-id'?: string;
        'mip-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/security/{personId}/currency';
};

export type SecurityControllerUpdateCurrencyForPersonSecuritiesResponses = {
    default: BulkOperationResult;
};

export type SecurityControllerUpdateCurrencyForPersonSecuritiesResponse = SecurityControllerUpdateCurrencyForPersonSecuritiesResponses[keyof SecurityControllerUpdateCurrencyForPersonSecuritiesResponses];

export type SecurityControllerSoftDeleteSecurityData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/soft-delete-one/{securityId}';
};

export type SecurityControllerSoftDeleteSecurityResponses = {
    200: unknown;
};

export type SecurityControllerBulkSoftDeleteSecuritiesData = {
    body: BulkSoftDeleteSecuritiesDto;
    headers?: {
        'deal-id'?: string;
        'mip-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/bulk-soft-delete';
};

export type SecurityControllerBulkSoftDeleteSecuritiesResponses = {
    default: BulkOperationResult;
};

export type SecurityControllerBulkSoftDeleteSecuritiesResponse = SecurityControllerBulkSoftDeleteSecuritiesResponses[keyof SecurityControllerBulkSoftDeleteSecuritiesResponses];

export type SecurityControllerDownloadExcelData = {
    body: DownloadSecuritiesCsvDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security/download-excel';
};

export type SecurityControllerDownloadExcelResponses = {
    default: DownloadSecuritiesCsvDto;
};

export type SecurityControllerDownloadExcelResponse = SecurityControllerDownloadExcelResponses[keyof SecurityControllerDownloadExcelResponses];

export type SecurityControllerUpdateSecurityAuthorisedCapitalData = {
    body: UpdateSecurityAuthorisedCapitalDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/authorised-capital';
};

export type SecurityControllerUpdateSecurityAuthorisedCapitalResponses = {
    default: DataSecurityTct;
};

export type SecurityControllerUpdateSecurityAuthorisedCapitalResponse = SecurityControllerUpdateSecurityAuthorisedCapitalResponses[keyof SecurityControllerUpdateSecurityAuthorisedCapitalResponses];

export type SecurityControllerUpdateSecurityParticipationThresholdData = {
    body: UpdateSecurityParticipationThresholdDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/participation-threshold';
};

export type SecurityControllerUpdateSecurityParticipationThresholdResponses = {
    default: DataSecurityTct;
};

export type SecurityControllerUpdateSecurityParticipationThresholdResponse = SecurityControllerUpdateSecurityParticipationThresholdResponses[keyof SecurityControllerUpdateSecurityParticipationThresholdResponses];

export type SecurityControllerGetSecurityNominalValueData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query: {
        date: string;
    };
    url: '/security/{securityId}/nominal-value';
};

export type SecurityControllerGetSecurityNominalValueResponses = {
    default: SecurityNominalValueRes;
};

export type SecurityControllerGetSecurityNominalValueResponse = SecurityControllerGetSecurityNominalValueResponses[keyof SecurityControllerGetSecurityNominalValueResponses];

export type SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/exchange-rights';
};

export type SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponses = {
    default: DataSecurityExchangeRightsTct;
};

export type SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponse = SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponses[keyof SecurityExchangeRightsControllerSoftDeleteSecurityExchangeRightsResponses];

export type SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsData = {
    body: CreateUpdateSecurityExchangeRightsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/exchange-rights';
};

export type SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponses = {
    default: DataSecurityExchangeRightsTct;
};

export type SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponse = SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponses[keyof SecurityExchangeRightsControllerCreateOrUpdateSecurityExchangeRightsResponses];

export type SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/interest-definition';
};

export type SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponses = {
    default: DataSecurityInterestDefinitionTct;
};

export type SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponse = SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponses[keyof SecurityInterestRedemptionControllerSoftDeleteSecurityInterestDefinitionResponses];

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionData = {
    body: CreateUpdateSecurityInterestDefinitionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/interest-definition';
};

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponses = {
    default: DataSecurityInterestDefinitionTct;
};

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponse = SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponses[keyof SecurityInterestRedemptionControllerCreateOrUpdateSecurityInterestDefinitionResponses];

export type SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/redemption-rights';
};

export type SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponses = {
    default: DataSecurityRedemptionRightsTct;
};

export type SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponse = SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponses[keyof SecurityInterestRedemptionControllerSoftDeleteSecurityRedemptionRightsResponses];

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsData = {
    body: CreateUpdateSecurityRedemptionRightsDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/redemption-rights';
};

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponses = {
    default: DataSecurityRedemptionRightsTct;
};

export type SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponse = SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponses[keyof SecurityInterestRedemptionControllerCreateOrUpdateSecurityRedemptionRightsResponses];

export type SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/catch-up-rights';
};

export type SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponses = {
    default: DataSecurityCatchUpRightsTct;
};

export type SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponse = SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponses[keyof SecurityCatchUpRightsControllerSoftDeleteSecurityCatchUpRightsResponses];

export type SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsData = {
    body: CreateUpdateSecurityCatchUpRightsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security/{securityId}/catch-up-rights';
};

export type SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponses = {
    default: DataSecurityCatchUpRightsTct;
};

export type SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponse = SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponses[keyof SecurityCatchUpRightsControllerCreateOrUpdateSecurityCatchUpRightsResponses];

export type SecurityLiquidationPreferenceControllerSoftDeleteData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/securities/{securityId}/liquidation-preference';
};

export type SecurityLiquidationPreferenceControllerSoftDeleteResponses = {
    default: SecurityLiquidationPreferenceRes;
};

export type SecurityLiquidationPreferenceControllerSoftDeleteResponse = SecurityLiquidationPreferenceControllerSoftDeleteResponses[keyof SecurityLiquidationPreferenceControllerSoftDeleteResponses];

export type SecurityLiquidationPreferenceControllerGetData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/securities/{securityId}/liquidation-preference';
};

export type SecurityLiquidationPreferenceControllerGetResponses = {
    default: SecurityLiquidationPreferenceRes;
};

export type SecurityLiquidationPreferenceControllerGetResponse = SecurityLiquidationPreferenceControllerGetResponses[keyof SecurityLiquidationPreferenceControllerGetResponses];

export type SecurityLiquidationPreferenceControllerCreateOrUpdateData = {
    body: CreateUpdateSecurityLiquidationPreferenceDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/securities/{securityId}/liquidation-preference';
};

export type SecurityLiquidationPreferenceControllerCreateOrUpdateResponses = {
    default: SecurityLiquidationPreferenceRes;
};

export type SecurityLiquidationPreferenceControllerCreateOrUpdateResponse = SecurityLiquidationPreferenceControllerCreateOrUpdateResponses[keyof SecurityLiquidationPreferenceControllerCreateOrUpdateResponses];

export type InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        handlerId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/release-workflow-progress/{handlerId}';
};

export type InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponses = {
    default: ReleaseWorkflowProgressRes;
};

export type InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponse = InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponses[keyof InvestorInvestmentWorkflowControllerGetReleaseWorkflowStatusResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/summary';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsSummaryResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponses = {
    default: GetInvestmentDetailsAllocationsRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsAllocationsResponses];

export type InvestorInvestmentWorkflowControllerAddInvestmentAllocationData = {
    body: AddInvestmentAllocationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations';
};

export type InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponses = {
    default: InvestmentDetailsAllocation;
};

export type InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponse = InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponses[keyof InvestorInvestmentWorkflowControllerAddInvestmentAllocationResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponses = {
    default: GetInvestmentDetailsLegalDocumentsRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsLegalDocumentsResponses];

export type InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents/manageable';
};

export type InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponses = {
    default: GetManageableLegalDocumentsRes;
};

export type InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponse = InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponses[keyof InvestorInvestmentWorkflowControllerGetManageableLegalDocumentsResponses];

export type InvestorInvestmentWorkflowControllerToggleLegalDocumentData = {
    body: ToggleLegalDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
        templateId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/legal-documents/manageable/{templateId}';
};

export type InvestorInvestmentWorkflowControllerToggleLegalDocumentResponses = {
    default: GetManageableLegalDocumentsRes;
};

export type InvestorInvestmentWorkflowControllerToggleLegalDocumentResponse = InvestorInvestmentWorkflowControllerToggleLegalDocumentResponses[keyof InvestorInvestmentWorkflowControllerToggleLegalDocumentResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/bank-information';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponses = {
    default: GetInvestmentDetailsBankInformationRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsBankInformationResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/other-data';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponses = {
    default: GetInvestmentDetailsOtherDataRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsOtherDataResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/tax-compliance';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponses = {
    default: GetInvestmentDetailsTaxComplianceRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsTaxComplianceResponses];

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/kyc-status';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponses = {
    default: GetInvestmentDetailsKycStatusRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponse = InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentDetailsKycStatusResponses];

export type InvestorInvestmentWorkflowControllerStartInvestmentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/start';
};

export type InvestorInvestmentWorkflowControllerStartInvestmentResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerStartInvestmentResponse = InvestorInvestmentWorkflowControllerStartInvestmentResponses[keyof InvestorInvestmentWorkflowControllerStartInvestmentResponses];

export type InvestorInvestmentWorkflowControllerApproveInvestmentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/approve';
};

export type InvestorInvestmentWorkflowControllerApproveInvestmentResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerApproveInvestmentResponse = InvestorInvestmentWorkflowControllerApproveInvestmentResponses[keyof InvestorInvestmentWorkflowControllerApproveInvestmentResponses];

export type InvestorInvestmentWorkflowControllerMakeDraftData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/make-draft';
};

export type InvestorInvestmentWorkflowControllerMakeDraftResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerMakeDraftResponse = InvestorInvestmentWorkflowControllerMakeDraftResponses[keyof InvestorInvestmentWorkflowControllerMakeDraftResponses];

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesData = {
    body: SetTargetDatesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/target-dates';
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponse = InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponses[keyof InvestorInvestmentWorkflowControllerSetInvestmentDetailsTargetDatesResponses];

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivData = {
    body: SetInvestmentDetailsPivDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/piv';
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponse = InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponses[keyof InvestorInvestmentWorkflowControllerSetInvestmentDetailsPivResponses];

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountData = {
    body: SetSelectedBankAccountDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/bank-account';
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponses = {
    default: GetInvestmentDetailsBankInformationRes;
};

export type InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponse = InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponses[keyof InvestorInvestmentWorkflowControllerSetInvestmentDetailsBankAccountResponses];

export type InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowData = {
    body: InvestorBulkActionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/bulk-release-investment-workflow';
};

export type InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponses = {
    default: ReleaseInvestmentWorkflowRes;
};

export type InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponse = InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponses[keyof InvestorInvestmentWorkflowControllerBulkReleaseInvestmentWorkflowResponses];

export type InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowData = {
    body: ReleaseInvestmentWorkflowDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/release-single-investment-workflow';
};

export type InvestorInvestmentWorkflowControllerReleaseSingleInvestmentWorkflowResponses = {
    201: unknown;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentsForMipData = {
    body: InvestmentsListQueryDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/list';
};

export type InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponses = {
    default: GetInvestmentsForMipRes;
};

export type InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponse = InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponses[keyof InvestorInvestmentWorkflowControllerGetInvestmentsForMipResponses];

export type InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsData = {
    body: InvestmentsListQueryDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/ordered-ids';
};

export type InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponses = {
    default: GetInvestmentOrderedIdsRes;
};

export type InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponse = InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponses[keyof InvestorInvestmentWorkflowControllerGetOrderedInvestmentIdsResponses];

export type InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeData = {
    body: BulkUpdateExpectedTransactionTypeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/bulk-update-expected-transaction-type';
};

export type InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponses = {
    default: BulkUpdateExpectedTransactionTypeRes;
};

export type InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponse = InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponses[keyof InvestorInvestmentWorkflowControllerBulkUpdateExpectedTransactionTypeResponses];

export type InvestorInvestmentWorkflowControllerDownloadExcelData = {
    body: DownloadInvestmentsExcelDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/mip-investments/download-excel';
};

export type InvestorInvestmentWorkflowControllerDownloadExcelResponses = {
    default: DownloadInvestmentsExcelDto;
};

export type InvestorInvestmentWorkflowControllerDownloadExcelResponse = InvestorInvestmentWorkflowControllerDownloadExcelResponses[keyof InvestorInvestmentWorkflowControllerDownloadExcelResponses];

export type InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
        allocationId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations/{allocationId}';
};

export type InvestorInvestmentWorkflowControllerRemoveInvestmentAllocationResponses = {
    200: unknown;
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationData = {
    body: UpdateInvestmentAllocationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
        allocationId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/allocations/{allocationId}';
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponses = {
    default: InvestmentDetailsAllocation;
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponse = InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponses[keyof InvestorInvestmentWorkflowControllerUpdateInvestmentAllocationResponses];

export type InvestorInvestmentWorkflowControllerAddInvestmentLoanData = {
    body: AddInvestmentLoanDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan';
};

export type InvestorInvestmentWorkflowControllerAddInvestmentLoanResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerAddInvestmentLoanResponse = InvestorInvestmentWorkflowControllerAddInvestmentLoanResponses[keyof InvestorInvestmentWorkflowControllerAddInvestmentLoanResponses];

export type InvestorInvestmentWorkflowControllerRemoveInvestmentLoanData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
        loanId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan/{loanId}';
};

export type InvestorInvestmentWorkflowControllerRemoveInvestmentLoanResponses = {
    200: unknown;
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentLoanData = {
    body: UpdateInvestmentLoanDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
        investmentId: string;
        loanId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/investment-details/{investmentId}/loan/{loanId}';
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponses = {
    default: GetInvestmentDetailsSummaryRes;
};

export type InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponse = InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponses[keyof InvestorInvestmentWorkflowControllerUpdateInvestmentLoanResponses];

export type InvestorInvestmentWorkflowControllerUpsertShareAssociationsData = {
    body: UpsertShareAssociationsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor-investment-workflow/bulk-update-allocations';
};

export type InvestorInvestmentWorkflowControllerUpsertShareAssociationsResponses = {
    201: unknown;
};

export type InvestorControllerGetMipInvestorsListData = {
    body: QueryRequestDtoV2;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/list';
};

export type InvestorControllerGetMipInvestorsListResponses = {
    default: GetInvestorsListRes;
};

export type InvestorControllerGetMipInvestorsListResponse = InvestorControllerGetMipInvestorsListResponses[keyof InvestorControllerGetMipInvestorsListResponses];

export type InvestorControllerGetMipInvestorsOrderedIdsData = {
    body: QueryRequestDtoV2;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/ordered-ids';
};

export type InvestorControllerGetMipInvestorsOrderedIdsResponses = {
    default: GetInvestorOrderedIdsRes;
};

export type InvestorControllerGetMipInvestorsOrderedIdsResponse = InvestorControllerGetMipInvestorsOrderedIdsResponses[keyof InvestorControllerGetMipInvestorsOrderedIdsResponses];

export type InvestorControllerGetMipInvestorsDataForSendModalData = {
    body: InvestorBulkActionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/invite/investors-data';
};

export type InvestorControllerGetMipInvestorsDataForSendModalResponses = {
    default: GetInvestorForSendModalRes;
};

export type InvestorControllerGetMipInvestorsDataForSendModalResponse = InvestorControllerGetMipInvestorsDataForSendModalResponses[keyof InvestorControllerGetMipInvestorsDataForSendModalResponses];

export type InvestorControllerGetMipSelectedInvestorsDataData = {
    body: InvestorBulkActionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/selected-investors';
};

export type InvestorControllerGetMipSelectedInvestorsDataResponses = {
    default: GetSelectedInvestorRes;
};

export type InvestorControllerGetMipSelectedInvestorsDataResponse = InvestorControllerGetMipSelectedInvestorsDataResponses[keyof InvestorControllerGetMipSelectedInvestorsDataResponses];

export type InvestorControllerGetMipInvestorsIdsData = {
    body: InvestorsFilterQueryDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/ids';
};

export type InvestorControllerGetMipInvestorsIdsResponses = {
    default: Array<string>;
};

export type InvestorControllerGetMipInvestorsIdsResponse = InvestorControllerGetMipInvestorsIdsResponses[keyof InvestorControllerGetMipInvestorsIdsResponses];

export type InvestorControllerGetMipInvestorByIdData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor/get-investor-by-id/{id}';
};

export type InvestorControllerGetMipInvestorByIdResponses = {
    default: GetInvestorDetailsWithPersonRes;
};

export type InvestorControllerGetMipInvestorByIdResponse = InvestorControllerGetMipInvestorByIdResponses[keyof InvestorControllerGetMipInvestorByIdResponses];

export type InvestorControllerGetInvestorInvestmentsAndTransactionsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/mip/investor/get-investments-transactions/{investorId}';
};

export type InvestorControllerGetInvestorInvestmentsAndTransactionsResponses = {
    default: GetInvestorInvestmentsAndTransactionsRes;
};

export type InvestorControllerGetInvestorInvestmentsAndTransactionsResponse = InvestorControllerGetInvestorInvestmentsAndTransactionsResponses[keyof InvestorControllerGetInvestorInvestmentsAndTransactionsResponses];

export type InvestorControllerGetMipInvestorDocumentWorkflowListByIdData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/mip/investor/{investorId}/document-workflow';
};

export type InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponses = {
    default: GetInvestorDocumentWorkflowsRes;
};

export type InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponse = InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponses[keyof InvestorControllerGetMipInvestorDocumentWorkflowListByIdResponses];

export type InvestorControllerSendInvitesData = {
    body: SendInvestorInviteDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/invite';
};

export type InvestorControllerSendInvitesResponses = {
    default: InvestorInviteRes;
};

export type InvestorControllerSendInvitesResponse = InvestorControllerSendInvitesResponses[keyof InvestorControllerSendInvitesResponses];

export type InvestorControllerGetMipInvestorsSecuritiesListDataData = {
    body: InvestorBulkActionDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/securities-list';
};

export type InvestorControllerGetMipInvestorsSecuritiesListDataResponses = {
    default: Array<InvestmentSecurityRes>;
};

export type InvestorControllerGetMipInvestorsSecuritiesListDataResponse = InvestorControllerGetMipInvestorsSecuritiesListDataResponses[keyof InvestorControllerGetMipInvestorsSecuritiesListDataResponses];

export type InvestorControllerGetMipDraftJoinerInvestorTemplateData = {
    body: DataJoinerInvestorGetTemplateDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/joiner/template';
};

export type InvestorControllerGetMipDraftJoinerInvestorTemplateResponses = {
    /**
     * Returns .xlsx file with example investors and example values for securities
     */
    default: unknown;
};

export type InvestorControllerPostMipDraftJoinerInvestorTemplateData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/joiner/parse-template';
};

export type InvestorControllerPostMipDraftJoinerInvestorTemplateResponses = {
    /**
     * Responds with request file parsed into JSON
     */
    default: PostInvestorJoinerParseTemplateRes;
};

export type InvestorControllerPostMipDraftJoinerInvestorTemplateResponse = InvestorControllerPostMipDraftJoinerInvestorTemplateResponses[keyof InvestorControllerPostMipDraftJoinerInvestorTemplateResponses];

export type InvestorControllerGetMipDraftLeaverInvestorTemplateData = {
    body: DataJoinerInvestorGetTemplateDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/leaver/template';
};

export type InvestorControllerGetMipDraftLeaverInvestorTemplateResponses = {
    /**
     * Returns .xlsx file with example investors and example values for securities
     */
    default: unknown;
};

export type InvestorControllerPostMipDraftJLeaverInvestorTemplateData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/leaver/parse-template';
};

export type InvestorControllerPostMipDraftJLeaverInvestorTemplateResponses = {
    /**
     * Responds with request file parsed into JSON
     */
    default: PostInvestorLeaverParseTemplateRes;
};

export type InvestorControllerPostMipDraftJLeaverInvestorTemplateResponse = InvestorControllerPostMipDraftJLeaverInvestorTemplateResponses[keyof InvestorControllerPostMipDraftJLeaverInvestorTemplateResponses];

export type InvestorControllerDownloadInvestorsDataData = {
    body: InvestorBulkActionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/bulk-download';
};

export type InvestorControllerDownloadInvestorsDataResponses = {
    201: unknown;
};

export type InvestorControllerStartDownloadInvestorsDataWorkflowData = {
    body: InvestorBulkActionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/bulk-generate-file';
};

export type InvestorControllerStartDownloadInvestorsDataWorkflowResponses = {
    201: unknown;
};

export type InvestorControllerPostRevokeTsaData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/mip/investor/revoke/{investmentWorkflowId}';
};

export type InvestorControllerPostRevokeTsaResponses = {
    /**
     * Revoke requested InvestmentWorkflow
     */
    default: unknown;
};

export type InvestorControllerPostBulkRevokeTsaData = {
    body: BulkRevokeInvestmentWorkflowDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/bulk-revoke';
};

export type InvestorControllerPostBulkRevokeTsaResponses = {
    /**
     * Bulk revoke requested InvestmentWorkflows
     */
    default: unknown;
};

export type InvestorControllerPostRemoveInvestorData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/mip/investor/remove-investor/{investorId}';
};

export type InvestorControllerPostRemoveInvestorResponses = {
    /**
     * Remove investor
     */
    default: unknown;
};

export type InvestorControllerPutInvestorCustomDetailsData = {
    body: UpdateInvestorCustomDetailsDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/mip/investor/{investorId}/custom-details';
};

export type InvestorControllerPutInvestorCustomDetailsResponses = {
    200: unknown;
};

export type InvestorControllerGetSecurityVestingDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        investorId: string;
        securityId: string;
    };
    query?: never;
    url: '/mip/investor/vesting/{investorId}/{securityId}';
};

export type InvestorControllerGetSecurityVestingDataResponses = {
    default: GetSecurityVestingRes;
};

export type InvestorControllerGetSecurityVestingDataResponse = InvestorControllerGetSecurityVestingDataResponses[keyof InvestorControllerGetSecurityVestingDataResponses];

export type InvestorControllerGetInvestorInvestmentValuationsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor/valuations/{id}';
};

export type InvestorControllerGetInvestorInvestmentValuationsResponses = {
    default: GetInvestorValuationsRes;
};

export type InvestorControllerGetInvestorInvestmentValuationsResponse = InvestorControllerGetInvestorInvestmentValuationsResponses[keyof InvestorControllerGetInvestorInvestmentValuationsResponses];

export type InvestorControllerGetInvestmentVehicleValuationsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/mip/investor/investment-vehicle/{personId}/valuations';
};

export type InvestorControllerGetInvestmentVehicleValuationsResponses = {
    default: GetInvestmentVehicleValuationsRes;
};

export type InvestorControllerGetInvestmentVehicleValuationsResponse = InvestorControllerGetInvestmentVehicleValuationsResponses[keyof InvestorControllerGetInvestmentVehicleValuationsResponses];

export type InvestorControllerGetInvestmentVehicleRelatedPeopleData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/mip/investor/investment-vehicle/{personId}/related-people';
};

export type InvestorControllerGetInvestmentVehicleRelatedPeopleResponses = {
    default: GetInvestmentVehicleRelatedPeopleRes;
};

export type InvestorControllerGetInvestmentVehicleRelatedPeopleResponse = InvestorControllerGetInvestmentVehicleRelatedPeopleResponses[keyof InvestorControllerGetInvestmentVehicleRelatedPeopleResponses];

export type InvestorControllerGetInvestmentVehicleHoldingsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/mip/investor/investment-vehicle/{personId}/holdings';
};

export type InvestorControllerGetInvestmentVehicleHoldingsResponses = {
    default: GetInvestorHoldingsRes;
};

export type InvestorControllerGetInvestmentVehicleHoldingsResponse = InvestorControllerGetInvestmentVehicleHoldingsResponses[keyof InvestorControllerGetInvestmentVehicleHoldingsResponses];

export type InvestorControllerGetInvestmentVehicleQuickLinksData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/mip/investor/investment-vehicle/{personId}/quick-links';
};

export type InvestorControllerGetInvestmentVehicleQuickLinksResponses = {
    default: GetInvestmentVehicleQuickLinksRes;
};

export type InvestorControllerGetInvestmentVehicleQuickLinksResponse = InvestorControllerGetInvestmentVehicleQuickLinksResponses[keyof InvestorControllerGetInvestmentVehicleQuickLinksResponses];

export type InvestorControllerGetInvestorQuickLinksData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor/quick-links/{id}';
};

export type InvestorControllerGetInvestorQuickLinksResponses = {
    default: GetInvestorQuickLinksRes;
};

export type InvestorControllerGetInvestorQuickLinksResponse = InvestorControllerGetInvestorQuickLinksResponses[keyof InvestorControllerGetInvestorQuickLinksResponses];

export type InvestorControllerGetInvestorJourneysData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor/journeys/{id}';
};

export type InvestorControllerGetInvestorJourneysResponses = {
    default: GetInvestorJourneysRes;
};

export type InvestorControllerGetInvestorJourneysResponse = InvestorControllerGetInvestorJourneysResponses[keyof InvestorControllerGetInvestorJourneysResponses];

export type InvestorControllerGetInvestorHoldingsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor/holdings/{id}';
};

export type InvestorControllerGetInvestorHoldingsResponses = {
    default: GetInvestorHoldingsRes;
};

export type InvestorControllerGetInvestorHoldingsResponse = InvestorControllerGetInvestorHoldingsResponses[keyof InvestorControllerGetInvestorHoldingsResponses];

export type InvestorControllerGetInvestorHoldingTransactionsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query: {
        holderId: string;
        securityId: string;
        /**
         * Omitted for a holding outside any programme
         */
        programmeId?: string;
    };
    url: '/mip/investor/holdings/{id}/transactions';
};

export type InvestorControllerGetInvestorHoldingTransactionsResponses = {
    default: Array<GetInvestorTransactionDetailsRes>;
};

export type InvestorControllerGetInvestorHoldingTransactionsResponse = InvestorControllerGetInvestorHoldingTransactionsResponses[keyof InvestorControllerGetInvestorHoldingTransactionsResponses];

export type InvestorControllerGetMipInvestorNamesForFilteringData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        cursor?: string;
        limit?: string;
        searchQuery?: string;
    };
    url: '/mip/investor/names/filtering';
};

export type InvestorControllerGetMipInvestorNamesForFilteringResponses = {
    default: GetInvestorNamesForFilteringRes;
};

export type InvestorControllerGetMipInvestorNamesForFilteringResponse = InvestorControllerGetMipInvestorNamesForFilteringResponses[keyof InvestorControllerGetMipInvestorNamesForFilteringResponses];

export type InvestorControllerGetMipInvestmentVehicleNamesForFilteringData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        cursor?: string;
        limit?: string;
        search?: string;
    };
    url: '/mip/investor/investment-vehicles/names/filtering';
};

export type InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponses = {
    default: GetNamesOfPersonWithPivRelationRes;
};

export type InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponse = InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponses[keyof InvestorControllerGetMipInvestmentVehicleNamesForFilteringResponses];

export type InvestorControllerRequestKycData = {
    body: RequestKycDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor/request-kyc';
};

export type InvestorControllerRequestKycResponses = {
    201: unknown;
};

export type InvestorDraftControllerPostMipDraftInvestorTemplateData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor-draft/template';
};

export type InvestorDraftControllerPostMipDraftInvestorTemplateResponses = {
    /**
     * Responds with request file parsed into JSON
     */
    default: PostInvestorDraftRes;
};

export type InvestorDraftControllerPostMipDraftInvestorTemplateResponse = InvestorDraftControllerPostMipDraftInvestorTemplateResponses[keyof InvestorDraftControllerPostMipDraftInvestorTemplateResponses];

export type InvestorDraftControllerGetMipInvestorsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor-draft';
};

export type InvestorDraftControllerGetMipInvestorsResponses = {
    default: GetInvestorDraftRes;
};

export type InvestorDraftControllerGetMipInvestorsResponse = InvestorDraftControllerGetMipInvestorsResponses[keyof InvestorDraftControllerGetMipInvestorsResponses];

export type InvestorDraftControllerPostMipDraftInvestorDataData = {
    body: InvestorDraftDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor-draft';
};

export type InvestorDraftControllerPostMipDraftInvestorDataResponses = {
    200: unknown;
};

export type PaymentControllerGetStatusData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/payment';
};

export type PaymentControllerGetStatusResponses = {
    default: GetPaymentRes;
};

export type PaymentControllerGetStatusResponse = PaymentControllerGetStatusResponses[keyof PaymentControllerGetStatusResponses];

export type PaymentControllerBulkUpdateData = {
    body: BulkPatchPaymentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/payment/bulk';
};

export type PaymentControllerBulkUpdateResponses = {
    default: BulkUpdatePaymentRes;
};

export type PaymentControllerBulkUpdateResponse = PaymentControllerBulkUpdateResponses[keyof PaymentControllerBulkUpdateResponses];

export type PaymentControllerUpdateData = {
    body: PatchPaymentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/payment/{id}';
};

export type PaymentControllerUpdateResponses = {
    200: unknown;
};

export type PaymentControllerDownloadMipPaymentsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/payment/bulk-download';
};

export type PaymentControllerDownloadMipPaymentsResponses = {
    /**
     * Returns .xlsx file with all payments for current mip
     */
    default: unknown;
};

export type LoanDefinitionControllerGetLoansDefinitionByMipIdData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/loan-definition';
};

export type LoanDefinitionControllerGetLoansDefinitionByMipIdResponses = {
    default: Array<DataLoanDefinitionTct>;
};

export type LoanDefinitionControllerGetLoansDefinitionByMipIdResponse = LoanDefinitionControllerGetLoansDefinitionByMipIdResponses[keyof LoanDefinitionControllerGetLoansDefinitionByMipIdResponses];

export type LoanDefinitionControllerCreateLoanDefinitionsData = {
    body: LoanDefinitionDataDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/loan-definition';
};

export type LoanDefinitionControllerCreateLoanDefinitionsResponses = {
    default: Array<DataLoanDefinitionTct>;
};

export type LoanDefinitionControllerCreateLoanDefinitionsResponse = LoanDefinitionControllerCreateLoanDefinitionsResponses[keyof LoanDefinitionControllerCreateLoanDefinitionsResponses];

export type LoanDefinitionControllerDeleteLoanDefinitionData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/loan-definition/{id}';
};

export type LoanDefinitionControllerDeleteLoanDefinitionResponses = {
    200: unknown;
};

export type LoanDefinitionControllerUpdateLoanDefinitionData = {
    body: LoanDefinitionDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/loan-definition/{id}';
};

export type LoanDefinitionControllerUpdateLoanDefinitionResponses = {
    200: unknown;
};

export type CustomDetailControllerToggleArchivedData = {
    body: UpdateArchivedCustomDetailDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        customDetailId: string;
    };
    query?: never;
    url: '/mip/custom-detail/{customDetailId}/archive';
};

export type CustomDetailControllerToggleArchivedResponses = {
    /**
     * Custom detail archived/unarchived successfully
     */
    200: unknown;
};

export type CustomDetailControllerGetAllMipCustomDetailData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/custom-detail';
};

export type CustomDetailControllerGetAllMipCustomDetailResponses = {
    default: Array<DataCustomDetailTct>;
};

export type CustomDetailControllerGetAllMipCustomDetailResponse = CustomDetailControllerGetAllMipCustomDetailResponses[keyof CustomDetailControllerGetAllMipCustomDetailResponses];

export type CustomDetailControllerCreateSingleCustomDetailData = {
    body: CreateCustomDetailDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/custom-detail';
};

export type CustomDetailControllerCreateSingleCustomDetailResponses = {
    201: unknown;
};

export type CustomDetailControllerDeleteSingleCustomDetailData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/custom-detail/{id}';
};

export type CustomDetailControllerDeleteSingleCustomDetailResponses = {
    200: unknown;
};

export type CustomDetailControllerUpdateSingleCustomDetailData = {
    body: UpdateCustomDetailDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/custom-detail/{id}';
};

export type CustomDetailControllerUpdateSingleCustomDetailResponses = {
    200: unknown;
};

export type CustomDetailControllerGetKycWorkflowCustomDetailsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/mip/custom-detail/kycWorkflow/{kycWorkflowId}';
};

export type CustomDetailControllerGetKycWorkflowCustomDetailsResponses = {
    default: Array<KycWorkflowCustomDetailResponseDto>;
};

export type CustomDetailControllerGetKycWorkflowCustomDetailsResponse = CustomDetailControllerGetKycWorkflowCustomDetailsResponses[keyof CustomDetailControllerGetKycWorkflowCustomDetailsResponses];

export type CustomDetailControllerUpdateKycWorkflowCustomDetailData = {
    body: UpdateKycWorkflowCustomDetailDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/mip/custom-detail/kycWorkflow/{kycWorkflowId}';
};

export type CustomDetailControllerUpdateKycWorkflowCustomDetailResponses = {
    200: unknown;
};

export type OrganizationControllerGetAllOrganizationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        page?: number;
        limit?: number;
        /**
         * Case-insensitive substring match over organization name and contact email
         */
        search?: string;
    };
    url: '/organization';
};

export type OrganizationControllerGetAllOrganizationsResponses = {
    /**
     * Returns one page of DealStack organizations, searchable by name and contact email. Restricted to DealStack support users.
     */
    default: OrganizationListRes;
};

export type OrganizationControllerGetAllOrganizationsResponse = OrganizationControllerGetAllOrganizationsResponses[keyof OrganizationControllerGetAllOrganizationsResponses];

export type OrganizationControllerCreateOrganizationData = {
    body: CreateOrganizationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/organization';
};

export type OrganizationControllerCreateOrganizationResponses = {
    201: unknown;
};

export type OrganizationControllerLookupWorkOsOrganizationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * Email domain to look up, e.g. `dealstack.io`. A leading `@` is ignored.
         */
        domain: string;
    };
    url: '/organization/workos-lookup';
};

export type OrganizationControllerLookupWorkOsOrganizationsResponses = {
    /**
     * Finds WorkOs organizations by email domain so one can be imported. Capped; `truncated` says when more matched.
     */
    default: WorkOsOrganizationLookupRes;
};

export type OrganizationControllerLookupWorkOsOrganizationsResponse = OrganizationControllerLookupWorkOsOrganizationsResponses[keyof OrganizationControllerLookupWorkOsOrganizationsResponses];

export type OrganizationControllerDeleteOrganizationData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}';
};

export type OrganizationControllerDeleteOrganizationResponses = {
    200: unknown;
};

export type OrganizationControllerGetOrganizationDetailsByIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}';
};

export type OrganizationControllerGetOrganizationDetailsByIdResponses = {
    default: OrganizationRes;
};

export type OrganizationControllerGetOrganizationDetailsByIdResponse = OrganizationControllerGetOrganizationDetailsByIdResponses[keyof OrganizationControllerGetOrganizationDetailsByIdResponses];

export type OrganizationControllerUpdateOrganizationData = {
    body: UpdateOrganizationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}';
};

export type OrganizationControllerUpdateOrganizationResponses = {
    default: OrganizationRes;
};

export type OrganizationControllerUpdateOrganizationResponse = OrganizationControllerUpdateOrganizationResponses[keyof OrganizationControllerUpdateOrganizationResponses];

export type OrganizationControllerUpdateOrganizationTypeData = {
    body: UpdateOrganizationTypeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}/type';
};

export type OrganizationControllerUpdateOrganizationTypeResponses = {
    default: OrganizationRes;
};

export type OrganizationControllerUpdateOrganizationTypeResponse = OrganizationControllerUpdateOrganizationTypeResponses[keyof OrganizationControllerUpdateOrganizationTypeResponses];

export type OrganizationControllerImportOrganizationData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        authenticationProviderOrgId: string;
    };
    query?: never;
    url: '/organization/import/{authenticationProviderOrgId}';
};

export type OrganizationControllerImportOrganizationResponses = {
    default: OrganizationRes;
};

export type OrganizationControllerImportOrganizationResponse = OrganizationControllerImportOrganizationResponses[keyof OrganizationControllerImportOrganizationResponses];

export type KycSettingControllerGetMipRequirementsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/kyc-setting/mip';
};

export type KycSettingControllerGetMipRequirementsResponses = {
    default: MipKycSettingResponseDto;
};

export type KycSettingControllerGetMipRequirementsResponse = KycSettingControllerGetMipRequirementsResponses[keyof KycSettingControllerGetMipRequirementsResponses];

export type KycSettingControllerUpdateMipRequirementsData = {
    body: UpdateMipKycSettingDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/kyc-setting/mip';
};

export type KycSettingControllerUpdateMipRequirementsResponses = {
    200: unknown;
};

export type KycSettingControllerGetByKycWorkflowIdData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/kyc-setting/kycWorkflow/{kycWorkflowId}';
};

export type KycSettingControllerGetByKycWorkflowIdResponses = {
    default: KycWorkflowSettingResponseDto;
};

export type KycSettingControllerGetByKycWorkflowIdResponse = KycSettingControllerGetByKycWorkflowIdResponses[keyof KycSettingControllerGetByKycWorkflowIdResponses];

export type KycSettingControllerUpdateByKycWorkflowIdData = {
    body: UpdateKycWorkflowSettingDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/kyc-setting/kycWorkflow/{kycWorkflowId}';
};

export type KycSettingControllerUpdateByKycWorkflowIdResponses = {
    200: unknown;
};

export type KycControllerGetKycWorkflowsDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        sortBy?: string;
        sortDesc?: boolean;
        investmentType?: Array<string>;
        cohortIds?: Array<string>;
        status?: 'OPEN' | 'DEFINITION_COMPLETE' | 'IN_PROGRESS' | 'APPROVED' | 'WITHDRAWN';
        investorIds?: Array<string>;
        masterFilter?: KycMasterFilter;
        declarationsStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
        proofOfIdentityStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
        proofOfAddressStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
        investmentVehicleStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
        formsStatus?: Array<'APPROVED' | 'PENDING' | 'REJECTED' | 'REREQUESTED' | 'REQUESTED'>;
        searchQuery?: string;
    };
    url: '/mip/kyc/workflows';
};

export type KycControllerGetKycWorkflowsDataResponses = {
    default: GetKycWorkflowsRes;
};

export type KycControllerGetKycWorkflowsDataResponse = KycControllerGetKycWorkflowsDataResponses[keyof KycControllerGetKycWorkflowsDataResponses];

export type KycControllerGetKycInvestorsDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        offset?: string;
        limit?: string;
        searchQuery?: string;
    };
    url: '/mip/kyc/investors';
};

export type KycControllerGetKycInvestorsDataResponses = {
    default: GetKycRes;
};

export type KycControllerGetKycInvestorsDataResponse = KycControllerGetKycInvestorsDataResponses[keyof KycControllerGetKycInvestorsDataResponses];

export type KycControllerGetKycInvestorDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/mip/kyc/investors/{investorId}';
};

export type KycControllerGetKycInvestorDataResponses = {
    default: GetKycRes;
};

export type KycControllerGetKycInvestorDataResponse = KycControllerGetKycInvestorDataResponses[keyof KycControllerGetKycInvestorDataResponses];

export type KycControllerMorePivDocumentsData = {
    body: InvestorProcessSettingsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/mip/kyc/more-piv-documents/{investorId}';
};

export type KycControllerMorePivDocumentsResponses = {
    200: unknown;
};

export type KycControllerGetInvestorsStatisticsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/kyc/statistics';
};

export type KycControllerGetInvestorsStatisticsResponses = {
    default: GetKycStatisticsRes;
};

export type KycControllerGetInvestorsStatisticsResponse = KycControllerGetInvestorsStatisticsResponses[keyof KycControllerGetInvestorsStatisticsResponses];

export type KycControllerUpdateKycStatusData = {
    body: UpdateAcceptanceStatusDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/kyc/kyc-file/{id}';
};

export type KycControllerUpdateKycStatusResponses = {
    200: unknown;
};

export type KycControllerUpdateKycFileData = {
    body: UpdateKycFileDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/kyc/kyc-file/{id}';
};

export type KycControllerUpdateKycFileResponses = {
    200: unknown;
};

export type KycControllerResendKycFileCertifierInvitationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/kyc/kyc-file/{id}/certification/resend';
};

export type KycControllerResendKycFileCertifierInvitationResponses = {
    default: KycFileCertificationRes;
};

export type KycControllerResendKycFileCertifierInvitationResponse = KycControllerResendKycFileCertifierInvitationResponses[keyof KycControllerResendKycFileCertifierInvitationResponses];

export type KycControllerUpdateDeclarationsStatusData = {
    body: UpdateAcceptanceStatusDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/mip/kyc/{investorId}/declarations';
};

export type KycControllerUpdateDeclarationsStatusResponses = {
    200: unknown;
};

export type KycControllerSetInvestorDeclarationsData = {
    body: PatchDeclarationsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/mip/kyc/{investorId}/declarations';
};

export type KycControllerSetInvestorDeclarationsResponses = {
    200: unknown;
};

export type KycControllerDownloadInvestorsFilesData = {
    body: BulkDownloadKycDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/kyc/bulk-download';
};

export type KycControllerDownloadInvestorsFilesResponses = {
    201: unknown;
};

export type KycControllerPutAssociateKycFileData = {
    body: CreateKycFileViaKycAdminDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/kyc/associate-kyc-file';
};

export type KycControllerPutAssociateKycFileResponses = {
    200: unknown;
};

export type KycControllerDeleteKycFileData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        userId: string;
    };
    query?: never;
    url: '/mip/kyc/kyc-file/{id}/{userId}';
};

export type KycControllerDeleteKycFileResponses = {
    200: unknown;
};

export type KycControllerWithdrawStandaloneKycWorkflowData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/mip/kyc/workflows/standalone/{kycWorkflowId}';
};

export type KycControllerWithdrawStandaloneKycWorkflowResponses = {
    200: unknown;
};

export type AuthControllerStartHostedAuthKitData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * Which app the callback lands on. Rejected if outside the enum.
         */
        applicationType: ApplicationType;
        /**
         * Opens AuthKit on its sign-in or sign-up screen.
         */
        screenHint?: AuthKitScreenHint;
        /**
         * From the invitation email. A usable token goes to AuthKit, a superseded one to the pending invitation for the same address, and an expired or unknown one to the invitation-expired page. A malformed one is refused.
         */
        invitationToken?: string;
    };
    url: '/auth/start';
};

export type AuthControllerStartHostedAuthKitResponses = {
    200: unknown;
};

export type AuthControllerCanChangeCredentialsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/can-change-credentials';
};

export type AuthControllerCanChangeCredentialsResponses = {
    default: CanChangeCredentialsRes;
};

export type AuthControllerCanChangeCredentialsResponse = AuthControllerCanChangeCredentialsResponses[keyof AuthControllerCanChangeCredentialsResponses];

export type AuthControllerDeleteChangeEmailRequestData = {
    body: DeleteChangeEmailRequestDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/change-email';
};

export type AuthControllerDeleteChangeEmailRequestResponses = {
    200: unknown;
};

export type AuthControllerUpdateEmailData = {
    body: ChangeEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/change-email';
};

export type AuthControllerUpdateEmailResponses = {
    201: unknown;
};

export type AuthControllerChangeEmailRequestData = {
    body: ChangeEmailRequestDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/change-email/request';
};

export type AuthControllerChangeEmailRequestResponses = {
    201: unknown;
};

export type AuthControllerCancelChangeEmailRequestData = {
    body: CancelChangeEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/change-email/cancel';
};

export type AuthControllerCancelChangeEmailRequestResponses = {
    200: unknown;
};

export type AuthControllerRenewInvitationData = {
    body: RenewInvitationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/invitation/renew';
};

export type AuthControllerRenewInvitationResponses = {
    default: InvitationRenewalRes;
};

export type AuthControllerRenewInvitationResponse = AuthControllerRenewInvitationResponses[keyof AuthControllerRenewInvitationResponses];

export type TwoFaControllerSetup2FaData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/2FA/setup';
};

export type TwoFaControllerSetup2FaResponses = {
    default: Auth2FaChallengeAndFactorResponse;
};

export type TwoFaControllerSetup2FaResponse = TwoFaControllerSetup2FaResponses[keyof TwoFaControllerSetup2FaResponses];

export type TwoFaControllerVerifyChallenge2FaData = {
    body: VerifyChallenge2FaDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/2FA/verify-challenge';
};

export type TwoFaControllerVerifyChallenge2FaResponses = {
    default: VerifyChallengeResponse;
};

export type TwoFaControllerVerifyChallenge2FaResponse = TwoFaControllerVerifyChallenge2FaResponses[keyof TwoFaControllerVerifyChallenge2FaResponses];

export type TwoFaControllerDeleteAuthFactorData = {
    body: DeleteAuthFactorDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/2FA/delete-factor';
};

export type TwoFaControllerDeleteAuthFactorResponses = {
    200: unknown;
};

export type PasswordControllerUpdatePasswordData = {
    body: ChangePasswordDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/change-password';
};

export type PasswordControllerUpdatePasswordResponses = {
    201: unknown;
};

export type SessionManagementControllerRefreshTokenData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/refresh-token';
};

export type SessionManagementControllerRefreshTokenResponses = {
    200: unknown;
};

export type SessionManagementControllerGetSessionStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/session';
};

export type SessionManagementControllerGetSessionStatusResponses = {
    default: SessionStatusResponse;
};

export type SessionManagementControllerGetSessionStatusResponse = SessionManagementControllerGetSessionStatusResponses[keyof SessionManagementControllerGetSessionStatusResponses];

export type SessionManagementControllerKeepSessionAliveData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/session/keep-alive';
};

export type SessionManagementControllerKeepSessionAliveResponses = {
    default: SessionStatusResponse;
};

export type SessionManagementControllerKeepSessionAliveResponse = SessionManagementControllerKeepSessionAliveResponses[keyof SessionManagementControllerKeepSessionAliveResponses];

export type SessionManagementControllerLogoutData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/logout';
};

export type SessionManagementControllerLogoutResponses = {
    200: unknown;
};

export type SessionManagementControllerSignOutData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/sign-out';
};

export type SessionManagementControllerSignOutResponses = {
    200: unknown;
};

export type SessionManagementControllerRedirectCallbackFromWorkOsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * Authorization code from WorkOs provider
         */
        code: string;
        /**
         * OAuth error from the provider, e.g. access_denied when the user cancels.
         */
        error?: string;
        /**
         * Provider-authored detail for `error`. Logged, never shown to the user.
         */
        error_description?: string;
        /**
         * Optional state parameter to encodeApiBody information to help restore application state between redirects.
         */
        state?: 'godmode' | 'dealstack' | 'investor';
    };
    url: '/auth/redirectUri';
};

export type SessionManagementControllerRedirectCallbackFromWorkOsResponses = {
    200: unknown;
};

export type SessionManagementControllerSendMagicAuthVerificationCodeData = {
    body: SendVerificationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/email/send/magic-code';
};

export type SessionManagementControllerSendMagicAuthVerificationCodeResponses = {
    200: unknown;
};

export type SessionManagementControllerValidateMagicCodeData = {
    body: ValidateMagicCodeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/email/validate/magic-code';
};

export type SessionManagementControllerValidateMagicCodeResponses = {
    default: ValidateAuthResponse;
};

export type SessionManagementControllerValidateMagicCodeResponse = SessionManagementControllerValidateMagicCodeResponses[keyof SessionManagementControllerValidateMagicCodeResponses];

export type ProfileControllerUpdatePhoneData = {
    body: UpdatePhoneDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/auth/profile/phone';
};

export type ProfileControllerUpdatePhoneResponses = {
    200: unknown;
};

export type DealControllerSoftDeleteDealData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal';
};

export type DealControllerSoftDeleteDealResponses = {
    200: unknown;
};

export type DealControllerGetListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal';
};

export type DealControllerGetListResponses = {
    default: Array<SummaryDealExtendedTct>;
};

export type DealControllerGetListResponse = DealControllerGetListResponses[keyof DealControllerGetListResponses];

export type DealControllerUpdateDealData = {
    body: UpdateDealDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal';
};

export type DealControllerUpdateDealResponses = {
    200: unknown;
};

export type DealControllerCreateDealData = {
    body: CreateDealDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal';
};

export type DealControllerCreateDealResponses = {
    default: SummaryDealExtendedTct;
};

export type DealControllerCreateDealResponse = DealControllerCreateDealResponses[keyof DealControllerCreateDealResponses];

export type DealControllerGetDealData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal/data';
};

export type DealControllerGetDealResponses = {
    default: SummaryDealTct;
};

export type DealControllerGetDealResponse = DealControllerGetDealResponses[keyof DealControllerGetDealResponses];

export type DealControllerGetDealBasicDataData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal/basic-data';
};

export type DealControllerGetDealBasicDataResponses = {
    default: DealBasicDataTct;
};

export type DealControllerGetDealBasicDataResponse = DealControllerGetDealBasicDataResponses[keyof DealControllerGetDealBasicDataResponses];

export type DealControllerGetDealDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}';
};

export type DealControllerGetDealDetailsResponses = {
    default: SummaryDealExtendedTct;
};

export type DealControllerGetDealDetailsResponse = DealControllerGetDealDetailsResponses[keyof DealControllerGetDealDetailsResponses];

export type DealControllerSetDealRestrictionData = {
    body: SetDealRestrictionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/restriction';
};

export type DealControllerSetDealRestrictionResponses = {
    200: unknown;
};

export type DealControllerGetDealClassifiersData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query: {
        filters: DealClassifiersFiltersDto;
    };
    url: '/deal/{dealId}/classifiers';
};

export type DealControllerGetDealClassifiersResponses = {
    default: FindDealClassifiersRes;
};

export type DealControllerGetDealClassifiersResponse = DealControllerGetDealClassifiersResponses[keyof DealControllerGetDealClassifiersResponses];

export type DealControllerCreateDealClassifiersData = {
    body: CreateDealClassifierDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/classifiers';
};

export type DealControllerCreateDealClassifiersResponses = {
    default: DealClassifierTct;
};

export type DealControllerCreateDealClassifiersResponse = DealControllerCreateDealClassifiersResponses[keyof DealControllerCreateDealClassifiersResponses];

export type DealControllerUpdateDealClassifiersData = {
    body: UpdateDealClassifierDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        dealClassifierId: string;
    };
    query?: never;
    url: '/deal/{dealId}/classifiers/{dealClassifierId}';
};

export type DealControllerUpdateDealClassifiersResponses = {
    default: DealClassifierTct;
};

export type DealControllerUpdateDealClassifiersResponse = DealControllerUpdateDealClassifiersResponses[keyof DealControllerUpdateDealClassifiersResponses];

export type DealControllerUpdateProjectRepresentativeData = {
    body: UpdateCompanyRepresentativeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/update-project-representative';
};

export type DealControllerUpdateProjectRepresentativeResponses = {
    200: unknown;
};

export type DealControllerUpdateCompanyRepresentativeData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/project-representative';
};

export type DealControllerUpdateCompanyRepresentativeResponses = {
    default: ProjectRepresentativeUserEntityRes;
};

export type DealControllerUpdateCompanyRepresentativeResponse = DealControllerUpdateCompanyRepresentativeResponses[keyof DealControllerUpdateCompanyRepresentativeResponses];

export type DealUsersControllerGetDealUsersData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/users';
};

export type DealUsersControllerGetDealUsersResponses = {
    default: Array<BasicUserWithPermissionRolesRes>;
};

export type DealUsersControllerGetDealUsersResponse = DealUsersControllerGetDealUsersResponses[keyof DealUsersControllerGetDealUsersResponses];

export type DealUsersControllerInviteUserToDealData = {
    body: InviteUserToDealDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/users';
};

export type DealUsersControllerInviteUserToDealResponses = {
    201: unknown;
};

export type DealUsersControllerSyncUserInDealToAllProgrammesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        userId: string;
    };
    query?: never;
    url: '/deal/{dealId}/users/{userId}/sync';
};

export type DealUsersControllerSyncUserInDealToAllProgrammesResponses = {
    200: unknown;
};

export type DealUsersControllerDeleteUserFromDealData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        userId: string;
    };
    query?: never;
    url: '/deal/{dealId}/users/{userId}';
};

export type DealUsersControllerDeleteUserFromDealResponses = {
    200: unknown;
};

export type DealUsersControllerGetDealUserData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/users/{userId}';
};

export type DealUsersControllerGetDealUserResponses = {
    default: BasicUserWithPermissionsRes;
};

export type DealUsersControllerGetDealUserResponse = DealUsersControllerGetDealUserResponses[keyof DealUsersControllerGetDealUserResponses];

export type ProgrammeUsersControllerGetProgrammeUsersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/mip/{programmeId}/users';
};

export type ProgrammeUsersControllerGetProgrammeUsersResponses = {
    default: Array<ProgrammeUserWithPermissionRolesRes>;
};

export type ProgrammeUsersControllerGetProgrammeUsersResponse = ProgrammeUsersControllerGetProgrammeUsersResponses[keyof ProgrammeUsersControllerGetProgrammeUsersResponses];

export type ProgrammeUsersControllerInviteUserToProgrammeData = {
    body: InviteUserToProgrammeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/mip/{programmeId}/users';
};

export type ProgrammeUsersControllerInviteUserToProgrammeResponses = {
    201: unknown;
};

export type ProgrammeUsersControllerDeleteUserFromProgrammeData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * User ID to delete from programme
         */
        userId: string;
        programmeId: string;
    };
    query?: never;
    url: '/mip/{programmeId}/users/{userId}';
};

export type ProgrammeUsersControllerDeleteUserFromProgrammeResponses = {
    /**
     * Returns the deleted userProgram data
     */
    200: unknown;
};

export type ProgrammeUsersControllerGetProgrammeUserData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        userId: string;
        programmeId: string;
    };
    query?: never;
    url: '/mip/{programmeId}/users/{userId}';
};

export type ProgrammeUsersControllerGetProgrammeUserResponses = {
    default: ProgrammeUserWithPermissionsRes;
};

export type ProgrammeUsersControllerGetProgrammeUserResponse = ProgrammeUsersControllerGetProgrammeUserResponses[keyof ProgrammeUsersControllerGetProgrammeUserResponses];

export type ProgrammeUsersControllerUpdateUserAndUserProgrammeData = {
    body: UpdateProgrammeUserDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        userId: string;
        programmeId: string;
    };
    query?: never;
    url: '/mip/{programmeId}/users/{userId}';
};

export type ProgrammeUsersControllerUpdateUserAndUserProgrammeResponses = {
    default: ProgrammeUserWithPermissionsRes;
};

export type ProgrammeUsersControllerUpdateUserAndUserProgrammeResponse = ProgrammeUsersControllerUpdateUserAndUserProgrammeResponses[keyof ProgrammeUsersControllerUpdateUserAndUserProgrammeResponses];

export type CapTableControllerDownloadExcelData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query: {
        format: ExcelFormat;
        filterDate?: string;
        rail?: CapTableRail;
    };
    url: '/cap/download-excel';
};

export type CapTableControllerDownloadExcelResponses = {
    200: unknown;
};

export type CapTableControllerPostCapTableDataData = {
    body: GetCapTableDataDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/data';
};

export type CapTableControllerPostCapTableDataResponses = {
    default: GetCapTableDataRes;
};

export type CapTableControllerPostCapTableDataResponse = CapTableControllerPostCapTableDataResponses[keyof CapTableControllerPostCapTableDataResponses];

export type CapTableControllerPostGroupStructureDataData = {
    body: GetCapTableDataDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/group-structure-data';
};

export type CapTableControllerPostGroupStructureDataResponses = {
    default: GetGroupStructureDataRes;
};

export type CapTableControllerPostGroupStructureDataResponse = CapTableControllerPostGroupStructureDataResponses[keyof CapTableControllerPostGroupStructureDataResponses];

export type CapTableControllerPostSecuritiesForGroupStructureDataData = {
    body: GetCapTableDataDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/group-structure-data/securities';
};

export type CapTableControllerPostSecuritiesForGroupStructureDataResponses = {
    default: Array<ChartSecuritiesTct>;
};

export type CapTableControllerPostSecuritiesForGroupStructureDataResponse = CapTableControllerPostSecuritiesForGroupStructureDataResponses[keyof CapTableControllerPostSecuritiesForGroupStructureDataResponses];

export type CapTableControllerPostGroupStructurePositionsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/group-structure-positions';
};

export type CapTableControllerPostGroupStructurePositionsResponses = {
    default: GetGroupStructurePositionsDataRes;
};

export type CapTableControllerPostGroupStructurePositionsResponse = CapTableControllerPostGroupStructurePositionsResponses[keyof CapTableControllerPostGroupStructurePositionsResponses];

export type CapTableControllerUpdateGroupStructurePositionsData = {
    body: UpdateGroupStructurePositionsDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/group-structure-positions';
};

export type CapTableControllerUpdateGroupStructurePositionsResponses = {
    default: GetGroupStructurePositionsDataRes;
};

export type CapTableControllerUpdateGroupStructurePositionsResponse = CapTableControllerUpdateGroupStructurePositionsResponses[keyof CapTableControllerUpdateGroupStructurePositionsResponses];

export type CapTableControllerGetCapDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/cap/deal/{dealId}/cap/details';
};

export type CapTableControllerGetCapDetailsResponses = {
    default: GetCapDetailsRes;
};

export type CapTableControllerGetCapDetailsResponse = CapTableControllerGetCapDetailsResponses[keyof CapTableControllerGetCapDetailsResponses];

export type CapTableControllerGetCapTransactionsValidationDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/cap/deal/{dealId}/cap/validation-details';
};

export type CapTableControllerGetCapTransactionsValidationDetailsResponses = {
    default: GetCapTransactionsValidationDetailsRes;
};

export type CapTableControllerGetCapTransactionsValidationDetailsResponse = CapTableControllerGetCapTransactionsValidationDetailsResponses[keyof CapTableControllerGetCapTransactionsValidationDetailsResponses];

export type CapTableControllerExportDealHoldingsJsonData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: {
        filterDate?: string;
        rail?: CapTableRail;
    };
    url: '/cap/deal/{dealId}/export-file';
};

export type CapTableControllerExportDealHoldingsJsonResponses = {
    default: DealExtractRes;
};

export type CapTableControllerExportDealHoldingsJsonResponse = CapTableControllerExportDealHoldingsJsonResponses[keyof CapTableControllerExportDealHoldingsJsonResponses];

export type DealEmailTemplateControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal-email-template';
};

export type DealEmailTemplateControllerListResponses = {
    200: Array<EmailTemplateSummaryRes>;
};

export type DealEmailTemplateControllerListResponse = DealEmailTemplateControllerListResponses[keyof DealEmailTemplateControllerListResponses];

export type DealEmailTemplateControllerGetOneData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/deal-email-template/{type}';
};

export type DealEmailTemplateControllerGetOneResponses = {
    200: EmailTemplateDetailRes;
};

export type DealEmailTemplateControllerGetOneResponse = DealEmailTemplateControllerGetOneResponses[keyof DealEmailTemplateControllerGetOneResponses];

export type DealEmailTemplateControllerUpdateData = {
    body: UpdateEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/deal-email-template/{type}';
};

export type DealEmailTemplateControllerUpdateResponses = {
    200: EmailTemplateDetailRes;
};

export type DealEmailTemplateControllerUpdateResponse = DealEmailTemplateControllerUpdateResponses[keyof DealEmailTemplateControllerUpdateResponses];

export type DealEmailTemplateControllerPreviewData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/deal-email-template/{type}/preview';
};

export type DealEmailTemplateControllerPreviewResponses = {
    200: EmailTemplatePreviewRes;
};

export type DealEmailTemplateControllerPreviewResponse = DealEmailTemplateControllerPreviewResponses[keyof DealEmailTemplateControllerPreviewResponses];

export type DealEmailTemplateControllerTestSendData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/deal-email-template/{type}/test-send';
};

export type DealEmailTemplateControllerTestSendResponses = {
    200: EmailTemplateTestSendRes;
};

export type DealEmailTemplateControllerTestSendResponse = DealEmailTemplateControllerTestSendResponses[keyof DealEmailTemplateControllerTestSendResponses];

export type DealEmailTemplateControllerResetData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/deal-email-template/{type}/reset';
};

export type DealEmailTemplateControllerResetResponses = {
    200: EmailTemplateDetailRes;
};

export type DealEmailTemplateControllerResetResponse = DealEmailTemplateControllerResetResponses[keyof DealEmailTemplateControllerResetResponses];

export type OrganizationDealEmailTemplateControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/deal-defaults/email-template/{organizationId}';
};

export type OrganizationDealEmailTemplateControllerListResponses = {
    200: Array<EmailTemplateSummaryRes>;
};

export type OrganizationDealEmailTemplateControllerListResponse = OrganizationDealEmailTemplateControllerListResponses[keyof OrganizationDealEmailTemplateControllerListResponses];

export type OrganizationDealEmailTemplateControllerGetOneData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/deal-defaults/email-template/{organizationId}/{type}';
};

export type OrganizationDealEmailTemplateControllerGetOneResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationDealEmailTemplateControllerGetOneResponse = OrganizationDealEmailTemplateControllerGetOneResponses[keyof OrganizationDealEmailTemplateControllerGetOneResponses];

export type OrganizationDealEmailTemplateControllerUpdateData = {
    body: UpdateEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/deal-defaults/email-template/{organizationId}/{type}';
};

export type OrganizationDealEmailTemplateControllerUpdateResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationDealEmailTemplateControllerUpdateResponse = OrganizationDealEmailTemplateControllerUpdateResponses[keyof OrganizationDealEmailTemplateControllerUpdateResponses];

export type OrganizationDealEmailTemplateControllerPreviewData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/deal-defaults/email-template/{organizationId}/{type}/preview';
};

export type OrganizationDealEmailTemplateControllerPreviewResponses = {
    200: EmailTemplatePreviewRes;
};

export type OrganizationDealEmailTemplateControllerPreviewResponse = OrganizationDealEmailTemplateControllerPreviewResponses[keyof OrganizationDealEmailTemplateControllerPreviewResponses];

export type OrganizationDealEmailTemplateControllerResetData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/deal-defaults/email-template/{organizationId}/{type}/reset';
};

export type OrganizationDealEmailTemplateControllerResetResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationDealEmailTemplateControllerResetResponse = OrganizationDealEmailTemplateControllerResetResponses[keyof OrganizationDealEmailTemplateControllerResetResponses];

export type OrganizationDealClassifierControllerListClassifiersData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/deal-defaults/classifier/{organizationId}';
};

export type OrganizationDealClassifierControllerListClassifiersResponses = {
    default: OrganizationDealClassifierListRes;
};

export type OrganizationDealClassifierControllerListClassifiersResponse = OrganizationDealClassifierControllerListClassifiersResponses[keyof OrganizationDealClassifierControllerListClassifiersResponses];

export type OrganizationDealClassifierControllerSetClassifiersData = {
    body: SetOrganizationDealClassifiersDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/deal-defaults/classifier/{organizationId}';
};

export type OrganizationDealClassifierControllerSetClassifiersResponses = {
    200: unknown;
};

export type FundControllerGetAllFundsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        organizationId: string;
    };
    url: '/fund';
};

export type FundControllerGetAllFundsResponses = {
    default: Array<FundWithDealRes>;
};

export type FundControllerGetAllFundsResponse = FundControllerGetAllFundsResponses[keyof FundControllerGetAllFundsResponses];

export type FundControllerCreateFundData = {
    body: CreateFundDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/fund';
};

export type FundControllerCreateFundResponses = {
    default: FundRes;
};

export type FundControllerCreateFundResponse = FundControllerCreateFundResponses[keyof FundControllerCreateFundResponses];

export type FundControllerGetFundData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fundId: string;
    };
    query?: never;
    url: '/fund/{fundId}';
};

export type FundControllerGetFundResponses = {
    default: FundWithDealRes;
};

export type FundControllerGetFundResponse = FundControllerGetFundResponses[keyof FundControllerGetFundResponses];

export type FundControllerUpdateFundData = {
    body: UpdateFundDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fundId: string;
    };
    query?: never;
    url: '/fund/{fundId}';
};

export type FundControllerUpdateFundResponses = {
    default: FundWithDealRes;
};

export type FundControllerUpdateFundResponse = FundControllerUpdateFundResponses[keyof FundControllerUpdateFundResponses];

export type FundControllerGetFundLinkedDealsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fundId: string;
    };
    query?: never;
    url: '/fund/{fundId}/linked-deals';
};

export type FundControllerGetFundLinkedDealsResponses = {
    default: FundDealWithDealRes;
};

export type FundControllerGetFundLinkedDealsResponse = FundControllerGetFundLinkedDealsResponses[keyof FundControllerGetFundLinkedDealsResponses];

export type FundControllerGetAvailableDealsForFundData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fundId: string;
    };
    query?: never;
    url: '/fund/{fundId}/available-deals';
};

export type FundControllerGetAvailableDealsForFundResponses = {
    default: Array<FundDealSummaryRes>;
};

export type FundControllerGetAvailableDealsForFundResponse = FundControllerGetAvailableDealsForFundResponses[keyof FundControllerGetAvailableDealsForFundResponses];

export type FundControllerGetAvailableDealsForPersonFundLinkData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fundId: string;
        personId: string;
    };
    query?: never;
    url: '/fund/{fundId}/available-deals-for-person/{personId}';
};

export type FundControllerGetAvailableDealsForPersonFundLinkResponses = {
    default: AvailableDealsForPersonFundLinkRes;
};

export type FundControllerGetAvailableDealsForPersonFundLinkResponse = FundControllerGetAvailableDealsForPersonFundLinkResponses[keyof FundControllerGetAvailableDealsForPersonFundLinkResponses];

export type FundControllerGetFundByDealData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/fund/deal/{dealId}';
};

export type FundControllerGetFundByDealResponses = {
    default: FundWithDealRes;
};

export type FundControllerGetFundByDealResponse = FundControllerGetFundByDealResponses[keyof FundControllerGetFundByDealResponses];

export type FundControllerLinkFundToDealData = {
    body: LinkFundToDealDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/fund/deal-link';
};

export type FundControllerLinkFundToDealResponses = {
    default: FundDealRes;
};

export type FundControllerLinkFundToDealResponse = FundControllerLinkFundToDealResponses[keyof FundControllerLinkFundToDealResponses];

export type FundControllerUnlinkFundFromDealData = {
    body: LinkFundToDealDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/fund/deal-unlink';
};

export type FundControllerUnlinkFundFromDealResponses = {
    201: unknown;
};

export type FundControllerUnlinkPersonFromFundData = {
    body: LinkPersonToFundDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/fund/link-person';
};

export type FundControllerUnlinkPersonFromFundResponses = {
    200: unknown;
};

export type FundControllerLinkPersonToFundData = {
    body: LinkPersonToFundDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/fund/link-person';
};

export type FundControllerLinkPersonToFundResponses = {
    default: PersonFundLinkRes;
};

export type FundControllerLinkPersonToFundResponse = FundControllerLinkPersonToFundResponses[keyof FundControllerLinkPersonToFundResponses];

export type FundControllerGetFundLinksForPersonData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/fund/person/{personId}/fund-links';
};

export type FundControllerGetFundLinksForPersonResponses = {
    default: Array<PersonFundLinkRes>;
};

export type FundControllerGetFundLinksForPersonResponse = FundControllerGetFundLinksForPersonResponses[keyof FundControllerGetFundLinksForPersonResponses];

export type MipControllerGetEmailWorkflowStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        handlerId: string;
    };
    query?: never;
    url: '/mip/email-workflow-progress/{handlerId}';
};

export type MipControllerGetEmailWorkflowStatusResponses = {
    default: EmailWorkflowProgressRes;
};

export type MipControllerGetEmailWorkflowStatusResponse = MipControllerGetEmailWorkflowStatusResponses[keyof MipControllerGetEmailWorkflowStatusResponses];

export type MipControllerListProgrammesData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Whether to use fallback if no MIPs found
         */
        fallback?: Object;
    };
    url: '/mip';
};

export type MipControllerListProgrammesResponses = {
    /**
     * Get Mips with fallback by deal ID
     */
    default: DataMipTct;
};

export type MipControllerListProgrammesResponse = MipControllerListProgrammesResponses[keyof MipControllerListProgrammesResponses];

export type MipControllerUpdateMipDataData = {
    body: UpdateMipDataDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip';
};

export type MipControllerUpdateMipDataResponses = {
    200: unknown;
};

export type MipControllerGetMipProgrammeEntitiesData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/entities';
};

export type MipControllerGetMipProgrammeEntitiesResponses = {
    default: Array<MipProgrammeEntityRes>;
};

export type MipControllerGetMipProgrammeEntitiesResponse = MipControllerGetMipProgrammeEntitiesResponses[keyof MipControllerGetMipProgrammeEntitiesResponses];

export type MipControllerAddMipProgrammeEntityData = {
    body: AddMipProgrammeEntityDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/entities';
};

export type MipControllerAddMipProgrammeEntityResponses = {
    201: unknown;
};

export type MipControllerDeleteMipProgrammeEntityData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        entityId: string;
    };
    query?: never;
    url: '/mip/entities/{entityId}';
};

export type MipControllerDeleteMipProgrammeEntityResponses = {
    200: unknown;
};

export type MipControllerGetMipDetailsForJoinerData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/joiner';
};

export type MipControllerGetMipDetailsForJoinerResponses = {
    default: DataMipTct;
};

export type MipControllerGetMipDetailsForJoinerResponse = MipControllerGetMipDetailsForJoinerResponses[keyof MipControllerGetMipDetailsForJoinerResponses];

export type MipControllerPostJoinerAdditionalAllocationsData = {
    body: PostJoinerAdditionalAllocationMipDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/joiner';
};

export type MipControllerPostJoinerAdditionalAllocationsResponses = {
    default: PostJoinerAllocationsRes;
};

export type MipControllerPostJoinerAdditionalAllocationsResponse = MipControllerPostJoinerAdditionalAllocationsResponses[keyof MipControllerPostJoinerAdditionalAllocationsResponses];

export type MipControllerGetMipDetailsForLeaverData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/leaver';
};

export type MipControllerGetMipDetailsForLeaverResponses = {
    default: DataMipTct;
};

export type MipControllerGetMipDetailsForLeaverResponse = MipControllerGetMipDetailsForLeaverResponses[keyof MipControllerGetMipDetailsForLeaverResponses];

export type MipControllerPostLeaverNegativeAllocationsData = {
    body: PostLeaverNegativeAllocationMipDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/leaver';
};

export type MipControllerPostLeaverNegativeAllocationsResponses = {
    default: PostLeaverNegativeAllocationsRes;
};

export type MipControllerPostLeaverNegativeAllocationsResponse = MipControllerPostLeaverNegativeAllocationsResponses[keyof MipControllerPostLeaverNegativeAllocationsResponses];

export type MipControllerGetWorkflowSettingsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/workflow-settings';
};

export type MipControllerGetWorkflowSettingsResponses = {
    default: MipSettingsDto;
};

export type MipControllerGetWorkflowSettingsResponse = MipControllerGetWorkflowSettingsResponses[keyof MipControllerGetWorkflowSettingsResponses];

export type MipControllerUpdateWorkflowSettingsData = {
    body: MipSettingsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/workflow-settings';
};

export type MipControllerUpdateWorkflowSettingsResponses = {
    200: unknown;
};

export type MipControllerUpdateMipKycRequiredData = {
    body: UpdateMipIsKycRequiredDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/kyc-required';
};

export type MipControllerUpdateMipKycRequiredResponses = {
    200: unknown;
};

export type MipControllerGetMipsForPersonData = {
    body: GetInvestmentProgrammeByPersonIdDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/person-mips';
};

export type MipControllerGetMipsForPersonResponses = {
    default: Array<GetInvestmentProgrammeByPersonIdRes>;
};

export type MipControllerGetMipsForPersonResponse = MipControllerGetMipsForPersonResponses[keyof MipControllerGetMipsForPersonResponses];

export type MipControllerGetPivDetailsForInvestorsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/piv-details-for-investors';
};

export type MipControllerGetPivDetailsForInvestorsResponses = {
    default: GetInvestorsPivDetailsRes;
};

export type MipControllerGetPivDetailsForInvestorsResponse = MipControllerGetPivDetailsForInvestorsResponses[keyof MipControllerGetPivDetailsForInvestorsResponses];

export type MipDraftControllerSoftDeleteMipDraftData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft';
};

export type MipDraftControllerSoftDeleteMipDraftResponses = {
    default: DataMipTct;
};

export type MipDraftControllerSoftDeleteMipDraftResponse = MipDraftControllerSoftDeleteMipDraftResponses[keyof MipDraftControllerSoftDeleteMipDraftResponses];

export type MipDraftControllerCreateMipData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft';
};

export type MipDraftControllerCreateMipResponses = {
    default: DataMipTct;
};

export type MipDraftControllerCreateMipResponse = MipDraftControllerCreateMipResponses[keyof MipDraftControllerCreateMipResponses];

export type MipDraftControllerUpdateDraftGeneralDealInputsData = {
    body: UpdateMipDraftGeneralDealInputsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft';
};

export type MipDraftControllerUpdateDraftGeneralDealInputsResponses = {
    default: DataMipTct;
};

export type MipDraftControllerUpdateDraftGeneralDealInputsResponse = MipDraftControllerUpdateDraftGeneralDealInputsResponses[keyof MipDraftControllerUpdateDraftGeneralDealInputsResponses];

export type MipDraftControllerCreateActiveProgrammeData = {
    body: CreateActiveProgrammeDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft/active';
};

export type MipDraftControllerCreateActiveProgrammeResponses = {
    default: DataMipTct;
};

export type MipDraftControllerCreateActiveProgrammeResponse = MipDraftControllerCreateActiveProgrammeResponses[keyof MipDraftControllerCreateActiveProgrammeResponses];

export type MipDraftControllerCompleteData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft/complete';
};

export type MipDraftControllerCompleteResponses = {
    200: unknown;
};

export type MipDraftControllerGetDraftStepsStatusesData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-draft/steps-statuses';
};

export type MipDraftControllerGetDraftStepsStatusesResponses = {
    default: Array<GetMipDraftStepStatusRes>;
};

export type MipDraftControllerGetDraftStepsStatusesResponse = MipDraftControllerGetDraftStepsStatusesResponses[keyof MipDraftControllerGetDraftStepsStatusesResponses];

export type InvestorMessageControllerGetMessagesForInvestorData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: {
        filters?: GetMessagesFiltersDto;
        investmentWorkflowId?: string;
        documentWorkflowInstanceId?: string;
    };
    url: '/mip/{mipId}/investor/{investorId}/messages';
};

export type InvestorMessageControllerGetMessagesForInvestorResponses = {
    default: InvestorMessagesRes;
};

export type InvestorMessageControllerGetMessagesForInvestorResponse = InvestorMessageControllerGetMessagesForInvestorResponses[keyof InvestorMessageControllerGetMessagesForInvestorResponses];

export type InvestorMessageControllerGetMessageForInvestorData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        messageId: string;
        investorId: string;
        mipId: string;
    };
    query?: never;
    url: '/mip/{mipId}/investor/{investorId}/messages/{messageId}';
};

export type InvestorMessageControllerGetMessageForInvestorResponses = {
    default: InvestorMessageRes;
};

export type InvestorMessageControllerGetMessageForInvestorResponse = InvestorMessageControllerGetMessageForInvestorResponses[keyof InvestorMessageControllerGetMessageForInvestorResponses];

export type BankAccountControllerGetMipBankAccountData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/bank-account';
};

export type BankAccountControllerGetMipBankAccountResponses = {
    default: DataBankAccountTct;
};

export type BankAccountControllerGetMipBankAccountResponse = BankAccountControllerGetMipBankAccountResponses[keyof BankAccountControllerGetMipBankAccountResponses];

export type BankAccountControllerCreateMipBankAccountData = {
    body: BankAccountDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/bank-account';
};

export type BankAccountControllerCreateMipBankAccountResponses = {
    default: DataBankAccountTct;
};

export type BankAccountControllerCreateMipBankAccountResponse = BankAccountControllerCreateMipBankAccountResponses[keyof BankAccountControllerCreateMipBankAccountResponses];

export type BankAccountControllerDeleteMipBankAccountData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/bank-account/{id}';
};

export type BankAccountControllerDeleteMipBankAccountResponses = {
    200: unknown;
};

export type BankAccountControllerUpdateMipBankAccountData = {
    body: BankAccountDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/bank-account/{id}';
};

export type BankAccountControllerUpdateMipBankAccountResponses = {
    default: DataBankAccountTct;
};

export type BankAccountControllerUpdateMipBankAccountResponse = BankAccountControllerUpdateMipBankAccountResponses[keyof BankAccountControllerUpdateMipBankAccountResponses];

export type BankAccountControllerValidateBankAccountData = {
    body: VerifyBankIdentifiersDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/bank-account/{id}/validate';
};

export type BankAccountControllerValidateBankAccountResponses = {
    default: VerifyBankIdentifiersRes;
};

export type BankAccountControllerValidateBankAccountResponse = BankAccountControllerValidateBankAccountResponses[keyof BankAccountControllerValidateBankAccountResponses];

export type DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: {
        search?: string;
        showArchived?: boolean;
        pagination?: Object;
        sortBy?: Object;
        filter?: DocumentWorkflowMasterDocumentsFilterDto;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/list';
};

export type DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponses = {
    /**
     * Successfully retrieved all document workflow templates for MIP (Master Documents)
     */
    default: GetAllDocumentWorkflowTemplatesRes;
};

export type DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponse = DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponses[keyof DocumentWorkflowMasterDocumentsControllerGetAllDocumentWorkflowTemplatesResponses];

export type DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}';
};

export type DocumentWorkflowMasterDocumentsControllerSoftDeleteMasterDocumentResponses = {
    200: unknown;
};

export type DocumentWorkflowMasterDocumentsControllerGetByIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}';
};

export type DocumentWorkflowMasterDocumentsControllerGetByIdResponses = {
    /**
     * Successfully retrieved document workflow template details
     */
    default: DocumentWorkflowTemplateInfo;
};

export type DocumentWorkflowMasterDocumentsControllerGetByIdResponse = DocumentWorkflowMasterDocumentsControllerGetByIdResponses[keyof DocumentWorkflowMasterDocumentsControllerGetByIdResponses];

export type DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentData = {
    body: UpdateDocumentWorkflowTemplatePropertiesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}';
};

export type DocumentWorkflowMasterDocumentsControllerUpdateMasterDocumentResponses = {
    200: unknown;
};

export type DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/signature-slots';
};

export type DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponses = {
    /**
     * List of stamp slots the admin must place manually, with the current placement coords for each (or null if not yet placed).
     */
    default: GetSignatureSlotsRes;
};

export type DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponse = DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponses[keyof DocumentWorkflowMasterDocumentsControllerGetSignatureSlotsResponses];

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings';
};

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponses = {
    /**
     * Persisted field bindings for a document workflow template.
     */
    default: Array<FieldBindingRes>;
};

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponse = DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponses[keyof DocumentWorkflowMasterDocumentsControllerGetFieldBindingsResponses];

export type DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsData = {
    body: UpdateFieldBindingsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings';
};

export type DocumentWorkflowMasterDocumentsControllerUpdateFieldBindingsResponses = {
    200: unknown;
};

export type DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query: {
        investorId: string;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-bindings/preview';
};

export type DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponses = {
    /**
     * Generated a field-bound PDF preview for the given investor.
     */
    default: {
        fileId?: string;
    };
};

export type DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponse = DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponses[keyof DocumentWorkflowMasterDocumentsControllerPreviewFieldBindingsResponses];

export type DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-document';
};

export type DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponses = {
    /**
     * The editable reflow document for a Word master document.
     */
    default: DocxFlowDocumentRes;
};

export type DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponse = DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponses[keyof DocumentWorkflowMasterDocumentsControllerGetDocxFlowDocumentResponses];

export type DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentData = {
    body: SaveDocxFlowDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-document';
};

export type DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponses = {
    /**
     * Saved the edited document, and re-read its fields.
     */
    default: DocxFlowDocumentRes;
};

export type DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponse = DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponses[keyof DocumentWorkflowMasterDocumentsControllerSaveDocxFlowDocumentResponses];

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-render/fields';
};

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponses = {
    /**
     * Rendered the stored Word template to a PDF, each field shown by name.
     */
    default: DocxRenderRes;
};

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponse = DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponses[keyof DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateFieldsViewResponses];

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateData = {
    body: RenderDocxTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: {
        /**
         * Omit to render the fields view with each field shown by name.
         */
        investorId?: string;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/docx-render';
};

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponses = {
    /**
     * Rendered the converted Word template to a PDF.
     */
    default: DocxRenderRes;
};

export type DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponse = DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponses[keyof DocumentWorkflowMasterDocumentsControllerRenderDocxTemplateResponses];

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: {
        investorId?: string;
    };
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/field-binding-catalogue';
};

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponses = {
    /**
     * Bindable data points with a sample value resolved for the given preview investor.
     */
    default: FieldBindingCatalogueRes;
};

export type DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponse = DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponses[keyof DocumentWorkflowMasterDocumentsControllerGetFieldBindingCatalogueResponses];

export type DocumentWorkflowMasterDocumentsControllerCreateData = {
    body: CreateDocumentWorkflowTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents';
};

export type DocumentWorkflowMasterDocumentsControllerCreateResponses = {
    /**
     * Created document workflow template (master document)
     */
    default: {
        id?: string;
    };
};

export type DocumentWorkflowMasterDocumentsControllerCreateResponse = DocumentWorkflowMasterDocumentsControllerCreateResponses[keyof DocumentWorkflowMasterDocumentsControllerCreateResponses];

export type DocumentWorkflowMasterDocumentsControllerUpdateArchivedData = {
    body: UpdateArchivedDocumentWorkflowTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
        templateId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/{templateId}/archive';
};

export type DocumentWorkflowMasterDocumentsControllerUpdateArchivedResponses = {
    200: unknown;
};

export type DocumentWorkflowMasterDocumentsControllerBulkArchiveData = {
    body: BulkArchiveDocumentWorkflowTemplatesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/bulk-archive';
};

export type DocumentWorkflowMasterDocumentsControllerBulkArchiveResponses = {
    default: BulkOperationResult;
};

export type DocumentWorkflowMasterDocumentsControllerBulkArchiveResponse = DocumentWorkflowMasterDocumentsControllerBulkArchiveResponses[keyof DocumentWorkflowMasterDocumentsControllerBulkArchiveResponses];

export type DocumentWorkflowMasterDocumentsControllerBulkDeleteData = {
    body: BulkActionPayloadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/document-workflow/master-documents/bulk-delete';
};

export type DocumentWorkflowMasterDocumentsControllerBulkDeleteResponses = {
    default: BulkDeleteDocumentWorkflowTemplatesRes;
};

export type DocumentWorkflowMasterDocumentsControllerBulkDeleteResponse = DocumentWorkflowMasterDocumentsControllerBulkDeleteResponses[keyof DocumentWorkflowMasterDocumentsControllerBulkDeleteResponses];

export type InvestorBankAccountControllerGetInvestorBankAccountsData = {
    body: ListInvestorBankAccountsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/investor-bank-account/list';
};

export type InvestorBankAccountControllerGetInvestorBankAccountsResponses = {
    default: GetInvestorBankAccountsRes;
};

export type InvestorBankAccountControllerGetInvestorBankAccountsResponse = InvestorBankAccountControllerGetInvestorBankAccountsResponses[keyof InvestorBankAccountControllerGetInvestorBankAccountsResponses];

export type InvestorBankAccountControllerGetBankAccountDetailData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor-bank-account/{id}';
};

export type InvestorBankAccountControllerGetBankAccountDetailResponses = {
    default: MipInvestorBankAccountDetailRes;
};

export type InvestorBankAccountControllerGetBankAccountDetailResponse = InvestorBankAccountControllerGetBankAccountDetailResponses[keyof InvestorBankAccountControllerGetBankAccountDetailResponses];

export type InvestorBankAccountControllerGetBankAccountHistoryData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor-bank-account/{id}/history';
};

export type InvestorBankAccountControllerGetBankAccountHistoryResponses = {
    default: Array<AuditTct>;
};

export type InvestorBankAccountControllerGetBankAccountHistoryResponse = InvestorBankAccountControllerGetBankAccountHistoryResponses[keyof InvestorBankAccountControllerGetBankAccountHistoryResponses];

export type InvestorBankAccountControllerReviewData = {
    body: ReviewBankAccountDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/mip/investor-bank-account/{id}/review';
};

export type InvestorBankAccountControllerReviewResponses = {
    default: MipInvestorBankAccountDetailRes;
};

export type InvestorBankAccountControllerReviewResponse = InvestorBankAccountControllerReviewResponses[keyof InvestorBankAccountControllerReviewResponses];

export type AuditControllerGetEntityAuditsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        entityId: string;
    };
    query?: never;
    url: '/audit/entity/{entityId}';
};

export type AuditControllerGetEntityAuditsResponses = {
    default: Array<AuditTct>;
};

export type AuditControllerGetEntityAuditsResponse = AuditControllerGetEntityAuditsResponses[keyof AuditControllerGetEntityAuditsResponses];

export type AuditControllerGetInvestmentAuditsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/audit/investment/{investmentWorkflowId}';
};

export type AuditControllerGetInvestmentAuditsResponses = {
    default: Array<AuditTct>;
};

export type AuditControllerGetInvestmentAuditsResponse = AuditControllerGetInvestmentAuditsResponses[keyof AuditControllerGetInvestmentAuditsResponses];

export type AuditControllerGetPersonAuditsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/audit/person/{personId}';
};

export type AuditControllerGetPersonAuditsResponses = {
    default: Array<AuditTct>;
};

export type AuditControllerGetPersonAuditsResponse = AuditControllerGetPersonAuditsResponses[keyof AuditControllerGetPersonAuditsResponses];

export type ProgrammeSettingControllerGetByMipIdData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-setting/mip';
};

export type ProgrammeSettingControllerGetByMipIdResponses = {
    default: ProgrammeSettingResponseDto;
};

export type ProgrammeSettingControllerGetByMipIdResponse = ProgrammeSettingControllerGetByMipIdResponses[keyof ProgrammeSettingControllerGetByMipIdResponses];

export type ProgrammeSettingControllerUpdateByMipIdData = {
    body: UpdateProgrammeSettingDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-setting/mip';
};

export type ProgrammeSettingControllerUpdateByMipIdResponses = {
    200: unknown;
};

export type OrganizationKycSettingControllerGetRequirementsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/kyc-setting/{organizationId}';
};

export type OrganizationKycSettingControllerGetRequirementsResponses = {
    default: OrganizationKycSettingResponseDto;
};

export type OrganizationKycSettingControllerGetRequirementsResponse = OrganizationKycSettingControllerGetRequirementsResponses[keyof OrganizationKycSettingControllerGetRequirementsResponses];

export type OrganizationKycSettingControllerUpdateRequirementsData = {
    body: UpdateOrganizationKycSettingDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/kyc-setting/{organizationId}';
};

export type OrganizationKycSettingControllerUpdateRequirementsResponses = {
    default: OrganizationKycSettingResponseDto;
};

export type OrganizationKycSettingControllerUpdateRequirementsResponse = OrganizationKycSettingControllerUpdateRequirementsResponses[keyof OrganizationKycSettingControllerUpdateRequirementsResponses];

export type OrganizationCustomFieldControllerGetCustomFieldsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/custom-field/{organizationId}';
};

export type OrganizationCustomFieldControllerGetCustomFieldsResponses = {
    default: Array<OrganizationCustomFieldResponseDto>;
};

export type OrganizationCustomFieldControllerGetCustomFieldsResponse = OrganizationCustomFieldControllerGetCustomFieldsResponses[keyof OrganizationCustomFieldControllerGetCustomFieldsResponses];

export type OrganizationCustomFieldControllerCreateCustomFieldData = {
    body: CreateOrganizationCustomFieldDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/custom-field/{organizationId}';
};

export type OrganizationCustomFieldControllerCreateCustomFieldResponses = {
    default: OrganizationCustomFieldResponseDto;
};

export type OrganizationCustomFieldControllerCreateCustomFieldResponse = OrganizationCustomFieldControllerCreateCustomFieldResponses[keyof OrganizationCustomFieldControllerCreateCustomFieldResponses];

export type OrganizationCustomFieldControllerDeleteCustomFieldData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        customFieldId: string;
    };
    query?: never;
    url: '/programme-defaults/custom-field/{organizationId}/{customFieldId}';
};

export type OrganizationCustomFieldControllerDeleteCustomFieldResponses = {
    200: unknown;
};

export type OrganizationCustomFieldControllerUpdateCustomFieldData = {
    body: UpdateOrganizationCustomFieldDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        customFieldId: string;
    };
    query?: never;
    url: '/programme-defaults/custom-field/{organizationId}/{customFieldId}';
};

export type OrganizationCustomFieldControllerUpdateCustomFieldResponses = {
    default: OrganizationCustomFieldResponseDto;
};

export type OrganizationCustomFieldControllerUpdateCustomFieldResponse = OrganizationCustomFieldControllerUpdateCustomFieldResponses[keyof OrganizationCustomFieldControllerUpdateCustomFieldResponses];

export type OrganizationVestingTermControllerGetVestingTermsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}';
};

export type OrganizationVestingTermControllerGetVestingTermsResponses = {
    default: Array<VestingTermRes>;
};

export type OrganizationVestingTermControllerGetVestingTermsResponse = OrganizationVestingTermControllerGetVestingTermsResponses[keyof OrganizationVestingTermControllerGetVestingTermsResponses];

export type OrganizationVestingTermControllerCreateVestingTermData = {
    body: CreateVestingTermDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}';
};

export type OrganizationVestingTermControllerCreateVestingTermResponses = {
    default: VestingTermSimplifiedRes;
};

export type OrganizationVestingTermControllerCreateVestingTermResponse = OrganizationVestingTermControllerCreateVestingTermResponses[keyof OrganizationVestingTermControllerCreateVestingTermResponses];

export type OrganizationVestingTermControllerDeleteVestingTermData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        vestingTermId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/{vestingTermId}';
};

export type OrganizationVestingTermControllerDeleteVestingTermResponses = {
    200: unknown;
};

export type OrganizationVestingTermControllerUpdateVestingTermData = {
    body: UpdateVestingTermDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        vestingTermId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/{vestingTermId}';
};

export type OrganizationVestingTermControllerUpdateVestingTermResponses = {
    default: VestingTermSimplifiedRes;
};

export type OrganizationVestingTermControllerUpdateVestingTermResponse = OrganizationVestingTermControllerUpdateVestingTermResponses[keyof OrganizationVestingTermControllerUpdateVestingTermResponses];

export type OrganizationVestingTermControllerCreateStraightLineData = {
    body: CreateVestingTermStraightLineDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/straight-line';
};

export type OrganizationVestingTermControllerCreateStraightLineResponses = {
    default: VestingTermStraightLineRes;
};

export type OrganizationVestingTermControllerCreateStraightLineResponse = OrganizationVestingTermControllerCreateStraightLineResponses[keyof OrganizationVestingTermControllerCreateStraightLineResponses];

export type OrganizationVestingTermControllerUpdateStraightLineData = {
    body: UpdateVestingTermStraightLineDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        straightLineId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/straight-line/{straightLineId}';
};

export type OrganizationVestingTermControllerUpdateStraightLineResponses = {
    default: VestingTermStraightLineRes;
};

export type OrganizationVestingTermControllerUpdateStraightLineResponse = OrganizationVestingTermControllerUpdateStraightLineResponses[keyof OrganizationVestingTermControllerUpdateStraightLineResponses];

export type OrganizationVestingTermControllerCreateGradedData = {
    body: CreateVestingTermGradedDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/graded';
};

export type OrganizationVestingTermControllerCreateGradedResponses = {
    default: VestingTermGradedRes;
};

export type OrganizationVestingTermControllerCreateGradedResponse = OrganizationVestingTermControllerCreateGradedResponses[keyof OrganizationVestingTermControllerCreateGradedResponses];

export type OrganizationVestingTermControllerDeleteGradedData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        gradedId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/graded/{gradedId}';
};

export type OrganizationVestingTermControllerDeleteGradedResponses = {
    200: unknown;
};

export type OrganizationVestingTermControllerUpdateGradedData = {
    body: UpdateVestingTermGradedDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        gradedId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/graded/{gradedId}';
};

export type OrganizationVestingTermControllerUpdateGradedResponses = {
    default: VestingTermGradedRes;
};

export type OrganizationVestingTermControllerUpdateGradedResponse = OrganizationVestingTermControllerUpdateGradedResponses[keyof OrganizationVestingTermControllerUpdateGradedResponses];

export type OrganizationVestingTermControllerCreateLeaverProvisionData = {
    body: CreateVestingTermLeaverProvisionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision';
};

export type OrganizationVestingTermControllerCreateLeaverProvisionResponses = {
    default: VestingTermLeaverProvisionRes;
};

export type OrganizationVestingTermControllerCreateLeaverProvisionResponse = OrganizationVestingTermControllerCreateLeaverProvisionResponses[keyof OrganizationVestingTermControllerCreateLeaverProvisionResponses];

export type OrganizationVestingTermControllerDeleteLeaverProvisionData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        leaverProvisionId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision/{leaverProvisionId}';
};

export type OrganizationVestingTermControllerDeleteLeaverProvisionResponses = {
    200: unknown;
};

export type OrganizationVestingTermControllerUpdateLeaverProvisionData = {
    body: UpdateVestingTermLeaverProvisionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        leaverProvisionId: string;
    };
    query?: never;
    url: '/programme-defaults/vesting-term/{organizationId}/leaver-provision/{leaverProvisionId}';
};

export type OrganizationVestingTermControllerUpdateLeaverProvisionResponses = {
    default: VestingTermLeaverProvisionRes;
};

export type OrganizationVestingTermControllerUpdateLeaverProvisionResponse = OrganizationVestingTermControllerUpdateLeaverProvisionResponses[keyof OrganizationVestingTermControllerUpdateLeaverProvisionResponses];

export type OrganizationDocumentTemplateControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: {
        search?: string;
        showArchived?: boolean;
        pagination?: Object;
        sortBy?: Object;
        filter?: DocumentWorkflowMasterDocumentsFilterDto;
    };
    url: '/programme-defaults/master-documents/{organizationId}/list';
};

export type OrganizationDocumentTemplateControllerListResponses = {
    default: GetAllDocumentWorkflowTemplatesRes;
};

export type OrganizationDocumentTemplateControllerListResponse = OrganizationDocumentTemplateControllerListResponses[keyof OrganizationDocumentTemplateControllerListResponses];

export type OrganizationDocumentTemplateControllerRemoveData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}';
};

export type OrganizationDocumentTemplateControllerRemoveResponses = {
    200: unknown;
};

export type OrganizationDocumentTemplateControllerGetByIdData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}';
};

export type OrganizationDocumentTemplateControllerGetByIdResponses = {
    default: DocumentWorkflowTemplateInfo;
};

export type OrganizationDocumentTemplateControllerGetByIdResponse = OrganizationDocumentTemplateControllerGetByIdResponses[keyof OrganizationDocumentTemplateControllerGetByIdResponses];

export type OrganizationDocumentTemplateControllerUpdateData = {
    body: UpdateDocumentWorkflowTemplatePropertiesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}';
};

export type OrganizationDocumentTemplateControllerUpdateResponses = {
    200: unknown;
};

export type OrganizationDocumentTemplateControllerCreateData = {
    body: CreateDocumentWorkflowTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}';
};

export type OrganizationDocumentTemplateControllerCreateResponses = {
    default: {
        id?: string;
    };
};

export type OrganizationDocumentTemplateControllerCreateResponse = OrganizationDocumentTemplateControllerCreateResponses[keyof OrganizationDocumentTemplateControllerCreateResponses];

export type OrganizationDocumentTemplateControllerUpdateArchivedData = {
    body: UpdateArchivedDocumentWorkflowTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/{templateId}/archive';
};

export type OrganizationDocumentTemplateControllerUpdateArchivedResponses = {
    200: unknown;
};

export type OrganizationDocumentTemplateControllerBulkArchiveData = {
    body: BulkArchiveDocumentWorkflowTemplatesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/bulk-archive';
};

export type OrganizationDocumentTemplateControllerBulkArchiveResponses = {
    201: unknown;
};

export type OrganizationDocumentTemplateControllerBulkDeleteData = {
    body: BulkActionPayloadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/master-documents/{organizationId}/bulk-delete';
};

export type OrganizationDocumentTemplateControllerBulkDeleteResponses = {
    201: unknown;
};

export type OrganizationKycFormTemplateControllerRemoveData = {
    body: DeleteKycFormTemplatesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}';
};

export type OrganizationKycFormTemplateControllerRemoveResponses = {
    204: void;
};

export type OrganizationKycFormTemplateControllerRemoveResponse = OrganizationKycFormTemplateControllerRemoveResponses[keyof OrganizationKycFormTemplateControllerRemoveResponses];

export type OrganizationKycFormTemplateControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: {
        archived?: boolean;
    };
    url: '/programme-defaults/tax-compliance/{organizationId}';
};

export type OrganizationKycFormTemplateControllerListResponses = {
    default: Array<KycFormTemplateRes>;
};

export type OrganizationKycFormTemplateControllerListResponse = OrganizationKycFormTemplateControllerListResponses[keyof OrganizationKycFormTemplateControllerListResponses];

export type OrganizationKycFormTemplateControllerCreateData = {
    body: CreateKycFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}';
};

export type OrganizationKycFormTemplateControllerCreateResponses = {
    204: void;
};

export type OrganizationKycFormTemplateControllerCreateResponse = OrganizationKycFormTemplateControllerCreateResponses[keyof OrganizationKycFormTemplateControllerCreateResponses];

export type OrganizationKycFormTemplateControllerUpdateData = {
    body: UpdateKycFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}';
};

export type OrganizationKycFormTemplateControllerUpdateResponses = {
    204: void;
};

export type OrganizationKycFormTemplateControllerUpdateResponse = OrganizationKycFormTemplateControllerUpdateResponses[keyof OrganizationKycFormTemplateControllerUpdateResponses];

export type OrganizationKycFormTemplateControllerArchiveData = {
    body: ArchiveKycFormTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/archive';
};

export type OrganizationKycFormTemplateControllerArchiveResponses = {
    204: void;
};

export type OrganizationKycFormTemplateControllerArchiveResponse = OrganizationKycFormTemplateControllerArchiveResponses[keyof OrganizationKycFormTemplateControllerArchiveResponses];

export type OrganizationKycFormTemplateControllerSignatureSlotsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/signature-slots';
};

export type OrganizationKycFormTemplateControllerSignatureSlotsResponses = {
    default: GetSignatureSlotsRes;
};

export type OrganizationKycFormTemplateControllerSignatureSlotsResponse = OrganizationKycFormTemplateControllerSignatureSlotsResponses[keyof OrganizationKycFormTemplateControllerSignatureSlotsResponses];

export type OrganizationKycFormTemplateControllerUpdateSignaturePlacementData = {
    body: UpdateKycSignaturePlacementDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        templateId: string;
    };
    query?: never;
    url: '/programme-defaults/tax-compliance/{organizationId}/{templateId}/signature-placement';
};

export type OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponses = {
    204: void;
};

export type OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponse = OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponses[keyof OrganizationKycFormTemplateControllerUpdateSignaturePlacementResponses];

export type OrganizationFileControllerDownloadPreSignedUrlData = {
    body: DownloadOrganizationFileDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        fileId: string;
    };
    query?: never;
    url: '/programme-defaults/file/{organizationId}/{fileId}/download-pre-signed-url';
};

export type OrganizationFileControllerDownloadPreSignedUrlResponses = {
    default: DownloadPreSignedUrlDto;
};

export type OrganizationFileControllerDownloadPreSignedUrlResponse = OrganizationFileControllerDownloadPreSignedUrlResponses[keyof OrganizationFileControllerDownloadPreSignedUrlResponses];

export type OrganizationEmailTemplateControllerListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/email-template/{organizationId}';
};

export type OrganizationEmailTemplateControllerListResponses = {
    200: Array<EmailTemplateSummaryRes>;
};

export type OrganizationEmailTemplateControllerListResponse = OrganizationEmailTemplateControllerListResponses[keyof OrganizationEmailTemplateControllerListResponses];

export type OrganizationEmailTemplateControllerGetOneData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/programme-defaults/email-template/{organizationId}/{type}';
};

export type OrganizationEmailTemplateControllerGetOneResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationEmailTemplateControllerGetOneResponse = OrganizationEmailTemplateControllerGetOneResponses[keyof OrganizationEmailTemplateControllerGetOneResponses];

export type OrganizationEmailTemplateControllerUpdateData = {
    body: UpdateEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/programme-defaults/email-template/{organizationId}/{type}';
};

export type OrganizationEmailTemplateControllerUpdateResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationEmailTemplateControllerUpdateResponse = OrganizationEmailTemplateControllerUpdateResponses[keyof OrganizationEmailTemplateControllerUpdateResponses];

export type OrganizationEmailTemplateControllerPreviewData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/programme-defaults/email-template/{organizationId}/{type}/preview';
};

export type OrganizationEmailTemplateControllerPreviewResponses = {
    200: EmailTemplatePreviewRes;
};

export type OrganizationEmailTemplateControllerPreviewResponse = OrganizationEmailTemplateControllerPreviewResponses[keyof OrganizationEmailTemplateControllerPreviewResponses];

export type OrganizationEmailTemplateControllerResetData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        type: string;
    };
    query?: never;
    url: '/programme-defaults/email-template/{organizationId}/{type}/reset';
};

export type OrganizationEmailTemplateControllerResetResponses = {
    200: EmailTemplateDetailRes;
};

export type OrganizationEmailTemplateControllerResetResponse = OrganizationEmailTemplateControllerResetResponses[keyof OrganizationEmailTemplateControllerResetResponses];

export type OrganizationEmailScheduleControllerListConfigsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/email-schedule/{organizationId}';
};

export type OrganizationEmailScheduleControllerListConfigsResponses = {
    default: Array<ProgrammeEmailScheduleConfigRes>;
};

export type OrganizationEmailScheduleControllerListConfigsResponse = OrganizationEmailScheduleControllerListConfigsResponses[keyof OrganizationEmailScheduleControllerListConfigsResponses];

export type OrganizationEmailScheduleControllerUpsertConfigData = {
    body: UpdateEmailScheduleConfigDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/email-schedule/{organizationId}';
};

export type OrganizationEmailScheduleControllerUpsertConfigResponses = {
    200: unknown;
};

export type ProgrammeDefaultsSummaryControllerGetMySummaryData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-defaults/summary';
};

export type ProgrammeDefaultsSummaryControllerGetMySummaryResponses = {
    default: ProgrammeDefaultsSummaryRes;
};

export type ProgrammeDefaultsSummaryControllerGetMySummaryResponse = ProgrammeDefaultsSummaryControllerGetMySummaryResponses[keyof ProgrammeDefaultsSummaryControllerGetMySummaryResponses];

export type ProgrammeDefaultsSummaryControllerGetSummaryForDealData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-defaults/summary/deal';
};

export type ProgrammeDefaultsSummaryControllerGetSummaryForDealResponses = {
    default: ProgrammeDefaultsSummaryRes;
};

export type ProgrammeDefaultsSummaryControllerGetSummaryForDealResponse = ProgrammeDefaultsSummaryControllerGetSummaryForDealResponses[keyof ProgrammeDefaultsSummaryControllerGetSummaryForDealResponses];

export type ProgrammeDefaultsSummaryControllerGetSummaryData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/summary/{organizationId}';
};

export type ProgrammeDefaultsSummaryControllerGetSummaryResponses = {
    default: ProgrammeDefaultsSummaryRes;
};

export type ProgrammeDefaultsSummaryControllerGetSummaryResponse = ProgrammeDefaultsSummaryControllerGetSummaryResponses[keyof ProgrammeDefaultsSummaryControllerGetSummaryResponses];

export type ProgrammeDefaultsSummaryControllerApplyData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/programme-defaults/summary/{organizationId}/apply';
};

export type ProgrammeDefaultsSummaryControllerApplyResponses = {
    204: void;
};

export type ProgrammeDefaultsSummaryControllerApplyResponse = ProgrammeDefaultsSummaryControllerApplyResponses[keyof ProgrammeDefaultsSummaryControllerApplyResponses];

export type MipClassifierControllerListData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        isArchived?: boolean;
    };
    url: '/mip-classifier';
};

export type MipClassifierControllerListResponses = {
    200: Array<MipClassifierRes>;
};

export type MipClassifierControllerListResponse = MipClassifierControllerListResponses[keyof MipClassifierControllerListResponses];

export type MipClassifierControllerCreateData = {
    body: CreateMipClassifierDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip-classifier';
};

export type MipClassifierControllerCreateResponses = {
    201: MipClassifierRes;
};

export type MipClassifierControllerCreateResponse = MipClassifierControllerCreateResponses[keyof MipClassifierControllerCreateResponses];

export type MipClassifierControllerUpdateData = {
    body: UpdateMipClassifierDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        mipClassifierId: string;
    };
    query?: never;
    url: '/mip-classifier/{mipClassifierId}';
};

export type MipClassifierControllerUpdateResponses = {
    200: MipClassifierRes;
};

export type MipClassifierControllerUpdateResponse = MipClassifierControllerUpdateResponses[keyof MipClassifierControllerUpdateResponses];

export type MipClassifierControllerListByInvestorData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/mip-classifier/by-investor/{investorId}';
};

export type MipClassifierControllerListByInvestorResponses = {
    200: Array<MipClassifierRes>;
};

export type MipClassifierControllerListByInvestorResponse = MipClassifierControllerListByInvestorResponses[keyof MipClassifierControllerListByInvestorResponses];

export type MipClassifierControllerAttachInvestorsData = {
    body: InvestorAssignmentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        mipClassifierId: string;
    };
    query?: never;
    url: '/mip-classifier/{mipClassifierId}/investors/attach';
};

export type MipClassifierControllerAttachInvestorsResponses = {
    204: void;
};

export type MipClassifierControllerAttachInvestorsResponse = MipClassifierControllerAttachInvestorsResponses[keyof MipClassifierControllerAttachInvestorsResponses];

export type MipClassifierControllerDetachInvestorsData = {
    body: InvestorAssignmentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        mipClassifierId: string;
    };
    query?: never;
    url: '/mip-classifier/{mipClassifierId}/investors/detach';
};

export type MipClassifierControllerDetachInvestorsResponses = {
    204: void;
};

export type MipClassifierControllerDetachInvestorsResponse = MipClassifierControllerDetachInvestorsResponses[keyof MipClassifierControllerDetachInvestorsResponses];

export type ProgrammeEmailTemplateControllerListData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-email-template';
};

export type ProgrammeEmailTemplateControllerListResponses = {
    200: Array<EmailTemplateSummaryRes>;
};

export type ProgrammeEmailTemplateControllerListResponse = ProgrammeEmailTemplateControllerListResponses[keyof ProgrammeEmailTemplateControllerListResponses];

export type ProgrammeEmailTemplateControllerGetOneData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/programme-email-template/{type}';
};

export type ProgrammeEmailTemplateControllerGetOneResponses = {
    200: EmailTemplateDetailRes;
};

export type ProgrammeEmailTemplateControllerGetOneResponse = ProgrammeEmailTemplateControllerGetOneResponses[keyof ProgrammeEmailTemplateControllerGetOneResponses];

export type ProgrammeEmailTemplateControllerUpdateData = {
    body: UpdateEmailTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/programme-email-template/{type}';
};

export type ProgrammeEmailTemplateControllerUpdateResponses = {
    200: EmailTemplateDetailRes;
};

export type ProgrammeEmailTemplateControllerUpdateResponse = ProgrammeEmailTemplateControllerUpdateResponses[keyof ProgrammeEmailTemplateControllerUpdateResponses];

export type ProgrammeEmailTemplateControllerPreviewData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/programme-email-template/{type}/preview';
};

export type ProgrammeEmailTemplateControllerPreviewResponses = {
    200: EmailTemplatePreviewRes;
};

export type ProgrammeEmailTemplateControllerPreviewResponse = ProgrammeEmailTemplateControllerPreviewResponses[keyof ProgrammeEmailTemplateControllerPreviewResponses];

export type ProgrammeEmailTemplateControllerTestSendData = {
    body: PreviewEmailTemplateDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/programme-email-template/{type}/test-send';
};

export type ProgrammeEmailTemplateControllerTestSendResponses = {
    200: EmailTemplateTestSendRes;
};

export type ProgrammeEmailTemplateControllerTestSendResponse = ProgrammeEmailTemplateControllerTestSendResponses[keyof ProgrammeEmailTemplateControllerTestSendResponses];

export type ProgrammeEmailTemplateControllerResetData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        type: string;
    };
    query?: never;
    url: '/programme-email-template/{type}/reset';
};

export type ProgrammeEmailTemplateControllerResetResponses = {
    200: EmailTemplateDetailRes;
};

export type ProgrammeEmailTemplateControllerResetResponse = ProgrammeEmailTemplateControllerResetResponses[keyof ProgrammeEmailTemplateControllerResetResponses];

export type TagControllerListData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        isArchived?: boolean;
    };
    url: '/tag';
};

export type TagControllerListResponses = {
    200: Array<TagRes>;
};

export type TagControllerListResponse = TagControllerListResponses[keyof TagControllerListResponses];

export type TagControllerCreateData = {
    body: CreateTagDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/tag';
};

export type TagControllerCreateResponses = {
    201: TagRes;
};

export type TagControllerCreateResponse = TagControllerCreateResponses[keyof TagControllerCreateResponses];

export type TagControllerRemoveData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        tagId: string;
    };
    query?: never;
    url: '/tag/{tagId}';
};

export type TagControllerRemoveResponses = {
    204: void;
};

export type TagControllerRemoveResponse = TagControllerRemoveResponses[keyof TagControllerRemoveResponses];

export type TagControllerUpdateData = {
    body: UpdateTagDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        tagId: string;
    };
    query?: never;
    url: '/tag/{tagId}';
};

export type TagControllerUpdateResponses = {
    200: TagRes;
};

export type TagControllerUpdateResponse = TagControllerUpdateResponses[keyof TagControllerUpdateResponses];

export type TagControllerAttachClassifiersData = {
    body: ClassifierAssignmentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        tagId: string;
    };
    query?: never;
    url: '/tag/{tagId}/classifiers/attach';
};

export type TagControllerAttachClassifiersResponses = {
    204: void;
};

export type TagControllerAttachClassifiersResponse = TagControllerAttachClassifiersResponses[keyof TagControllerAttachClassifiersResponses];

export type TagControllerDetachClassifiersData = {
    body: ClassifierAssignmentDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        tagId: string;
    };
    query?: never;
    url: '/tag/{tagId}/classifiers/detach';
};

export type TagControllerDetachClassifiersResponses = {
    204: void;
};

export type TagControllerDetachClassifiersResponse = TagControllerDetachClassifiersResponses[keyof TagControllerDetachClassifiersResponses];

export type TranslationsControllerTranslationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        language: string;
        namespace: string;
    };
    query?: never;
    url: '/translations/{language}/{namespace}';
};

export type TranslationsControllerTranslationsResponses = {
    200: unknown;
};

export type TaskControllerGetData = {
    body: TaskDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/task';
};

export type TaskControllerGetResponses = {
    default: GetTasksRes;
};

export type TaskControllerGetResponse = TaskControllerGetResponses[keyof TaskControllerGetResponses];

export type ConfigProviderControllerGetConfigData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/config-provider';
};

export type ConfigProviderControllerGetConfigResponses = {
    200: unknown;
};

export type TransactionControllerGetTransactionsData = {
    body: TransactionListQueryDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/list';
};

export type TransactionControllerGetTransactionsResponses = {
    default: GetTransactionsRes;
};

export type TransactionControllerGetTransactionsResponse = TransactionControllerGetTransactionsResponses[keyof TransactionControllerGetTransactionsResponses];

export type TransactionControllerGetTransactionDetailsData = {
    body: GetTransactionDetailsDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/transaction-details';
};

export type TransactionControllerGetTransactionDetailsResponses = {
    default: TransactionWithSecurityTct;
};

export type TransactionControllerGetTransactionDetailsResponse = TransactionControllerGetTransactionDetailsResponses[keyof TransactionControllerGetTransactionDetailsResponses];

export type TransactionControllerDownloadExcelData = {
    body: DownloadTransactionsDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/download-excel';
};

export type TransactionControllerDownloadExcelResponses = {
    default: DownloadTransactionsDto;
};

export type TransactionControllerDownloadExcelResponse = TransactionControllerDownloadExcelResponses[keyof TransactionControllerDownloadExcelResponses];

export type TransactionControllerCreateTransactionData = {
    body: CreateTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction';
};

export type TransactionControllerCreateTransactionResponses = {
    default: TransactionTct;
};

export type TransactionControllerCreateTransactionResponse = TransactionControllerCreateTransactionResponses[keyof TransactionControllerCreateTransactionResponses];

export type TransactionControllerPreviewTransferCounterpartData = {
    body: CreateTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/transfer-counterpart/preview';
};

export type TransactionControllerPreviewTransferCounterpartResponses = {
    default: TransferCounterpartPreviewRes;
};

export type TransactionControllerPreviewTransferCounterpartResponse = TransactionControllerPreviewTransferCounterpartResponses[keyof TransactionControllerPreviewTransferCounterpartResponses];

export type TransactionControllerCreatePairedIssueData = {
    body: CreatePairedIssueDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/paired-issue';
};

export type TransactionControllerCreatePairedIssueResponses = {
    default: Array<TransactionTct>;
};

export type TransactionControllerCreatePairedIssueResponse = TransactionControllerCreatePairedIssueResponses[keyof TransactionControllerCreatePairedIssueResponses];

export type TransactionControllerPreviewInseparableRedemptionData = {
    body: CreateInseparableRedemptionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/inseparable-redemption/preview';
};

export type TransactionControllerPreviewInseparableRedemptionResponses = {
    default: InseparableRedemptionPreviewRes;
};

export type TransactionControllerPreviewInseparableRedemptionResponse = TransactionControllerPreviewInseparableRedemptionResponses[keyof TransactionControllerPreviewInseparableRedemptionResponses];

export type TransactionControllerUpdateInseparableRedemptionData = {
    body: UpdateInseparableRedemptionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/inseparable-redemption';
};

export type TransactionControllerUpdateInseparableRedemptionResponses = {
    default: InseparableRedemptionGroupRes;
};

export type TransactionControllerUpdateInseparableRedemptionResponse = TransactionControllerUpdateInseparableRedemptionResponses[keyof TransactionControllerUpdateInseparableRedemptionResponses];

export type TransactionControllerCreateInseparableRedemptionData = {
    body: CreateInseparableRedemptionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/inseparable-redemption';
};

export type TransactionControllerCreateInseparableRedemptionResponses = {
    default: Array<TransactionTct>;
};

export type TransactionControllerCreateInseparableRedemptionResponse = TransactionControllerCreateInseparableRedemptionResponses[keyof TransactionControllerCreateInseparableRedemptionResponses];

export type TransactionControllerGetInseparableRedemptionGroupData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        redemptionGroupId: string;
    };
    query?: never;
    url: '/cap/transaction/inseparable-redemption/{redemptionGroupId}';
};

export type TransactionControllerGetInseparableRedemptionGroupResponses = {
    default: InseparableRedemptionGroupRes;
};

export type TransactionControllerGetInseparableRedemptionGroupResponse = TransactionControllerGetInseparableRedemptionGroupResponses[keyof TransactionControllerGetInseparableRedemptionGroupResponses];

export type TransactionControllerSplitTransactionData = {
    body: SplitTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/split';
};

export type TransactionControllerSplitTransactionResponses = {
    default: TransactionTct;
};

export type TransactionControllerSplitTransactionResponse = TransactionControllerSplitTransactionResponses[keyof TransactionControllerSplitTransactionResponses];

export type TransactionControllerSplitTransactionInterestData = {
    body: SplitInterestTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/split-interest';
};

export type TransactionControllerSplitTransactionInterestResponses = {
    default: TransactionTct;
};

export type TransactionControllerSplitTransactionInterestResponse = TransactionControllerSplitTransactionInterestResponses[keyof TransactionControllerSplitTransactionInterestResponses];

export type TransactionControllerGetPairTransactionData = {
    body: GetPairTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/get-pair';
};

export type TransactionControllerGetPairTransactionResponses = {
    default: TransactionWithSecurityUnitDenominatorTct;
};

export type TransactionControllerGetPairTransactionResponse = TransactionControllerGetPairTransactionResponses[keyof TransactionControllerGetPairTransactionResponses];

export type TransactionControllerPairTransactionData = {
    body: PairTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/pair';
};

export type TransactionControllerPairTransactionResponses = {
    default: PairTransactionRes;
};

export type TransactionControllerPairTransactionResponse = TransactionControllerPairTransactionResponses[keyof TransactionControllerPairTransactionResponses];

export type TransactionControllerUpdateData = {
    body: UpdateTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/update';
};

export type TransactionControllerUpdateResponses = {
    default: TransactionTct;
};

export type TransactionControllerUpdateResponse = TransactionControllerUpdateResponses[keyof TransactionControllerUpdateResponses];

export type TransactionControllerRestoreData = {
    body: RestoreTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/restore';
};

export type TransactionControllerRestoreResponses = {
    default: TransactionTct;
};

export type TransactionControllerRestoreResponse = TransactionControllerRestoreResponses[keyof TransactionControllerRestoreResponses];

export type TransactionControllerUpdateOrderData = {
    body: ReorderTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/reorder';
};

export type TransactionControllerUpdateOrderResponses = {
    default: TransactionTct;
};

export type TransactionControllerUpdateOrderResponse = TransactionControllerUpdateOrderResponses[keyof TransactionControllerUpdateOrderResponses];

export type TransactionControllerAutoReorderData = {
    body: AutoReorderTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/auto-reorder';
};

export type TransactionControllerAutoReorderResponses = {
    default: TransactionTct;
};

export type TransactionControllerAutoReorderResponse = TransactionControllerAutoReorderResponses[keyof TransactionControllerAutoReorderResponses];

export type TransactionControllerBulkUploadData = {
    body: BulkUploadTransactionsDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/bulk-upload';
};

export type TransactionControllerBulkUploadResponses = {
    201: unknown;
};

export type TransactionControllerBulkUploadManagementLoansData = {
    body: ManagementLoansBulkUploadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/management-loans/bulk-upload';
};

export type TransactionControllerBulkUploadManagementLoansResponses = {
    201: unknown;
};

export type TransactionControllerGetBulkUploadTaskStatusData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        sessionId: string;
    };
    query?: never;
    url: '/cap/transaction/bulk-upload/{sessionId}/status';
};

export type TransactionControllerGetBulkUploadTaskStatusResponses = {
    default: GetBulkUploadStatusRes;
};

export type TransactionControllerGetBulkUploadTaskStatusResponse = TransactionControllerGetBulkUploadTaskStatusResponses[keyof TransactionControllerGetBulkUploadTaskStatusResponses];

export type TransactionControllerBulkUpdateData = {
    body: BulkUpdateTransactionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/bulk-update';
};

export type TransactionControllerBulkUpdateResponses = {
    default: BulkUpdateTransactionsRes;
};

export type TransactionControllerBulkUpdateResponse = TransactionControllerBulkUpdateResponses[keyof TransactionControllerBulkUpdateResponses];

export type TransactionControllerBulkRestoreData = {
    body: BulkUpdateTransactionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/bulk-restore';
};

export type TransactionControllerBulkRestoreResponses = {
    default: BulkUpdateTransactionsRes;
};

export type TransactionControllerBulkRestoreResponse = TransactionControllerBulkRestoreResponses[keyof TransactionControllerBulkRestoreResponses];

export type TransactionControllerDeleteTransactionData = {
    body: DeleteTransactionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/delete';
};

export type TransactionControllerDeleteTransactionResponses = {
    default: unknown;
};

export type TransactionControllerBulkDeleteTransactionsData = {
    body: BulkDeleteTransactionsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/transaction/bulk-delete';
};

export type TransactionControllerBulkDeleteTransactionsResponses = {
    default: BulkUpdateTransactionsRes;
};

export type TransactionControllerBulkDeleteTransactionsResponse = TransactionControllerBulkDeleteTransactionsResponses[keyof TransactionControllerBulkDeleteTransactionsResponses];

export type DocumentControllerCreateUploadPreSignedUrlsData = {
    body: PreSignedUrlDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/upload-pre-signed-urls';
};

export type DocumentControllerCreateUploadPreSignedUrlsResponses = {
    200: unknown;
};

export type DocumentControllerCreateDocumentsData = {
    body: CreateDocumentsDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/create';
};

export type DocumentControllerCreateDocumentsResponses = {
    200: unknown;
};

export type DocumentControllerRemoveDocumentPersonLinkData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        personId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/{documentId}/person/{personId}';
};

export type DocumentControllerRemoveDocumentPersonLinkResponses = {
    200: unknown;
};

export type DocumentControllerRemoveDocumentTransactionLinkData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        transactionId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/{documentId}/transaction/{transactionId}';
};

export type DocumentControllerRemoveDocumentTransactionLinkResponses = {
    200: unknown;
};

export type DocumentControllerRemoveDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/{documentId}';
};

export type DocumentControllerRemoveDocumentResponses = {
    200: unknown;
};

export type DocumentControllerGetDocumentData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: {
        /**
         * The transaction the document is being viewed from. Makes the "related to" field editable.
         */
        transactionId?: string;
    };
    url: '/deal/{dealId}/document/{documentId}';
};

export type DocumentControllerGetDocumentResponses = {
    default: GetDocumentRes;
};

export type DocumentControllerGetDocumentResponse = DocumentControllerGetDocumentResponses[keyof DocumentControllerGetDocumentResponses];

export type DocumentControllerUpdateData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/{documentId}';
};

export type DocumentControllerUpdateResponses = {
    200: unknown;
};

export type DocumentControllerGetDocumentsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query: {
        searchQuery: string;
        pagination: PaginationDto;
        sortBy: SortByDto;
        fieldFilter: DocumentFieldFilterDto;
        /**
         * Scope to documents linked to this transaction. Mutually exclusive with personId.
         */
        transactionId?: string;
        /**
         * Scope to documents linked to this person. Mutually exclusive with transactionId.
         */
        personId?: string;
    };
    url: '/deal/{dealId}/document';
};

export type DocumentControllerGetDocumentsResponses = {
    default: GetDocumentsRes;
};

export type DocumentControllerGetDocumentsResponse = DocumentControllerGetDocumentsResponses[keyof DocumentControllerGetDocumentsResponses];

export type DocumentControllerFindRelatedFilesInDealData = {
    body: FindRelatedFileDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/find-related-files';
};

export type DocumentControllerFindRelatedFilesInDealResponses = {
    default: Array<FindRelatedFilesRes>;
};

export type DocumentControllerFindRelatedFilesInDealResponse = DocumentControllerFindRelatedFilesInDealResponses[keyof DocumentControllerFindRelatedFilesInDealResponses];

export type DocumentControllerFindRelatedDocumentsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query: {
        transactionId: string;
    };
    url: '/deal/{dealId}/document/{documentId}/related';
};

export type DocumentControllerFindRelatedDocumentsResponses = {
    default: Array<FindRelatedDocumentsRes>;
};

export type DocumentControllerFindRelatedDocumentsResponse = DocumentControllerFindRelatedDocumentsResponses[keyof DocumentControllerFindRelatedDocumentsResponses];

export type DocumentControllerUpdateRelatedDocumentsData = {
    body: Array<UpdateRelatedDocumentDto>;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document/{documentId}/related';
};

export type DocumentControllerUpdateRelatedDocumentsResponses = {
    200: unknown;
};

export type DocumentLibraryControllerGetDocumentsWithFilteringData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query: {
        pagination: PaginationDto;
        sortBy: SortByDto;
        classificationId: string;
        searchQuery: string;
        fieldFilter: DocumentFieldFilterDto;
        excludeWorkflowGenerated: boolean;
    };
    url: '/deal/{dealId}/document-library/documents';
};

export type DocumentLibraryControllerGetDocumentsWithFilteringResponses = {
    200: DocumentsRes;
};

export type DocumentLibraryControllerGetDocumentsWithFilteringResponse = DocumentLibraryControllerGetDocumentsWithFilteringResponses[keyof DocumentLibraryControllerGetDocumentsWithFilteringResponses];

export type DocumentLibraryControllerBulkClassifyDocumentsData = {
    body: BulkUpdateDocumentClassifiersDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query: {
        pagination: PaginationDto;
        sortBy: SortByDto;
        classificationId: string;
        searchQuery: string;
        fieldFilter: DocumentFieldFilterDto;
    };
    url: '/deal/{dealId}/document-library/document-classifiers';
};

export type DocumentLibraryControllerBulkClassifyDocumentsResponses = {
    200: unknown;
};

export type DocumentLibraryControllerGetDocumentDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        documentId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/document/{documentId}';
};

export type DocumentLibraryControllerGetDocumentDetailsResponses = {
    200: GetDocumentRes;
};

export type DocumentLibraryControllerGetDocumentDetailsResponse = DocumentLibraryControllerGetDocumentDetailsResponses[keyof DocumentLibraryControllerGetDocumentDetailsResponses];

export type DocumentLibraryControllerUpdateDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        documentId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/document/{documentId}';
};

export type DocumentLibraryControllerUpdateDocumentResponses = {
    200: unknown;
};

export type DocumentLibraryControllerGetDealClassifiersByGroupsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/classifier-groups';
};

export type DocumentLibraryControllerGetDealClassifiersByGroupsResponses = {
    200: Array<DealClassifierGroupRes>;
};

export type DocumentLibraryControllerGetDealClassifiersByGroupsResponse = DocumentLibraryControllerGetDealClassifiersByGroupsResponses[keyof DocumentLibraryControllerGetDealClassifiersByGroupsResponses];

export type DocumentLibraryControllerBulkDownloadDocumentFilesData = {
    /**
     * Array of document file ids to download
     */
    body: BulkDownloadDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/bulk-download';
};

export type DocumentLibraryControllerBulkDownloadDocumentFilesResponses = {
    /**
     * Pre-signed URL to download the zip, or an async-job marker when the zip is generated in the background
     */
    200: BulkDownloadFileSyncRes | BulkDownloadFileAsyncRes;
};

export type DocumentLibraryControllerBulkDownloadDocumentFilesResponse = DocumentLibraryControllerBulkDownloadDocumentFilesResponses[keyof DocumentLibraryControllerBulkDownloadDocumentFilesResponses];

export type DocumentLibraryControllerBulkDeleteDocumentsData = {
    body: BulkDeleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/bulk-delete';
};

export type DocumentLibraryControllerBulkDeleteDocumentsResponses = {
    200: BulkDeleteRes;
};

export type DocumentLibraryControllerBulkDeleteDocumentsResponse = DocumentLibraryControllerBulkDeleteDocumentsResponses[keyof DocumentLibraryControllerBulkDeleteDocumentsResponses];

export type DocumentLibraryControllerGetPersonsInDealData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/persons-in-deal';
};

export type DocumentLibraryControllerGetPersonsInDealResponses = {
    200: FindPersonsInDealRes;
};

export type DocumentLibraryControllerGetPersonsInDealResponse = DocumentLibraryControllerGetPersonsInDealResponses[keyof DocumentLibraryControllerGetPersonsInDealResponses];

export type DocumentLibraryControllerRemovePersonsFromDocumentData = {
    /**
     * Array of person ids to remove from the document
     */
    body: RemovePersonsFromDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/remove-persons-from-document/{documentId}';
};

export type DocumentLibraryControllerRemovePersonsFromDocumentResponses = {
    200: unknown;
};

export type DocumentLibraryControllerAddPersonsToDocumentData = {
    /**
     * Array of person ids to add to the document
     */
    body: AddPersonsToDocumentDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentId: string;
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/add-persons-to-document/{documentId}';
};

export type DocumentLibraryControllerAddPersonsToDocumentResponses = {
    200: unknown;
};

export type DocumentLibraryControllerSetPersonDocumentVisibilityData = {
    body: SetPersonDocumentVisibilityDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        documentId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/document/{documentId}/person-visibility';
};

export type DocumentLibraryControllerSetPersonDocumentVisibilityResponses = {
    200: unknown;
};

export type DocumentLibraryControllerAddPersonsToDocumentsData = {
    /**
     * Array of document ids and person ids to link together
     */
    body: PersonsToDocumentsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/add-persons-to-documents';
};

export type DocumentLibraryControllerAddPersonsToDocumentsResponses = {
    201: unknown;
};

export type DocumentLibraryControllerRemovePersonsFromDocumentsData = {
    /**
     * Array of document ids and person ids to unlink from each other
     */
    body: PersonsToDocumentsDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/document-library/remove-persons-from-documents';
};

export type DocumentLibraryControllerRemovePersonsFromDocumentsResponses = {
    201: unknown;
};

export type DocumentParsingControllerUploadExtractionDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-parsing/upload';
};

export type DocumentParsingControllerUploadExtractionDocumentResponses = {
    /**
     * File uploaded and bound to the deal
     */
    201: DataFileTct;
};

export type DocumentParsingControllerUploadExtractionDocumentResponse = DocumentParsingControllerUploadExtractionDocumentResponses[keyof DocumentParsingControllerUploadExtractionDocumentResponses];

export type DocumentParsingControllerStartExtractionData = {
    body: StartDocumentExtractionDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-parsing/start-extraction';
};

export type DocumentParsingControllerStartExtractionResponses = {
    /**
     * Extraction started successfully
     */
    201: StartExtractionRes;
};

export type DocumentParsingControllerStartExtractionResponse = DocumentParsingControllerStartExtractionResponses[keyof DocumentParsingControllerStartExtractionResponses];

export type DocumentParsingControllerGetExtractionStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        taskId: string;
    };
    query?: never;
    url: '/document-parsing/extraction/{taskId}/status';
};

export type DocumentParsingControllerGetExtractionStatusResponses = {
    /**
     * Task status retrieved
     */
    200: GetExtractionStatusRes;
};

export type DocumentParsingControllerGetExtractionStatusResponse = DocumentParsingControllerGetExtractionStatusResponses[keyof DocumentParsingControllerGetExtractionStatusResponses];

export type DocumentParsingControllerGetExtractionResultData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        taskId: string;
    };
    query?: never;
    url: '/document-parsing/extraction/{taskId}/result';
};

export type DocumentParsingControllerGetExtractionResultResponses = {
    /**
     * Task results retrieved
     */
    200: GetExtractionResultRes;
};

export type DocumentParsingControllerGetExtractionResultResponse = DocumentParsingControllerGetExtractionResultResponses[keyof DocumentParsingControllerGetExtractionResultResponses];

export type DocumentParsingControllerListBatchesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        personId: string;
    };
    url: '/document-parsing/batches';
};

export type DocumentParsingControllerListBatchesResponses = {
    /**
     * Batches retrieved
     */
    200: ListBatchesRes;
};

export type DocumentParsingControllerListBatchesResponse = DocumentParsingControllerListBatchesResponses[keyof DocumentParsingControllerListBatchesResponses];

export type DocumentParsingControllerListDealBatchesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/document-parsing/deal-batches';
};

export type DocumentParsingControllerListDealBatchesResponses = {
    /**
     * Deal batches retrieved
     */
    200: ListBatchesRes;
};

export type DocumentParsingControllerListDealBatchesResponse = DocumentParsingControllerListDealBatchesResponses[keyof DocumentParsingControllerListDealBatchesResponses];

export type DocumentParsingControllerUpdateBatchTitleData = {
    body: UpdateBatchTitleDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/extraction/batch/{batchId}/title';
};

export type DocumentParsingControllerUpdateBatchTitleResponses = {
    /**
     * Batch title updated
     */
    200: unknown;
};

export type DocumentParsingControllerGetDocumentTransactionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentId: string;
    };
    query?: never;
    url: '/document-parsing/document/{documentId}/transactions';
};

export type DocumentParsingControllerGetDocumentTransactionsResponses = {
    /**
     * Document transactions retrieved
     */
    200: unknown;
};

export type DocumentParsingControllerGetBatchTransactionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/transactions';
};

export type DocumentParsingControllerGetBatchTransactionsResponses = {
    /**
     * Batch transactions retrieved
     */
    200: GetBatchTransactionsRes;
};

export type DocumentParsingControllerGetBatchTransactionsResponse = DocumentParsingControllerGetBatchTransactionsResponses[keyof DocumentParsingControllerGetBatchTransactionsResponses];

export type DocumentParsingControllerGetBatchOverviewData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/overview';
};

export type DocumentParsingControllerGetBatchOverviewResponses = {
    /**
     * Batch overview retrieved
     */
    200: BatchOverviewRes;
};

export type DocumentParsingControllerGetBatchOverviewResponse = DocumentParsingControllerGetBatchOverviewResponses[keyof DocumentParsingControllerGetBatchOverviewResponses];

export type DocumentParsingControllerGetBatchDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/documents';
};

export type DocumentParsingControllerGetBatchDocumentsResponses = {
    /**
     * Batch documents retrieved
     */
    200: GetBatchDocumentsRes;
};

export type DocumentParsingControllerGetBatchDocumentsResponse = DocumentParsingControllerGetBatchDocumentsResponses[keyof DocumentParsingControllerGetBatchDocumentsResponses];

export type DocumentParsingControllerSaveBatchExtractionOverridesData = {
    body: SaveExtractionOverridesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/merge';
};

export type DocumentParsingControllerSaveBatchExtractionOverridesResponses = {
    /**
     * Overrides persisted. skippedTxIds lists any overrides dropped because their transaction ids no longer exist in the batch (stale after a re-extract).
     */
    201: SaveExtractionOverridesRes;
};

export type DocumentParsingControllerSaveBatchExtractionOverridesResponse = DocumentParsingControllerSaveBatchExtractionOverridesResponses[keyof DocumentParsingControllerSaveBatchExtractionOverridesResponses];

export type DocumentParsingControllerGetBatchSecuritiesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/securities';
};

export type DocumentParsingControllerGetBatchSecuritiesResponses = {
    /**
     * Batch securities retrieved
     */
    200: GetBatchSecuritiesRes;
};

export type DocumentParsingControllerGetBatchSecuritiesResponse = DocumentParsingControllerGetBatchSecuritiesResponses[keyof DocumentParsingControllerGetBatchSecuritiesResponses];

export type DocumentParsingControllerGetBatchPeopleData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/people';
};

export type DocumentParsingControllerGetBatchPeopleResponses = {
    /**
     * Batch people retrieved
     */
    200: GetBatchPeopleRes;
};

export type DocumentParsingControllerGetBatchPeopleResponse = DocumentParsingControllerGetBatchPeopleResponses[keyof DocumentParsingControllerGetBatchPeopleResponses];

export type DocumentParsingControllerMatchBatchPersonData = {
    body: MatchExtractedPersonDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/people/match';
};

export type DocumentParsingControllerMatchBatchPersonResponses = {
    /**
     * Match persisted
     */
    200: unknown;
};

export type DocumentParsingControllerMatchBatchSecurityData = {
    body: MatchExtractedSecurityDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/securities/match';
};

export type DocumentParsingControllerMatchBatchSecurityResponses = {
    /**
     * Match persisted
     */
    200: unknown;
};

export type DocumentParsingControllerReextractBatchData = {
    body: ReextractBatchDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        batchId: string;
    };
    query?: never;
    url: '/document-parsing/batch/{batchId}/reextract';
};

export type DocumentParsingControllerReextractBatchResponses = {
    /**
     * Re-extract accepted
     */
    202: unknown;
};

export type ClassifierControllerGetAllClassifiersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/classifier';
};

export type ClassifierControllerGetAllClassifiersResponses = {
    200: Array<ClassifierRes>;
};

export type ClassifierControllerGetAllClassifiersResponse = ClassifierControllerGetAllClassifiersResponses[keyof ClassifierControllerGetAllClassifiersResponses];

export type ClassifierControllerGetDealClassifiersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query: {
        classifierType: string;
    };
    url: '/classifier/deal-classifier';
};

export type ClassifierControllerGetDealClassifiersResponses = {
    200: Array<DealClassifierRes>;
};

export type ClassifierControllerGetDealClassifiersResponse = ClassifierControllerGetDealClassifiersResponses[keyof ClassifierControllerGetDealClassifiersResponses];

export type ClassifierControllerPostDealClassifiersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/classifier/deal-classifier';
};

export type ClassifierControllerPostDealClassifiersResponses = {
    200: Array<DealClassifierRes>;
};

export type ClassifierControllerPostDealClassifiersResponse = ClassifierControllerPostDealClassifiersResponses[keyof ClassifierControllerPostDealClassifiersResponses];

export type DealEventLogControllerGetDealEventsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Comma separated list
         */
        categories?: Array<DealEventCategory>;
        /**
         * Comma separated list of event types, as the feed reports them
         */
        types?: Array<string>;
        /**
         * Comma separated list
         */
        statuses?: Array<DealEventStatus>;
        /**
         * Comma separated list of security ids
         */
        securityIds?: Array<string>;
        /**
         * Comma separated list of exact recipient email addresses
         */
        recipientEmails?: Array<string>;
        /**
         * A user id, or "SYSTEM" for everything no person did
         */
        actorUserId?: string;
        /**
         * Comma separated list of ids of the users an access or auth event is about
         */
        targetUserIds?: Array<string>;
        /**
         * Comma separated list of ids of the investors an event is about
         */
        investorIds?: Array<string>;
        /**
         * Case-insensitive keyword
         */
        search?: string;
        from?: string;
        to?: string;
        cursor?: string;
        limit?: number;
    };
    url: '/deal-event-log/events';
};

export type DealEventLogControllerGetDealEventsResponses = {
    default: DealEventFeedRes;
};

export type DealEventLogControllerGetDealEventsResponse = DealEventLogControllerGetDealEventsResponses[keyof DealEventLogControllerGetDealEventsResponses];

export type DealEventLogControllerGetDealEventDailyCountsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Comma separated list
         */
        categories?: Array<DealEventCategory>;
        /**
         * Comma separated list of event types, as the feed reports them
         */
        types?: Array<string>;
        /**
         * Comma separated list
         */
        statuses?: Array<DealEventStatus>;
        /**
         * Comma separated list of security ids
         */
        securityIds?: Array<string>;
        /**
         * Comma separated list of exact recipient email addresses
         */
        recipientEmails?: Array<string>;
        /**
         * A user id, or "SYSTEM" for everything no person did
         */
        actorUserId?: string;
        /**
         * Comma separated list of ids of the users an access or auth event is about
         */
        targetUserIds?: Array<string>;
        /**
         * Comma separated list of ids of the investors an event is about
         */
        investorIds?: Array<string>;
        /**
         * Case-insensitive keyword
         */
        search?: string;
        from?: string;
        to?: string;
        /**
         * IANA time zone the days are cut in. Defaults to UTC.
         */
        timeZone?: string;
    };
    url: '/deal-event-log/events/daily-counts';
};

export type DealEventLogControllerGetDealEventDailyCountsResponses = {
    default: DealEventDailyCountsRes;
};

export type DealEventLogControllerGetDealEventDailyCountsResponse = DealEventLogControllerGetDealEventDailyCountsResponses[keyof DealEventLogControllerGetDealEventDailyCountsResponses];

export type DealEventLogControllerExportDealEventsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Comma separated list
         */
        categories?: Array<DealEventCategory>;
        /**
         * Comma separated list of event types, as the feed reports them
         */
        types?: Array<string>;
        /**
         * Comma separated list
         */
        statuses?: Array<DealEventStatus>;
        /**
         * Comma separated list of security ids
         */
        securityIds?: Array<string>;
        /**
         * Comma separated list of exact recipient email addresses
         */
        recipientEmails?: Array<string>;
        /**
         * A user id, or "SYSTEM" for everything no person did
         */
        actorUserId?: string;
        /**
         * Comma separated list of ids of the users an access or auth event is about
         */
        targetUserIds?: Array<string>;
        /**
         * Comma separated list of ids of the investors an event is about
         */
        investorIds?: Array<string>;
        /**
         * Case-insensitive keyword
         */
        search?: string;
        from?: string;
        to?: string;
    };
    url: '/deal-event-log/events/export';
};

export type DealEventLogControllerExportDealEventsResponses = {
    200: string;
};

export type DealEventLogControllerExportDealEventsResponse = DealEventLogControllerExportDealEventsResponses[keyof DealEventLogControllerExportDealEventsResponses];

export type DealEventLogControllerGetDealEventRecipientsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Case-insensitive substring match
         */
        search?: string;
        limit?: number;
    };
    url: '/deal-event-log/events/recipients';
};

export type DealEventLogControllerGetDealEventRecipientsResponses = {
    default: DealEventRecipientsRes;
};

export type DealEventLogControllerGetDealEventRecipientsResponse = DealEventLogControllerGetDealEventRecipientsResponses[keyof DealEventLogControllerGetDealEventRecipientsResponses];

export type DealEventLogControllerGetDealEventActorsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Case-insensitive substring match
         */
        search?: string;
        limit?: number;
        /**
         * Comma separated list
         */
        categories?: Array<DealEventCategory>;
    };
    url: '/deal-event-log/events/actors';
};

export type DealEventLogControllerGetDealEventActorsResponses = {
    default: DealEventActorsRes;
};

export type DealEventLogControllerGetDealEventActorsResponse = DealEventLogControllerGetDealEventActorsResponses[keyof DealEventLogControllerGetDealEventActorsResponses];

export type DealEventLogControllerGetDealEventParticipantsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal-event-log/events/participants';
};

export type DealEventLogControllerGetDealEventParticipantsResponses = {
    default: DealEventParticipantsRes;
};

export type DealEventLogControllerGetDealEventParticipantsResponse = DealEventLogControllerGetDealEventParticipantsResponses[keyof DealEventLogControllerGetDealEventParticipantsResponses];

export type DealEventLogControllerGetDealEventMessageData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        messageId: string;
    };
    query?: never;
    url: '/deal-event-log/events/messages/{messageId}';
};

export type DealEventLogControllerGetDealEventMessageResponses = {
    default: InvestorMessageRes;
};

export type DealEventLogControllerGetDealEventMessageResponse = DealEventLogControllerGetDealEventMessageResponses[keyof DealEventLogControllerGetDealEventMessageResponses];

export type DealEventLogControllerGetDealEventSendersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Case-insensitive substring match
         */
        search?: string;
        limit?: number;
    };
    url: '/deal-event-log/events/senders';
};

export type DealEventLogControllerGetDealEventSendersResponses = {
    default: DealEventSendersRes;
};

export type DealEventLogControllerGetDealEventSendersResponse = DealEventLogControllerGetDealEventSendersResponses[keyof DealEventLogControllerGetDealEventSendersResponses];

export type DealEventLogControllerGetDealEventSubjectsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        /**
         * Case-insensitive substring match
         */
        search?: string;
        limit?: number;
    };
    url: '/deal-event-log/events/subjects';
};

export type DealEventLogControllerGetDealEventSubjectsResponses = {
    default: DealEventSubjectsRes;
};

export type DealEventLogControllerGetDealEventSubjectsResponse = DealEventLogControllerGetDealEventSubjectsResponses[keyof DealEventLogControllerGetDealEventSubjectsResponses];

export type DealEventLogControllerGetUnreadData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal-event-log/unread';
};

export type DealEventLogControllerGetUnreadResponses = {
    default: DealEventLogUnreadRes;
};

export type DealEventLogControllerGetUnreadResponse = DealEventLogControllerGetUnreadResponses[keyof DealEventLogControllerGetUnreadResponses];

export type DealEventLogControllerMarkViewedData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/deal-event-log/viewed';
};

export type DealEventLogControllerMarkViewedResponses = {
    default: DealEventLogViewRes;
};

export type DealEventLogControllerMarkViewedResponse = DealEventLogControllerMarkViewedResponses[keyof DealEventLogControllerMarkViewedResponses];

export type SecurityEventControllerGetSecurityEventsData = {
    body: SecurityEventListQueryDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/security-event/events-list';
};

export type SecurityEventControllerGetSecurityEventsResponses = {
    default: GetSecurityEventsRes;
};

export type SecurityEventControllerGetSecurityEventsResponse = SecurityEventControllerGetSecurityEventsResponses[keyof SecurityEventControllerGetSecurityEventsResponses];

export type SecurityEventControllerCreateSecurityEventData = {
    body: CreateSecurityEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/security-event/create-security-event';
};

export type SecurityEventControllerCreateSecurityEventResponses = {
    default: CreateSecurityEventDto;
};

export type SecurityEventControllerCreateSecurityEventResponse = SecurityEventControllerCreateSecurityEventResponses[keyof SecurityEventControllerCreateSecurityEventResponses];

export type SecurityEventControllerUpdateSecurityEventData = {
    body: UpdateSecurityEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/security-event/update-security-event';
};

export type SecurityEventControllerUpdateSecurityEventResponses = {
    default: UpdateSecurityEventDto;
};

export type SecurityEventControllerUpdateSecurityEventResponse = SecurityEventControllerUpdateSecurityEventResponses[keyof SecurityEventControllerUpdateSecurityEventResponses];

export type SecurityEventControllerSoftDeleteSecurityEventData = {
    body: DeleteSecurityEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/security-event/soft-delete-security-event';
};

export type SecurityEventControllerSoftDeleteSecurityEventResponses = {
    default: DeleteSecurityEventRes;
};

export type SecurityEventControllerSoftDeleteSecurityEventResponse = SecurityEventControllerSoftDeleteSecurityEventResponses[keyof SecurityEventControllerSoftDeleteSecurityEventResponses];

export type ValuationControllerGetValuationsAndJoinWithClassifiersData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation';
};

export type ValuationControllerGetValuationsAndJoinWithClassifiersResponses = {
    200: Array<ValuationWithClassifierRes>;
};

export type ValuationControllerGetValuationsAndJoinWithClassifiersResponse = ValuationControllerGetValuationsAndJoinWithClassifiersResponses[keyof ValuationControllerGetValuationsAndJoinWithClassifiersResponses];

export type ValuationControllerCreateValuationData = {
    body: CreateValuationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation';
};

export type ValuationControllerCreateValuationResponses = {
    201: ValuationRes;
};

export type ValuationControllerCreateValuationResponse = ValuationControllerCreateValuationResponses[keyof ValuationControllerCreateValuationResponses];

export type ValuationControllerDeleteValuationData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}';
};

export type ValuationControllerDeleteValuationResponses = {
    200: unknown;
};

export type ValuationControllerUpdateValuationWithClassifiersData = {
    body: UpdateValuationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}';
};

export type ValuationControllerUpdateValuationWithClassifiersResponses = {
    200: ValuationWithClassifierRes;
};

export type ValuationControllerUpdateValuationWithClassifiersResponse = ValuationControllerUpdateValuationWithClassifiersResponses[keyof ValuationControllerUpdateValuationWithClassifiersResponses];

export type ValuationControllerUpsertValuationData = {
    body: UpsertValuationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}';
};

export type ValuationControllerUpsertValuationResponses = {
    200: ValuationWithClassifierRes;
};

export type ValuationControllerUpsertValuationResponse = ValuationControllerUpsertValuationResponses[keyof ValuationControllerUpsertValuationResponses];

export type ValuationControllerDuplicateValuationData = {
    body: DuplicateValuationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/duplicate';
};

export type ValuationControllerDuplicateValuationResponses = {
    201: ValuationRes;
};

export type ValuationControllerDuplicateValuationResponse = ValuationControllerDuplicateValuationResponses[keyof ValuationControllerDuplicateValuationResponses];

export type ValuationInputControllerGetValuationInputsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input';
};

export type ValuationInputControllerGetValuationInputsResponses = {
    200: Array<ValuationInputWithAdjustmentsRes>;
};

export type ValuationInputControllerGetValuationInputsResponse = ValuationInputControllerGetValuationInputsResponses[keyof ValuationInputControllerGetValuationInputsResponses];

export type ValuationInputControllerUpsertData = {
    body: UpsertValuationInputsDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input';
};

export type ValuationInputControllerUpsertResponses = {
    200: UpsertValuationInputsRes;
};

export type ValuationInputControllerUpsertResponse = ValuationInputControllerUpsertResponses[keyof ValuationInputControllerUpsertResponses];

export type ValuationInputControllerUpdateValuationInputData = {
    body: UpdateValuationInputDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Valuation input ID
         */
        valuationInputId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}';
};

export type ValuationInputControllerUpdateValuationInputResponses = {
    200: ValuationInputWithAdjustmentsRes;
};

export type ValuationInputControllerUpdateValuationInputResponse = ValuationInputControllerUpdateValuationInputResponses[keyof ValuationInputControllerUpdateValuationInputResponses];

export type ValuationInputControllerCreateValuationInputAdjustmentData = {
    body: CreateValuationInputAdjustmentDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Valuation input ID
         */
        valuationInputId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment';
};

export type ValuationInputControllerCreateValuationInputAdjustmentResponses = {
    201: ValuationInputAdjustmentWithClassifierRes;
};

export type ValuationInputControllerCreateValuationInputAdjustmentResponse = ValuationInputControllerCreateValuationInputAdjustmentResponses[keyof ValuationInputControllerCreateValuationInputAdjustmentResponses];

export type ValuationInputControllerDeleteValuationInputAdjustmentData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Valuation input ID
         */
        valuationInputId: string;
        /**
         * Valuation input adjustment ID
         */
        valuationInputAdjustmentId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment/{valuationInputAdjustmentId}';
};

export type ValuationInputControllerDeleteValuationInputAdjustmentResponses = {
    200: unknown;
};

export type ValuationInputControllerUpdateValuationInputAdjustmentData = {
    body: UpdateValuationInputAdjustmentDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Valuation input ID
         */
        valuationInputId: string;
        /**
         * Valuation input adjustment ID
         */
        valuationInputAdjustmentId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/input/{valuationInputId}/adjustment/{valuationInputAdjustmentId}';
};

export type ValuationInputControllerUpdateValuationInputAdjustmentResponses = {
    200: ValuationInputAdjustmentWithClassifierRes;
};

export type ValuationInputControllerUpdateValuationInputAdjustmentResponse = ValuationInputControllerUpdateValuationInputAdjustmentResponses[keyof ValuationInputControllerUpdateValuationInputAdjustmentResponses];

export type ForeignExchangeControllerGetLatestExchangeRateData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        base: CurrencyType;
        currencies: Array<CurrencyType>;
    };
    url: '/fx';
};

export type ForeignExchangeControllerGetLatestExchangeRateResponses = {
    200: LatestExchangeRateRes;
};

export type ForeignExchangeControllerGetLatestExchangeRateResponse = ForeignExchangeControllerGetLatestExchangeRateResponses[keyof ForeignExchangeControllerGetLatestExchangeRateResponses];

export type ForeignExchangeControllerGetHistoricalAndCustomExchangeRateData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/fx';
};

export type ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponses = {
    200: HistoricalAndCustomExchangeRateRes;
};

export type ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponse = ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponses[keyof ForeignExchangeControllerGetHistoricalAndCustomExchangeRateResponses];

export type ForeignExchangeControllerPutCustomExchangeRateData = {
    body: PutCustomExchangeRateDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/fx';
};

export type ForeignExchangeControllerPutCustomExchangeRateResponses = {
    200: PutCustomExchangeRateRes;
};

export type ForeignExchangeControllerPutCustomExchangeRateResponse = ForeignExchangeControllerPutCustomExchangeRateResponses[keyof ForeignExchangeControllerPutCustomExchangeRateResponses];

export type ForeignExchangeControllerGetCurrenciesUsedInValuationData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/currency';
};

export type ForeignExchangeControllerGetCurrenciesUsedInValuationResponses = {
    200: GetCurrenciesUsedInValuationRes;
};

export type ForeignExchangeControllerGetCurrenciesUsedInValuationResponse = ForeignExchangeControllerGetCurrenciesUsedInValuationResponses[keyof ForeignExchangeControllerGetCurrenciesUsedInValuationResponses];

export type ValuationPersonInputControllerGetValuationPersonInputsData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input';
};

export type ValuationPersonInputControllerGetValuationPersonInputsResponses = {
    200: Array<ValuationPersonInputRes>;
};

export type ValuationPersonInputControllerGetValuationPersonInputsResponse = ValuationPersonInputControllerGetValuationPersonInputsResponses[keyof ValuationPersonInputControllerGetValuationPersonInputsResponses];

export type ValuationPersonInputControllerCreateValuationPersonInputData = {
    body: CreateValuationPersonInputDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input';
};

export type ValuationPersonInputControllerCreateValuationPersonInputResponses = {
    201: ValuationPersonInputRes;
};

export type ValuationPersonInputControllerCreateValuationPersonInputResponse = ValuationPersonInputControllerCreateValuationPersonInputResponses[keyof ValuationPersonInputControllerCreateValuationPersonInputResponses];

export type ValuationPersonInputControllerUpsertValuationPersonInputsData = {
    body: UpsertValuationPersonInputsDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input';
};

export type ValuationPersonInputControllerUpsertValuationPersonInputsResponses = {
    200: UpsertValuationPersonInputsRes;
};

export type ValuationPersonInputControllerUpsertValuationPersonInputsResponse = ValuationPersonInputControllerUpsertValuationPersonInputsResponses[keyof ValuationPersonInputControllerUpsertValuationPersonInputsResponses];

export type ValuationPersonInputControllerDeleteValuationPersonInputData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
        /**
         * Valuation person input ID
         */
        inputId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input/{inputId}';
};

export type ValuationPersonInputControllerDeleteValuationPersonInputResponses = {
    204: void;
};

export type ValuationPersonInputControllerDeleteValuationPersonInputResponse = ValuationPersonInputControllerDeleteValuationPersonInputResponses[keyof ValuationPersonInputControllerDeleteValuationPersonInputResponses];

export type ValuationPersonInputControllerUpdateValuationPersonInputData = {
    body: UpdateValuationPersonInputDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
        /**
         * Valuation person input ID
         */
        inputId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/input/{inputId}';
};

export type ValuationPersonInputControllerUpdateValuationPersonInputResponses = {
    200: ValuationPersonInputRes;
};

export type ValuationPersonInputControllerUpdateValuationPersonInputResponse = ValuationPersonInputControllerUpdateValuationPersonInputResponses[keyof ValuationPersonInputControllerUpdateValuationPersonInputResponses];

export type ValuationSummaryControllerStartCalculateValuationData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/start';
};

export type ValuationSummaryControllerStartCalculateValuationResponses = {
    201: StartCalculateValuationRes;
};

export type ValuationSummaryControllerStartCalculateValuationResponse = ValuationSummaryControllerStartCalculateValuationResponses[keyof ValuationSummaryControllerStartCalculateValuationResponses];

export type ValuationSummaryControllerStreamCalculateValuationData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query: {
        /**
         * The workflowId returned by calculate-valuation/start
         */
        workflowId: string;
    };
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/stream';
};

export type ValuationSummaryControllerStreamCalculateValuationResponses = {
    200: unknown;
};

export type ValuationSummaryControllerGetValuationSummaryResultData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Persisted compute result ID
         */
        resultId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/calculate-valuation/result/{resultId}';
};

export type ValuationSummaryControllerGetValuationSummaryResultResponses = {
    200: GetValuationSummaryResultRes;
};

export type ValuationSummaryControllerGetValuationSummaryResultResponse = ValuationSummaryControllerGetValuationSummaryResultResponses[keyof ValuationSummaryControllerGetValuationSummaryResultResponses];

export type ValuationSummaryControllerGetValuationBreakpointSummaryData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
    };
    query: {
        /**
         * The ID of the MIP to get the breakpoint summary for
         */
        mipId?: string;
        /**
         * Persisted compute result ID returned by the calculate-valuation stream
         */
        resultId: string;
    };
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/breakpoint';
};

export type ValuationSummaryControllerGetValuationBreakpointSummaryResponses = {
    200: BreakpointSummaryRes;
};

export type ValuationSummaryControllerGetValuationBreakpointSummaryResponse = ValuationSummaryControllerGetValuationBreakpointSummaryResponses[keyof ValuationSummaryControllerGetValuationBreakpointSummaryResponses];

export type ValuationSummaryControllerDownloadInterestEventsExcelData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Person ID
         */
        personId: string;
    };
    query: {
        /**
         * Persisted compute result ID returned by the calculate-valuation stream
         */
        resultId: string;
        /**
         * Security ID whose interest ledger to export
         */
        securityId: string;
        /**
         * ISO date part of the tranche key
         */
        trancheKey: string;
        /**
         * Optional MIP context
         */
        mipId?: string;
    };
    url: '/deal/{dealId}/valuation/{valuationId}/person/{personId}/interest-events-excel';
};

export type ValuationSummaryControllerDownloadInterestEventsExcelResponses = {
    /**
     * Excel file download (.xlsx)
     */
    200: Blob | File;
};

export type ValuationSummaryControllerDownloadInterestEventsExcelResponse = ValuationSummaryControllerDownloadInterestEventsExcelResponses[keyof ValuationSummaryControllerDownloadInterestEventsExcelResponses];

export type ValuationSummaryControllerDownloadExcelData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query: {
        /**
         * Persisted compute result ID returned by the calculate-valuation stream
         */
        resultId: string;
    };
    url: '/deal/{dealId}/valuation/{valuationId}/summary-excel';
};

export type ValuationSummaryControllerDownloadExcelResponses = {
    /**
     * Excel file download (.xlsx)
     */
    200: Blob | File;
};

export type ValuationSummaryControllerDownloadExcelResponse = ValuationSummaryControllerDownloadExcelResponses[keyof ValuationSummaryControllerDownloadExcelResponses];

export type SecurityValueOverrideControllerCreateSecurityValueOverrideData = {
    body: CreateSecurityValueOverrideDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride';
};

export type SecurityValueOverrideControllerCreateSecurityValueOverrideResponses = {
    201: SecurityValueOverrideRes;
};

export type SecurityValueOverrideControllerCreateSecurityValueOverrideResponse = SecurityValueOverrideControllerCreateSecurityValueOverrideResponses[keyof SecurityValueOverrideControllerCreateSecurityValueOverrideResponses];

export type SecurityValueOverrideControllerDeleteSecurityValueOverrideData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Security value override ID
         */
        securityValueOverrideId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride/{securityValueOverrideId}';
};

export type SecurityValueOverrideControllerDeleteSecurityValueOverrideResponses = {
    204: void;
};

export type SecurityValueOverrideControllerDeleteSecurityValueOverrideResponse = SecurityValueOverrideControllerDeleteSecurityValueOverrideResponses[keyof SecurityValueOverrideControllerDeleteSecurityValueOverrideResponses];

export type SecurityValueOverrideControllerUpdateSecurityValueOverrideData = {
    body: UpdateSecurityValueOverrideDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * Deal ID
         */
        dealId: string;
        /**
         * Valuation ID
         */
        valuationId: string;
        /**
         * Security value override ID
         */
        securityValueOverrideId: string;
    };
    query?: never;
    url: '/deal/{dealId}/valuation/{valuationId}/securityValueOverride/{securityValueOverrideId}';
};

export type SecurityValueOverrideControllerUpdateSecurityValueOverrideResponses = {
    200: SecurityValueOverrideRes;
};

export type SecurityValueOverrideControllerUpdateSecurityValueOverrideResponse = SecurityValueOverrideControllerUpdateSecurityValueOverrideResponses[keyof SecurityValueOverrideControllerUpdateSecurityValueOverrideResponses];

export type HoldingsControllerGenerateShareRegisterPdfData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        /**
         * The issuer person ID
         */
        issuerId: string;
    };
    query?: {
        /**
         * The date to compute the share register for (ISO 8601 format). Defaults to current date.
         */
        date?: string;
    };
    url: '/cap/share-register-pdf/{issuerId}';
};

export type HoldingsControllerGenerateShareRegisterPdfResponses = {
    default: GenerateShareRegisterRes;
};

export type HoldingsControllerGenerateShareRegisterPdfResponse = HoldingsControllerGenerateShareRegisterPdfResponses[keyof HoldingsControllerGenerateShareRegisterPdfResponses];

export type HoldingsControllerGenerateShareRegisterPdfInlineData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        issuerId: string;
    };
    query?: {
        /**
         * ISO 8601 date to compute the register at. Defaults to current date.
         */
        date?: string;
    };
    url: '/cap/share-register-pdf/{issuerId}/inline';
};

export type HoldingsControllerGenerateShareRegisterPdfInlineResponses = {
    /**
     * PDF bytes
     */
    200: Blob | File;
};

export type HoldingsControllerGenerateShareRegisterPdfInlineResponse = HoldingsControllerGenerateShareRegisterPdfInlineResponses[keyof HoldingsControllerGenerateShareRegisterPdfInlineResponses];

export type HoldingsControllerStartShareRegisterPdfGenerationData = {
    body: GenerateShareRegisterPdfDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        issuerId: string;
    };
    query?: never;
    url: '/cap/share-register-pdf/{issuerId}/generate';
};

export type HoldingsControllerStartShareRegisterPdfGenerationResponses = {
    default: CreateShareRegisterPdfTaskRes;
};

export type HoldingsControllerStartShareRegisterPdfGenerationResponse = HoldingsControllerStartShareRegisterPdfGenerationResponses[keyof HoldingsControllerStartShareRegisterPdfGenerationResponses];

export type HoldingsControllerGetShareRegisterPdfTaskStatusData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        taskId: string;
    };
    query?: never;
    url: '/cap/share-register-pdf/task/{taskId}/status';
};

export type HoldingsControllerGetShareRegisterPdfTaskStatusResponses = {
    default: ShareRegisterPdfTaskStatusRes;
};

export type HoldingsControllerGetShareRegisterPdfTaskStatusResponse = HoldingsControllerGetShareRegisterPdfTaskStatusResponses[keyof HoldingsControllerGetShareRegisterPdfTaskStatusResponses];

export type HoldingsControllerPostHoldingsListForPersonData = {
    body: GetHoldingsListForPersonDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/holdings-list-for-person';
};

export type HoldingsControllerPostHoldingsListForPersonResponses = {
    200: Array<HoldingRes>;
};

export type HoldingsControllerPostHoldingsListForPersonResponse = HoldingsControllerPostHoldingsListForPersonResponses[keyof HoldingsControllerPostHoldingsListForPersonResponses];

export type HoldingsControllerGetHoldingByPersonAndSecurityData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
        securityId: string;
    };
    query?: {
        rail?: 'LEGAL' | 'BENEFICIAL';
    };
    url: '/cap/holdings/person/{personId}/security/{securityId}';
};

export type HoldingsControllerGetHoldingByPersonAndSecurityResponses = {
    200: HoldingDetailRes;
};

export type HoldingsControllerGetHoldingByPersonAndSecurityResponse = HoldingsControllerGetHoldingByPersonAndSecurityResponses[keyof HoldingsControllerGetHoldingByPersonAndSecurityResponses];

export type HoldingsControllerGetHoldingEventsListByPersonAndSecurityData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        personId: string;
        securityId: string;
    };
    query: {
        filterDate: string;
        rail?: 'LEGAL' | 'BENEFICIAL';
    };
    url: '/cap/holdings/person/{personId}/security/{securityId}/events';
};

export type HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponses = {
    200: Array<HoldingEventDto>;
};

export type HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponse = HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponses[keyof HoldingsControllerGetHoldingEventsListByPersonAndSecurityResponses];

export type HoldingsControllerPostWideViewHoldingsCsvData = {
    body: GetWideViewHoldingsCsvDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/wide-view-csv';
};

export type HoldingsControllerPostWideViewHoldingsCsvResponses = {
    200: unknown;
};

export type HoldingsControllerPostRegularViewHoldingsCsvData = {
    body: GetRegularViewHoldingsCsvDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/regular-view-csv';
};

export type HoldingsControllerPostRegularViewHoldingsCsvResponses = {
    200: unknown;
};

export type HoldingsControllerDownloadHoldingsExcelData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query: {
        personId: string;
        isOwnership: boolean;
        filterDate: string;
        rail?: 'LEGAL' | 'BENEFICIAL';
    };
    url: '/cap/holdings-excel';
};

export type HoldingsControllerDownloadHoldingsExcelResponses = {
    200: unknown;
};

export type HoldingsControllerDownloadVestingEventsReportData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query: {
        issuerId: string;
        investorId?: string;
    };
    url: '/cap/vesting-events-report';
};

export type HoldingsControllerDownloadVestingEventsReportResponses = {
    /**
     * Returns .xlsx file with vesting events report
     */
    default: unknown;
};

export type HoldingEventControllerCreateHoldingEventData = {
    body: CreateHoldingEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/holdings-event/create-holdings-event';
};

export type HoldingEventControllerCreateHoldingEventResponses = {
    default: CreateHoldingEventDto;
};

export type HoldingEventControllerCreateHoldingEventResponse = HoldingEventControllerCreateHoldingEventResponses[keyof HoldingEventControllerCreateHoldingEventResponses];

export type HoldingEventControllerCreateBulkHoldingEventsData = {
    body: BulkCreateHoldingEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/holdings-event/create-bulk-holdings-event';
};

export type HoldingEventControllerCreateBulkHoldingEventsResponses = {
    default: BulkCreateHoldingEventDto;
};

export type HoldingEventControllerCreateBulkHoldingEventsResponse = HoldingEventControllerCreateBulkHoldingEventsResponses[keyof HoldingEventControllerCreateBulkHoldingEventsResponses];

export type HoldingEventControllerUpdateHoldingEventData = {
    body: UpdateHoldingEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/holdings-event/update-holdings-event';
};

export type HoldingEventControllerUpdateHoldingEventResponses = {
    default: UpdateHoldingEventDto;
};

export type HoldingEventControllerUpdateHoldingEventResponse = HoldingEventControllerUpdateHoldingEventResponses[keyof HoldingEventControllerUpdateHoldingEventResponses];

export type HoldingEventControllerSoftDeleteHoldingEventData = {
    body: DeleteHoldingEventDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/cap/holdings-event/soft-delete-holdings-event';
};

export type HoldingEventControllerSoftDeleteHoldingEventResponses = {
    default: HoldingEventRes;
};

export type HoldingEventControllerSoftDeleteHoldingEventResponse = HoldingEventControllerSoftDeleteHoldingEventResponses[keyof HoldingEventControllerSoftDeleteHoldingEventResponses];

export type E2eControllerWarmupPoolData = {
    body: WarmupPoolDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/warmup';
};

export type E2eControllerWarmupPoolResponses = {
    200: unknown;
};

export type E2eControllerCreateUserData = {
    body: CreateE2eUserDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/user';
};

export type E2eControllerCreateUserResponses = {
    default: CreateE2eUserRes;
};

export type E2eControllerCreateUserResponse = E2eControllerCreateUserResponses[keyof E2eControllerCreateUserResponses];

export type E2eControllerAuthenticateUserData = {
    body: AuthenticateDealstackUserDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/authenticate';
};

export type E2eControllerAuthenticateUserResponses = {
    default: AuthenticationRes;
};

export type E2eControllerAuthenticateUserResponse = E2eControllerAuthenticateUserResponses[keyof E2eControllerAuthenticateUserResponses];

export type E2eControllerGetChangeEmailVerificationCodeData = {
    body: ChangeEmailVerificationCodeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/change-email-verification-code';
};

export type E2eControllerGetChangeEmailVerificationCodeResponses = {
    default: ChangeEmailVerificationCodeRes;
};

export type E2eControllerGetChangeEmailVerificationCodeResponse = E2eControllerGetChangeEmailVerificationCodeResponses[keyof E2eControllerGetChangeEmailVerificationCodeResponses];

export type E2eControllerGetWorkOsEmailVerificationCodeData = {
    body: WorkOsMailLookupDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-email-verification-code';
};

export type E2eControllerGetWorkOsEmailVerificationCodeResponses = {
    default: WorkOsEmailVerificationCodeRes;
};

export type E2eControllerGetWorkOsEmailVerificationCodeResponse = E2eControllerGetWorkOsEmailVerificationCodeResponses[keyof E2eControllerGetWorkOsEmailVerificationCodeResponses];

export type E2eControllerGetWorkOsMagicAuthCodeData = {
    body: WorkOsMailLookupDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-magic-auth-code';
};

export type E2eControllerGetWorkOsMagicAuthCodeResponses = {
    default: WorkOsEmailVerificationCodeRes;
};

export type E2eControllerGetWorkOsMagicAuthCodeResponse = E2eControllerGetWorkOsMagicAuthCodeResponses[keyof E2eControllerGetWorkOsMagicAuthCodeResponses];

export type E2eControllerGetWorkOsPasswordResetLinkData = {
    body: WorkOsMailLookupDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-password-reset-link';
};

export type E2eControllerGetWorkOsPasswordResetLinkResponses = {
    default: WorkOsPasswordResetLinkRes;
};

export type E2eControllerGetWorkOsPasswordResetLinkResponse = E2eControllerGetWorkOsPasswordResetLinkResponses[keyof E2eControllerGetWorkOsPasswordResetLinkResponses];

export type E2eControllerGetSsoFixtureData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/sso-fixture';
};

export type E2eControllerGetSsoFixtureResponses = {
    default: SsoFixtureRes;
};

export type E2eControllerGetSsoFixtureResponse = E2eControllerGetSsoFixtureResponses[keyof E2eControllerGetSsoFixtureResponses];

export type E2eControllerResetSsoOrganizationData = {
    body: ResetSsoOrganizationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        label: string;
    };
    query?: never;
    url: '/e2e/sso-organization/{label}/reset';
};

export type E2eControllerResetSsoOrganizationResponses = {
    default: SsoFixtureOrganizationRes;
};

export type E2eControllerResetSsoOrganizationResponse = E2eControllerResetSsoOrganizationResponses[keyof E2eControllerResetSsoOrganizationResponses];

export type E2eControllerGetSentEmailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * The recipient address to read mail for.
         */
        to: string;
        /**
         * Only return mail sent at or after this ISO-8601 instant.
         */
        since: string;
    };
    url: '/e2e/emails';
};

export type E2eControllerGetSentEmailsResponses = {
    default: E2eSentEmailsRes;
};

export type E2eControllerGetSentEmailsResponse = E2eControllerGetSentEmailsResponses[keyof E2eControllerGetSentEmailsResponses];

export type E2eControllerGetWorkOsUserData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * The address to resolve the WorkOS user by.
         */
        email: string;
    };
    url: '/e2e/workos-user';
};

export type E2eControllerGetWorkOsUserResponses = {
    default: E2eWorkOsUserRes;
};

export type E2eControllerGetWorkOsUserResponse = E2eControllerGetWorkOsUserResponses[keyof E2eControllerGetWorkOsUserResponses];

export type E2eControllerCreateWorkOsUserData = {
    body: CreateWorkOsUserDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-user';
};

export type E2eControllerCreateWorkOsUserResponses = {
    default: E2eWorkOsUserRes;
};

export type E2eControllerCreateWorkOsUserResponse = E2eControllerCreateWorkOsUserResponses[keyof E2eControllerCreateWorkOsUserResponses];

export type E2eControllerChangeWorkOsUserEmailData = {
    body: ChangeWorkOsUserEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-user/email';
};

export type E2eControllerChangeWorkOsUserEmailResponses = {
    default: E2eWorkOsUserRes;
};

export type E2eControllerChangeWorkOsUserEmailResponse = E2eControllerChangeWorkOsUserEmailResponses[keyof E2eControllerChangeWorkOsUserEmailResponses];

export type E2eControllerAcceptWorkOsInvitationData = {
    body: AcceptWorkOsInvitationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-invitation/accept';
};

export type E2eControllerAcceptWorkOsInvitationResponses = {
    default: E2eWorkOsInvitationRes;
};

export type E2eControllerAcceptWorkOsInvitationResponse = E2eControllerAcceptWorkOsInvitationResponses[keyof E2eControllerAcceptWorkOsInvitationResponses];

export type E2eControllerPollWorkOsEventsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/e2e/workos-events/poll';
};

export type E2eControllerPollWorkOsEventsResponses = {
    default: E2eWorkOsEventsPollRes;
};

export type E2eControllerPollWorkOsEventsResponse = E2eControllerPollWorkOsEventsResponses[keyof E2eControllerPollWorkOsEventsResponses];

export type E2eControllerDisableMipKycData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query?: never;
    url: '/e2e/mip/{mipId}/disable-kyc';
};

export type E2eControllerDisableMipKycResponses = {
    200: unknown;
};

export type CspReportControllerCollectReportData = {
    /**
     * A browser CSP violation report. Accepts both the `report-uri` shape (`{"csp-report": {…}}`) and the `report-to` shape (`{"body": {…}}`). Unrecognised bodies are discarded silently.
     */
    body: {
        [key: string]: unknown;
    };
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/csp-report';
};

export type CspReportControllerCollectReportResponses = {
    204: void;
};

export type CspReportControllerCollectReportResponse = CspReportControllerCollectReportResponses[keyof CspReportControllerCollectReportResponses];

export type EidEasyWebhookControllerDocumentSignedData = {
    body?: never;
    headers: {
        'x-eideasy-hmac-sha256': string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/eid-easy/webhook/document-signed';
};

export type EidEasyWebhookControllerDocumentSignedResponses = {
    200: unknown;
};

export type EidEasyWebhookControllerCustomSignatureImageData = {
    body: CustomSignatureImageWebhookDto;
    headers: {
        'x-eideasy-hmac-sha256': string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/eid-easy/webhook/custom-signature-image';
};

export type EidEasyWebhookControllerCustomSignatureImageResponses = {
    201: unknown;
};

export type WorkOsWebhookControllerWebhookData = {
    body?: never;
    headers: {
        'workos-signature': string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/workos/webhook';
};

export type WorkOsWebhookControllerWebhookResponses = {
    200: unknown;
};

export type EidEasyMockControllerSignPageData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        doc_id: string;
        otp_error: string;
    };
    url: '/eid-easy/mock/sign-page';
};

export type EidEasyMockControllerSignPageResponses = {
    200: unknown;
};

export type EidEasyMockControllerVerifyOtpData = {
    body: MockVerifyOtpDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/eid-easy/mock/verify-otp';
};

export type EidEasyMockControllerVerifyOtpResponses = {
    201: unknown;
};

export type EidEasyMockControllerCompleteData = {
    body: MockCompleteDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/eid-easy/mock/complete';
};

export type EidEasyMockControllerCompleteResponses = {
    201: unknown;
};

export type HealthControllerHealthCheckData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/health';
};

export type HealthControllerHealthCheckErrors = {
    /**
     * The Health Check is not successful
     */
    503: {
        status?: string;
        info?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        error?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        details?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        };
    };
};

export type HealthControllerHealthCheckError = HealthControllerHealthCheckErrors[keyof HealthControllerHealthCheckErrors];

export type HealthControllerHealthCheckResponses = {
    /**
     * The Health Check is successful
     */
    200: {
        status?: string;
        info?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        error?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        } | null;
        details?: {
            [key: string]: {
                status: string;
                [key: string]: unknown;
            };
        };
    };
};

export type HealthControllerHealthCheckResponse = HealthControllerHealthCheckResponses[keyof HealthControllerHealthCheckResponses];

export type OrganizationDefaultMemberControllerListMembersData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        resourceType: 'DEAL' | 'PROGRAMME';
    };
    query?: never;
    url: '/organization-defaults/members/{organizationId}/{resourceType}';
};

export type OrganizationDefaultMemberControllerListMembersResponses = {
    default: Array<OrganizationDefaultMemberRes>;
};

export type OrganizationDefaultMemberControllerListMembersResponse = OrganizationDefaultMemberControllerListMembersResponses[keyof OrganizationDefaultMemberControllerListMembersResponses];

export type OrganizationDefaultMemberControllerAddMemberData = {
    body: AddOrganizationDefaultMemberDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        resourceType: 'DEAL' | 'PROGRAMME';
    };
    query?: never;
    url: '/organization-defaults/members/{organizationId}/{resourceType}';
};

export type OrganizationDefaultMemberControllerAddMemberResponses = {
    201: unknown;
};

export type OrganizationDefaultMemberControllerRemoveMemberData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
        userId: string;
        resourceType: 'DEAL' | 'PROGRAMME';
    };
    query?: never;
    url: '/organization-defaults/members/{organizationId}/{resourceType}/{userId}';
};

export type OrganizationDefaultMemberControllerRemoveMemberResponses = {
    200: unknown;
};

export type OrganizationUsersControllerGetOrganizationUsersData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}/users';
};

export type OrganizationUsersControllerGetOrganizationUsersResponses = {
    default: Array<BasicUserWithPermissionRolesRes>;
};

export type OrganizationUsersControllerGetOrganizationUsersResponse = OrganizationUsersControllerGetOrganizationUsersResponses[keyof OrganizationUsersControllerGetOrganizationUsersResponses];

export type OrganizationUsersControllerInviteUserToOrganizationData = {
    body: InviteUserToOrganizationDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}/users';
};

export type OrganizationUsersControllerInviteUserToOrganizationResponses = {
    201: unknown;
};

export type OrganizationUsersControllerDeleteUserFromOrganizationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}/users/{userId}';
};

export type OrganizationUsersControllerDeleteUserFromOrganizationsResponses = {
    default: BasicUserRes;
};

export type OrganizationUsersControllerDeleteUserFromOrganizationsResponse = OrganizationUsersControllerDeleteUserFromOrganizationsResponses[keyof OrganizationUsersControllerDeleteUserFromOrganizationsResponses];

export type OrganizationUsersControllerGetOrganizationUserWithPermissionsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        userId: string;
        organizationId: string;
    };
    query?: never;
    url: '/organization/{organizationId}/users/{userId}';
};

export type OrganizationUsersControllerGetOrganizationUserWithPermissionsResponses = {
    default: BasicUserWithPermissionsRes;
};

export type OrganizationUsersControllerGetOrganizationUserWithPermissionsResponse = OrganizationUsersControllerGetOrganizationUserWithPermissionsResponses[keyof OrganizationUsersControllerGetOrganizationUserWithPermissionsResponses];

export type InfoControllerDeploymentInfoData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/info';
};

export type InfoControllerDeploymentInfoResponses = {
    200: DeploymentInfoRes;
};

export type InfoControllerDeploymentInfoResponse = InfoControllerDeploymentInfoResponses[keyof InfoControllerDeploymentInfoResponses];

export type ShareholderKycControllerDeleteKycFileData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
        'mip-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/kyc/{id}';
};

export type ShareholderKycControllerDeleteKycFileResponses = {
    200: unknown;
};

export type ShareholderKycControllerGetProofOfIdentityData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/proof-of-identity';
};

export type ShareholderKycControllerGetProofOfIdentityResponses = {
    default: DataKycFileTct;
};

export type ShareholderKycControllerGetProofOfIdentityResponse = ShareholderKycControllerGetProofOfIdentityResponses[keyof ShareholderKycControllerGetProofOfIdentityResponses];

export type ShareholderKycControllerPutProofOfIdentityData = {
    body: CreateKycFileDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/proof-of-identity';
};

export type ShareholderKycControllerPutProofOfIdentityResponses = {
    200: unknown;
};

export type ShareholderKycControllerGetProofOfAddressData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/proof-of-address';
};

export type ShareholderKycControllerGetProofOfAddressResponses = {
    200: unknown;
};

export type ShareholderKycControllerPutProofOfAddressData = {
    body: CreateKycFileDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/proof-of-address';
};

export type ShareholderKycControllerPutProofOfAddressResponses = {
    200: unknown;
};

export type ShareholderKycControllerGetInvestmentVehicleKycFilesData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/investment-vehicle';
};

export type ShareholderKycControllerGetInvestmentVehicleKycFilesResponses = {
    200: unknown;
};

export type ShareholderKycControllerPostInvestmentVehicleData = {
    body: CreateKycFileDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/investment-vehicle';
};

export type ShareholderKycControllerPostInvestmentVehicleResponses = {
    201: unknown;
};

export type ShareholderKycControllerGetInvestorKycFormsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/kyc-forms-documentworkflow';
};

export type ShareholderKycControllerGetInvestorKycFormsResponses = {
    default: Array<InvestorKycFormRes>;
};

export type ShareholderKycControllerGetInvestorKycFormsResponse = ShareholderKycControllerGetInvestorKycFormsResponses[keyof ShareholderKycControllerGetInvestorKycFormsResponses];

export type ShareholderKycControllerPreFillInvestorKycFormData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/kyc-form/{templateId}/prefill';
};

export type ShareholderKycControllerPreFillInvestorKycFormResponses = {
    default: InvestorKycFormRes;
};

export type ShareholderKycControllerPreFillInvestorKycFormResponse = ShareholderKycControllerPreFillInvestorKycFormResponses[keyof ShareholderKycControllerPreFillInvestorKycFormResponses];

export type ShareholderKycControllerAddFilledKycFormData = {
    body: CreateKycFileDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/kyc-form';
};

export type ShareholderKycControllerAddFilledKycFormResponses = {
    201: unknown;
};

export type ShareholderKycControllerRemoveInvestorFormData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/kyc-form/{templateId}';
};

export type ShareholderKycControllerRemoveInvestorFormResponses = {
    200: unknown;
};

export type ShareholderKycControllerConfirmInvestorFormData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        templateId: string;
    };
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/kyc-form/{templateId}/confirm';
};

export type ShareholderKycControllerConfirmInvestorFormResponses = {
    200: unknown;
};

export type ShareholderKycControllerGetDeclarationsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/declarations';
};

export type ShareholderKycControllerGetDeclarationsResponses = {
    default: Array<DataDeclarationTct>;
};

export type ShareholderKycControllerGetDeclarationsResponse = ShareholderKycControllerGetDeclarationsResponses[keyof ShareholderKycControllerGetDeclarationsResponses];

export type ShareholderKycControllerPatchDeclarationsData = {
    body: PatchDeclarationsDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/declarations';
};

export type ShareholderKycControllerPatchDeclarationsResponses = {
    200: unknown;
};

export type ShareholderKycControllerConfirmKycFileData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/kyc/kyc-file/{id}/confirm';
};

export type ShareholderKycControllerConfirmKycFileResponses = {
    200: unknown;
};

export type ShareholderKycControllerChangeKycFileCertificationData = {
    body: KycFileCertificationChoiceDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/kyc/kyc-file/{id}/certification';
};

export type ShareholderKycControllerChangeKycFileCertificationResponses = {
    default: KycFileCertificationRes;
};

export type ShareholderKycControllerChangeKycFileCertificationResponse = ShareholderKycControllerChangeKycFileCertificationResponses[keyof ShareholderKycControllerChangeKycFileCertificationResponses];

export type ShareholderKycControllerResendKycFileCertifierInvitationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/kyc/kyc-file/{id}/certification/resend';
};

export type ShareholderKycControllerResendKycFileCertifierInvitationResponses = {
    default: KycFileCertificationRes;
};

export type ShareholderKycControllerResendKycFileCertifierInvitationResponse = ShareholderKycControllerResendKycFileCertifierInvitationResponses[keyof ShareholderKycControllerResendKycFileCertifierInvitationResponses];

export type ShareholderKycControllerConfirmDeclarationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/kyc/declaration/{id}/confirm';
};

export type ShareholderKycControllerConfirmDeclarationResponses = {
    200: unknown;
};

export type ShareholderKycControllerSetOffMorePivDocumentsData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/set-off-more-piv-documents';
};

export type ShareholderKycControllerSetOffMorePivDocumentsResponses = {
    200: unknown;
};

export type ShareholderKycControllerResetInheritedData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        kycWorkflowId: string;
    };
    url: '/shareholder/kyc/reset-inherited';
};

export type ShareholderKycControllerResetInheritedResponses = {
    200: unknown;
};

export type ShareholderKycControllerGetStandaloneKycMetadataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        kycWorkflowId: string;
    };
    query?: never;
    url: '/shareholder/kyc/standalone/{kycWorkflowId}';
};

export type ShareholderKycControllerGetStandaloneKycMetadataResponses = {
    default: GetStandaloneKycMetadataRes;
};

export type ShareholderKycControllerGetStandaloneKycMetadataResponse = ShareholderKycControllerGetStandaloneKycMetadataResponses[keyof ShareholderKycControllerGetStandaloneKycMetadataResponses];

export type ShareholderKycControllerDownloadPreFilledKycFormFileData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        kycFormCustomDetailId: string;
    };
    query?: never;
    url: '/shareholder/kyc/pre-filled-form-file/{kycFormCustomDetailId}';
};

export type ShareholderKycControllerDownloadPreFilledKycFormFileResponses = {
    /**
     * Returns pre-filled kyc form file
     */
    default: unknown;
};

export type ShareholderBankAccountControllerGetUserBankAccountData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * Returns bank accounts for the PIV persons linked to the user persons
         */
        showPivAccounts: boolean;
    };
    url: '/shareholder/bank-account';
};

export type ShareholderBankAccountControllerGetUserBankAccountResponses = {
    default: Array<ShareholderInvestorPersonBankAccountsRes>;
};

export type ShareholderBankAccountControllerGetUserBankAccountResponse = ShareholderBankAccountControllerGetUserBankAccountResponses[keyof ShareholderBankAccountControllerGetUserBankAccountResponses];

export type ShareholderBankAccountControllerUpsertBankAccountData = {
    body: PatchShareholderInvestorBankAccountDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        /**
         * ID of the person to associate the bank account with
         */
        personId: string;
    };
    url: '/shareholder/bank-account';
};

export type ShareholderBankAccountControllerUpsertBankAccountResponses = {
    default: UpsertBankAccountRes;
};

export type ShareholderBankAccountControllerUpsertBankAccountResponse = ShareholderBankAccountControllerUpsertBankAccountResponses[keyof ShareholderBankAccountControllerUpsertBankAccountResponses];

export type ShareholderBankAccountControllerDeleteBankAccountData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/bank-account/{id}';
};

export type ShareholderBankAccountControllerDeleteBankAccountResponses = {
    204: void;
};

export type ShareholderBankAccountControllerDeleteBankAccountResponse = ShareholderBankAccountControllerDeleteBankAccountResponses[keyof ShareholderBankAccountControllerDeleteBankAccountResponses];

export type ShareholderBankAccountControllerRequestBankAccountCodeData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/bank-account/{id}/request-code';
};

export type ShareholderBankAccountControllerRequestBankAccountCodeResponses = {
    201: unknown;
};

export type ShareholderBankAccountControllerConfirmBankAccountData = {
    body: ConfirmBankAccountCodeDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/bank-account/{id}/confirm';
};

export type ShareholderBankAccountControllerConfirmBankAccountResponses = {
    default: ConfirmBankAccountRes;
};

export type ShareholderBankAccountControllerConfirmBankAccountResponse = ShareholderBankAccountControllerConfirmBankAccountResponses[keyof ShareholderBankAccountControllerConfirmBankAccountResponses];

export type ShareholderBankAccountControllerValidateBankAccountData = {
    body: VerifyBankIdentifiersDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/shareholder/bank-account/{id}/validate';
};

export type ShareholderBankAccountControllerValidateBankAccountResponses = {
    default: VerifyBankIdentifiersRes;
};

export type ShareholderBankAccountControllerValidateBankAccountResponse = ShareholderBankAccountControllerValidateBankAccountResponses[keyof ShareholderBankAccountControllerValidateBankAccountResponses];

export type ShareholderCustomDetailControllerGetShareholderCustomDetailDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        kycWorkflowId?: string;
    };
    url: '/shareholder/custom-detail';
};

export type ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponses = {
    default: GetShareholderCustomDetailRes;
};

export type ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponse = ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponses[keyof ShareholderCustomDetailControllerGetShareholderCustomDetailDataResponses];

export type ShareholderCustomDetailControllerUpdateShareholderInvestorDataData = {
    body: PatchShareholderInvestorCustomDetailDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/custom-detail';
};

export type ShareholderCustomDetailControllerUpdateShareholderInvestorDataResponses = {
    200: unknown;
};

export type ShareholderContractControllerGetListOfActionableDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query: {
        excludeTsaContracts: boolean;
        investmentWorkflowId: string;
    };
    url: '/shareholder/contract/transaction/investor/{investorId}/signable-documents';
};

export type ShareholderContractControllerGetListOfActionableDocumentsResponses = {
    default: GetSignableContractsAndInvestorPhoneStatusRes;
};

export type ShareholderContractControllerGetListOfActionableDocumentsResponse = ShareholderContractControllerGetListOfActionableDocumentsResponses[keyof ShareholderContractControllerGetListOfActionableDocumentsResponses];

export type ShareholderContractControllerStreamSignableDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/shareholder/contract/transaction/investor/{investorId}/programme/{mipId}/signable-documents/stream';
};

export type ShareholderContractControllerStreamSignableDocumentsResponses = {
    200: unknown;
};

export type ShareholderContractControllerReviewDocumentData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowInstanceId: string;
    };
    query: {
        fileId: string;
    };
    url: '/shareholder/contract/review-document-workflow/{documentWorkflowInstanceId}';
};

export type ShareholderContractControllerReviewDocumentResponses = {
    201: unknown;
};

export type ShareholderContractControllerGenerateSignableDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: {
        investmentWorkflowId?: string;
        shouldRegenerateAllContracts?: boolean;
    };
    url: '/shareholder/contract/transaction/investor/{investorId}/generate-signable-documents';
};

export type ShareholderContractControllerGenerateSignableDocumentsResponses = {
    201: unknown;
};

export type ShareholderContractControllerGeneratePrefillableFormFileData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        fileId: string;
        instanceSignatureId: string;
    };
    query?: never;
    url: '/shareholder/contract/download-prefillable-form-file/{fileId}/{instanceSignatureId}';
};

export type ShareholderContractControllerGeneratePrefillableFormFileResponses = {
    /**
     * Returns prefillable form file dynamically populated with form template data
     */
    default: unknown;
};

export type InvestmentControllerGetInvestmentDetailsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        mipId: string;
    };
    query: {
        investmentWorkflowId: string;
    };
    url: '/shareholder/investment/by-mip-id/{mipId}';
};

export type InvestmentControllerGetInvestmentDetailsResponses = {
    default: Array<GetInvestmentDetailsRes>;
};

export type InvestmentControllerGetInvestmentDetailsResponse = InvestmentControllerGetInvestmentDetailsResponses[keyof InvestmentControllerGetInvestmentDetailsResponses];

export type InvestmentControllerGetInvestmentsAndSdwDocumentsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investment/with-sdw-documents';
};

export type InvestmentControllerGetInvestmentsAndSdwDocumentsResponses = {
    default: Array<GetShareholderInvestmentEntryWithSdwDocumentRes>;
};

export type InvestmentControllerGetInvestmentsAndSdwDocumentsResponse = InvestmentControllerGetInvestmentsAndSdwDocumentsResponses[keyof InvestmentControllerGetInvestmentsAndSdwDocumentsResponses];

export type InvestmentControllerGetInvestmentV2Data = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/shareholder/investment/with-sdw-documents/{investorId}';
};

export type InvestmentControllerGetInvestmentV2Responses = {
    default: GetShareholderInvestmentEntryWithSdwDocumentRes;
};

export type InvestmentControllerGetInvestmentV2Response = InvestmentControllerGetInvestmentV2Responses[keyof InvestmentControllerGetInvestmentV2Responses];

export type InvestmentControllerGetAllInvestmentValuationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investment/valuations';
};

export type InvestmentControllerGetAllInvestmentValuationsResponses = {
    default: Array<GetInvestorValuationsRes>;
};

export type InvestmentControllerGetAllInvestmentValuationsResponse = InvestmentControllerGetAllInvestmentValuationsResponses[keyof InvestmentControllerGetAllInvestmentValuationsResponses];

export type InvestmentControllerGetSecurityVestingDataData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
        securityId: string;
    };
    query?: never;
    url: '/shareholder/investment/vesting/{investorId}/{securityId}';
};

export type InvestmentControllerGetSecurityVestingDataResponses = {
    default: GetSecurityVestingRes;
};

export type InvestmentControllerGetSecurityVestingDataResponse = InvestmentControllerGetSecurityVestingDataResponses[keyof InvestmentControllerGetSecurityVestingDataResponses];

export type InvestmentControllerGetInvestmentValuationsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investorId: string;
    };
    query?: never;
    url: '/shareholder/investment/valuations/{investorId}';
};

export type InvestmentControllerGetInvestmentValuationsResponses = {
    default: GetInvestorValuationsRes;
};

export type InvestmentControllerGetInvestmentValuationsResponse = InvestmentControllerGetInvestmentValuationsResponses[keyof InvestmentControllerGetInvestmentValuationsResponses];

export type InvestmentControllerGetInvestmentPaymentInstructionData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investment/payment-instruction-template';
};

export type InvestmentControllerGetInvestmentPaymentInstructionResponses = {
    200: unknown;
};

export type InvestmentControllerGetUserInvestmentsListData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/shareholder/investment/user-investments';
};

export type InvestmentControllerGetUserInvestmentsListResponses = {
    default: Array<GetUserInvestmentsListItemRes>;
};

export type InvestmentControllerGetUserInvestmentsListResponse = InvestmentControllerGetUserInvestmentsListResponses[keyof InvestmentControllerGetUserInvestmentsListResponses];

export type InvestmentControllerSetSelectedBankAccountData = {
    body: PatchInvestmentSelectedBankAccountDto;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        investmentWorkflowId: string;
    };
    query?: never;
    url: '/shareholder/investment/{investmentWorkflowId}/selected-bank-account';
};

export type InvestmentControllerSetSelectedBankAccountResponses = {
    200: unknown;
};

export type PermissionControllerAddResourcePermissionsForUserData = {
    body: PermissionRolesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * The unique identifier of the resource (UUID format)
         */
        resourceId: string;
        /**
         * The type of the resource (e.g., "deal", "programme") for which the permissions are being set
         */
        resourceType: 'platform' | 'user' | 'deal' | 'programme' | 'organization';
    };
    query?: never;
    url: '/permissions/{resourceType}/{resourceId}/permissions/create';
};

export type PermissionControllerAddResourcePermissionsForUserResponses = {
    201: unknown;
};

export type PermissionControllerRemoveResourcePermissionForUserData = {
    body: PermissionRolesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * The unique identifier of the resource (UUID format)
         */
        resourceId: string;
        /**
         * The type of the resource (e.g., "deal", "programme") for which the permissions are being set
         */
        resourceType: 'platform' | 'user' | 'deal' | 'programme' | 'organization';
    };
    query?: never;
    url: '/permissions/{resourceType}/{resourceId}/permissions/delete';
};

export type PermissionControllerRemoveResourcePermissionForUserResponses = {
    201: unknown;
};

export type PermissionControllerSetResourcePermissionsForUserData = {
    body: PermissionRolesDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        /**
         * The unique identifier of the resource (UUID format)
         */
        resourceId: string;
        /**
         * The type of the resource (e.g., "deal", "programme") for which the permissions are being set
         */
        resourceType: 'platform' | 'user' | 'deal' | 'programme' | 'organization';
    };
    query?: never;
    url: '/permissions/{resourceType}/{resourceId}/permissions/set';
};

export type PermissionControllerSetResourcePermissionsForUserResponses = {
    201: unknown;
};

export type ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/programme-security-allocations/security/{securityId}';
};

export type ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponses = {
    default: Array<ProgrammeSecurityAllocationTct>;
};

export type ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponse = ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponses[keyof ProgrammeSecurityAllocationsControllerGetAllocationsBySecurityIdResponses];

export type ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query: {
        includeMipId: string;
    };
    url: '/programme-security-allocations/security/{securityId}/mip-list';
};

export type ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponses = {
    default: Array<SummaryMipNameTct>;
};

export type ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponse = ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponses[keyof ProgrammeSecurityAllocationsControllerGetAllocationMipListBySecurityIdResponses];

export type ProgrammeSecurityAllocationsControllerCreateAllocationData = {
    body: UpdateProgrammeSecurityAllocationDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/programme-security-allocations';
};

export type ProgrammeSecurityAllocationsControllerCreateAllocationResponses = {
    default: ProgrammeSecurityAllocationTct;
};

export type ProgrammeSecurityAllocationsControllerCreateAllocationResponse = ProgrammeSecurityAllocationsControllerCreateAllocationResponses[keyof ProgrammeSecurityAllocationsControllerCreateAllocationResponses];

export type ProgrammeSecurityAllocationsControllerDeleteAllocationData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path: {
        allocationId: string;
    };
    query?: never;
    url: '/programme-security-allocations/{allocationId}';
};

export type ProgrammeSecurityAllocationsControllerDeleteAllocationResponses = {
    default: unknown;
};

export type ProgrammeSecurityAllocationsControllerUpdateAllocationData = {
    body: UpdateProgrammeSecurityAllocationDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        allocationId: string;
    };
    query?: never;
    url: '/programme-security-allocations/{allocationId}';
};

export type ProgrammeSecurityAllocationsControllerUpdateAllocationResponses = {
    default: ProgrammeSecurityAllocationTct;
};

export type ProgrammeSecurityAllocationsControllerUpdateAllocationResponse = ProgrammeSecurityAllocationsControllerUpdateAllocationResponses[keyof ProgrammeSecurityAllocationsControllerUpdateAllocationResponses];

export type ResendControllerEmailEventData = {
    body?: never;
    headers: {
        'svix-id': string;
        'svix-timestamp': string;
        'svix-signature': string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/resend/webhooks/email-event';
};

export type ResendControllerEmailEventResponses = {
    200: unknown;
};

export type HelpBlogControllerGetArticlesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        searchKeyword: string;
        language: string;
        refId: string;
        limit: number;
    };
    url: '/help-blog/{dataset}/articles';
};

export type HelpBlogControllerGetArticlesResponses = {
    default: Array<ArticleRes>;
};

export type HelpBlogControllerGetArticlesResponse = HelpBlogControllerGetArticlesResponses[keyof HelpBlogControllerGetArticlesResponses];

export type HelpBlogControllerGetEntrypointArticlesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        language: string;
    };
    url: '/help-blog/{dataset}/articles/entrypoints';
};

export type HelpBlogControllerGetEntrypointArticlesResponses = {
    default: Array<EntrypointArticlesRes>;
};

export type HelpBlogControllerGetEntrypointArticlesResponse = HelpBlogControllerGetEntrypointArticlesResponses[keyof HelpBlogControllerGetEntrypointArticlesResponses];

export type HelpBlogControllerGetSlugArticleData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        slug: string;
    };
    query?: never;
    url: '/help-blog/{dataset}/articles/{slug}';
};

export type HelpBlogControllerGetSlugArticleResponses = {
    default: ArticleRes;
};

export type HelpBlogControllerGetSlugArticleResponse = HelpBlogControllerGetSlugArticleResponses[keyof HelpBlogControllerGetSlugArticleResponses];

export type HelpBlogControllerGetCategoriesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        language: string;
        limit: number;
    };
    url: '/help-blog/{dataset}/categories';
};

export type HelpBlogControllerGetCategoriesResponses = {
    default: Array<CategoryRes>;
};

export type HelpBlogControllerGetCategoriesResponse = HelpBlogControllerGetCategoriesResponses[keyof HelpBlogControllerGetCategoriesResponses];

export type HelpBlogControllerGetAuthorsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path?: never;
    query: {
        language: string;
        limit: number;
    };
    url: '/help-blog/{dataset}/authors';
};

export type HelpBlogControllerGetAuthorsResponses = {
    default: Array<AuthorRes>;
};

export type HelpBlogControllerGetAuthorsResponse = HelpBlogControllerGetAuthorsResponses[keyof HelpBlogControllerGetAuthorsResponses];

export type HelpBlogControllerGetSlugCategoryData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        slug: string;
    };
    query?: never;
    url: '/help-blog/{dataset}/categories/{slug}';
};

export type HelpBlogControllerGetSlugCategoryResponses = {
    default: CategoryRes;
};

export type HelpBlogControllerGetSlugCategoryResponse = HelpBlogControllerGetSlugCategoryResponses[keyof HelpBlogControllerGetSlugCategoryResponses];

export type HelpBlogControllerGetSlugAuthorData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        slug: string;
    };
    query?: never;
    url: '/help-blog/{dataset}/author/{slug}';
};

export type HelpBlogControllerGetSlugAuthorResponses = {
    default: AuthorRes;
};

export type HelpBlogControllerGetSlugAuthorResponse = HelpBlogControllerGetSlugAuthorResponses[keyof HelpBlogControllerGetSlugAuthorResponses];

export type SimpleDocumentWorkflowControllerGetInvestorsFilteringDataData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: {
        cursor?: string;
        limit?: string;
        search?: string;
        sortingOrder?: SortingOrder;
    };
    url: '/mip/simple-document-workflow/document-files';
};

export type SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponses = {
    default: GetDocumentWorkflowFilesRes;
};

export type SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponse = SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponses[keyof SimpleDocumentWorkflowControllerGetInvestorsFilteringDataResponses];

export type SimpleDocumentWorkflowControllerAddFileToMipData = {
    body: DocumentWorkflowFileDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/simple-document-workflow/document-file';
};

export type SimpleDocumentWorkflowControllerAddFileToMipResponses = {
    default: CreateDocumentWorkflowFileRes;
};

export type SimpleDocumentWorkflowControllerAddFileToMipResponse = SimpleDocumentWorkflowControllerAddFileToMipResponses[keyof SimpleDocumentWorkflowControllerAddFileToMipResponses];

export type SimpleDocumentWorkflowControllerCreateDocumentsData = {
    body: CreateDocumentWorkflowsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/simple-document-workflow/create-documents';
};

export type SimpleDocumentWorkflowControllerCreateDocumentsResponses = {
    default: CreateDocumentWorkflowRes;
};

export type SimpleDocumentWorkflowControllerCreateDocumentsResponse = SimpleDocumentWorkflowControllerCreateDocumentsResponses[keyof SimpleDocumentWorkflowControllerCreateDocumentsResponses];

export type SimpleDocumentWorkflowControllerSendMasterDocumentsData = {
    body: SendMasterDocumentsDto;
    headers?: {
        'mip-id'?: string;
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/mip/simple-document-workflow/send';
};

export type SimpleDocumentWorkflowControllerSendMasterDocumentsResponses = {
    default: SendMasterDocumentsRes;
};

export type SimpleDocumentWorkflowControllerSendMasterDocumentsResponse = SimpleDocumentWorkflowControllerSendMasterDocumentsResponses[keyof SimpleDocumentWorkflowControllerSendMasterDocumentsResponses];

export type SimpleDocumentWorkflowControllerRemoveDocumentFileData = {
    body?: never;
    headers?: {
        'mip-id'?: string;
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        documentWorkflowFileId: string;
    };
    query?: never;
    url: '/mip/simple-document-workflow/remove/{documentWorkflowFileId}';
};

export type SimpleDocumentWorkflowControllerRemoveDocumentFileResponses = {
    200: unknown;
};

export type SecurityRankDefinitionControllerGetPersonRanksData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        personId: string;
    };
    query?: never;
    url: '/securityRankDefinition/{personId}';
};

export type SecurityRankDefinitionControllerGetPersonRanksResponses = {
    default: Array<SecurityRankDefinitionRes>;
};

export type SecurityRankDefinitionControllerGetPersonRanksResponse = SecurityRankDefinitionControllerGetPersonRanksResponses[keyof SecurityRankDefinitionControllerGetPersonRanksResponses];

export type SecurityRankDefinitionControllerCreateRankData = {
    body: CreateSecurityRankDefinitionDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/securityRankDefinition';
};

export type SecurityRankDefinitionControllerCreateRankResponses = {
    default: SecurityRankDefinitionRes;
};

export type SecurityRankDefinitionControllerCreateRankResponse = SecurityRankDefinitionControllerCreateRankResponses[keyof SecurityRankDefinitionControllerCreateRankResponses];

export type SecurityRankDefinitionControllerSoftDeleteRankData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        rankId: string;
    };
    query?: never;
    url: '/securityRankDefinition/{rankId}';
};

export type SecurityRankDefinitionControllerSoftDeleteRankResponses = {
    default: SecurityRankDefinitionRes;
};

export type SecurityRankDefinitionControllerSoftDeleteRankResponse = SecurityRankDefinitionControllerSoftDeleteRankResponses[keyof SecurityRankDefinitionControllerSoftDeleteRankResponses];

export type SecurityRankDefinitionControllerUpdateRankData = {
    body: UpdateSecurityRankDefinitionDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        rankId: string;
    };
    query?: never;
    url: '/securityRankDefinition/{rankId}';
};

export type SecurityRankDefinitionControllerUpdateRankResponses = {
    default: SecurityRankDefinitionRes;
};

export type SecurityRankDefinitionControllerUpdateRankResponse = SecurityRankDefinitionControllerUpdateRankResponses[keyof SecurityRankDefinitionControllerUpdateRankResponses];

export type SecurityRankControllerUpsertSecurityRankData = {
    body: UpsertSecurityRankDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security-rank';
};

export type SecurityRankControllerUpsertSecurityRankResponses = {
    default: SecurityRankRes;
};

export type SecurityRankControllerUpsertSecurityRankResponse = SecurityRankControllerUpsertSecurityRankResponses[keyof SecurityRankControllerUpsertSecurityRankResponses];

export type SecurityRankControllerUpsertSecurityIncomeRanksData = {
    body: UpsertSecurityIncomeRanksDto;
    headers?: {
        'deal-id'?: string;
    };
    path?: never;
    query?: never;
    url: '/security-rank/income';
};

export type SecurityRankControllerUpsertSecurityIncomeRanksResponses = {
    default: Array<SecurityRankRes>;
};

export type SecurityRankControllerUpsertSecurityIncomeRanksResponse = SecurityRankControllerUpsertSecurityIncomeRanksResponses[keyof SecurityRankControllerUpsertSecurityIncomeRanksResponses];

export type SecurityRankControllerDeleteSecurityRankData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        id: string;
    };
    query?: never;
    url: '/security-rank/{id}';
};

export type SecurityRankControllerDeleteSecurityRankResponses = {
    200: unknown;
};

export type SecurityRankControllerDeleteSecurityIncomeRanksData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security-rank/income/{securityId}';
};

export type SecurityRankControllerDeleteSecurityIncomeRanksResponses = {
    200: unknown;
};

export type SecurityRatchetControllerDeleteScheduleData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security-ratchet/{securityId}';
};

export type SecurityRatchetControllerDeleteScheduleResponses = {
    200: unknown;
};

export type SecurityRatchetControllerGetScheduleData = {
    body?: never;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security-ratchet/{securityId}';
};

export type SecurityRatchetControllerGetScheduleResponses = {
    200: unknown;
};

export type SecurityRatchetControllerUpsertScheduleData = {
    body: CreateUpdateSecurityRatchetScheduleDto;
    headers?: {
        'deal-id'?: string;
    };
    path: {
        securityId: string;
    };
    query?: never;
    url: '/security-ratchet/{securityId}';
};

export type SecurityRatchetControllerUpsertScheduleResponses = {
    201: unknown;
};

export type EmailSchedulerControllerListConfigsData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/config';
};

export type EmailSchedulerControllerListConfigsResponses = {
    default: Array<ProgrammeEmailScheduleConfigRes>;
};

export type EmailSchedulerControllerListConfigsResponse = EmailSchedulerControllerListConfigsResponses[keyof EmailSchedulerControllerListConfigsResponses];

export type EmailSchedulerControllerUpsertConfigData = {
    body: UpdateEmailScheduleConfigDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/config';
};

export type EmailSchedulerControllerUpsertConfigResponses = {
    200: unknown;
};

export type EmailSchedulerControllerListSchedulesData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: {
        documentWorkflowInstanceId?: string;
        status?: 'ACTIVE' | 'PROCESSING' | 'COMPLETED' | 'CANCELLED' | 'FAILED';
    };
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules';
};

export type EmailSchedulerControllerListSchedulesResponses = {
    default: Array<ScheduledEmailRes>;
};

export type EmailSchedulerControllerListSchedulesResponse = EmailSchedulerControllerListSchedulesResponses[keyof EmailSchedulerControllerListSchedulesResponses];

export type EmailSchedulerControllerCreateScheduleData = {
    body: CreateScheduledEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules';
};

export type EmailSchedulerControllerCreateScheduleResponses = {
    default: ScheduledEmailRes;
};

export type EmailSchedulerControllerCreateScheduleResponse = EmailSchedulerControllerCreateScheduleResponses[keyof EmailSchedulerControllerCreateScheduleResponses];

export type EmailSchedulerControllerCancelData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        id: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/cancel';
};

export type EmailSchedulerControllerCancelResponses = {
    200: unknown;
};

export type EmailSchedulerControllerRescheduleData = {
    body: RescheduleScheduledEmailDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        id: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/reschedule';
};

export type EmailSchedulerControllerRescheduleResponses = {
    200: unknown;
};

export type EmailSchedulerControllerRestartData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        id: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/restart';
};

export type EmailSchedulerControllerRestartResponses = {
    200: unknown;
};

export type EmailSchedulerControllerSendNowData = {
    body?: never;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        id: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/send-now';
};

export type EmailSchedulerControllerSendNowResponses = {
    200: unknown;
};

export type EmailSchedulerControllerSetEndDateData = {
    body: SetScheduledEmailEndDateDto;
    headers?: {
        /**
         * Deal ID
         */
        'deal-id'?: string;
    };
    path: {
        dealId: string;
        programmeId: string;
        id: string;
    };
    query?: never;
    url: '/deal/{dealId}/mip/{programmeId}/email-scheduler/schedules/{id}/end-date';
};

export type EmailSchedulerControllerSetEndDateResponses = {
    200: unknown;
};
